/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Any: { input: any; output: any };
  Double: { input: any; output: any };
  Int64: { input: number; output: number };
  Map: { input: any; output: any };
  Void: { input: any; output: any };
};

/**  Create new restriction for this user in account  */
export type AccountsMsAddPrivilegeRestrictionRequest = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Cancel support user invite  */
export type AccountsMsCancelSupportUserInviteRequest = {
  /**  The id of the support user to cancel  */
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Cancel user invite  */
export type AccountsMsCancelUserInviteRequest = {
  /**  the id on witch account he will be canceled  */
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The id of the user to cancel  */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Count sectors of user in related to caller restriction  */
export type AccountsMsCountNumberOfSectorsRequest = {
  privilegeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsCountNumberOfSectorsResponse = {
  __typename?: "AccountsMsCountNumberOfSectorsResponse";
  count: Scalars["Int64"]["output"];
};

export type AccountsMsCountSupportUsersByStatusResponse = {
  __typename?: "AccountsMsCountSupportUsersByStatusResponse";
  all: Scalars["Int64"]["output"];
  disabled: Scalars["Int64"]["output"];
  enabled: Scalars["Int64"]["output"];
  inviting: Scalars["Int64"]["output"];
};

/**  Count the users by status, scoped to the current account  */
export type AccountsMsCountUsersByStatusRequest = {
  /**  when provided, it will count only the ones that match the provided roles profiles  */
  rolesProfileIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type AccountsMsCountUsersByStatusResponse = {
  __typename?: "AccountsMsCountUsersByStatusResponse";
  all: Scalars["Int64"]["output"];
  disabled: Scalars["Int64"]["output"];
  enabled: Scalars["Int64"]["output"];
  inviting: Scalars["Int64"]["output"];
};

/**  Count the users in a roles profile, scoped to the current account  */
export type AccountsMsCountUsersInRolesProfileRequest = {
  rolesProfileId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsCountUsersInRolesProfileResponse = {
  __typename?: "AccountsMsCountUsersInRolesProfileResponse";
  disabled: Scalars["Int64"]["output"];
  enabled: Scalars["Int64"]["output"];
  inviting: Scalars["Int64"]["output"];
  total: Scalars["Int64"]["output"];
};

/**  Count the users in sector  */
export type AccountsMsCountUsersInSectorRequest = {
  filters?: InputMaybe<AccountsMsCountUsersInSectorRequestFilters>;
};

export type AccountsMsCountUsersInSectorRequestFilters = {
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type AccountsMsCountUsersInSectorResponse = {
  __typename?: "AccountsMsCountUsersInSectorResponse";
  /**  All users in sectors  */
  data?: Maybe<Array<AccountsMsCountUsersInSectorResponseData>>;
};

/**  All users in sectors  */
export type AccountsMsCountUsersInSectorResponseData = {
  __typename?: "AccountsMsCountUsersInSectorResponseData";
  /**  All users  */
  all: Scalars["Int64"]["output"];
  /**  All users of future or terminated  */
  disabled: Scalars["Int64"]["output"];
  /**  All users activated  */
  enabled: Scalars["Int64"]["output"];
  sectorId: Scalars["ID"]["output"];
};

/**  Create a new agency  */
export type AccountsMsCreateAgencyRequest = {
  agent?: InputMaybe<AccountsMsCreateAgencyRequestAgent>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  subsidiaries?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type AccountsMsCreateAgencyRequestAgent = {
  /**  The user email address  */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**  The first name  */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**  Digital Pass identifier  */
  igg?: InputMaybe<Scalars["String"]["input"]>;
  /**  The functions of the user (mandatory)  */
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  /**  The last name  */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsCreateAgencyResponse = {
  __typename?: "AccountsMsCreateAgencyResponse";
  /**  The id of the created agency  */
  id: Scalars["ID"]["output"];
};

/**
 *  Creates a roles profile
 *
 * When a roles profile is created under another one, the roles selection is restricted to the parent roles profile roles.
 */
export type AccountsMsCreateRolesProfileRequest = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  roles?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type AccountsMsCreateRolesProfileResponse = {
  __typename?: "AccountsMsCreateRolesProfileResponse";
  data: AccountsMsRolesProfile;
};

/**
 *  Deletes a roles profile
 *
 * Only unused roles profile can be deleted.
 */
export type AccountsMsDeleteRolesProfileRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsDeleteRolesProfileResponse = {
  __typename?: "AccountsMsDeleteRolesProfileResponse";
  deleted: Scalars["Boolean"]["output"];
};

/**
 *  Disable a privilege
 *
 * The related user won't have access to this account anymore. Nothing happens if the privilege is already disabled.
 */
export type AccountsMsDisableRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Disable support user  */
export type AccountsMsDisableSupportUserRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 *  Enable a privilege
 *
 * The related user will be granted back his access to this account. Nothing happens if the privilege is already enabled.
 */
export type AccountsMsEnableRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Enable support user  */
export type AccountsMsEnableSupportUserRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 *  Extend a support session
 *
 * Extend a session for a support operator.
 */
export type AccountsMsExtendSupportRequest = {
  /**  The session id  */
  sessionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsExtendSupportResponse = {
  __typename?: "AccountsMsExtendSupportResponse";
  /**  When the code expires  */
  expiresTs: Scalars["Int64"]["output"];
};

/**
 *  Forget a privilege
 *
 * Deletes a privilege forever.
 */
export type AccountsMsForgetRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsGetOwnerResponse = {
  __typename?: "AccountsMsGetOwnerResponse";
  PrivilegeIdData?: Maybe<AccountsMsSearchPrivilegesResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  privilegeId: Scalars["ID"]["output"];
  /**  The related user  */
  userId: Scalars["ID"]["output"];
};

export type AccountsMsGetRolesGridRequest = {
  roleProfileId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsGetRolesGridResponse = {
  __typename?: "AccountsMsGetRolesGridResponse";
  billingSection: AccountsMsGetRolesGridResponseBillingSection;
  collaboratorsSection: AccountsMsGetRolesGridResponseCollaboratorSection;
  contractSection: AccountsMsGetRolesGridResponseContractSection;
  ledgersSection: AccountsMsGetRolesGridResponseLedgersSection;
  reportingSection: AccountsMsGetRolesGridResponseReportingSection;
  usersSection: AccountsMsGetRolesGridResponseUsersSection;
};

export type AccountsMsGetRolesGridResponseBillingSection = {
  __typename?: "AccountsMsGetRolesGridResponseBillingSection";
  billing: AccountsMsGetRolesGridResponseBillingSectionBillingLine;
  tid: AccountsMsGetRolesGridResponseBillingSectionTidLine;
};

export type AccountsMsGetRolesGridResponseBillingSectionBillingLine = {
  __typename?: "AccountsMsGetRolesGridResponseBillingSectionBillingLine";
  read: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseBillingSectionTidLine = {
  __typename?: "AccountsMsGetRolesGridResponseBillingSectionTidLine";
  read: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseCollaboratorSection = {
  __typename?: "AccountsMsGetRolesGridResponseCollaboratorSection";
  collaborators: AccountsMsGetRolesGridResponseCollaboratorSectionCollaboratorsLine;
  driverCodes: AccountsMsGetRolesGridResponseCollaboratorSectionDriverCodesLine;
  vehicles: AccountsMsGetRolesGridResponseCollaboratorSectionVehiclesLine;
};

export type AccountsMsGetRolesGridResponseCollaboratorSectionCollaboratorsLine =
  {
    __typename?: "AccountsMsGetRolesGridResponseCollaboratorSectionCollaboratorsLine";
    read: Scalars["Boolean"]["output"];
    write: Scalars["Boolean"]["output"];
  };

export type AccountsMsGetRolesGridResponseCollaboratorSectionDriverCodesLine = {
  __typename?: "AccountsMsGetRolesGridResponseCollaboratorSectionDriverCodesLine";
  read: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseCollaboratorSectionVehiclesLine = {
  __typename?: "AccountsMsGetRolesGridResponseCollaboratorSectionVehiclesLine";
  read: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseContractSection = {
  __typename?: "AccountsMsGetRolesGridResponseContractSection";
  contract: AccountsMsGetRolesGridResponseContractSectionContractLine;
};

export type AccountsMsGetRolesGridResponseContractSectionContractLine = {
  __typename?: "AccountsMsGetRolesGridResponseContractSectionContractLine";
  read: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseLedgersSection = {
  __typename?: "AccountsMsGetRolesGridResponseLedgersSection";
  ledgers: AccountsMsGetRolesGridResponseLedgersSectionLedgersLine;
  transactions: AccountsMsGetRolesGridResponseLedgersSectionTransactionsLine;
};

export type AccountsMsGetRolesGridResponseLedgersSectionLedgersLine = {
  __typename?: "AccountsMsGetRolesGridResponseLedgersSectionLedgersLine";
  block: Scalars["Boolean"]["output"];
  read: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseLedgersSectionTransactionsLine = {
  __typename?: "AccountsMsGetRolesGridResponseLedgersSectionTransactionsLine";
  read: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseReportingSection = {
  __typename?: "AccountsMsGetRolesGridResponseReportingSection";
  alerting: AccountsMsGetRolesGridResponseReportingSectionAlertingLine;
  reporting: AccountsMsGetRolesGridResponseReportingSectionReportingLine;
};

export type AccountsMsGetRolesGridResponseReportingSectionAlertingLine = {
  __typename?: "AccountsMsGetRolesGridResponseReportingSectionAlertingLine";
  read: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseReportingSectionReportingLine = {
  __typename?: "AccountsMsGetRolesGridResponseReportingSectionReportingLine";
  advancedRead: Scalars["Boolean"]["output"];
  read: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseUsersSection = {
  __typename?: "AccountsMsGetRolesGridResponseUsersSection";
  divisions: AccountsMsGetRolesGridResponseUsersSectionDivisionLine;
  rolesProfiles: AccountsMsGetRolesGridResponseUsersSectionRolesProfilesLine;
  sectors: AccountsMsGetRolesGridResponseUsersSectionSectorLine;
  users: AccountsMsGetRolesGridResponseUsersSectionUsersLine;
};

export type AccountsMsGetRolesGridResponseUsersSectionDivisionLine = {
  __typename?: "AccountsMsGetRolesGridResponseUsersSectionDivisionLine";
  read: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseUsersSectionRolesProfilesLine = {
  __typename?: "AccountsMsGetRolesGridResponseUsersSectionRolesProfilesLine";
  read: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseUsersSectionSectorLine = {
  __typename?: "AccountsMsGetRolesGridResponseUsersSectionSectorLine";
  read: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export type AccountsMsGetRolesGridResponseUsersSectionUsersLine = {
  __typename?: "AccountsMsGetRolesGridResponseUsersSectionUsersLine";
  read: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

/**  Invite support user  */
export type AccountsMsInviteSupportUserRequest = {
  /**  The user email address  */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**  The first name  */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**  Digital Pass identifier  */
  igg?: InputMaybe<Scalars["String"]["input"]>;
  /**  The functions of the user  */
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  /**  The last name  */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**  The profile of the user  */
  profile?: InputMaybe<AccountsMsInviteSupportUserRequestProfile>;
  rights?: InputMaybe<AccountsMsInviteSupportUserRequestRightsList>;
};

/**  The profile of the user  */
export enum AccountsMsInviteSupportUserRequestProfile {
  Agent = "AGENT",
  ProfileUnknown = "PROFILE_UNKNOWN",
  SuperAgent = "SUPER_AGENT",
}

export type AccountsMsInviteSupportUserRequestRightsList = {
  impersonate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccountsMsInviteSupportUserResponse = {
  __typename?: "AccountsMsInviteSupportUserResponse";
  /**  The id of the invited user  */
  id: Scalars["ID"]["output"];
};

/**
 *  Invite a user.
 *
 * Create a privilege for the given user in the current account. A notification is sent to the user.
 * When the user do not exist, we send a welcome notification. Otherwise, we send a classical invitation notification.
 * A new user is created with the same timezone and locale of the current user when the account preferred_locale is
 * not set.
 */
export type AccountsMsInviteUserRequest = {
  /**  An optional email address (required if the user id is empty)  */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**  The first name of the user if the user_id is empty  */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**  The function of the user in the given account  */
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  /**  The last name of the user if the user_id is empty  */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**  The phone number of the user, prefixed with the country code (following E164 standard), if the user_id is empty  */
  phone?: InputMaybe<Scalars["String"]["input"]>;
  /**  The alternative phone number of the user, prefixed with the country code (following E164 standard), if the user_id is empty  */
  phoneAlt?: InputMaybe<Scalars["String"]["input"]>;
  /**  An optional list of roles profiles, otherwise the user is created with the default role profile(s)  */
  rolesProfileIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  An optional list of sectors, otherwise the user is created without restriction  */
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  An optional user id (required if the email is empty). Filled up from a LookupUser response.  */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsInviteUserResponse = {
  __typename?: "AccountsMsInviteUserResponse";
  /**  The id of the invited user  */
  userId: Scalars["ID"]["output"];
};

export type AccountsMsListLocalesResponse = {
  __typename?: "AccountsMsListLocalesResponse";
  codes?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type AccountsMsListRolesResponse = {
  __typename?: "AccountsMsListRolesResponse";
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 *  Find a user.
 *
 * Search a user in the user book. Multiple results may be returned.
 */
export type AccountsMsLookupUserRequest = {
  /**  The email of the user or other search information.  */
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsLookupUserResponse = {
  __typename?: "AccountsMsLookupUserResponse";
  matches?: Maybe<Array<AccountsMsLookupUserResponseUserPreview>>;
};

export type AccountsMsLookupUserResponseUserPreview = {
  __typename?: "AccountsMsLookupUserResponseUserPreview";
  /**  The first name and the first letter of the family name of the user.  */
  name: Scalars["String"]["output"];
  userId: Scalars["ID"]["output"];
};

/**
 *  The current identity information
 *
 * Returns the current user information, used by the frontend to load partial data about the user profile.
 */
export type AccountsMsMeRequest = {
  /**
   *  The list of account ids narrowing down the returned visa list.
   * The client should add all account ids it caches in order to invalidate the related visa.
   * When no account id is specified, we consider it filled with the user's default account id if there is such.
   */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type AccountsMsMeResponse = {
  __typename?: "AccountsMsMeResponse";
  /**  True if the user is a beta tester  */
  betaTester: Scalars["Boolean"]["output"];
  customerUserInfo: AccountsMsMeResponseCustomerUser;
  /**  The user profile ts is the last time of the user's profile shared data were updated.  */
  sharedUserProfileTs: Scalars["Int64"]["output"];
  supportUserInfo: AccountsMsMeResponseSupportUser;
  systemUserInfo?: Maybe<Scalars["Void"]["output"]>;
  /**  The customer user or the support user ID  */
  userId: Scalars["ID"]["output"];
};

export type AccountsMsMeResponseCustomerUser = {
  __typename?: "AccountsMsMeResponseCustomerUser";
  /**  The default account id of the user, if not defined the user must select among the account list.  */
  defaultAccountId: Scalars["ID"]["output"];
  /**  The user's email  */
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  /**  The user's locale  */
  locale: Scalars["String"]["output"];
  /**  The total of accounts the user know. This also count inactive privileges.  */
  numberOfAccounts: Scalars["Int64"]["output"];
  /**  The number of accounts the user has access to. This does not count inactive privileges.  */
  numberOfSwitchableAccounts: Scalars["Int64"]["output"];
  phone: Scalars["String"]["output"];
  phoneAlt: Scalars["String"]["output"];
  /**  The user's timezone  */
  timezone: Scalars["String"]["output"];
  /**  The public visa information, narrowed to the requested account ids  */
  visas?: Maybe<Array<AccountsMsMeResponseCustomerUserPublicVisa>>;
};

/**  The public visa information, narrowed to the requested account ids  */
export type AccountsMsMeResponseCustomerUserPublicVisa = {
  __typename?: "AccountsMsMeResponseCustomerUserPublicVisa";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  /**  The account id  */
  accountId: Scalars["ID"]["output"];
  /**  True if the account is active  */
  accountIsActive: Scalars["Boolean"]["output"];
  /**  The customer account number  */
  customerAccountNumber: Scalars["String"]["output"];
  /**  The exhaustive list of feature codes  */
  features?: Maybe<Array<AccountsMsMeResponseCustomerUserPublicVisaFeatures>>;
  /**  True if the user owns this account  */
  owner: Scalars["Boolean"]["output"];
  /**  An exhaustive list of user roles for the given account  */
  roles?: Maybe<Array<AccountsMsMeResponseCustomerUserPublicVisaRoles>>;
};

/**  The exhaustive list of feature codes  */
export enum AccountsMsMeResponseCustomerUserPublicVisaFeatures {
  BlockLedger = "BLOCK_LEDGER",
  CancelLedgerOrder = "CANCEL_LEDGER_ORDER",
  CollaboratorsForcedRestricted = "COLLABORATORS_FORCED_RESTRICTED",
  CreateLedger = "CREATE_LEDGER",
  DisplayPinCodePortal = "DISPLAY_PIN_CODE_PORTAL",
  DownloadAllTransactionsMobilityCorporate = "DOWNLOAD_ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  DownloadAllTransactionsReport = "DOWNLOAD_ALL_TRANSACTIONS_REPORT",
  DownloadBudgetReport = "DOWNLOAD_BUDGET_REPORT",
  DownloadDriverCodeReport = "DOWNLOAD_DRIVER_CODE_REPORT",
  DownloadInvoice = "DOWNLOAD_INVOICE",
  DownloadInvoiceFilesTid = "DOWNLOAD_INVOICE_FILES_TID",
  DownloadLedgersStatusesReport = "DOWNLOAD_LEDGERS_STATUSES_REPORT",
  DownloadMileageReport = "DOWNLOAD_MILEAGE_REPORT",
  DownloadReportDetailedEvTransactions = "DOWNLOAD_REPORT_DETAILED_EV_TRANSACTIONS",
  DownloadThermalConsumptionReport = "DOWNLOAD_THERMAL_CONSUMPTION_REPORT",
  DownloadTid = "DOWNLOAD_TID",
  DownloadTollPassages = "DOWNLOAD_TOLL_PASSAGES",
  DownloadTransactions = "DOWNLOAD_TRANSACTIONS",
  DownloadTransactionsFridayMondayReport = "DOWNLOAD_TRANSACTIONS_FRIDAY_MONDAY_REPORT",
  DownloadTransactionsWeekendHolidaysReport = "DOWNLOAD_TRANSACTIONS_WEEKEND_HOLIDAYS_REPORT",
  DownloadTransactionAnomalies = "DOWNLOAD_TRANSACTION_ANOMALIES",
  DownloadTransactionAnomalies_24 = "DOWNLOAD_TRANSACTION_ANOMALIES_24",
  DownloadTransactionDetailsPdf = "DOWNLOAD_TRANSACTION_DETAILS_PDF",
  DownloadTruckPositions = "DOWNLOAD_TRUCK_POSITIONS",
  DriverCodes = "DRIVER_CODES",
  FeatureUndefined = "FEATURE_UNDEFINED",
  Kpi = "KPI",
  ListInvoices = "LIST_INVOICES",
  ListLedgers = "LIST_LEDGERS",
  ListTransactions = "LIST_TRANSACTIONS",
  ManageCollaborators = "MANAGE_COLLABORATORS",
  ManageDivision = "MANAGE_DIVISION",
  ManageGuaranteePayment = "MANAGE_GUARANTEE_PAYMENT",
  ManageInvoicePayment = "MANAGE_INVOICE_PAYMENT",
  ManageLedgerAssignments = "MANAGE_LEDGER_ASSIGNMENTS",
  ManageLedgerRenewal = "MANAGE_LEDGER_RENEWAL",
  ManageMileages = "MANAGE_MILEAGES",
  ManageReportPlan = "MANAGE_REPORT_PLAN",
  ManageRestrictions = "MANAGE_RESTRICTIONS",
  ManageRolesProfiles = "MANAGE_ROLES_PROFILES",
  ManageSectors = "MANAGE_SECTORS",
  ManageUsers = "MANAGE_USERS",
  ManageUserRolesProfiles = "MANAGE_USER_ROLES_PROFILES",
  ManageVehicles = "MANAGE_VEHICLES",
  MobilityCorporate = "MOBILITY_CORPORATE",
  PriceCeilingReport = "PRICE_CEILING_REPORT",
  RedirectionPassalert = "REDIRECTION_PASSALERT",
  RedirectionSva = "REDIRECTION_SVA",
  ResendPinCode = "RESEND_PIN_CODE",
  ResendPinCodeByPaperMail = "RESEND_PIN_CODE_BY_PAPER_MAIL",
  SaeEvLimitNotification = "SAE_EV_LIMIT_NOTIFICATION",
  SubscriptionMailAnomalies_24 = "SUBSCRIPTION_MAIL_ANOMALIES_24",
  SubscriptionMailAnomaliesLedgers = "SUBSCRIPTION_MAIL_ANOMALIES_LEDGERS",
  SubscriptionMailRemainingBalance = "SUBSCRIPTION_MAIL_REMAINING_BALANCE",
  TaxExemption = "TAX_EXEMPTION",
  UpdateLedger = "UPDATE_LEDGER",
}

/**  An exhaustive list of user roles for the given account  */
export enum AccountsMsMeResponseCustomerUserPublicVisaRoles {
  RoleAdmin = "ROLE_ADMIN",
  RoleAlerts = "ROLE_ALERTS",
  RoleAssignmentCreate = "ROLE_ASSIGNMENT_CREATE",
  RoleAssignmentDelete = "ROLE_ASSIGNMENT_DELETE",
  RoleAssignmentUpdate = "ROLE_ASSIGNMENT_UPDATE",
  RoleAssignmentView = "ROLE_ASSIGNMENT_VIEW",
  RoleBilling = "ROLE_BILLING",
  RoleBillingGuaranteeManager = "ROLE_BILLING_GUARANTEE_MANAGER",
  RoleBillingInvoiceDownload = "ROLE_BILLING_INVOICE_DOWNLOAD",
  RoleBillingInvoiceManager = "ROLE_BILLING_INVOICE_MANAGER",
  RoleBillingInvoicePayment = "ROLE_BILLING_INVOICE_PAYMENT",
  RoleBillingInvoiceView = "ROLE_BILLING_INVOICE_VIEW",
  RoleBillingTidManager = "ROLE_BILLING_TID_MANAGER",
  RoleBillingTransactionPdf = "ROLE_BILLING_TRANSACTION_PDF",
  RoleCollaboratorArchive = "ROLE_COLLABORATOR_ARCHIVE",
  RoleCollaboratorCreate = "ROLE_COLLABORATOR_CREATE",
  RoleCollaboratorDelete = "ROLE_COLLABORATOR_DELETE",
  RoleCollaboratorManager = "ROLE_COLLABORATOR_MANAGER",
  RoleCollaboratorSupervisor = "ROLE_COLLABORATOR_SUPERVISOR",
  RoleCollaboratorUpdate = "ROLE_COLLABORATOR_UPDATE",
  RoleCollaboratorView = "ROLE_COLLABORATOR_VIEW",
  RoleContractManager = "ROLE_CONTRACT_MANAGER",
  RoleContractView = "ROLE_CONTRACT_VIEW",
  RoleDocumentEoyStatement = "ROLE_DOCUMENT_EOY_STATEMENT",
  RoleDocumentManager = "ROLE_DOCUMENT_MANAGER",
  RoleDriverCodeCreate = "ROLE_DRIVER_CODE_CREATE",
  RoleDriverCodeLink = "ROLE_DRIVER_CODE_LINK",
  RoleDriverCodeManager = "ROLE_DRIVER_CODE_MANAGER",
  RoleDriverCodeReport = "ROLE_DRIVER_CODE_REPORT",
  RoleDriverCodeUpdate = "ROLE_DRIVER_CODE_UPDATE",
  RoleDriverCodeView = "ROLE_DRIVER_CODE_VIEW",
  RoleLedgers = "ROLE_LEDGERS",
  RoleLedgersDivisionCreate = "ROLE_LEDGERS_DIVISION_CREATE",
  RoleLedgersDivisionManager = "ROLE_LEDGERS_DIVISION_MANAGER",
  RoleLedgersDivisionUpdate = "ROLE_LEDGERS_DIVISION_UPDATE",
  RoleLedgersDivisionView = "ROLE_LEDGERS_DIVISION_VIEW",
  RoleLedgersLedgerBlock = "ROLE_LEDGERS_LEDGER_BLOCK",
  RoleLedgersLedgerCancelRenewal = "ROLE_LEDGERS_LEDGER_CANCEL_RENEWAL",
  RoleLedgersLedgerCreate = "ROLE_LEDGERS_LEDGER_CREATE",
  RoleLedgersLedgerExportSupportConfig = "ROLE_LEDGERS_LEDGER_EXPORT_SUPPORT_CONFIG",
  RoleLedgersLedgerManager = "ROLE_LEDGERS_LEDGER_MANAGER",
  RoleLedgersLedgerUpdate = "ROLE_LEDGERS_LEDGER_UPDATE",
  RoleLedgersLedgerView = "ROLE_LEDGERS_LEDGER_VIEW",
  RoleLedgersMcExpensesView = "ROLE_LEDGERS_MC_EXPENSES_VIEW",
  RoleLedgersMcManager = "ROLE_LEDGERS_MC_MANAGER",
  RoleLedgersQuotaEvAlerting = "ROLE_LEDGERS_QUOTA_EV_ALERTING",
  RoleLedgersQuotaManager = "ROLE_LEDGERS_QUOTA_MANAGER",
  RoleLedgersResendPinCode = "ROLE_LEDGERS_RESEND_PIN_CODE",
  RoleLedgersTransactionAllTransactionsMobilityCorporate = "ROLE_LEDGERS_TRANSACTION_ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  RoleLedgersTransactionAnomalies_24 = "ROLE_LEDGERS_TRANSACTION_ANOMALIES_24",
  RoleLedgersTransactionAnomaliesLedgers = "ROLE_LEDGERS_TRANSACTION_ANOMALIES_LEDGERS",
  RoleLedgersTransactionExportTransactions = "ROLE_LEDGERS_TRANSACTION_EXPORT_TRANSACTIONS",
  RoleLedgersTransactionManager = "ROLE_LEDGERS_TRANSACTION_MANAGER",
  RoleLedgersTransactionReportConsumptionMonitoring = "ROLE_LEDGERS_TRANSACTION_REPORT_CONSUMPTION_MONITORING",
  RoleLedgersTransactionReportCostTracking = "ROLE_LEDGERS_TRANSACTION_REPORT_COST_TRACKING",
  RoleLedgersTransactionReportDetailedEvTransactions = "ROLE_LEDGERS_TRANSACTION_REPORT_DETAILED_EV_TRANSACTIONS",
  RoleLedgersTransactionReportMileage = "ROLE_LEDGERS_TRANSACTION_REPORT_MILEAGE",
  RoleLedgersTransactionReportPriceCeiling = "ROLE_LEDGERS_TRANSACTION_REPORT_PRICE_CEILING",
  RoleLedgersTransactionReportTransactionsFridayMonday = "ROLE_LEDGERS_TRANSACTION_REPORT_TRANSACTIONS_FRIDAY_MONDAY",
  RoleLedgersTransactionReportTransactionsWeekendHolidays = "ROLE_LEDGERS_TRANSACTION_REPORT_TRANSACTIONS_WEEKEND_HOLIDAYS",
  RoleLedgersTransactionTollPassages = "ROLE_LEDGERS_TRANSACTION_TOLL_PASSAGES",
  RoleLedgersTransactionTruckPositions = "ROLE_LEDGERS_TRANSACTION_TRUCK_POSITIONS",
  RoleLedgersTransactionView = "ROLE_LEDGERS_TRANSACTION_VIEW",
  RoleLedgersWalletManager = "ROLE_LEDGERS_WALLET_MANAGER",
  RoleLedgersWalletRemainingBalance = "ROLE_LEDGERS_WALLET_REMAINING_BALANCE",
  RoleLedgersWalletView = "ROLE_LEDGERS_WALLET_VIEW",
  RoleLedgerAssignment = "ROLE_LEDGER_ASSIGNMENT",
  RoleLedgerAssignmentManager = "ROLE_LEDGER_ASSIGNMENT_MANAGER",
  RoleMedia = "ROLE_MEDIA",
  RoleNotification = "ROLE_NOTIFICATION",
  RoleNotificationManager = "ROLE_NOTIFICATION_MANAGER",
  RoleNotificationSubscription = "ROLE_NOTIFICATION_SUBSCRIPTION",
  RolePassango = "ROLE_PASSANGO",
  RoleRedirectToPassalert = "ROLE_REDIRECT_TO_PASSALERT",
  RoleRedirectToSva = "ROLE_REDIRECT_TO_SVA",
  RoleReporting = "ROLE_REPORTING",
  RoleReportAdvanced = "ROLE_REPORT_ADVANCED",
  RoleReportBasic = "ROLE_REPORT_BASIC",
  RoleReportManager = "ROLE_REPORT_MANAGER",
  RoleRolesProfileCreate = "ROLE_ROLES_PROFILE_CREATE",
  RoleRolesProfileDelete = "ROLE_ROLES_PROFILE_DELETE",
  RoleRolesProfileLink = "ROLE_ROLES_PROFILE_LINK",
  RoleRolesProfileLinker = "ROLE_ROLES_PROFILE_LINKER",
  RoleRolesProfileManager = "ROLE_ROLES_PROFILE_MANAGER",
  RoleRolesProfileUnlink = "ROLE_ROLES_PROFILE_UNLINK",
  RoleRolesProfileUpdate = "ROLE_ROLES_PROFILE_UPDATE",
  RoleRolesProfileView = "ROLE_ROLES_PROFILE_VIEW",
  RoleSectorCreate = "ROLE_SECTOR_CREATE",
  RoleSectorDelete = "ROLE_SECTOR_DELETE",
  RoleSectorManager = "ROLE_SECTOR_MANAGER",
  RoleSectorUpdate = "ROLE_SECTOR_UPDATE",
  RoleSectorView = "ROLE_SECTOR_VIEW",
  RoleTransaction = "ROLE_TRANSACTION",
  RoleTransactionAnomalies = "ROLE_TRANSACTION_ANOMALIES",
  RoleTransactionAnomalies_24 = "ROLE_TRANSACTION_ANOMALIES_24",
  RoleTransactionManager = "ROLE_TRANSACTION_MANAGER",
  RoleUndefined = "ROLE_UNDEFINED",
  RoleUserAccounts = "ROLE_USER_ACCOUNTS",
  RoleUserArchive = "ROLE_USER_ARCHIVE",
  RoleUserCreate = "ROLE_USER_CREATE",
  RoleUserDelete = "ROLE_USER_DELETE",
  RoleUserDuplicate = "ROLE_USER_DUPLICATE",
  RoleUserInvite = "ROLE_USER_INVITE",
  RoleUserManager = "ROLE_USER_MANAGER",
  RoleUserUpdate = "ROLE_USER_UPDATE",
  RoleUserView = "ROLE_USER_VIEW",
  RoleVehicle = "ROLE_VEHICLE",
  RoleVehicleArchive = "ROLE_VEHICLE_ARCHIVE",
  RoleVehicleCreate = "ROLE_VEHICLE_CREATE",
  RoleVehicleDelete = "ROLE_VEHICLE_DELETE",
  RoleVehicleManager = "ROLE_VEHICLE_MANAGER",
  RoleVehicleUpdate = "ROLE_VEHICLE_UPDATE",
  RoleVehicleView = "ROLE_VEHICLE_VIEW",
}

export type AccountsMsMeResponseSupportUser = {
  __typename?: "AccountsMsMeResponseSupportUser";
  /**  The support user's email  */
  email: Scalars["String"]["output"];
  /**  The support user's first name  */
  firstName: Scalars["String"]["output"];
  /**  The support user's igg  */
  igg: Scalars["String"]["output"];
  /**  The support user's last name  */
  lastName: Scalars["String"]["output"];
  /**  The global user rights  */
  rights?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The support user's agency subsidiaries  */
  subsidiaries?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type AccountsMsPagedPagination = {
  __typename?: "AccountsMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type AccountsMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AccountsMsReadRolesProfileRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsReadRolesProfileResponse = {
  __typename?: "AccountsMsReadRolesProfileResponse";
  data: AccountsMsRolesProfile;
  deletable: Scalars["Boolean"]["output"];
};

/**  Resend invitation  */
export type AccountsMsResendInviteUserNotificationRequest = {
  privilegeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsResendInviteUserNotificationResponse = {
  __typename?: "AccountsMsResendInviteUserNotificationResponse";
  /**  After how many seconds the invitation can be sent again, zero if the notification can be sent right away.  */
  retryableInSeconds: Scalars["Int64"]["output"];
  /**  If the invitation has been sent.  */
  sent: Scalars["Boolean"]["output"];
};

export type AccountsMsRolesProfile = {
  __typename?: "AccountsMsRolesProfile";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  ParentIdData?: Maybe<AccountsMsSearchRolesProfilesResponseData>;
  RootIdData?: Maybe<AccountsMsSearchRolesProfilesResponseData>;
  /**  An optional account id when the roles profiles belongs to an account  */
  accountId: Scalars["ID"]["output"];
  /**  The system code  */
  code: Scalars["String"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  The ID of a RolesProfile  */
  id: Scalars["ID"]["output"];
  /**  The roles profiles label  */
  name: Scalars["String"]["output"];
  /**  The parent ID of a RolesProfile  */
  parentId: Scalars["ID"]["output"];
  /**  The roles profiles roles. When the roles profiles is nested, the roles options are narrowed down to the parent roles.  */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The root of a RolesProfile when nested  */
  rootId: Scalars["ID"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

/**  Get the account information & preferences  */
export type AccountsMsSearchAccountsRequest = {
  filters?: InputMaybe<AccountsMsSearchAccountsRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<AccountsMsSearchAccountsRequestSort>>>;
};

export type AccountsMsSearchAccountsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  number?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsSearchAccountsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchAccountsRequestSortField>;
};

export enum AccountsMsSearchAccountsRequestSortField {
  CreatedTs = "created_ts",
  Name = "name",
  Number = "number",
  PreferredLocale = "preferred_locale",
  RegistrationName = "registration_name",
}

export type AccountsMsSearchAccountsResponse = {
  __typename?: "AccountsMsSearchAccountsResponse";
  data?: Maybe<Array<AccountsMsSearchAccountsResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchAccountsResponseData = {
  __typename?: "AccountsMsSearchAccountsResponseData";
  CurrentContractIdData?: Maybe<AccountsMsSearchContractsResponseData>;
  MainPrivilegeIdData?: Maybe<AccountsMsSearchPrivilegesResponseData>;
  /**  The physical address of the customer  */
  address: Scalars["String"]["output"];
  /**  The physical city of the customer  */
  city: Scalars["String"]["output"];
  /**  The physical country of the customer encoded in ISO 3166-1 standard  */
  country: Scalars["String"]["output"];
  createdTs: Scalars["String"]["output"];
  /**  The current contract  */
  currentContractId: Scalars["ID"]["output"];
  /**  The ID of an account  */
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  /**  The privilege of the main user, the owner of the account.  */
  mainPrivilegeId: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  /**  The internal customer code inside TotalEnergies  */
  number: Scalars["String"]["output"];
  /**  The pre-filled locale used to create users  */
  preferredLocale: Scalars["String"]["output"];
  /**  The pre-filled timezone used to create users  */
  preferredTimezone: Scalars["String"]["output"];
  /**  Also named "Raison sociale"  */
  registrationName: Scalars["String"]["output"];
  /**  The registration number of the legal entity.  */
  registrationNumber: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  /**  The physical zip code of the customer  */
  zipCode: Scalars["String"]["output"];
};

/**  Search Agencies  */
export type AccountsMsSearchAgenciesRequest = {
  filters?: InputMaybe<AccountsMsSearchAgenciesRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<AccountsMsSearchAgenciesRequestSort>>>;
};

export type AccountsMsSearchAgenciesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsSearchAgenciesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchAgenciesRequestSortField>;
};

export enum AccountsMsSearchAgenciesRequestSortField {
  Name = "name",
}

export type AccountsMsSearchAgenciesResponse = {
  __typename?: "AccountsMsSearchAgenciesResponse";
  data?: Maybe<Array<AccountsMsSearchAgenciesResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchAgenciesResponseData = {
  __typename?: "AccountsMsSearchAgenciesResponseData";
  createdTs: Scalars["Int64"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  subsidiaries?: Maybe<Array<Scalars["String"]["output"]>>;
  updatedTs: Scalars["Int64"]["output"];
};

/**
 *  Search among the logs
 * A customer user can see the actions that has been done for him/her
 * A super support agent can see all the actions among their subsidiaries
 */
export type AccountsMsSearchAuditLogsRequest = {
  filters?: InputMaybe<AccountsMsSearchAuditLogsRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<AccountsMsSearchAuditLogsRequestSort>>>;
};

export type AccountsMsSearchAuditLogsRequestFilters = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  agentIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type AccountsMsSearchAuditLogsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchAuditLogsRequestSortField>;
};

export enum AccountsMsSearchAuditLogsRequestSortField {
  Agent = "agent",
  Id = "id",
  User = "user",
  WhenTs = "when_ts",
}

export type AccountsMsSearchAuditLogsResponse = {
  __typename?: "AccountsMsSearchAuditLogsResponse";
  data?: Maybe<Array<AccountsMsSearchAuditLogsResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchAuditLogsResponseData = {
  __typename?: "AccountsMsSearchAuditLogsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  AgentIdData?: Maybe<AccountsMsSearchSupportUsersResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  The related account (optional)  */
  accountId: Scalars["ID"]["output"];
  /**  The audit code  */
  action: Scalars["String"]["output"];
  /**  The agent user id  */
  agentId: Scalars["ID"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  The ID of a Account feature  */
  id: Scalars["ID"]["output"];
  /**  A base64 JSON representation of the payload (optional)  */
  payload: Scalars["String"]["output"];
  /**  The impersonated user id  */
  userId: Scalars["ID"]["output"];
  /**  A timestamp in sec of the action  */
  whenTs: Scalars["Int64"]["output"];
};

/**  Search among Contracts  */
export type AccountsMsSearchContractsRequest = {
  filters?: InputMaybe<AccountsMsSearchContractsRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<AccountsMsSearchContractsRequestSort>>>;
};

export type AccountsMsSearchContractsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  customerAccountNumber?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsSearchContractsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchContractsRequestSortField>;
};

export enum AccountsMsSearchContractsRequestSortField {
  Id = "id",
  Reference = "reference",
}

export type AccountsMsSearchContractsResponse = {
  __typename?: "AccountsMsSearchContractsResponse";
  data?: Maybe<Array<AccountsMsSearchContractsResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchContractsResponseData = {
  __typename?: "AccountsMsSearchContractsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  /**  The related account  */
  accountId: Scalars["String"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  The ID of a Contract  */
  id: Scalars["ID"]["output"];
  /**  True if the contract is active  */
  isActive: Scalars["Boolean"]["output"];
  /**  The last date when the contract were active  */
  lastActiveTs: Scalars["Int64"]["output"];
  /**  The reference of the offer  */
  offerCode: Scalars["String"]["output"];
  /**  The name of the offer  */
  offerName: Scalars["String"]["output"];
  /**  The list of products (card, badges or other supports), also name PCOM in MSA  */
  pcomList?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The reference of a contract (contract number)  */
  reference: Scalars["String"]["output"];
  /**  The reference of the contract in salsa (contract id)  */
  revision: Scalars["String"]["output"];
  /**  The list of commercial services, also name SCOM in MSA  */
  scomList?: Maybe<Array<Scalars["String"]["output"]>>;
  updatedTs: Scalars["Int64"]["output"];
};

/**  Search among current user's privileges  */
export type AccountsMsSearchOwnPrivilegesRequest = {
  filters?: InputMaybe<AccountsMsSearchOwnPrivilegesRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<AccountsMsSearchOwnPrivilegesRequestSort>>
  >;
};

export type AccountsMsSearchOwnPrivilegesRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsSearchOwnPrivilegesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchOwnPrivilegesRequestSortField>;
};

export enum AccountsMsSearchOwnPrivilegesRequestSortField {
  AccountId = "account_id",
  AccountName = "account_name",
  AccountNumber = "account_number",
  Id = "id",
}

export type AccountsMsSearchOwnPrivilegesResponse = {
  __typename?: "AccountsMsSearchOwnPrivilegesResponse";
  data?: Maybe<Array<AccountsMsSearchOwnPrivilegesResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchOwnPrivilegesResponseData = {
  __typename?: "AccountsMsSearchOwnPrivilegesResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  InvitedByIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  Subscriptions?: Maybe<
    Array<Maybe<AccountsMsSearchPrivilegeSubscriptionsResponseData>>
  >;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**
   *  When the given privileged has been revoked, used when we want to deactivate a privilege.
   * Gives the info that the privilege is disabled or enabled
   */
  disabledTs: Scalars["Int64"]["output"];
  /**
   *  Set when
   * - we activate a privilege,
   * - the user access an account for the first time after being invited.
   * - the user has been imported
   */
  enabledLastTs: Scalars["Int64"]["output"];
  /**  The ID of a Privilege  */
  id: Scalars["ID"]["output"];
  /**  The user who created this privilege (if there is such)  */
  invitedById: Scalars["ID"]["output"];
  /**  Set when the user has been invited on the account along with the inviter.  */
  invitedTs: Scalars["Int64"]["output"];
  /**  When the privilege has been used for the last time.  */
  lastUsedTs: Scalars["Int64"]["output"];
  owner: Scalars["Boolean"]["output"];
  /**  The factorized privileges  */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  status: AccountsMsSearchOwnPrivilegesResponseDataStatus;
};

export enum AccountsMsSearchOwnPrivilegesResponseDataStatus {
  Active = "ACTIVE",
  Deleted = "DELETED",
  Inactive = "INACTIVE",
  Inviting = "INVITING",
  PrivilegeStatusUnknown = "PRIVILEGE_STATUS_UNKNOWN",
  Suspended = "SUSPENDED",
}

/**  Search among user-account privileges  */
export type AccountsMsSearchPlatformAccessesRequest = {
  filters?: InputMaybe<AccountsMsSearchPlatformAccessesRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<AccountsMsSearchPlatformAccessesRequestSort>>
  >;
};

export type AccountsMsSearchPlatformAccessesRequestFilters = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  cognitoIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  gigyaIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  iggs?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type AccountsMsSearchPlatformAccessesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchPlatformAccessesRequestSortField>;
};

export enum AccountsMsSearchPlatformAccessesRequestSortField {
  Id = "id",
}

export type AccountsMsSearchPlatformAccessesResponse = {
  __typename?: "AccountsMsSearchPlatformAccessesResponse";
  data?: Maybe<Array<AccountsMsSearchPlatformAccessesResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchPlatformAccessesResponseData = {
  __typename?: "AccountsMsSearchPlatformAccessesResponseData";
  /**  Client Id  */
  clientId: Scalars["String"]["output"];
  /**  The JWT subject provided by Cognito.  */
  cognitoId: Scalars["String"]["output"];
  /**  TE Connect  */
  gigyaId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /**  Digital Pass identifier  */
  igg: Scalars["String"]["output"];
  /**  The last time the platform has been accessed with.  */
  lastAccessTs: Scalars["Int64"]["output"];
  /**  When the access has been or will be suspended, 0 when the access is not suspended.  */
  suspendedTs: Scalars["Int64"]["output"];
};

/**  Search privilege restrictions  */
export type AccountsMsSearchPrivilegeRestrictionsRequest = {
  filters?: InputMaybe<AccountsMsSearchPrivilegeRestrictionsRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<AccountsMsSearchPrivilegeRestrictionsRequestSort>>
  >;
};

export type AccountsMsSearchPrivilegeRestrictionsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  privilegeIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  showAll?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccountsMsSearchPrivilegeRestrictionsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchPrivilegeRestrictionsRequestSortField>;
};

export enum AccountsMsSearchPrivilegeRestrictionsRequestSortField {
  FromTs = "from_ts",
  Id = "id",
  PrivilegeId = "privilege_id",
  SectorId = "sector_id",
}

export type AccountsMsSearchPrivilegeRestrictionsResponse = {
  __typename?: "AccountsMsSearchPrivilegeRestrictionsResponse";
  data?: Maybe<Array<AccountsMsSearchPrivilegeRestrictionsResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchPrivilegeRestrictionsResponseData = {
  __typename?: "AccountsMsSearchPrivilegeRestrictionsResponseData";
  PrivilegeIdData?: Maybe<AccountsMsSearchPrivilegesResponseData>;
  SectorIdData?: Maybe<SectorsMsSearchSectorsResponseData>;
  /**  The restriction starting date  */
  fromTs: Scalars["Int64"]["output"];
  /**  The restriction id  */
  id: Scalars["ID"]["output"];
  /**  The related privilege  */
  privilegeId: Scalars["ID"]["output"];
  /**  The related sector  */
  sectorId: Scalars["ID"]["output"];
  /**  When the restriction ended. It is kept empty while the restriction is active.  */
  tillTs: Scalars["Int64"]["output"];
};

/**  Search among privilege subscriptions  */
export type AccountsMsSearchPrivilegeSubscriptionsRequest = {
  filters?: InputMaybe<AccountsMsSearchPrivilegeSubscriptionsRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<AccountsMsSearchPrivilegeSubscriptionsRequestSort>>
  >;
};

export type AccountsMsSearchPrivilegeSubscriptionsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  privilegeIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  rolesProfileIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**
   *  Only active subscriptions are retrieved by default (at the current time).
   * This filter allows to get both active and inactive subscriptions
   */
  showAll?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccountsMsSearchPrivilegeSubscriptionsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchPrivilegeSubscriptionsRequestSortField>;
};

export enum AccountsMsSearchPrivilegeSubscriptionsRequestSortField {
  Id = "id",
  RolesProfile = "roles_profile",
  UpdatedTs = "updated_ts",
}

export type AccountsMsSearchPrivilegeSubscriptionsResponse = {
  __typename?: "AccountsMsSearchPrivilegeSubscriptionsResponse";
  data?: Maybe<Array<AccountsMsSearchPrivilegeSubscriptionsResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchPrivilegeSubscriptionsResponseData = {
  __typename?: "AccountsMsSearchPrivilegeSubscriptionsResponseData";
  PrivilegeIdData?: Maybe<AccountsMsSearchPrivilegesResponseData>;
  RolesProfileIdData?: Maybe<AccountsMsSearchRolesProfilesResponseData>;
  /**  The equivalent of a created date  */
  fromTs: Scalars["Int64"]["output"];
  /**  The subscription id  */
  id: Scalars["ID"]["output"];
  /**  The related privilege  */
  privilegeId: Scalars["ID"]["output"];
  /**  The related roles profile  */
  rolesProfileId: Scalars["ID"]["output"];
  /**  When the subscription ended, empty if the subscription is still active (future dates are not supported).  */
  tillTs: Scalars["Int64"]["output"];
};

/**  Search among user-account privileges  */
export type AccountsMsSearchPrivilegesRequest = {
  filters?: InputMaybe<AccountsMsSearchPrivilegesRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<AccountsMsSearchPrivilegesRequestSort>>>;
};

export type AccountsMsSearchPrivilegesRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  activeRolesProfileIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ownersOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  query?: InputMaybe<AccountsMsSearchPrivilegesRequestFiltersQuery>;
  showDisabledUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  showEnabledUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  showInvitedUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsSearchPrivilegesRequestFiltersQuery = {
  account?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsSearchPrivilegesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchPrivilegesRequestSortField>;
};

export enum AccountsMsSearchPrivilegesRequestSortField {
  AccountId = "account_id",
  Id = "id",
  UserId = "user_id",
}

export type AccountsMsSearchPrivilegesResponse = {
  __typename?: "AccountsMsSearchPrivilegesResponse";
  data?: Maybe<Array<AccountsMsSearchPrivilegesResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchPrivilegesResponseData = {
  __typename?: "AccountsMsSearchPrivilegesResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  InvitedByIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  Subscriptions?: Maybe<
    Array<Maybe<AccountsMsSearchPrivilegeSubscriptionsResponseData>>
  >;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**
   *  When the given privileged has been revoked, used when we want to deactivate a privilege.
   * Gives the info that the privilege is disabled or enabled
   */
  disabledTs: Scalars["Int64"]["output"];
  /**
   *  Set when
   * - we activate a privilege,
   * - the user access an account for the first time after being invited.
   * - the user has been imported
   */
  enabledLastTs: Scalars["Int64"]["output"];
  /**  The ID of a Privilege  */
  id: Scalars["ID"]["output"];
  /**  Set when the user accepts invitation on the account along with the inviter.  */
  invitationAcceptedTs: Scalars["Int64"]["output"];
  /**  The user who created this privilege (if there is such)  */
  invitedById: Scalars["ID"]["output"];
  /**  Set when the user has been invited on the account along with the inviter.  */
  invitedTs: Scalars["Int64"]["output"];
  /**  When the privilege has been used for the last time.  */
  lastUsedTs: Scalars["Int64"]["output"];
  owner: Scalars["Boolean"]["output"];
  /**  The factorized privileges  */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  Set when the roles should be computed again  */
  rolesInvalidatedTs: Scalars["Int64"]["output"];
  status: AccountsMsSearchPrivilegesResponseDataStatus;
  /**  The related user  */
  userId: Scalars["ID"]["output"];
};

export enum AccountsMsSearchPrivilegesResponseDataStatus {
  Active = "ACTIVE",
  Deleted = "DELETED",
  Inactive = "INACTIVE",
  Inviting = "INVITING",
  PrivilegeStatusUnknown = "PRIVILEGE_STATUS_UNKNOWN",
  Suspended = "SUSPENDED",
}

/**  Search among roles profiles  */
export type AccountsMsSearchRolesProfilesRequest = {
  filters?: InputMaybe<AccountsMsSearchRolesProfilesRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<AccountsMsSearchRolesProfilesRequestSort>>
  >;
};

export type AccountsMsSearchRolesProfilesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type AccountsMsSearchRolesProfilesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchRolesProfilesRequestSortField>;
};

export enum AccountsMsSearchRolesProfilesRequestSortField {
  Name = "name",
}

export type AccountsMsSearchRolesProfilesResponse = {
  __typename?: "AccountsMsSearchRolesProfilesResponse";
  data?: Maybe<Array<AccountsMsSearchRolesProfilesResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchRolesProfilesResponseData = {
  __typename?: "AccountsMsSearchRolesProfilesResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  ParentIdData?: Maybe<AccountsMsSearchRolesProfilesResponseData>;
  RootIdData?: Maybe<AccountsMsSearchRolesProfilesResponseData>;
  Subscriptions?: Maybe<
    Array<Maybe<AccountsMsSearchPrivilegeSubscriptionsResponseData>>
  >;
  /**  An optional account id when the roles profiles belongs to an account  */
  accountId: Scalars["String"]["output"];
  /**
   *  Only present for system roles profile
   * see fixtures to know which value you'll have
   */
  code: Scalars["String"]["output"];
  /**  The ID of a RolesProfile  */
  id: Scalars["ID"]["output"];
  /**  The roles profiles label  */
  name: Scalars["String"]["output"];
  /**
   *  fixme:
   * As we can not bind CountUsersInRolesProfile with a graphql relation
   * we have decided to add this attribute on search
   * @Pierre please, do something
   */
  numberOfUsers: AccountsMsSearchRolesProfilesResponseDataNumberOfUsers;
  /**  The parent ID of a RolesProfile  */
  parentId: Scalars["String"]["output"];
  /**  The roles profiles roles. When the roles profiles is nested, the roles options are narrowed down to the parent roles.  */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The root of a RolesProfile when nested  */
  rootId: Scalars["String"]["output"];
  system: Scalars["Boolean"]["output"];
};

/**
 *  fixme:
 * As we can not bind CountUsersInRolesProfile with a graphql relation
 * we have decided to add this attribute on search
 * @Pierre please, do something
 */
export type AccountsMsSearchRolesProfilesResponseDataNumberOfUsers = {
  __typename?: "AccountsMsSearchRolesProfilesResponseDataNumberOfUsers";
  disabled: Scalars["Int64"]["output"];
  enabled: Scalars["Int64"]["output"];
  inviting: Scalars["Int64"]["output"];
  total: Scalars["Int64"]["output"];
};

/**  Search among support users  */
export type AccountsMsSearchSupportUsersRequest = {
  filters?: InputMaybe<AccountsMsSearchSupportUsersRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<AccountsMsSearchSupportUsersRequestSort>>
  >;
};

export type AccountsMsSearchSupportUsersRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  igg?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<AccountsMsSearchSupportUsersRequestFiltersStatus>;
};

export enum AccountsMsSearchSupportUsersRequestFiltersStatus {
  StatusUnknown = "STATUS_UNKNOWN",
  SupportUserDisabled = "SUPPORT_USER_DISABLED",
  SupportUserEnabled = "SUPPORT_USER_ENABLED",
  SupportUserInviting = "SUPPORT_USER_INVITING",
}

export type AccountsMsSearchSupportUsersRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchSupportUsersRequestSortField>;
};

export enum AccountsMsSearchSupportUsersRequestSortField {
  Email = "email",
  Id = "id",
  Igg = "igg",
  LastName = "lastName",
  Profile = "profile",
}

export type AccountsMsSearchSupportUsersResponse = {
  __typename?: "AccountsMsSearchSupportUsersResponse";
  data?: Maybe<Array<AccountsMsSearchSupportUsersResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchSupportUsersResponseData = {
  __typename?: "AccountsMsSearchSupportUsersResponseData";
  AccessIdData?: Maybe<AccountsMsSearchPlatformAccessesResponseData>;
  AgencyIdData?: Maybe<AccountsMsSearchAgenciesResponseData>;
  InvitedByData?: Maybe<AccountsMsSearchSupportUsersResponseData>;
  /**  The related access  */
  accessId: Scalars["ID"]["output"];
  agencyId: Scalars["ID"]["output"];
  createdTs: Scalars["Int64"]["output"];
  disabledTs: Scalars["Int64"]["output"];
  /**  The user email address  */
  email: Scalars["String"]["output"];
  /**  The first name  */
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  invitedBy: Scalars["String"]["output"];
  /**  The functions of the user  */
  jobTitle: Scalars["String"]["output"];
  /**  The last name  */
  lastName: Scalars["String"]["output"];
  profile: AccountsMsSearchSupportUsersResponseDataProfile;
  /**  The global rights of a user, despite of its accounts.  */
  rights?: Maybe<Array<Scalars["String"]["output"]>>;
  status: AccountsMsSearchSupportUsersResponseDataStatus;
};

export enum AccountsMsSearchSupportUsersResponseDataProfile {
  Agent = "AGENT",
  ProfileUnknown = "PROFILE_UNKNOWN",
  SuperAgent = "SUPER_AGENT",
}

export enum AccountsMsSearchSupportUsersResponseDataStatus {
  StatusUnknown = "STATUS_UNKNOWN",
  SupportUserDisabled = "SUPPORT_USER_DISABLED",
  SupportUserEnabled = "SUPPORT_USER_ENABLED",
  SupportUserInviting = "SUPPORT_USER_INVITING",
}

/**  Search among users  */
export type AccountsMsSearchUsersRequest = {
  filters?: InputMaybe<AccountsMsSearchUsersRequestFilters>;
  paging?: InputMaybe<AccountsMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<AccountsMsSearchUsersRequestSort>>>;
};

export type AccountsMsSearchUsersRequestFilters = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  Find a user using multiple criteria  */
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsSearchUsersRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AccountsMsSearchUsersRequestSortField>;
};

export enum AccountsMsSearchUsersRequestSortField {
  Email = "email",
  FirstName = "first_name",
  Id = "id",
  LastName = "last_name",
}

export type AccountsMsSearchUsersResponse = {
  __typename?: "AccountsMsSearchUsersResponse";
  data?: Maybe<Array<AccountsMsSearchUsersResponseData>>;
  pagination: AccountsMsPagedPagination;
};

export type AccountsMsSearchUsersResponseData = {
  __typename?: "AccountsMsSearchUsersResponseData";
  AccessIdData?: Maybe<AccountsMsSearchPlatformAccessesResponseData>;
  DefaultAccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  /**  The related access  */
  accessId: Scalars["ID"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  The related account  */
  defaultAccountId: Scalars["String"]["output"];
  /**  When the user received a deletion reminder  */
  deletedReminderSentTs: Scalars["Int64"]["output"];
  /**  When the user is/was scheduled for deletion  */
  deletedScheduledTs: Scalars["Int64"]["output"];
  /**  When the user was deleted  */
  deletedTs: Scalars["Int64"]["output"];
  /**  The user email address  */
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  /**  The ID of a User  */
  id: Scalars["ID"]["output"];
  /**  The functions of the user  */
  jobTitle: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  /**  The user's language-underscore-country following respectively the ISO 639-1 and ISO 3166-1 standards.  */
  locale: Scalars["String"]["output"];
  /**  The phone number of the user, prefixed with the country code (following E164 standard)  */
  phone: Scalars["String"]["output"];
  /**  The alternative phone number of the user, prefixed with the country code (following E164 standard)  */
  phoneAlt: Scalars["String"]["output"];
  /**  The last time of the user's profile shared data were updated.  */
  sharedUserProfileTs: Scalars["Int64"]["output"];
  /**  The user's timezone  */
  timezone: Scalars["String"]["output"];
  /**  When the use was welcomed on the portal  */
  welcomedTs: Scalars["Int64"]["output"];
};

/**  Defines the main account of the current user.  */
export type AccountsMsSetDefaultAccountRequest = {
  /**  An account id among the list of user's accounts  */
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsStartSessionResponse = {
  __typename?: "AccountsMsStartSessionResponse";
  accessToken: Scalars["String"]["output"];
};

/**
 *  Start a support session
 *
 * Start a session for a support operator, a session id will be created for a defined duration
 */
export type AccountsMsStartSupportRequest = {
  /**  The user id concerned by the support session  */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccountsMsStartSupportResponse = {
  __typename?: "AccountsMsStartSupportResponse";
  /**  When the code expires  */
  expiresTs: Scalars["Int64"]["output"];
  /**  The session id  */
  sessionId: Scalars["ID"]["output"];
};

/**  Link the user's privilege to a roles profile  */
export type AccountsMsSubscribePrivilegeRequest = {
  privilegeId?: InputMaybe<Scalars["ID"]["input"]>;
  rolesProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  /**
   *  Ask to unsubscribe to all other roles profiles
   * and keep only the one we subscribed for
   */
  unsubscribeAllOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**  Unlink user's privilege from from a roles profile  */
export type AccountsMsUnsubscribePrivilegeRequest = {
  subscriptionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Update the current user  */
export type AccountsMsUpdateMeRequest = {
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**  The user's language-underscore-country following respectively the ISO 639-1 and ISO 3166-1 standards.  */
  locale?: InputMaybe<Scalars["String"]["input"]>;
  /**  The phone number of the user, prefixed with the country code (following E164 standard)  */
  phone?: InputMaybe<Scalars["String"]["input"]>;
  /**  The alternative phone number of the user, prefixed with the country code (following E164 standard)  */
  phoneAlt?: InputMaybe<Scalars["String"]["input"]>;
  /**  The user's timezone  */
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsUpdateMyPersonalDataRequest = {
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**  The phone number of the user, prefixed with the country code (following E164 standard)  */
  phone?: InputMaybe<Scalars["String"]["input"]>;
  /**  The alternative phone number of the user, prefixed with the country code (following E164 standard)  */
  phoneAlt?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountsMsUpdateMyPersonalPreferencesRequest = {
  /**  The user's language-underscore-country following respectively the ISO 639-1 and ISO 3166-1 standards.  */
  locale?: InputMaybe<Scalars["String"]["input"]>;
  /**  The user's timezone  */
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

/**  Update privilege restrictions depending on the caller's restrictions  */
export type AccountsMsUpdatePrivilegeRestrictionsRequest = {
  /**  The privilege identifier  */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type AccountsMsUpdateRolesProfileRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  roles?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type AccountsMsUpdateRolesProfileResponse = {
  __typename?: "AccountsMsUpdateRolesProfileResponse";
  data: AccountsMsRolesProfile;
};

/**  Update support user. They must be active in order to be updated.  */
export type AccountsMsUpdateSupportUserRequest = {
  /**  The first name  */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**  The id of the support user  */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The functions of the user  */
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  /**  The last name  */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   *  The profile of the user
   * Be aware that a super agent can downgrade themselves
   */
  profile?: InputMaybe<AccountsMsUpdateSupportUserRequestProfile>;
  rights?: InputMaybe<AccountsMsUpdateSupportUserRequestRightsList>;
};

/**
 *  The profile of the user
 * Be aware that a super agent can downgrade themselves
 */
export enum AccountsMsUpdateSupportUserRequestProfile {
  Agent = "AGENT",
  ProfileUnknown = "PROFILE_UNKNOWN",
  SuperAgent = "SUPER_AGENT",
}

export type AccountsMsUpdateSupportUserRequestRightsList = {
  impersonate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**  Assign a collaborator to a ledger  */
export type AssignmentsMsAssignCollaboratorRequest = {
  /**  The collaborator id  */
  collaboratorId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The timespan of the start of the assignment  */
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The ledger id  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The timespan of the end of the assignment  */
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type AssignmentsMsAssignCollaboratorResponse = {
  __typename?: "AssignmentsMsAssignCollaboratorResponse";
  /**  The created assignment id  */
  id: Scalars["ID"]["output"];
};

/**  Assign a vehicle to a ledger  */
export type AssignmentsMsAssignVehicleRequest = {
  /**  The timespan of the start of the assignment  */
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The ledger id  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The timespan of the end of the assignment  */
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The vehicle id  */
  vehicleId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AssignmentsMsAssignVehicleResponse = {
  __typename?: "AssignmentsMsAssignVehicleResponse";
  /**  The created assignment id  */
  id: Scalars["ID"]["output"];
};

/**  Count assignments by status  */
export type AssignmentsMsCountAssignmentsByStatusRequest = {
  /**  The ledger id  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AssignmentsMsCountAssignmentsByStatusResponse = {
  __typename?: "AssignmentsMsCountAssignmentsByStatusResponse";
  collaborators: AssignmentsMsCountAssignmentsByStatusResponseTypeAssignmentsCount;
  vehicles: AssignmentsMsCountAssignmentsByStatusResponseTypeAssignmentsCount;
};

export type AssignmentsMsCountAssignmentsByStatusResponseTypeAssignmentsCount =
  {
    __typename?: "AssignmentsMsCountAssignmentsByStatusResponseTypeAssignmentsCount";
    all: Scalars["Int64"]["output"];
    archived: Scalars["Int64"]["output"];
    current: Scalars["Int64"]["output"];
    future: Scalars["Int64"]["output"];
  };

/**  Delete assignment  */
export type AssignmentsMsDeleteAssignmentRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Check if collaborator assignment is available for ledger  */
export type AssignmentsMsIsCollaboratorAssignmentAvailableRequest = {
  /**  The ledger id  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AssignmentsMsIsCollaboratorAssignmentAvailableResponse = {
  __typename?: "AssignmentsMsIsCollaboratorAssignmentAvailableResponse";
  available: Scalars["Boolean"]["output"];
};

export type AssignmentsMsPagedPagination = {
  __typename?: "AssignmentsMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type AssignmentsMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  Search among collaborator assignments  */
export type AssignmentsMsSearchCollaboratorAssignmentsRequest = {
  filters?: InputMaybe<AssignmentsMsSearchCollaboratorAssignmentsRequestFilters>;
  paging?: InputMaybe<AssignmentsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<AssignmentsMsSearchCollaboratorAssignmentsRequestSort>>
  >;
};

export type AssignmentsMsSearchCollaboratorAssignmentsRequestFilters = {
  /**  Find assignments around a period (that might overlap the period)  */
  around?: InputMaybe<AssignmentsMsSearchCollaboratorAssignmentsRequestFiltersAround>;
  collaboratorId?: InputMaybe<Scalars["ID"]["input"]>;
  collaboratorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  ledgerIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/**  Find assignments around a period (that might overlap the period)  */
export type AssignmentsMsSearchCollaboratorAssignmentsRequestFiltersAround = {
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  When not provided, it is considered infinite  */
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type AssignmentsMsSearchCollaboratorAssignmentsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AssignmentsMsSearchCollaboratorAssignmentsRequestSortField>;
};

export enum AssignmentsMsSearchCollaboratorAssignmentsRequestSortField {
  CollaboratorId = "collaborator_id",
  FromTs = "from_ts",
  Id = "id",
  LedgerId = "ledger_id",
  TillTs = "till_ts",
  UpdatedTs = "updated_ts",
}

export type AssignmentsMsSearchCollaboratorAssignmentsResponse = {
  __typename?: "AssignmentsMsSearchCollaboratorAssignmentsResponse";
  data?: Maybe<Array<AssignmentsMsSearchCollaboratorAssignmentsResponseData>>;
  pagination: AssignmentsMsPagedPagination;
};

export type AssignmentsMsSearchCollaboratorAssignmentsResponseData = {
  __typename?: "AssignmentsMsSearchCollaboratorAssignmentsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  CollaboratorIdData?: Maybe<CollaboratorsMsSearchCollaboratorsResponseData>;
  LedgerIdData?: Maybe<LedgersMsSearchLedgersResponseData>;
  accountId: Scalars["ID"]["output"];
  /**  The collaborator id  */
  collaboratorId: Scalars["ID"]["output"];
  /**  The ID of the assignment  */
  id: Scalars["ID"]["output"];
  /**  The ledger id  */
  ledgerId: Scalars["ID"]["output"];
  period: AssignmentsMsSearchCollaboratorAssignmentsResponseDataPeriod;
  status: AssignmentsMsSearchCollaboratorAssignmentsResponseDataStatus;
};

export type AssignmentsMsSearchCollaboratorAssignmentsResponseDataPeriod = {
  __typename?: "AssignmentsMsSearchCollaboratorAssignmentsResponseDataPeriod";
  fromTs: Scalars["Int64"]["output"];
  tillTs: Scalars["Int64"]["output"];
};

export enum AssignmentsMsSearchCollaboratorAssignmentsResponseDataStatus {
  AssignmentStatusUnknown = "ASSIGNMENT_STATUS_UNKNOWN",
  InComing = "IN_COMING",
  InProgress = "IN_PROGRESS",
  Passed = "PASSED",
}

/**  Search among vehicle assignments  */
export type AssignmentsMsSearchVehicleAssignmentsRequest = {
  filters?: InputMaybe<AssignmentsMsSearchVehicleAssignmentsRequestFilters>;
  paging?: InputMaybe<AssignmentsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<AssignmentsMsSearchVehicleAssignmentsRequestSort>>
  >;
};

export type AssignmentsMsSearchVehicleAssignmentsRequestFilters = {
  /**  Find assignments around a period (that might overlap the period)  */
  around?: InputMaybe<AssignmentsMsSearchVehicleAssignmentsRequestFiltersAround>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  ledgerIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  vehicleId?: InputMaybe<Scalars["ID"]["input"]>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/**  Find assignments around a period (that might overlap the period)  */
export type AssignmentsMsSearchVehicleAssignmentsRequestFiltersAround = {
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  When not provided, it is considered infinite  */
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type AssignmentsMsSearchVehicleAssignmentsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<AssignmentsMsSearchVehicleAssignmentsRequestSortField>;
};

export enum AssignmentsMsSearchVehicleAssignmentsRequestSortField {
  FromTs = "from_ts",
  Id = "id",
  LedgerId = "ledger_id",
  TillTs = "till_ts",
  UpdatedTs = "updated_ts",
  VehicleId = "vehicle_id",
}

export type AssignmentsMsSearchVehicleAssignmentsResponse = {
  __typename?: "AssignmentsMsSearchVehicleAssignmentsResponse";
  data?: Maybe<Array<AssignmentsMsSearchVehicleAssignmentsResponseData>>;
  pagination: AssignmentsMsPagedPagination;
};

export type AssignmentsMsSearchVehicleAssignmentsResponseData = {
  __typename?: "AssignmentsMsSearchVehicleAssignmentsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  LedgerIdData?: Maybe<LedgersMsSearchLedgersResponseData>;
  VehicleIdData?: Maybe<VehiclesMsSearchVehiclesResponseData>;
  accountId: Scalars["ID"]["output"];
  /**  The ID of the assignment  */
  id: Scalars["ID"]["output"];
  /**  The ledger id  */
  ledgerId: Scalars["ID"]["output"];
  period: AssignmentsMsSearchVehicleAssignmentsResponseDataPeriod;
  status: AssignmentsMsSearchVehicleAssignmentsResponseDataStatus;
  /**  The vehicle id  */
  vehicleId: Scalars["ID"]["output"];
};

export type AssignmentsMsSearchVehicleAssignmentsResponseDataPeriod = {
  __typename?: "AssignmentsMsSearchVehicleAssignmentsResponseDataPeriod";
  fromTs: Scalars["Int64"]["output"];
  tillTs: Scalars["Int64"]["output"];
};

export enum AssignmentsMsSearchVehicleAssignmentsResponseDataStatus {
  AssignmentStatusUnknown = "ASSIGNMENT_STATUS_UNKNOWN",
  InComing = "IN_COMING",
  InProgress = "IN_PROGRESS",
  Passed = "PASSED",
}

/**  Update assignment dates  */
export type AssignmentsMsUpdatePeriodRequest = {
  /**  The assignment id  */
  assignmentId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The new timespan of the start of the assignment  */
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The new timespan of the end of the assignment  */
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

/**  Close a payment  */
export type BillingMsClosePaymentRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BillingMsClosePaymentResponse = {
  __typename?: "BillingMsClosePaymentResponse";
  id: Scalars["ID"]["output"];
  status: Scalars["String"]["output"];
};

/**  Commit a payment  */
export type BillingMsCommitPaymentRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Create a guarantee payment  */
export type BillingMsCreateGuaranteePaymentRequest = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
};

export type BillingMsCreateGuaranteePaymentResponse = {
  __typename?: "BillingMsCreateGuaranteePaymentResponse";
  amount: Scalars["Float"]["output"];
  creationDateTs: Scalars["Int64"]["output"];
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  monext: BillingMsCreateGuaranteePaymentResponseMonext;
  reference: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type BillingMsCreateGuaranteePaymentResponseMonext = {
  __typename?: "BillingMsCreateGuaranteePaymentResponseMonext";
  code: Scalars["String"]["output"];
  sessionId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

/**  Create a invoice payment  */
export type BillingMsCreateInvoicePaymentRequest = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  documentList?: InputMaybe<
    Array<InputMaybe<BillingMsCreateInvoicePaymentRequestDocument>>
  >;
  dueDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type BillingMsCreateInvoicePaymentRequestDocument = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  dateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  dueDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  externalId?: InputMaybe<Scalars["String"]["input"]>;
  fees?: InputMaybe<Scalars["Float"]["input"]>;
  number?: InputMaybe<Scalars["String"]["input"]>;
  subDocumentList?: InputMaybe<
    Array<InputMaybe<BillingMsCreateInvoicePaymentRequestDocumentSubDocument>>
  >;
};

export type BillingMsCreateInvoicePaymentRequestDocumentSubDocument = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  dateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  dueDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  externalId?: InputMaybe<Scalars["String"]["input"]>;
  fees?: InputMaybe<Scalars["Float"]["input"]>;
  number?: InputMaybe<Scalars["String"]["input"]>;
};

export type BillingMsCreateInvoicePaymentResponse = {
  __typename?: "BillingMsCreateInvoicePaymentResponse";
  amount: Scalars["Float"]["output"];
  creationDateTs: Scalars["Int64"]["output"];
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  monext: BillingMsCreateInvoicePaymentResponseMonext;
  reference: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type BillingMsCreateInvoicePaymentResponseMonext = {
  __typename?: "BillingMsCreateInvoicePaymentResponseMonext";
  code: Scalars["String"]["output"];
  sessionId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

/**
 *  Create an invoice transaction document order that will trigger OnCreateInvoiceTransactionsDocument
 * through event CreateInvoiceTransactionsDocumentEvent
 */
export type BillingMsCreateInvoiceTransactionsDocumentRequest = {
  /**  The id of the invoice for which to generate the detailed-transactions document  */
  invoiceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BillingMsCreateInvoiceTransactionsDocumentResponse = {
  __typename?: "BillingMsCreateInvoiceTransactionsDocumentResponse";
  /**  The id of the newly created InvoiceDocument row  */
  invoiceTransactionDocumentId: Scalars["ID"]["output"];
};

export type BillingMsCreateTidDeliveryConfigRequest = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  externalFlowId?: InputMaybe<Scalars["String"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<BillingMsCreateTidDeliveryConfigRequestType>;
};

export enum BillingMsCreateTidDeliveryConfigRequestType {
  TidDeliveryTypeSftp = "TID_DELIVERY_TYPE_SFTP",
  TidDeliveryTypeUnspecified = "TID_DELIVERY_TYPE_UNSPECIFIED",
}

export type BillingMsCreateTidDeliveryConfigResponse = {
  __typename?: "BillingMsCreateTidDeliveryConfigResponse";
  tidDeliveryConfigId: Scalars["ID"]["output"];
};

/**  Create a tid linked account  */
export type BillingMsCreateTidLinkedAccountRequest = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  linkedAccountId?: InputMaybe<Scalars["ID"]["input"]>;
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BillingMsCreateTidLinkedAccountResponse = {
  __typename?: "BillingMsCreateTidLinkedAccountResponse";
  id: Scalars["ID"]["output"];
};

export type BillingMsCreateTidOrderRequest = {
  tidId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BillingMsCreateTidOrderResponse = {
  __typename?: "BillingMsCreateTidOrderResponse";
  tidOrderId: Scalars["ID"]["output"];
};

/**  Create a Tid report.  */
export type BillingMsCreateTidReportRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BillingMsCreateTidReportResponse = {
  __typename?: "BillingMsCreateTidReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

export type BillingMsDeleteTidDeliveryConfigRequest = {
  tidDeliveryConfigId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Delete a tid linked account  */
export type BillingMsDeleteTidLinkedAccountRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BillingMsGetAccountsLinkableToTidRequest = {
  filters?: InputMaybe<BillingMsGetAccountsLinkableToTidRequestFilters>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsGetAccountsLinkableToTidRequestSort>>
  >;
};

export type BillingMsGetAccountsLinkableToTidRequestFilters = {
  query?: InputMaybe<Scalars["String"]["input"]>;
  targetAccountId?: InputMaybe<Scalars["ID"]["input"]>;
  tidTypeCode?: InputMaybe<BillingMsGetAccountsLinkableToTidRequestFiltersTidTypeCode>;
};

export enum BillingMsGetAccountsLinkableToTidRequestFiltersTidTypeCode {
  Delegate = "DELEGATE",
  Payer = "PAYER",
  UnknownTidTypeCode = "UNKNOWN_TID_TYPE_CODE",
}

export type BillingMsGetAccountsLinkableToTidRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsGetAccountsLinkableToTidRequestSortField>;
};

export enum BillingMsGetAccountsLinkableToTidRequestSortField {
  Name = "name",
  Number = "number",
}

export type BillingMsGetAccountsLinkableToTidResponse = {
  __typename?: "BillingMsGetAccountsLinkableToTidResponse";
  data?: Maybe<Array<BillingMsGetAccountsLinkableToTidResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsGetAccountsLinkableToTidResponseData = {
  __typename?: "BillingMsGetAccountsLinkableToTidResponseData";
  accountId: Scalars["ID"]["output"];
  accountName: Scalars["String"]["output"];
  accountNumber: Scalars["String"]["output"];
};

export type BillingMsGetActiveGuaranteePaymentResponse = {
  __typename?: "BillingMsGetActiveGuaranteePaymentResponse";
  accountId: Scalars["String"]["output"];
  /**  The amount of the Payment  */
  amount: Scalars["Float"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  The currency of the Payment  */
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /**  Min delay between two guarantee payments (in hours)  */
  minPaymentsDelayInHours: Scalars["Int"]["output"];
  /**  The reference of the Payment (unique)  */
  reference: Scalars["String"]["output"];
  /**  The status of the Payment  */
  status: BillingMsGetActiveGuaranteePaymentResponseStatus;
  updatedTs: Scalars["Int64"]["output"];
  userId: Scalars["String"]["output"];
};

/**  The status of the Payment  */
export enum BillingMsGetActiveGuaranteePaymentResponseStatus {
  Cancelled = "CANCELLED",
  Closed = "CLOSED",
  Created = "CREATED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Succeeded = "SUCCEEDED",
  UnknownPaymentStatus = "UNKNOWN_PAYMENT_STATUS",
}

export type BillingMsGetCustomerCreditStateResponse = {
  __typename?: "BillingMsGetCustomerCreditStateResponse";
  CustomerCreditFrequencyIdData?: Maybe<BillingMsSearchCustomerCreditFrequenciesResponseData>;
  customerCreditConsumption: Scalars["Float"]["output"];
  customerCreditFrequencyId: Scalars["ID"]["output"];
  customerCreditLastTs: Scalars["Int64"]["output"];
  customerCreditLimit: Scalars["Float"]["output"];
  customerCreditOutstanding: Scalars["Float"]["output"];
  customerCreditRenewTs: Scalars["Int64"]["output"];
  customerCreditWarning: BillingMsGetCustomerCreditStateResponseCustomerCreditWarning;
  hasBlockingCustomerCreditLimit: Scalars["Boolean"]["output"];
};

export enum BillingMsGetCustomerCreditStateResponseCustomerCreditWarning {
  Alert = "ALERT",
  CustomerCreditWarningUnknown = "CUSTOMER_CREDIT_WARNING_UNKNOWN",
  None = "NONE",
  Warning = "WARNING",
}

export type BillingMsGetLastInvoiceResponse = {
  __typename?: "BillingMsGetLastInvoiceResponse";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  DocumentIdData?: Maybe<MediaMsSearchDocumentsResponseData>;
  accountId: Scalars["ID"]["output"];
  amountCurrency: Scalars["String"]["output"];
  amountIncludingVat: Scalars["Float"]["output"];
  /**  The document is available if not zero  */
  availableCheckedTs: Scalars["Int64"]["output"];
  dateTs: Scalars["Int64"]["output"];
  documentId: Scalars["ID"]["output"];
  dueDateTs: Scalars["Int64"]["output"];
  hasLastInvoice: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  invoiceCode: BillingMsGetLastInvoiceResponseInvoiceCode;
  number: Scalars["String"]["output"];
  recipientAccountNumber: Scalars["String"]["output"];
};

export enum BillingMsGetLastInvoiceResponseInvoiceCode {
  Fcli = "FCLI",
  Fpoc = "FPOC",
  Rlvg = "RLVG",
  Rlvp = "RLVP",
  Unknown = "UNKNOWN",
}

export type BillingMsListMyLastInvoiceDocumentsResponse = {
  __typename?: "BillingMsListMyLastInvoiceDocumentsResponse";
  data?: Maybe<Array<BillingMsListMyLastInvoiceDocumentsResponseData>>;
};

export type BillingMsListMyLastInvoiceDocumentsResponseData = {
  __typename?: "BillingMsListMyLastInvoiceDocumentsResponseData";
  /**  Account identifier  */
  accountId: Scalars["String"]["output"];
  /**  Account number  */
  accountNumber: Scalars["String"]["output"];
  /**  Document identifier  */
  documentId: Scalars["String"]["output"];
  /**  Invoice number  */
  number: Scalars["String"]["output"];
};

export type BillingMsListMyLastTidDocumentsResponse = {
  __typename?: "BillingMsListMyLastTidDocumentsResponse";
  data?: Maybe<Array<BillingMsListMyLastTidDocumentsResponseData>>;
};

export type BillingMsListMyLastTidDocumentsResponseData = {
  __typename?: "BillingMsListMyLastTidDocumentsResponseData";
  accountId: Scalars["String"]["output"];
  accountNumber: Scalars["String"]["output"];
  documentId: Scalars["String"]["output"];
};

/**  Create a invoice payment  */
export type BillingMsListOpenPaymentDocumentsRequest = {
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
};

export type BillingMsListOpenPaymentDocumentsResponse = {
  __typename?: "BillingMsListOpenPaymentDocumentsResponse";
  data?: Maybe<Array<BillingMsListOpenPaymentDocumentsResponseDocument>>;
};

export type BillingMsListOpenPaymentDocumentsResponseDocument = {
  __typename?: "BillingMsListOpenPaymentDocumentsResponseDocument";
  amount: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  dateTs: Scalars["Int64"]["output"];
  dueDateTs: Scalars["Int64"]["output"];
  externalId: Scalars["String"]["output"];
  fees: Scalars["Float"]["output"];
  isPaid: Scalars["Boolean"]["output"];
  number: Scalars["String"]["output"];
  subDocumentList?: Maybe<
    Array<BillingMsListOpenPaymentDocumentsResponseDocumentSubDocument>
  >;
};

export type BillingMsListOpenPaymentDocumentsResponseDocumentSubDocument = {
  __typename?: "BillingMsListOpenPaymentDocumentsResponseDocumentSubDocument";
  amount: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  dateTs: Scalars["Int64"]["output"];
  dueDateTs: Scalars["Int64"]["output"];
  externalId: Scalars["String"]["output"];
  fees: Scalars["Float"]["output"];
  number: Scalars["String"]["output"];
};

export type BillingMsPagedPagination = {
  __typename?: "BillingMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type BillingMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  Search among invoice addresses  */
export type BillingMsSearchAddressesRequest = {
  filters?: InputMaybe<BillingMsSearchAddressesRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<BillingMsSearchAddressesRequestSort>>>;
};

export type BillingMsSearchAddressesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchAddressesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchAddressesRequestSortField>;
};

export enum BillingMsSearchAddressesRequestSortField {
  RegistrationName = "registration_name",
}

export type BillingMsSearchAddressesResponse = {
  __typename?: "BillingMsSearchAddressesResponse";
  data?: Maybe<Array<BillingMsSearchAddressesResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchAddressesResponseData = {
  __typename?: "BillingMsSearchAddressesResponseData";
  /**  The physical address of the customer  */
  address: Scalars["String"]["output"];
  /**  The physical city of the customer  */
  city: Scalars["String"]["output"];
  /**  The email address used as contact  */
  contactEmail: Scalars["String"]["output"];
  /**  The physical country of the customer encoded in ISO 3166-1 standard  */
  country: Scalars["String"]["output"];
  /**  The invoice address id  */
  id: Scalars["ID"]["output"];
  /**  Also named "Raison sociale"  */
  registrationName: Scalars["String"]["output"];
  /**  The registration number of the legal entity.  */
  registrationNumber: Scalars["String"]["output"];
  /**  The physical zip code of the customer  */
  zipCode: Scalars["String"]["output"];
};

/**  Get account preferences related to the billing domain  */
export type BillingMsSearchBillingAccountPreferencesRequest = {
  filters?: InputMaybe<BillingMsSearchBillingAccountPreferencesRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchBillingAccountPreferencesRequestSort>>
  >;
};

export type BillingMsSearchBillingAccountPreferencesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  payingAccountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchBillingAccountPreferencesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchBillingAccountPreferencesRequestSortField>;
};

export enum BillingMsSearchBillingAccountPreferencesRequestSortField {
  Id = "id",
}

export type BillingMsSearchBillingAccountPreferencesResponse = {
  __typename?: "BillingMsSearchBillingAccountPreferencesResponse";
  data?: Maybe<Array<BillingMsSearchBillingAccountPreferencesResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchBillingAccountPreferencesResponseData = {
  __typename?: "BillingMsSearchBillingAccountPreferencesResponseData";
  BillingFrequencyIdData?: Maybe<BillingMsSearchBillingFrequenciesResponseData>;
  CustomerCreditFrequencyIdData?: Maybe<BillingMsSearchCustomerCreditFrequenciesResponseData>;
  DelegateAccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  IdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  PayingAccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  PaymentMethodIdData?: Maybe<BillingMsSearchPaymentMethodsResponseData>;
  /**  The related billing frequency  */
  billingFrequencyId: Scalars["String"]["output"];
  /**  The main currency of the account  */
  currency: Scalars["String"]["output"];
  /**  The total amount of maximum transactions on a given customer credit frequency. Also called PPB in french.  */
  customerCreditConsumption: Scalars["Float"]["output"];
  /**  The customer credit frequency  */
  customerCreditFrequencyId: Scalars["String"]["output"];
  /**  When was the customer credit data updated for the last time  */
  customerCreditLastTs: Scalars["Int64"]["output"];
  /**  The total amount of maximum transactions on a given customer credit frequency. Also called PPB in french.  */
  customerCreditLimit: Scalars["Float"]["output"];
  /**  The delegator account id  */
  delegateAccountId: Scalars["ID"]["output"];
  /**  The delegator updated timestamp  */
  delegateUpdatedTs: Scalars["Int64"]["output"];
  /**  The account ID  */
  id: Scalars["ID"]["output"];
  /**  The account number (copied data)  */
  number: Scalars["String"]["output"];
  /**  The band address  */
  payerBankDomiciliation: Scalars["String"]["output"];
  /**  True if the SEPA mandate is enabled  */
  payerHasMandate: Scalars["Boolean"]["output"];
  /**  The International Bank Account Number  */
  payerIban: Scalars["String"]["output"];
  /**  The SEPA mandate reference  */
  payerRumReference: Scalars["String"]["output"];
  /**  The Society for Worldwide Interbank Financial Telecommunication or Bank Identification Code  */
  payerSwiftCode: Scalars["String"]["output"];
  /**  The paying account id  */
  payingAccountId: Scalars["ID"]["output"];
  /**  The paying updated timestamp  */
  payingUpdatedTs: Scalars["Int64"]["output"];
  /**  The related payment method  */
  paymentMethodId: Scalars["String"]["output"];
  /**  The email address of manager to send invoice  */
  preferredContactEmail: Scalars["String"]["output"];
  /**  The amount of the security deposit made my the customer  */
  securityDepositAmount: Scalars["Float"]["output"];
  /**  The SEPA mandate signature date  */
  sepaSignatureDate: Scalars["String"]["output"];
  /**  The SEPA mandate signature location  */
  sepaSignatureLocation: Scalars["String"]["output"];
};

/**  Search among billing frequencies  */
export type BillingMsSearchBillingFrequenciesRequest = {
  filters?: InputMaybe<BillingMsSearchBillingFrequenciesRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchBillingFrequenciesRequestSort>>
  >;
};

export type BillingMsSearchBillingFrequenciesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchBillingFrequenciesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchBillingFrequenciesRequestSortField>;
};

export enum BillingMsSearchBillingFrequenciesRequestSortField {
  Code = "code",
}

export type BillingMsSearchBillingFrequenciesResponse = {
  __typename?: "BillingMsSearchBillingFrequenciesResponse";
  data?: Maybe<Array<BillingMsSearchBillingFrequenciesResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchBillingFrequenciesResponseData = {
  __typename?: "BillingMsSearchBillingFrequenciesResponseData";
  /**  The code name  */
  code: Scalars["String"]["output"];
  /**  The ID of the billing frequency  */
  id: Scalars["ID"]["output"];
  /**  The date of the 1st day of the next billing period  */
  nextDate: Scalars["String"]["output"];
};

export type BillingMsSearchBillingFrequencyHistoryRequest = {
  filters?: InputMaybe<BillingMsSearchBillingFrequencyHistoryRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchBillingFrequencyHistoryRequestSort>>
  >;
};

export type BillingMsSearchBillingFrequencyHistoryRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchBillingFrequencyHistoryRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchBillingFrequencyHistoryRequestSortField>;
};

export enum BillingMsSearchBillingFrequencyHistoryRequestSortField {
  CreatedTs = "created_ts",
  FromTs = "from_ts",
  Id = "id",
  TillTs = "till_ts",
}

export type BillingMsSearchBillingFrequencyHistoryResponse = {
  __typename?: "BillingMsSearchBillingFrequencyHistoryResponse";
  data?: Maybe<Array<BillingMsSearchBillingFrequencyHistoryResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchBillingFrequencyHistoryResponseData = {
  __typename?: "BillingMsSearchBillingFrequencyHistoryResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  BillingFrequencyIdData?: Maybe<BillingMsSearchBillingFrequenciesResponseData>;
  /**  account id  */
  accountId: Scalars["ID"]["output"];
  /**  The related billing frequency  */
  billingFrequencyId: Scalars["ID"]["output"];
  /**  when billing frequency become effective  */
  fromTs: Scalars["Int64"]["output"];
  /**  The ID of the billing frequency audit  */
  id: Scalars["ID"]["output"];
  /**  when billing period ends  */
  tillTs: Scalars["Int64"]["output"];
};

/**  Search customer billing period for invoice  */
export type BillingMsSearchBillingPeriodLinksRequest = {
  filters?: InputMaybe<BillingMsSearchBillingPeriodLinksRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchBillingPeriodLinksRequestSort>>
  >;
};

export type BillingMsSearchBillingPeriodLinksRequestFilters = {
  customerBillingPeriodId?: InputMaybe<Scalars["ID"]["input"]>;
  delegateBillingPeriodIds?: InputMaybe<
    Array<InputMaybe<Scalars["ID"]["input"]>>
  >;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  payerBillingPeriodIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchBillingPeriodLinksRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchBillingPeriodLinksRequestSortField>;
};

export enum BillingMsSearchBillingPeriodLinksRequestSortField {
  Id = "id",
  UpdatedTs = "updated_ts",
}

export type BillingMsSearchBillingPeriodLinksResponse = {
  __typename?: "BillingMsSearchBillingPeriodLinksResponse";
  data?: Maybe<Array<BillingMsSearchBillingPeriodLinksResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchBillingPeriodLinksResponseData = {
  __typename?: "BillingMsSearchBillingPeriodLinksResponseData";
  CustomerBillingPeriodIdData?: Maybe<BillingMsSearchCustomerBillingPeriodsResponseData>;
  CustomerBillingPeriods?: Maybe<
    Array<Maybe<BillingMsSearchCustomerBillingPeriodsResponseData>>
  >;
  DelegateBillingPeriods?: Maybe<
    Array<Maybe<BillingMsSearchDelegateBillingPeriodsResponseData>>
  >;
  PayerBillingPeriods?: Maybe<
    Array<Maybe<BillingMsSearchPayerBillingPeriodsResponseData>>
  >;
  /**  The customer billing period linked  */
  customerBillingPeriodId: Scalars["ID"]["output"];
  /**  The id of the bp link  */
  id: Scalars["String"]["output"];
  /**  The payer or delegate billing period linked  */
  payerDelegateBillingPeriodId: Scalars["ID"]["output"];
};

/**  Search billing period for invoice  */
export type BillingMsSearchBillingPeriodsRequest = {
  filters?: InputMaybe<BillingMsSearchBillingPeriodsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchBillingPeriodsRequestSort>>
  >;
};

export type BillingMsSearchBillingPeriodsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchBillingPeriodsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchBillingPeriodsRequestSortField>;
};

export enum BillingMsSearchBillingPeriodsRequestSortField {
  ClosedTs = "closed_ts",
  EndTs = "end_ts",
  Id = "id",
  StartTs = "start_ts",
}

export type BillingMsSearchBillingPeriodsResponse = {
  __typename?: "BillingMsSearchBillingPeriodsResponse";
  data?: Maybe<Array<BillingMsSearchBillingPeriodsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchBillingPeriodsResponseData = {
  __typename?: "BillingMsSearchBillingPeriodsResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  BillingFrequencyIdData?: Maybe<BillingMsSearchBillingFrequenciesResponseData>;
  Tids?: Maybe<Array<Maybe<BillingMsSearchTidsResponseData>>>;
  /**  The account id linked to the billing period.  */
  accountId: Scalars["String"]["output"];
  /**  The billing frequency of the billing period.  */
  billingFrequencyId: Scalars["String"]["output"];
  /**  timestamp that indicates whether a billing period has been processed for delegate  */
  checkDelegateTs: Scalars["Int64"]["output"];
  /**  timestamp that indicates whether a billing period has been processed for payer  */
  checkPayerTs: Scalars["Int64"]["output"];
  /**  The timestamp when the billing period was closed  */
  closedTs: Scalars["Int64"]["output"];
  /**  The end timestamp for the billing period.  */
  endTs: Scalars["Int64"]["output"];
  /**  The id of the billing period.  */
  id: Scalars["ID"]["output"];
  /**  The timestamp when the last invoice is received  */
  maxTs: Scalars["Int64"]["output"];
  /**  The timestamp when the first invoice is received  */
  minTs: Scalars["Int64"]["output"];
  /**  The start timestamp for the billing period.  */
  startTs: Scalars["Int64"]["output"];
  /**  The status of the billing period.  */
  status: BillingMsSearchBillingPeriodsResponseDataStatus;
  /**  The timestamp when the tid is ready  */
  tidReadyTs: Scalars["Int64"]["output"];
  /**  The total amount including vat for the billing period  */
  totalAmountIncludingVat: Scalars["Float"]["output"];
  /**  The timestamp when the total amount including vat for the billing period is ready  */
  totalAmountIncludingVatTs: Scalars["Int64"]["output"];
  /**  The billing period version  */
  version: BillingMsSearchBillingPeriodsResponseDataVersion;
};

export enum BillingMsSearchBillingPeriodsResponseDataStatus {
  BillingPeriodStatusActive = "BILLING_PERIOD_STATUS_ACTIVE",
  BillingPeriodStatusClosed = "BILLING_PERIOD_STATUS_CLOSED",
  BillingPeriodStatusTemporarilyClosed = "BILLING_PERIOD_STATUS_TEMPORARILY_CLOSED",
  UnknownBillingPeriod = "UNKNOWN_BILLING_PERIOD",
}

export enum BillingMsSearchBillingPeriodsResponseDataVersion {
  UnknownVersion = "UNKNOWN_VERSION",
  V1 = "V1",
  V2 = "V2",
}

/**  Search customer billing period for invoice  */
export type BillingMsSearchCustomerBillingPeriodsRequest = {
  filters?: InputMaybe<BillingMsSearchCustomerBillingPeriodsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchCustomerBillingPeriodsRequestSort>>
  >;
};

export type BillingMsSearchCustomerBillingPeriodsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  versions?: InputMaybe<
    Array<
      InputMaybe<BillingMsSearchCustomerBillingPeriodsRequestFiltersVersions>
    >
  >;
};

export enum BillingMsSearchCustomerBillingPeriodsRequestFiltersVersions {
  UnknownVersion = "UNKNOWN_VERSION",
  V1 = "V1",
  V2 = "V2",
}

export type BillingMsSearchCustomerBillingPeriodsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchCustomerBillingPeriodsRequestSortField>;
};

export enum BillingMsSearchCustomerBillingPeriodsRequestSortField {
  ClosedTs = "closed_ts",
  EndTs = "end_ts",
  Id = "id",
  StartTs = "start_ts",
}

export type BillingMsSearchCustomerBillingPeriodsResponse = {
  __typename?: "BillingMsSearchCustomerBillingPeriodsResponse";
  data?: Maybe<Array<BillingMsSearchCustomerBillingPeriodsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchCustomerBillingPeriodsResponseData = {
  __typename?: "BillingMsSearchCustomerBillingPeriodsResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  BillingFrequencyIdData?: Maybe<BillingMsSearchBillingFrequenciesResponseData>;
  Tids?: Maybe<Array<Maybe<BillingMsSearchTidsResponseData>>>;
  /**  The account id linked to the billing period.  */
  accountId: Scalars["String"]["output"];
  /**  The billing frequency of the billing period.  */
  billingFrequencyId: Scalars["String"]["output"];
  /**  timestamp that indicates whether a billing period has been processed for delegate  */
  checkDelegateTs: Scalars["Int64"]["output"];
  /**  timestamp that indicates whether a billing period has been processed for payer  */
  checkPayerTs: Scalars["Int64"]["output"];
  /**  The timestamp when the billing period was closed  */
  closedTs: Scalars["Int64"]["output"];
  /**  The end timestamp for the billing period.  */
  endTs: Scalars["Int64"]["output"];
  /**  The id of the billing period.  */
  id: Scalars["ID"]["output"];
  /**  The timestamp when the last invoice is received  */
  maxTs: Scalars["Int64"]["output"];
  /**  The timestamp when the first invoice is received  */
  minTs: Scalars["Int64"]["output"];
  /**  The start timestamp for the billing period.  */
  startTs: Scalars["Int64"]["output"];
  /**  The status of the billing period.  */
  status: BillingMsSearchCustomerBillingPeriodsResponseDataStatus;
  /**  The timestamp when the tid is ready  */
  tidReadyTs: Scalars["Int64"]["output"];
  /**  The total amount including vat for the billing period  */
  totalAmountIncludingVat: Scalars["Float"]["output"];
  /**  The timestamp when the total amount including vat for the billing period is ready  */
  totalAmountIncludingVatTs: Scalars["Int64"]["output"];
  /**  The type of the billing period  */
  type: BillingMsSearchCustomerBillingPeriodsResponseDataType;
  /**  The billing period version  */
  version: BillingMsSearchCustomerBillingPeriodsResponseDataVersion;
};

export enum BillingMsSearchCustomerBillingPeriodsResponseDataStatus {
  BillingPeriodStatusActive = "BILLING_PERIOD_STATUS_ACTIVE",
  BillingPeriodStatusClosed = "BILLING_PERIOD_STATUS_CLOSED",
  BillingPeriodStatusTemporarilyClosed = "BILLING_PERIOD_STATUS_TEMPORARILY_CLOSED",
  UnknownBillingPeriod = "UNKNOWN_BILLING_PERIOD",
}

export enum BillingMsSearchCustomerBillingPeriodsResponseDataType {
  BillingPeriodTypeCustomer = "BILLING_PERIOD_TYPE_CUSTOMER",
  BillingPeriodTypeDelegate = "BILLING_PERIOD_TYPE_DELEGATE",
  BillingPeriodTypePayer = "BILLING_PERIOD_TYPE_PAYER",
  UnknownBillingPeriodType = "UNKNOWN_BILLING_PERIOD_TYPE",
}

export enum BillingMsSearchCustomerBillingPeriodsResponseDataVersion {
  UnknownVersion = "UNKNOWN_VERSION",
  V1 = "V1",
  V2 = "V2",
}

/**  Search among customer credit frequencies  */
export type BillingMsSearchCustomerCreditFrequenciesRequest = {
  filters?: InputMaybe<BillingMsSearchCustomerCreditFrequenciesRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchCustomerCreditFrequenciesRequestSort>>
  >;
};

export type BillingMsSearchCustomerCreditFrequenciesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchCustomerCreditFrequenciesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchCustomerCreditFrequenciesRequestSortField>;
};

export enum BillingMsSearchCustomerCreditFrequenciesRequestSortField {
  Code = "code",
}

export type BillingMsSearchCustomerCreditFrequenciesResponse = {
  __typename?: "BillingMsSearchCustomerCreditFrequenciesResponse";
  data?: Maybe<Array<BillingMsSearchCustomerCreditFrequenciesResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchCustomerCreditFrequenciesResponseData = {
  __typename?: "BillingMsSearchCustomerCreditFrequenciesResponseData";
  /**  The code name  */
  code: Scalars["String"]["output"];
  /**  The ID of the customer credit frequency  */
  id: Scalars["ID"]["output"];
};

/**  Search Delegate billing period for invoice  */
export type BillingMsSearchDelegateBillingPeriodsRequest = {
  filters?: InputMaybe<BillingMsSearchDelegateBillingPeriodsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchDelegateBillingPeriodsRequestSort>>
  >;
};

export type BillingMsSearchDelegateBillingPeriodsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchDelegateBillingPeriodsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchDelegateBillingPeriodsRequestSortField>;
};

export enum BillingMsSearchDelegateBillingPeriodsRequestSortField {
  ClosedTs = "closed_ts",
  EndTs = "end_ts",
  Id = "id",
  StartTs = "start_ts",
}

export type BillingMsSearchDelegateBillingPeriodsResponse = {
  __typename?: "BillingMsSearchDelegateBillingPeriodsResponse";
  data?: Maybe<Array<BillingMsSearchDelegateBillingPeriodsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchDelegateBillingPeriodsResponseData = {
  __typename?: "BillingMsSearchDelegateBillingPeriodsResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  BillingFrequencyIdData?: Maybe<BillingMsSearchBillingFrequenciesResponseData>;
  LinkedCustomerBillingPeriods?: Maybe<
    Array<Maybe<BillingMsSearchBillingPeriodLinksResponseData>>
  >;
  Tids?: Maybe<Array<Maybe<BillingMsSearchTidsResponseData>>>;
  /**  The account id linked to the billing period.  */
  accountId: Scalars["String"]["output"];
  /**  The billing frequency of the billing period.  */
  billingFrequencyId: Scalars["String"]["output"];
  /**  timestamp that indicates whether a billing period has been processed for delegate  */
  checkDelegateTs: Scalars["Int64"]["output"];
  /**  timestamp that indicates whether a billing period has been processed for payer  */
  checkPayerTs: Scalars["Int64"]["output"];
  /**  The timestamp when the billing period was closed  */
  closedTs: Scalars["Int64"]["output"];
  /**  The end timestamp for the billing period.  */
  endTs: Scalars["Int64"]["output"];
  /**  The id of the billing period.  */
  id: Scalars["ID"]["output"];
  /**  The start timestamp for the billing period.  */
  startTs: Scalars["Int64"]["output"];
  /**  The status of the billing period.  */
  status: BillingMsSearchDelegateBillingPeriodsResponseDataStatus;
  /**  The timestamp when the tid is ready  */
  tidReadyTs: Scalars["Int64"]["output"];
  /**  The type of the billing period  */
  type: BillingMsSearchDelegateBillingPeriodsResponseDataType;
};

export enum BillingMsSearchDelegateBillingPeriodsResponseDataStatus {
  BillingPeriodStatusActive = "BILLING_PERIOD_STATUS_ACTIVE",
  BillingPeriodStatusClosed = "BILLING_PERIOD_STATUS_CLOSED",
  BillingPeriodStatusTemporarilyClosed = "BILLING_PERIOD_STATUS_TEMPORARILY_CLOSED",
  UnknownBillingPeriod = "UNKNOWN_BILLING_PERIOD",
}

export enum BillingMsSearchDelegateBillingPeriodsResponseDataType {
  BillingPeriodTypeCustomer = "BILLING_PERIOD_TYPE_CUSTOMER",
  BillingPeriodTypeDelegate = "BILLING_PERIOD_TYPE_DELEGATE",
  BillingPeriodTypePayer = "BILLING_PERIOD_TYPE_PAYER",
  UnknownBillingPeriodType = "UNKNOWN_BILLING_PERIOD_TYPE",
}

/**  Search invoice documents  */
export type BillingMsSearchInvoiceDocumentsRequest = {
  filters?: InputMaybe<BillingMsSearchInvoiceDocumentsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchInvoiceDocumentsRequestSort>>
  >;
};

export type BillingMsSearchInvoiceDocumentsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  invoiceId?: InputMaybe<Scalars["ID"]["input"]>;
  invoiceIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchInvoiceDocumentsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchInvoiceDocumentsRequestSortField>;
};

export enum BillingMsSearchInvoiceDocumentsRequestSortField {
  UpdatedTs = "updated_ts",
}

export type BillingMsSearchInvoiceDocumentsResponse = {
  __typename?: "BillingMsSearchInvoiceDocumentsResponse";
  data?: Maybe<Array<BillingMsSearchInvoiceDocumentsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchInvoiceDocumentsResponseData = {
  __typename?: "BillingMsSearchInvoiceDocumentsResponseData";
  DocumentIdData?: Maybe<MediaMsSearchDocumentsResponseData>;
  InvoiceIdData?: Maybe<BillingMsSearchInvoicesResponseData>;
  /**  the document id  */
  documentId: Scalars["String"]["output"];
  /**  The title of the document  */
  documentTitle: Scalars["String"]["output"];
  /**  The external document id  */
  externalDocumentId: Scalars["String"]["output"];
  /**  The invoice detail id  */
  id: Scalars["ID"]["output"];
  /**  the id of the invoice  */
  invoiceId: Scalars["String"]["output"];
};

/**
 *  Search among invoice lines
 *
 * The invoice lines show the transaction that haven't been paired yet. If you wish to list the transactions of the
 * related invoice, please use the transactions search endpoint.
 */
export type BillingMsSearchInvoiceLinesRequest = {
  filters?: InputMaybe<BillingMsSearchInvoiceLinesRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<BillingMsSearchInvoiceLinesRequestSort>>>;
};

export type BillingMsSearchInvoiceLinesRequestFilters = {
  alsoShowPairedTransactions?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  invoiceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BillingMsSearchInvoiceLinesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchInvoiceLinesRequestSortField>;
};

export enum BillingMsSearchInvoiceLinesRequestSortField {
  TransactionNumber = "transaction_number",
}

export type BillingMsSearchInvoiceLinesResponse = {
  __typename?: "BillingMsSearchInvoiceLinesResponse";
  data?: Maybe<Array<BillingMsSearchInvoiceLinesResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchInvoiceLinesResponseData = {
  __typename?: "BillingMsSearchInvoiceLinesResponseData";
  InvoiceIdData?: Maybe<BillingMsSearchInvoicesResponseData>;
  createdTs: Scalars["Int64"]["output"];
  /**  The ID of the invoice line  */
  id: Scalars["ID"]["output"];
  /**  The related invoice  */
  invoiceId: Scalars["ID"]["output"];
  /**
   *  The related transaction if there is such. Transactions are paired on a later stage and can be done whenever they
   * are available in the ledgers.
   * The transaction may not be available anymore once it has been archived.
   */
  transactionId: Scalars["String"]["output"];
  /**  The transaction original reference  */
  transactionNumber: Scalars["String"]["output"];
};

export type BillingMsSearchInvoiceTransactionDocumentOrdersRequest = {
  filters?: InputMaybe<BillingMsSearchInvoiceTransactionDocumentOrdersRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<
      InputMaybe<BillingMsSearchInvoiceTransactionDocumentOrdersRequestSort>
    >
  >;
};

export type BillingMsSearchInvoiceTransactionDocumentOrdersRequestFilters = {
  documentIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  invoiceIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  statuses?: InputMaybe<
    Array<
      InputMaybe<BillingMsSearchInvoiceTransactionDocumentOrdersRequestFiltersStatuses>
    >
  >;
};

export enum BillingMsSearchInvoiceTransactionDocumentOrdersRequestFiltersStatuses {
  InvoiceTransactionOrderStatusCreated = "INVOICE_TRANSACTION_ORDER_STATUS_CREATED",
  InvoiceTransactionOrderStatusFailed = "INVOICE_TRANSACTION_ORDER_STATUS_FAILED",
  InvoiceTransactionOrderStatusInProgress = "INVOICE_TRANSACTION_ORDER_STATUS_IN_PROGRESS",
  InvoiceTransactionOrderStatusSuccess = "INVOICE_TRANSACTION_ORDER_STATUS_SUCCESS",
  InvoiceTransactionOrderStatusUnknown = "INVOICE_TRANSACTION_ORDER_STATUS_UNKNOWN",
}

export type BillingMsSearchInvoiceTransactionDocumentOrdersRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchInvoiceTransactionDocumentOrdersRequestSortField>;
};

export enum BillingMsSearchInvoiceTransactionDocumentOrdersRequestSortField {
  CreatedTs = "created_ts",
  UpdatedTs = "updated_ts",
}

export type BillingMsSearchInvoiceTransactionDocumentOrdersResponse = {
  __typename?: "BillingMsSearchInvoiceTransactionDocumentOrdersResponse";
  data?: Maybe<
    Array<BillingMsSearchInvoiceTransactionDocumentOrdersResponseData>
  >;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchInvoiceTransactionDocumentOrdersResponseData = {
  __typename?: "BillingMsSearchInvoiceTransactionDocumentOrdersResponseData";
  DocumentIdData?: Maybe<MediaMsSearchDocumentsResponseData>;
  InvoiceIdData?: Maybe<BillingMsSearchInvoicesResponseData>;
  /**  the created timestamp  */
  createdTs: Scalars["Int64"]["output"];
  /**  The related document if there is such  */
  documentId: Scalars["ID"]["output"];
  /**  the reason of failure in case of errors  */
  failReason: Scalars["String"]["output"];
  /**  the id of the TidOrder  */
  id: Scalars["ID"]["output"];
  /**  the id of the invoice  */
  invoiceId: Scalars["ID"]["output"];
  /**  the language of the document  */
  locale: Scalars["String"]["output"];
  /**  the enum of status for TidOrder  */
  status: BillingMsSearchInvoiceTransactionDocumentOrdersResponseDataStatus;
  /**  the updated timestamp  */
  updatedTs: Scalars["Int64"]["output"];
};

export enum BillingMsSearchInvoiceTransactionDocumentOrdersResponseDataStatus {
  InvoiceTransactionOrderStatusCreated = "INVOICE_TRANSACTION_ORDER_STATUS_CREATED",
  InvoiceTransactionOrderStatusFailed = "INVOICE_TRANSACTION_ORDER_STATUS_FAILED",
  InvoiceTransactionOrderStatusInProgress = "INVOICE_TRANSACTION_ORDER_STATUS_IN_PROGRESS",
  InvoiceTransactionOrderStatusSuccess = "INVOICE_TRANSACTION_ORDER_STATUS_SUCCESS",
  InvoiceTransactionOrderStatusUnknown = "INVOICE_TRANSACTION_ORDER_STATUS_UNKNOWN",
}

/**  Search among invoice types  */
export type BillingMsSearchInvoiceTypesRequest = {
  filters?: InputMaybe<BillingMsSearchInvoiceTypesRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<BillingMsSearchInvoiceTypesRequestSort>>>;
};

export type BillingMsSearchInvoiceTypesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchInvoiceTypesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchInvoiceTypesRequestSortField>;
};

export enum BillingMsSearchInvoiceTypesRequestSortField {
  Code = "code",
}

export type BillingMsSearchInvoiceTypesResponse = {
  __typename?: "BillingMsSearchInvoiceTypesResponse";
  data?: Maybe<Array<BillingMsSearchInvoiceTypesResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchInvoiceTypesResponseData = {
  __typename?: "BillingMsSearchInvoiceTypesResponseData";
  /**  The unique code  */
  code: Scalars["String"]["output"];
  /**  The invoice type id  */
  id: Scalars["ID"]["output"];
};

/**  Search among Invoices  */
export type BillingMsSearchInvoicesRequest = {
  filters?: InputMaybe<BillingMsSearchInvoicesRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<BillingMsSearchInvoicesRequestSort>>>;
};

export type BillingMsSearchInvoicesRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  billingPeriodId?: InputMaybe<Scalars["ID"]["input"]>;
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  number?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  showAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  showNotAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  tillDate?: InputMaybe<Scalars["String"]["input"]>;
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BillingMsSearchInvoicesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchInvoicesRequestSortField>;
};

export enum BillingMsSearchInvoicesRequestSortField {
  AmountExcludingVat = "amount_excluding_vat",
  AmountIncludingVat = "amount_including_vat",
  AmountVat = "amount_vat",
  Country = "country",
  Date = "date",
  DateTs = "date_ts",
  DueDateTs = "due_date_ts",
  Number = "number",
  Reference = "reference",
  Type = "type",
}

export type BillingMsSearchInvoicesResponse = {
  __typename?: "BillingMsSearchInvoicesResponse";
  data?: Maybe<Array<BillingMsSearchInvoicesResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchInvoicesResponseData = {
  __typename?: "BillingMsSearchInvoicesResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  BilledAddressIdData?: Maybe<BillingMsSearchAddressesResponseData>;
  BillingPeriodIdData?: Maybe<BillingMsSearchBillingPeriodsResponseData>;
  DocumentIdData?: Maybe<MediaMsSearchDocumentsResponseData>;
  Documents?: Maybe<Array<Maybe<BillingMsSearchInvoiceDocumentsResponseData>>>;
  InvoiceTransactionDocuments?: Maybe<
    Array<Maybe<BillingMsSearchInvoiceTransactionDocumentOrdersResponseData>>
  >;
  TypeIdData?: Maybe<BillingMsSearchInvoiceTypesResponseData>;
  /**  The account which was billed.  */
  accountId: Scalars["String"]["output"];
  /**  The currency of the related amounts  */
  amountCurrency: Scalars["String"]["output"];
  /**  The total amount without the VAT (normalized in an integer, check the precision related to the currency)  */
  amountExcludingVat: Scalars["Float"]["output"];
  /**  The total amount including the VAT (normalized in an integer, check the precision related to the currency)  */
  amountIncludingVat: Scalars["Float"]["output"];
  /**  The VAT tax amount (normalized in an integer, check the precision related to the currency)  */
  amountVat: Scalars["Float"]["output"];
  /**  The document is available if not zero  */
  availableCheckedTs: Scalars["Int64"]["output"];
  /**  The related document if there is such  */
  billedAddressId: Scalars["String"]["output"];
  /**  The billing period linked to the invoice.  */
  billingPeriodId: Scalars["String"]["output"];
  /**  The timestamp when the invoice was completed (amounts, currencies, etc)  */
  completedTs: Scalars["Int64"]["output"];
  /**  The country of the invoice  */
  country: Scalars["String"]["output"];
  /**  The date of the invoice in ISO 8601 format  */
  date: Scalars["String"]["output"];
  /**  The date of the invoice in seconds  */
  dateTs: Scalars["String"]["output"];
  /**  The related document if there is such  */
  documentId: Scalars["String"]["output"];
  /**  The due date of the invoice in seconds  */
  dueDateTs: Scalars["String"]["output"];
  /**  The ID of the invoice  */
  id: Scalars["ID"]["output"];
  /**  Indicates the notification state of the invoice (SCHEDULED, SENT, FAILED, SENT_TO_PARENT)  */
  invoiceNotificationState: BillingMsSearchInvoicesResponseDataInvoiceNotificationState;
  /**  The number of the invoice  */
  number: Scalars["String"]["output"];
  /**  The recipient customer account number  */
  recipientAccountNumber: Scalars["String"]["output"];
  /**  The reference of the invoice  */
  reference: Scalars["String"]["output"];
  /**  Indicate the source of the invoice  */
  source: BillingMsSearchInvoicesResponseDataSource;
  /**  The subsidiary code related to the invoice  */
  subsidiaryCode: Scalars["String"]["output"];
  /**  The tid ready ts of the invoice  */
  tidReadyTs: Scalars["Int64"]["output"];
  /**  The related invoice type  */
  typeId: Scalars["String"]["output"];
};

export enum BillingMsSearchInvoicesResponseDataInvoiceNotificationState {
  InvoiceNotificationDisabled = "INVOICE_NOTIFICATION_DISABLED",
  InvoiceNotificationFailed = "INVOICE_NOTIFICATION_FAILED",
  InvoiceNotificationScheduled = "INVOICE_NOTIFICATION_SCHEDULED",
  InvoiceNotificationSent = "INVOICE_NOTIFICATION_SENT",
  InvoiceNotificationSentFcliGroup = "INVOICE_NOTIFICATION_SENT_FCLI_GROUP",
  InvoiceNotificationSentRlvpGroup = "INVOICE_NOTIFICATION_SENT_RLVP_GROUP",
  InvoiceNotificationSentToParentFcli = "INVOICE_NOTIFICATION_SENT_TO_PARENT_FCLI",
  InvoiceNotificationSentToParentRlvp = "INVOICE_NOTIFICATION_SENT_TO_PARENT_RLVP",
  UnknownInvoiceNotificationStatus = "UNKNOWN_INVOICE_NOTIFICATION_STATUS",
}

export enum BillingMsSearchInvoicesResponseDataSource {
  MonInvoice = "MON_INVOICE",
  NotifSap = "NOTIF_SAP",
  UnknownSource = "UNKNOWN_SOURCE",
}

/**  Search payer billing period for invoice  */
export type BillingMsSearchPayerBillingPeriodsRequest = {
  filters?: InputMaybe<BillingMsSearchPayerBillingPeriodsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchPayerBillingPeriodsRequestSort>>
  >;
};

export type BillingMsSearchPayerBillingPeriodsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchPayerBillingPeriodsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchPayerBillingPeriodsRequestSortField>;
};

export enum BillingMsSearchPayerBillingPeriodsRequestSortField {
  ClosedTs = "closed_ts",
  EndTs = "end_ts",
  Id = "id",
  StartTs = "start_ts",
}

export type BillingMsSearchPayerBillingPeriodsResponse = {
  __typename?: "BillingMsSearchPayerBillingPeriodsResponse";
  data?: Maybe<Array<BillingMsSearchPayerBillingPeriodsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchPayerBillingPeriodsResponseData = {
  __typename?: "BillingMsSearchPayerBillingPeriodsResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  BillingFrequencyIdData?: Maybe<BillingMsSearchBillingFrequenciesResponseData>;
  LinkedCustomerBillingPeriods?: Maybe<
    Array<Maybe<BillingMsSearchBillingPeriodLinksResponseData>>
  >;
  Tids?: Maybe<Array<Maybe<BillingMsSearchTidsResponseData>>>;
  /**  The account id linked to the billing period.  */
  accountId: Scalars["String"]["output"];
  /**  The billing frequency of the billing period.  */
  billingFrequencyId: Scalars["String"]["output"];
  /**  timestamp that indicates whether a billing period has been processed for delegate  */
  checkDelegateTs: Scalars["Int64"]["output"];
  /**  timestamp that indicates whether a billing period has been processed for payer  */
  checkPayerTs: Scalars["Int64"]["output"];
  /**  The timestamp when the billing period was closed  */
  closedTs: Scalars["Int64"]["output"];
  /**  The end timestamp for the billing period.  */
  endTs: Scalars["Int64"]["output"];
  /**  The id of the billing period.  */
  id: Scalars["ID"]["output"];
  /**  The start timestamp for the billing period.  */
  startTs: Scalars["Int64"]["output"];
  /**  The status of the billing period.  */
  status: BillingMsSearchPayerBillingPeriodsResponseDataStatus;
  /**  The timestamp when the tid is ready  */
  tidReadyTs: Scalars["Int64"]["output"];
  /**  The type of the billing period  */
  type: BillingMsSearchPayerBillingPeriodsResponseDataType;
};

export enum BillingMsSearchPayerBillingPeriodsResponseDataStatus {
  BillingPeriodStatusActive = "BILLING_PERIOD_STATUS_ACTIVE",
  BillingPeriodStatusClosed = "BILLING_PERIOD_STATUS_CLOSED",
  BillingPeriodStatusTemporarilyClosed = "BILLING_PERIOD_STATUS_TEMPORARILY_CLOSED",
  UnknownBillingPeriod = "UNKNOWN_BILLING_PERIOD",
}

export enum BillingMsSearchPayerBillingPeriodsResponseDataType {
  BillingPeriodTypeCustomer = "BILLING_PERIOD_TYPE_CUSTOMER",
  BillingPeriodTypeDelegate = "BILLING_PERIOD_TYPE_DELEGATE",
  BillingPeriodTypePayer = "BILLING_PERIOD_TYPE_PAYER",
  UnknownBillingPeriodType = "UNKNOWN_BILLING_PERIOD_TYPE",
}

/**  Search among payment documents  */
export type BillingMsSearchPaymentDocumentsRequest = {
  filters?: InputMaybe<BillingMsSearchPaymentDocumentsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchPaymentDocumentsRequestSort>>
  >;
};

export type BillingMsSearchPaymentDocumentsRequestFilters = {
  /**  The external ID of the Document.  */
  externalId?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  The number of the invoice  */
  invoiceNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**  The status of the notification of payment to SAP  */
  notificationStatus?: InputMaybe<BillingMsSearchPaymentDocumentsRequestFiltersNotificationStatus>;
  /**  The Payment the Document belongs to.  */
  paymentId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  The status of the notification of payment to SAP  */
export enum BillingMsSearchPaymentDocumentsRequestFiltersNotificationStatus {
  NotifFailed = "NOTIF_FAILED",
  NotifInProgress = "NOTIF_IN_PROGRESS",
  NotifSkipped = "NOTIF_SKIPPED",
  NotifSucceeded = "NOTIF_SUCCEEDED",
  UnknownNotifStatus = "UNKNOWN_NOTIF_STATUS",
}

export type BillingMsSearchPaymentDocumentsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchPaymentDocumentsRequestSortField>;
};

export enum BillingMsSearchPaymentDocumentsRequestSortField {
  CreatedTs = "created_ts",
  ExternalId = "external_id",
  InvoiceAmount = "invoice_amount",
  InvoiceDateTs = "invoice_date_ts",
  InvoiceDueDateTs = "invoice_due_date_ts",
  InvoiceFees = "invoice_fees",
  InvoiceNumber = "invoice_number",
  UpdatedTs = "updated_ts",
}

export type BillingMsSearchPaymentDocumentsResponse = {
  __typename?: "BillingMsSearchPaymentDocumentsResponse";
  data?: Maybe<Array<BillingMsSearchPaymentDocumentsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchPaymentDocumentsResponseData = {
  __typename?: "BillingMsSearchPaymentDocumentsResponseData";
  PaymentIdData?: Maybe<BillingMsSearchPaymentsResponseData>;
  createdTs: Scalars["Int64"]["output"];
  /**  The external ID of the Document.  */
  externalId: Scalars["String"]["output"];
  /**  The ID of the Document  */
  id: Scalars["ID"]["output"];
  /**  The amount of the invoice  */
  invoiceAmount: Scalars["Float"]["output"];
  /**  The fees of the invoice  */
  invoiceCurrency: Scalars["String"]["output"];
  /**  The date of the invoice  */
  invoiceDateTs: Scalars["Int64"]["output"];
  /**  The date of the invoice  */
  invoiceDueDateTs: Scalars["Int64"]["output"];
  /**  The fees of the invoice  */
  invoiceFees: Scalars["Float"]["output"];
  /**  The number of the invoice  */
  invoiceNumber: Scalars["String"]["output"];
  /**  The date of the notification to SAP (last succeeded or last try failed)  */
  notificationDateTs: Scalars["Int64"]["output"];
  /**  The status of the notification of payment to SAP  */
  notificationStatus: BillingMsSearchPaymentDocumentsResponseDataNotificationStatus;
  /**  The Payment the Document belongs to.  */
  paymentId: Scalars["ID"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

/**  The status of the notification of payment to SAP  */
export enum BillingMsSearchPaymentDocumentsResponseDataNotificationStatus {
  NotifFailed = "NOTIF_FAILED",
  NotifInProgress = "NOTIF_IN_PROGRESS",
  NotifSkipped = "NOTIF_SKIPPED",
  NotifSucceeded = "NOTIF_SUCCEEDED",
  UnknownNotifStatus = "UNKNOWN_NOTIF_STATUS",
}

/**  Search among payment methods  */
export type BillingMsSearchPaymentMethodsRequest = {
  filters?: InputMaybe<BillingMsSearchPaymentMethodsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchPaymentMethodsRequestSort>>
  >;
};

export type BillingMsSearchPaymentMethodsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchPaymentMethodsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchPaymentMethodsRequestSortField>;
};

export enum BillingMsSearchPaymentMethodsRequestSortField {
  Code = "code",
}

export type BillingMsSearchPaymentMethodsResponse = {
  __typename?: "BillingMsSearchPaymentMethodsResponse";
  data?: Maybe<Array<BillingMsSearchPaymentMethodsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchPaymentMethodsResponseData = {
  __typename?: "BillingMsSearchPaymentMethodsResponseData";
  /**  The code name  */
  code: Scalars["String"]["output"];
  /**  The ID of the billing frequency  */
  id: Scalars["ID"]["output"];
};

/**  Search among payments  */
export type BillingMsSearchPaymentsRequest = {
  filters?: InputMaybe<BillingMsSearchPaymentsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<BillingMsSearchPaymentsRequestSort>>>;
};

export type BillingMsSearchPaymentsRequestFilters = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  statuses?: InputMaybe<
    Array<InputMaybe<BillingMsSearchPaymentsRequestFiltersStatuses>>
  >;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export enum BillingMsSearchPaymentsRequestFiltersStatuses {
  Cancelled = "CANCELLED",
  Closed = "CLOSED",
  Created = "CREATED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Succeeded = "SUCCEEDED",
  UnknownPaymentStatus = "UNKNOWN_PAYMENT_STATUS",
}

export type BillingMsSearchPaymentsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchPaymentsRequestSortField>;
};

export enum BillingMsSearchPaymentsRequestSortField {
  Status = "status",
  Type = "type",
}

export type BillingMsSearchPaymentsResponse = {
  __typename?: "BillingMsSearchPaymentsResponse";
  data?: Maybe<Array<BillingMsSearchPaymentsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchPaymentsResponseData = {
  __typename?: "BillingMsSearchPaymentsResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  The Account the Payment belongs to.  */
  accountId: Scalars["String"]["output"];
  /**  The amount of the Payment  */
  amount: Scalars["Float"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  The currency of the Payment  */
  currency: Scalars["String"]["output"];
  /**  The ID of the Payment.  */
  id: Scalars["ID"]["output"];
  /**  The reference of the Payment (unique)  */
  reference: Scalars["String"]["output"];
  /**  The status of the Payment  */
  status: BillingMsSearchPaymentsResponseDataStatus;
  /**  The type of the Payment (GUARANTEE or INVOICE)  */
  type: BillingMsSearchPaymentsResponseDataType;
  updatedTs: Scalars["Int64"]["output"];
  /**  The User that requested the Payment.  */
  userId: Scalars["String"]["output"];
};

/**  The status of the Payment  */
export enum BillingMsSearchPaymentsResponseDataStatus {
  Cancelled = "CANCELLED",
  Closed = "CLOSED",
  Created = "CREATED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Succeeded = "SUCCEEDED",
  UnknownPaymentStatus = "UNKNOWN_PAYMENT_STATUS",
}

/**  The type of the Payment (GUARANTEE or INVOICE)  */
export enum BillingMsSearchPaymentsResponseDataType {
  Ccl = "CCL",
  Guarantee = "GUARANTEE",
  Invoice = "INVOICE",
  Sap = "SAP",
  Undefined = "UNDEFINED",
}

/**  Search for TID Delivery Configurations based on filter (Account IDs)  */
export type BillingMsSearchTidDeliveryConfigRequest = {
  filters?: InputMaybe<BillingMsSearchTidDeliveryConfigRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchTidDeliveryConfigRequestSort>>
  >;
};

export type BillingMsSearchTidDeliveryConfigRequestFilters = {
  /**  Filter by one or more account IDs  */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchTidDeliveryConfigRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchTidDeliveryConfigRequestSortField>;
};

export enum BillingMsSearchTidDeliveryConfigRequestSortField {
  CreatedTs = "created_ts",
  UpdatedTs = "updated_ts",
}

export type BillingMsSearchTidDeliveryConfigResponse = {
  __typename?: "BillingMsSearchTidDeliveryConfigResponse";
  data?: Maybe<Array<BillingMsSearchTidDeliveryConfigResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchTidDeliveryConfigResponseData = {
  __typename?: "BillingMsSearchTidDeliveryConfigResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  associated account id  */
  accountId: Scalars["ID"]["output"];
  /**  created timestamp  */
  createdTs: Scalars["Int64"]["output"];
  /**  id of the flow from boost  */
  externalFlowId: Scalars["String"]["output"];
  /**  unique identifier  */
  id: Scalars["ID"]["output"];
  /**  destination path for delivery  */
  path: Scalars["String"]["output"];
  /**  delivery type (e.g., SFTP)  */
  type: BillingMsSearchTidDeliveryConfigResponseDataType;
  /**  updated timestamp  */
  updatedTs: Scalars["Int64"]["output"];
  /**  user who configured the delivery  */
  userId: Scalars["ID"]["output"];
};

export enum BillingMsSearchTidDeliveryConfigResponseDataType {
  TidDeliveryTypeSftp = "TID_DELIVERY_TYPE_SFTP",
  TidDeliveryTypeUnspecified = "TID_DELIVERY_TYPE_UNSPECIFIED",
}

/**  Search tid linked account types  */
export type BillingMsSearchTidLinkedAccountTypesRequest = {
  filters?: InputMaybe<BillingMsSearchTidLinkedAccountTypesRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchTidLinkedAccountTypesRequestSort>>
  >;
};

export type BillingMsSearchTidLinkedAccountTypesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  lockedStatus?: InputMaybe<BillingMsSearchTidLinkedAccountTypesRequestFiltersLockedStatus>;
};

export enum BillingMsSearchTidLinkedAccountTypesRequestFiltersLockedStatus {
  IsLocked = "IS_LOCKED",
  IsUnlocked = "IS_UNLOCKED",
  UnknownStatus = "UNKNOWN_STATUS",
}

export type BillingMsSearchTidLinkedAccountTypesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchTidLinkedAccountTypesRequestSortField>;
};

export enum BillingMsSearchTidLinkedAccountTypesRequestSortField {
  CreatedTs = "created_ts",
  Id = "id",
  UpdatedTs = "updated_ts",
}

export type BillingMsSearchTidLinkedAccountTypesResponse = {
  __typename?: "BillingMsSearchTidLinkedAccountTypesResponse";
  data?: Maybe<Array<BillingMsSearchTidLinkedAccountTypesResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchTidLinkedAccountTypesResponseData = {
  __typename?: "BillingMsSearchTidLinkedAccountTypesResponseData";
  /**  uuid of invoice  */
  code: Scalars["String"]["output"];
  /**  the created ts of the linked account type  */
  createdTs: Scalars["Int64"]["output"];
  /**  id  */
  id: Scalars["String"]["output"];
  /**  if the link is from salsa or BO  */
  isLocked: Scalars["Boolean"]["output"];
  /**  the updated ts of the linked account type  */
  updatedTs: Scalars["Int64"]["output"];
};

/**  Search for tid linked accounts  */
export type BillingMsSearchTidLinkedAccountsRequest = {
  filters?: InputMaybe<BillingMsSearchTidLinkedAccountsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<BillingMsSearchTidLinkedAccountsRequestSort>>
  >;
};

export type BillingMsSearchTidLinkedAccountsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  linkedAccountId?: InputMaybe<Scalars["ID"]["input"]>;
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchTidLinkedAccountsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchTidLinkedAccountsRequestSortField>;
};

export enum BillingMsSearchTidLinkedAccountsRequestSortField {
  CreatedTs = "created_ts",
  Id = "id",
  UpdatedTs = "updated_ts",
}

export type BillingMsSearchTidLinkedAccountsResponse = {
  __typename?: "BillingMsSearchTidLinkedAccountsResponse";
  data?: Maybe<Array<BillingMsSearchTidLinkedAccountsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchTidLinkedAccountsResponseData = {
  __typename?: "BillingMsSearchTidLinkedAccountsResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  LinkedAccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  TypeIdData?: Maybe<BillingMsSearchTidLinkedAccountTypesResponseData>;
  /**  The account id  */
  accountId: Scalars["String"]["output"];
  /**  The timestamp when the link was created.  */
  createdTs: Scalars["Int64"]["output"];
  /**  The timestamp when the link was deleted.  */
  deletedTs: Scalars["Int64"]["output"];
  /**  The id of the link.  */
  id: Scalars["String"]["output"];
  /**  The linked account id.  */
  linkedAccountId: Scalars["String"]["output"];
  /**  The id of the linked account.  */
  typeId: Scalars["String"]["output"];
  /**  The timestamp when the link was updated.  */
  updatedTs: Scalars["Int64"]["output"];
  /**  The user id of the person who created the link.  */
  userId: Scalars["String"]["output"];
};

export type BillingMsSearchTidOrdersRequest = {
  filters?: InputMaybe<BillingMsSearchTidOrdersRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<BillingMsSearchTidOrdersRequestSort>>>;
};

export type BillingMsSearchTidOrdersRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  statuses?: InputMaybe<
    Array<InputMaybe<BillingMsSearchTidOrdersRequestFiltersStatuses>>
  >;
  tidIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export enum BillingMsSearchTidOrdersRequestFiltersStatuses {
  TidOrderStatusCreated = "TID_ORDER_STATUS_CREATED",
  TidOrderStatusFailed = "TID_ORDER_STATUS_FAILED",
  TidOrderStatusInProgress = "TID_ORDER_STATUS_IN_PROGRESS",
  TidOrderStatusSuccess = "TID_ORDER_STATUS_SUCCESS",
  TidOrderStatusUnknown = "TID_ORDER_STATUS_UNKNOWN",
}

export type BillingMsSearchTidOrdersRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchTidOrdersRequestSortField>;
};

export enum BillingMsSearchTidOrdersRequestSortField {
  CreatedTs = "created_ts",
  Status = "status",
  UpdatedTs = "updated_ts",
}

export type BillingMsSearchTidOrdersResponse = {
  __typename?: "BillingMsSearchTidOrdersResponse";
  data?: Maybe<Array<BillingMsSearchTidOrdersResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchTidOrdersResponseData = {
  __typename?: "BillingMsSearchTidOrdersResponseData";
  TidIdData?: Maybe<BillingMsSearchTidsResponseData>;
  /**  the created timestamp  */
  createdTs: Scalars["Int64"]["output"];
  /**  the reason of failure in case of errors  */
  failReason: Scalars["String"]["output"];
  /**  the id of the TidOrder  */
  id: Scalars["ID"]["output"];
  /**  locale of the tid order  */
  locale: Scalars["String"]["output"];
  /**  the retry count for a tid order  */
  retryCount: Scalars["Int"]["output"];
  /**  the enum of status for TidOrder  */
  status: BillingMsSearchTidOrdersResponseDataStatus;
  /**  the termination timestamp  */
  terminationTs: Scalars["Int64"]["output"];
  /**  the linked tid_id  */
  tidId: Scalars["ID"]["output"];
  /**  time zone is needed for TID XLS V1  */
  timezone: Scalars["String"]["output"];
  /**  the updated timestamp  */
  updatedTs: Scalars["Int64"]["output"];
  /**  the user id performing the tid order  */
  userId: Scalars["ID"]["output"];
};

export enum BillingMsSearchTidOrdersResponseDataStatus {
  TidOrderStatusCreated = "TID_ORDER_STATUS_CREATED",
  TidOrderStatusFailed = "TID_ORDER_STATUS_FAILED",
  TidOrderStatusInProgress = "TID_ORDER_STATUS_IN_PROGRESS",
  TidOrderStatusSuccess = "TID_ORDER_STATUS_SUCCESS",
  TidOrderStatusUnknown = "TID_ORDER_STATUS_UNKNOWN",
}

export type BillingMsSearchTidTypeRequest = {
  filters?: InputMaybe<BillingMsSearchTidTypeRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<BillingMsSearchTidTypeRequestSort>>>;
};

export type BillingMsSearchTidTypeRequestFilters = {
  code?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchTidTypeRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchTidTypeRequestSortField>;
};

export enum BillingMsSearchTidTypeRequestSortField {
  Code = "code",
  CreatedTs = "created_ts",
  UpdatedTs = "updated_ts",
}

export type BillingMsSearchTidTypeResponse = {
  __typename?: "BillingMsSearchTidTypeResponse";
  data?: Maybe<Array<BillingMsSearchTidTypeResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchTidTypeResponseData = {
  __typename?: "BillingMsSearchTidTypeResponseData";
  /**  tid type code  */
  code: Scalars["String"]["output"];
  /**  the created ts of tid type  */
  createdTs: Scalars["Int64"]["output"];
  /**  id  */
  id: Scalars["String"]["output"];
  /**  the updated ts of the tid type  */
  updatedTs: Scalars["Int64"]["output"];
};

/**  Search among Tids  */
export type BillingMsSearchTidsRequest = {
  filters?: InputMaybe<BillingMsSearchTidsRequestFilters>;
  paging?: InputMaybe<BillingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<BillingMsSearchTidsRequestSort>>>;
};

export type BillingMsSearchTidsRequestFilters = {
  billingPeriodIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type BillingMsSearchTidsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<BillingMsSearchTidsRequestSortField>;
};

export enum BillingMsSearchTidsRequestSortField {
  EndDateTs = "end_date_ts",
  StartDateTs = "start_date_ts",
}

export type BillingMsSearchTidsResponse = {
  __typename?: "BillingMsSearchTidsResponse";
  data?: Maybe<Array<BillingMsSearchTidsResponseData>>;
  pagination: BillingMsPagedPagination;
};

export type BillingMsSearchTidsResponseData = {
  __typename?: "BillingMsSearchTidsResponseData";
  AccountIdData?: Maybe<BillingMsSearchBillingAccountPreferencesResponseData>;
  BillingPeriodIdData?: Maybe<BillingMsSearchBillingPeriodsResponseData>;
  DocumentIdData?: Maybe<MediaMsSearchDocumentsResponseData>;
  TypeIdData?: Maybe<BillingMsSearchTidTypeResponseData>;
  /**  The Account the TID belongs to.  */
  accountId: Scalars["String"]["output"];
  /**  The billing period linked to the invoice.  */
  billingPeriodId: Scalars["String"]["output"];
  /**  The id of the related TXT document.  */
  documentId: Scalars["String"]["output"];
  /**  The end date.  */
  endDateTs: Scalars["Int64"]["output"];
  /**  The external ID of the TID.  */
  externalId: Scalars["ID"]["output"];
  /**  The ID of the TID.  */
  id: Scalars["ID"]["output"];
  /**  The start date.  */
  startDateTs: Scalars["Int64"]["output"];
  /**  tid format xls / TXT  */
  tidFormat: BillingMsSearchTidsResponseDataTidFormat;
  /**  type of tid delegate,payer,account  */
  typeId: Scalars["String"]["output"];
};

export enum BillingMsSearchTidsResponseDataTidFormat {
  TidTxt = "TID_TXT",
  TidXls = "TID_XLS",
  UnknownType = "UNKNOWN_TYPE",
}

/**  Update account address  */
export type BillingMsUpdateAccountEmailAddressRequest = {
  /**  Email Address to update account  */
  preferredContactEmail?: InputMaybe<Scalars["String"]["input"]>;
};

/**  Archive collaborator  */
export type CollaboratorsMsArchiveCollaboratorRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**  Todo: rename to archived_ts  */
  leavingDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type CollaboratorsMsCountCollaboratorsByStatusResponse = {
  __typename?: "CollaboratorsMsCountCollaboratorsByStatusResponse";
  /**  All collaborators currently in the company  */
  activated: Scalars["Int64"]["output"];
  /**  All collaborators  */
  all: Scalars["Int64"]["output"];
  /**  All collaborators who left the company  */
  archived: Scalars["Int64"]["output"];
};

/**  Count collaborators in sector  */
export type CollaboratorsMsCountCollaboratorsInSectorRequest = {
  filters?: InputMaybe<CollaboratorsMsCountCollaboratorsInSectorRequestFilters>;
};

export type CollaboratorsMsCountCollaboratorsInSectorRequestFilters = {
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type CollaboratorsMsCountCollaboratorsInSectorResponse = {
  __typename?: "CollaboratorsMsCountCollaboratorsInSectorResponse";
  /**  All collaborators in sectors  */
  data?: Maybe<Array<CollaboratorsMsCountCollaboratorsInSectorResponseData>>;
};

/**  All collaborators in sectors  */
export type CollaboratorsMsCountCollaboratorsInSectorResponseData = {
  __typename?: "CollaboratorsMsCountCollaboratorsInSectorResponseData";
  /**  All collaborators without archived date or in future  */
  activated: Scalars["Int64"]["output"];
  /**  All collaborators  */
  all: Scalars["Int64"]["output"];
  /**  All collaborators with an expired archive date exceeded  */
  archived: Scalars["Int64"]["output"];
  sectorId: Scalars["ID"]["output"];
};

/**  Create a collaborator  */
export type CollaboratorsMsCreateCollaboratorRequest = {
  contactEmail?: InputMaybe<Scalars["String"]["input"]>;
  /**
   *  A four-digit code that is used only in account with the feature DRIVER_CODES
   * If the driver code does not exist from our partner, we will request to create it
   * The driver code will be in "creating" state.
   * Is also allowed an orphan driver code (the driver code will be in "active" state).
   */
  driverCode?: InputMaybe<Scalars["String"]["input"]>;
  /**  A label(name) for the driver code when creating a driverCode with the collaborator  */
  driverCodeLabel?: InputMaybe<Scalars["String"]["input"]>;
  /**  Todo: remove  */
  enteredDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
  supportNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollaboratorsMsCreateCollaboratorResponse = {
  __typename?: "CollaboratorsMsCreateCollaboratorResponse";
  /**  The ID of the Collaborator  */
  id: Scalars["ID"]["output"];
};

/**  Create a driver code with option to assign a collaborator  */
export type CollaboratorsMsCreateDriverCodeRequest = {
  /**  on creating a driver code, a collaborator can be linked to it  */
  collaboratorId?: InputMaybe<Scalars["ID"]["input"]>;
  driverCode?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  supportNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollaboratorsMsCreateDriverCodeResponse = {
  __typename?: "CollaboratorsMsCreateDriverCodeResponse";
  /**  The ID of the DriverCode  */
  id: Scalars["ID"]["output"];
};

/**
 *  Link a driver code to a collaborator. If the driver code does not exist, we will request our partner to create it.
 * The driver code will be in "creating" state.
 * We can also link an orphan driver code. It will be in "active" state.
 * We can link a driver code for a collaborator that has no driver code yet, or their drive code is blocked.
 */
export type CollaboratorsMsLinkDriverCodeRequest = {
  collaboratorId?: InputMaybe<Scalars["ID"]["input"]>;
  driverCode?: InputMaybe<Scalars["String"]["input"]>;
  driverCodeLabel?: InputMaybe<Scalars["String"]["input"]>;
  supportNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollaboratorsMsPagedPagination = {
  __typename?: "CollaboratorsMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type CollaboratorsMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 *  Our partner has accepted our request, the driver code will have the state "waiting to be blocked"
 * The driver code will be "blocked" when our partner will send us the relative state
 * If the partner does not accept our request (error), the driver code will stay at its previous state
 * Only an active driver code can be blocked.
 */
export type CollaboratorsMsRequestToBlockDriverCodeRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type CollaboratorsMsRequestToBlockDriverCodeResponse = {
  __typename?: "CollaboratorsMsRequestToBlockDriverCodeResponse";
  bulkOperationId: Scalars["ID"]["output"];
  isBulkOperation: Scalars["Boolean"]["output"];
};

/**
 *  Our partner has accepted our request, the driver code will have the state "waiting to be unblocked"
 * The driver code will be "unblocked" when our partner will send us the relative state
 * If the partner does not accept our request (error), the driver code will stay at its previous state
 * Only a blocked driver code can be unblocked.
 */
export type CollaboratorsMsRequestToUnBlockDriverCodeRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type CollaboratorsMsRequestToUnBlockDriverCodeResponse = {
  __typename?: "CollaboratorsMsRequestToUnBlockDriverCodeResponse";
  bulkOperationId: Scalars["ID"]["output"];
  isBulkOperation: Scalars["Boolean"]["output"];
};

/**  Search among collaborators  */
export type CollaboratorsMsSearchCollaboratorsRequest = {
  filters?: InputMaybe<CollaboratorsMsSearchCollaboratorsRequestFilters>;
  paging?: InputMaybe<CollaboratorsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<CollaboratorsMsSearchCollaboratorsRequestSort>>
  >;
};

export type CollaboratorsMsSearchCollaboratorsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  When set to "true", only collaborator matching the "can be allocated" rule are returned  */
  allocatableOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollaboratorsMsSearchCollaboratorsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<CollaboratorsMsSearchCollaboratorsRequestSortField>;
};

export enum CollaboratorsMsSearchCollaboratorsRequestSortField {
  FirstName = "first_name",
  Id = "id",
  LastName = "last_name",
}

export type CollaboratorsMsSearchCollaboratorsResponse = {
  __typename?: "CollaboratorsMsSearchCollaboratorsResponse";
  data?: Maybe<Array<CollaboratorsMsSearchCollaboratorsResponseData>>;
  pagination: CollaboratorsMsPagedPagination;
};

export type CollaboratorsMsSearchCollaboratorsResponseData = {
  __typename?: "CollaboratorsMsSearchCollaboratorsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  Allocations?: Maybe<
    Array<Maybe<CollaboratorsMsSearchDriverCodeAllocationsResponseData>>
  >;
  Assignments?: Maybe<
    Array<Maybe<AssignmentsMsSearchCollaboratorAssignmentsResponseData>>
  >;
  NameLedgers?: Maybe<Array<Maybe<LedgersMsSearchLedgersResponseData>>>;
  SectorIdData?: Maybe<SectorsMsSearchSectorsResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**  The date the collaborator has been archived  */
  archivedTs: Scalars["Int64"]["output"];
  /**  The informative email address of the collaborator  */
  contactEmail: Scalars["String"]["output"];
  /**  Todo: remove  */
  enteredDateTs: Scalars["Int64"]["output"];
  /**  The first name  */
  firstName: Scalars["String"]["output"];
  /**  The ID of a Collaborator  */
  id: Scalars["ID"]["output"];
  /**  The functions of the collaborator  */
  jobTitle: Scalars["String"]["output"];
  /**  The last name  */
  lastName: Scalars["String"]["output"];
  /**  Todo: replaced by archived_ts  */
  leavingDateTs: Scalars["Int64"]["output"];
  /**  The related sector  */
  sectorId: Scalars["ID"]["output"];
  status: CollaboratorsMsSearchCollaboratorsResponseDataStatus;
  /**  The email of the collaborator supervisor  */
  supervisorEmail: Scalars["String"]["output"];
};

export enum CollaboratorsMsSearchCollaboratorsResponseDataStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  CollaboratorStatusUnknown = "COLLABORATOR_STATUS_UNKNOWN",
}

export type CollaboratorsMsSearchDriverCodeAllocationsRequest = {
  filters?: InputMaybe<CollaboratorsMsSearchDriverCodeAllocationsRequestFilters>;
  paging?: InputMaybe<CollaboratorsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<CollaboratorsMsSearchDriverCodeAllocationsRequestSort>>
  >;
};

export type CollaboratorsMsSearchDriverCodeAllocationsRequestFilters = {
  collaboratorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  driverCodeIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**
   *  Only active allocations are retrieved by default (based on current time).
   * This filter allows to get both active and inactive allocations
   */
  showAll?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollaboratorsMsSearchDriverCodeAllocationsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<CollaboratorsMsSearchDriverCodeAllocationsRequestSortField>;
};

export enum CollaboratorsMsSearchDriverCodeAllocationsRequestSortField {
  DriverCodeId = "driver_code_id",
  FromTs = "from_ts",
  Id = "id",
}

export type CollaboratorsMsSearchDriverCodeAllocationsResponse = {
  __typename?: "CollaboratorsMsSearchDriverCodeAllocationsResponse";
  data?: Maybe<Array<CollaboratorsMsSearchDriverCodeAllocationsResponseData>>;
  pagination: CollaboratorsMsPagedPagination;
};

export type CollaboratorsMsSearchDriverCodeAllocationsResponseData = {
  __typename?: "CollaboratorsMsSearchDriverCodeAllocationsResponseData";
  CollaboratorIdData?: Maybe<CollaboratorsMsSearchCollaboratorsResponseData>;
  DriverCodeIdData?: Maybe<CollaboratorsMsSearchDriverCodesResponseData>;
  /**  The related collaborator  */
  collaboratorId: Scalars["ID"]["output"];
  /**  The related driver code  */
  driverCodeId: Scalars["ID"]["output"];
  /**  The allocation start date  */
  fromTs: Scalars["Int64"]["output"];
  id: Scalars["ID"]["output"];
  /**  The allocation end date  */
  tillTs: Scalars["Int64"]["output"];
};

export type CollaboratorsMsSearchDriverCodesRequest = {
  filters?: InputMaybe<CollaboratorsMsSearchDriverCodesRequestFilters>;
  paging?: InputMaybe<CollaboratorsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<CollaboratorsMsSearchDriverCodesRequestSort>>
  >;
};

export type CollaboratorsMsSearchDriverCodesRequestFilters = {
  /**  When set to "true", only driver codes matching the "can be allocated" rule are returned  */
  allocatableOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  Used to filter driver status - can be multiple statuses at once  */
  status?: InputMaybe<
    Array<InputMaybe<CollaboratorsMsSearchDriverCodesRequestFiltersStatus>>
  >;
  supportNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/**  Used to filter driver status - can be multiple statuses at once  */
export enum CollaboratorsMsSearchDriverCodesRequestFiltersStatus {
  Burned = "BURNED",
  Creating = "CREATING",
  DriverCodeStatusUnknown = "DRIVER_CODE_STATUS_UNKNOWN",
  IsActive = "IS_ACTIVE",
  IsSuspended = "IS_SUSPENDED",
  Modifying = "MODIFYING",
  Reactivating = "REACTIVATING",
  Suspending = "SUSPENDING",
}

export type CollaboratorsMsSearchDriverCodesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<CollaboratorsMsSearchDriverCodesRequestSortField>;
};

export enum CollaboratorsMsSearchDriverCodesRequestSortField {
  Code = "code",
  Id = "id",
  Name = "name",
}

export type CollaboratorsMsSearchDriverCodesResponse = {
  __typename?: "CollaboratorsMsSearchDriverCodesResponse";
  data?: Maybe<Array<CollaboratorsMsSearchDriverCodesResponseData>>;
  pagination: CollaboratorsMsPagedPagination;
};

export type CollaboratorsMsSearchDriverCodesResponseData = {
  __typename?: "CollaboratorsMsSearchDriverCodesResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  Allocations?: Maybe<
    Array<Maybe<CollaboratorsMsSearchDriverCodeAllocationsResponseData>>
  >;
  SectorIdData?: Maybe<SectorsMsSearchSectorsResponseData>;
  Support?: Maybe<LedgersMsSearchWalletSettingsResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**  The four-digit human-readable code  */
  code: Scalars["String"]["output"];
  collaboratorId: Scalars["ID"]["output"];
  /**  The ID of a Driver Code  */
  id: Scalars["ID"]["output"];
  /**  The name of a Driver Code  */
  name: Scalars["String"]["output"];
  /**  The related sector  */
  sectorId: Scalars["ID"]["output"];
  /**  The current status  */
  status: CollaboratorsMsSearchDriverCodesResponseDataStatus;
  /**  The support number of the code  */
  supportNumber: Scalars["String"]["output"];
};

export enum CollaboratorsMsSearchDriverCodesResponseDataStatus {
  Burned = "BURNED",
  Creating = "CREATING",
  DriverCodeStatusUnknown = "DRIVER_CODE_STATUS_UNKNOWN",
  IsActive = "IS_ACTIVE",
  IsSuspended = "IS_SUSPENDED",
  Modifying = "MODIFYING",
  Reactivating = "REACTIVATING",
  Suspending = "SUSPENDING",
}

/**  Set a collaborator supervisor  */
export type CollaboratorsMsSetSupervisorRequest = {
  collaboratorId?: InputMaybe<Scalars["ID"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollaboratorsMsSuggestDriverCodeRequest = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
  supportNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollaboratorsMsSuggestDriverCodeResponse = {
  __typename?: "CollaboratorsMsSuggestDriverCodeResponse";
  code: Scalars["String"]["output"];
};

/**  Unarchive collaborator  */
export type CollaboratorsMsUnarchiveCollaboratorRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Remove a supervisor from a collaborator  */
export type CollaboratorsMsUnsetSupervisorRequest = {
  collaboratorId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Updates a collaborator  */
export type CollaboratorsMsUpdateCollaboratorRequest = {
  /**  The informative email address of the collaborator  */
  contactEmail?: InputMaybe<Scalars["String"]["input"]>;
  /**  The first name  */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**  The ID of a Collaborator  */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The functions of the collaborator  */
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  /**  The last name  */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**  The related sector  */
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Update a driver code label with option to assign or update a collaborator  */
export type CollaboratorsMsUpdateDriverCodeRequest = {
  /**  on updating a driver code, we can link or update the linked collaborator  */
  collaboratorId?: InputMaybe<Scalars["ID"]["input"]>;
  driverCodeId?: InputMaybe<Scalars["ID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
};

/**  Search + create + update collaborator for mobility corporate  */
export type CollaboratorsMsUpsertMobilityCorporateCollaboratorRequest = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CollaboratorsMsUpsertMobilityCorporateCollaboratorResponse = {
  __typename?: "CollaboratorsMsUpsertMobilityCorporateCollaboratorResponse";
  collaboratorId: Scalars["ID"]["output"];
};

/**  Flag customer in invoice for resync  */
export type DatabayMsUpdateByAccountIdRequest = {
  accountId?: InputMaybe<Scalars["String"]["input"]>;
};

/**  Block (oppose) a card or a badge for system partners  */
export type LedgersMsBlockLedgerAsPartnerRequest = {
  /**  The PAN  */
  pan?: InputMaybe<Scalars["String"]["input"]>;
  /**  Why do you wish to block this ledger?  */
  reason?: InputMaybe<LedgersMsBlockLedgerAsPartnerRequestReason>;
  /**  Set to true if you wish to receive a replacement card  */
  renew?: InputMaybe<Scalars["Boolean"]["input"]>;
  who?: InputMaybe<LedgersMsBlockLedgerAsPartnerRequestWho>;
};

/**  Why do you wish to block this ledger?  */
export enum LedgersMsBlockLedgerAsPartnerRequestReason {
  Defective = "DEFECTIVE",
  Lost = "LOST",
  NotReceived = "NOT_RECEIVED",
  Stolen = "STOLEN",
  Undefined = "UNDEFINED",
}

export type LedgersMsBlockLedgerAsPartnerRequestWho = {
  /**  The end user Gigya ID  */
  gigyaId?: InputMaybe<Scalars["String"]["input"]>;
  /**  The requesting service  */
  service?: InputMaybe<LedgersMsBlockLedgerAsPartnerRequestWhoService>;
};

/**  The requesting service  */
export enum LedgersMsBlockLedgerAsPartnerRequestWhoService {
  MyCard = "MY_CARD",
  ServiceUndefined = "SERVICE_UNDEFINED",
}

/**  Check if ledger with duplicata can be blocked  */
export type LedgersMsBlockLedgerOptionsRequest = {
  /**  The ledger id  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsBlockLedgerOptionsResponse = {
  __typename?: "LedgersMsBlockLedgerOptionsResponse";
  /**  boolean stating if duplicata of a ledger is available  */
  isDuplicataAvailable: Scalars["Boolean"]["output"];
  /**  list of reasons for blocking the ledger  */
  reasons?: Maybe<Array<LedgersMsBlockLedgerOptionsResponseReasons>>;
};

/**  list of reasons for blocking the ledger  */
export enum LedgersMsBlockLedgerOptionsResponseReasons {
  Defective = "DEFECTIVE",
  Lost = "LOST",
  NotReceived = "NOT_RECEIVED",
  Stolen = "STOLEN",
  Undefined = "UNDEFINED",
}

/**  Block (oppose) a card or a badge  */
export type LedgersMsBlockLedgerRequest = {
  /**  The ledger id  */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**  Why do you wish to block this ledger?  */
  reason?: InputMaybe<LedgersMsBlockLedgerRequestReason>;
  /**  Set to true if you wish to receive a replacement card  */
  renew?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**  Why do you wish to block this ledger?  */
export enum LedgersMsBlockLedgerRequestReason {
  Defective = "DEFECTIVE",
  Lost = "LOST",
  NotReceived = "NOT_RECEIVED",
  Stolen = "STOLEN",
  Undefined = "UNDEFINED",
}

/**  Who initiated the request  */
export type LedgersMsBlockLedgerRequestWho = {
  gigyaId?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsBlockLedgerResponse = {
  __typename?: "LedgersMsBlockLedgerResponse";
  /**  The partner's http status if not successful  */
  httpStatusCode: Scalars["Int"]["output"];
  /**  Contains the failed reason from card pro  */
  messageBody: Scalars["String"]["output"];
};

/**  Cancel the renewal of a ledger  */
export type LedgersMsCancelLedgerRenewalRequest = {
  /**  The ledger id  */
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsCancelLedgerRenewalRequestWho = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsCancelLedgerRenewalResponse = {
  __typename?: "LedgersMsCancelLedgerRenewalResponse";
  httpStatusCode: Scalars["Int"]["output"];
  invalidEncodedJsonData: Scalars["Boolean"]["output"];
  /**  Contains the failed reason from card pro  */
  messageBody: Scalars["String"]["output"];
};

/**  Count the ledgers by status  */
export type LedgersMsCountLedgersByStatusRequest = {
  /**  The type of ledger to count by status  */
  pcomType?: InputMaybe<LedgersMsCountLedgersByStatusRequestPcomType>;
  /**  The list of status codes to narrow the result with. All codes will be used if empty.  */
  statusCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/**  The type of ledger to count by status  */
export enum LedgersMsCountLedgersByStatusRequestPcomType {
  Badge = "BADGE",
  Card = "CARD",
  PcomTypeUnknown = "PCOM_TYPE_UNKNOWN",
}

export type LedgersMsCountLedgersByStatusResponse = {
  __typename?: "LedgersMsCountLedgersByStatusResponse";
  metrics?: Maybe<Array<LedgersMsCountLedgersByStatusResponseMetric>>;
};

export type LedgersMsCountLedgersByStatusResponseMetric = {
  __typename?: "LedgersMsCountLedgersByStatusResponseMetric";
  StatusIdData?: Maybe<LedgersMsSearchStatusesResponseData>;
  ledgerTypeMetrics?: Maybe<
    Array<LedgersMsCountLedgersByStatusResponseMetricLedgerTypeMetric>
  >;
  /**  The ledger status code  */
  statusCode: Scalars["String"]["output"];
  /**  The ledger status id  */
  statusId: Scalars["ID"]["output"];
  /**  The total number of ledgers  */
  total: Scalars["Int64"]["output"];
};

export type LedgersMsCountLedgersByStatusResponseMetricLedgerTypeMetric = {
  __typename?: "LedgersMsCountLedgersByStatusResponseMetricLedgerTypeMetric";
  total: Scalars["Int64"]["output"];
  type: Scalars["String"]["output"];
};

/**  Count ledgers in sector  */
export type LedgersMsCountLedgersInSectorRequest = {
  filters?: InputMaybe<LedgersMsCountLedgersInSectorRequestFilters>;
};

export type LedgersMsCountLedgersInSectorRequestFilters = {
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsCountLedgersInSectorResponse = {
  __typename?: "LedgersMsCountLedgersInSectorResponse";
  /**  All cards in sectors  */
  data?: Maybe<Array<LedgersMsCountLedgersInSectorResponseData>>;
};

/**  All cards in sectors  */
export type LedgersMsCountLedgersInSectorResponseData = {
  __typename?: "LedgersMsCountLedgersInSectorResponseData";
  counts?: Maybe<
    Array<LedgersMsCountLedgersInSectorResponseDataCountByPcomType>
  >;
  sectorId: Scalars["ID"]["output"];
};

export type LedgersMsCountLedgersInSectorResponseDataCountByPcomType = {
  __typename?: "LedgersMsCountLedgersInSectorResponseDataCountByPcomType";
  /**  All ledgers of category  */
  all: Scalars["Int64"]["output"];
  /**  The ledger group category  */
  category: LedgersMsCountLedgersInSectorResponseDataCountByPcomTypeCategory;
  /**  Ledgers of category with an expired archive date exceeded  */
  disabled: Scalars["Int64"]["output"];
  /**  Ledgers of category without archived date or in future  */
  enabled: Scalars["Int64"]["output"];
};

/**  The ledger group category  */
export enum LedgersMsCountLedgersInSectorResponseDataCountByPcomTypeCategory {
  Badge = "BADGE",
  Card = "CARD",
  PcomTypeUnknown = "PCOM_TYPE_UNKNOWN",
}

/**  Count the orders by status  */
export type LedgersMsCountOrdersByStatusRequest = {
  /**  The list of order status to narrow the result with. All statuses will be used if empty.  */
  statuses?: InputMaybe<
    Array<InputMaybe<LedgersMsCountOrdersByStatusRequestStatuses>>
  >;
};

/**  The list of order status to narrow the result with. All statuses will be used if empty.  */
export enum LedgersMsCountOrdersByStatusRequestStatuses {
  Failed = "FAILED",
  Initialized = "INITIALIZED",
  OrderStatusUnknown = "ORDER_STATUS_UNKNOWN",
  Processing = "PROCESSING",
  Retrying = "RETRYING",
  Successful = "SUCCESSFUL",
}

export type LedgersMsCountOrdersByStatusResponse = {
  __typename?: "LedgersMsCountOrdersByStatusResponse";
  metrics?: Maybe<Array<LedgersMsCountOrdersByStatusResponseMetric>>;
};

export type LedgersMsCountOrdersByStatusResponseMetric = {
  __typename?: "LedgersMsCountOrdersByStatusResponseMetric";
  /**  The order status  */
  status: LedgersMsCountOrdersByStatusResponseMetricStatus;
  /**  The total number of orders  */
  total: Scalars["Int64"]["output"];
};

/**  The order status  */
export enum LedgersMsCountOrdersByStatusResponseMetricStatus {
  Failed = "FAILED",
  Initialized = "INITIALIZED",
  OrderStatusUnknown = "ORDER_STATUS_UNKNOWN",
  Processing = "PROCESSING",
  Retrying = "RETRYING",
  Successful = "SUCCESSFUL",
}

/**  Count the transactions by state  */
export type LedgersMsCountTransactionsByStateRequest = {
  /**  The list of status codes to narrow the result with. All codes will be used if empty.  */
  invoiceStateCode?: InputMaybe<
    Array<InputMaybe<LedgersMsCountTransactionsByStateRequestInvoiceStateCode>>
  >;
};

/**  The list of status codes to narrow the result with. All codes will be used if empty.  */
export enum LedgersMsCountTransactionsByStateRequestInvoiceStateCode {
  Invoiced = "INVOICED",
  OutOfInvoice = "OUT_OF_INVOICE",
  PendingInvoice = "PENDING_INVOICE",
  PendingValorization = "PENDING_VALORIZATION",
  UnknownInvoiceState = "UNKNOWN_INVOICE_STATE",
}

export type LedgersMsCountTransactionsByStateResponse = {
  __typename?: "LedgersMsCountTransactionsByStateResponse";
  metrics?: Maybe<Array<LedgersMsCountTransactionsByStateResponseMetric>>;
};

export type LedgersMsCountTransactionsByStateResponseMetric = {
  __typename?: "LedgersMsCountTransactionsByStateResponseMetric";
  /**  The transaction status code  */
  invoiceStateCode: LedgersMsCountTransactionsByStateResponseMetricInvoiceStateCode;
  /**  The total number of transactions  */
  total: Scalars["Int64"]["output"];
};

/**  The transaction status code  */
export enum LedgersMsCountTransactionsByStateResponseMetricInvoiceStateCode {
  Invoiced = "INVOICED",
  OutOfInvoice = "OUT_OF_INVOICE",
  PendingInvoice = "PENDING_INVOICE",
  PendingValorization = "PENDING_VALORIZATION",
  UnknownInvoiceState = "UNKNOWN_INVOICE_STATE",
}

/**  Create a all transactions MC report  */
export type LedgersMsCreateAllTransactionsMobilityCorporateReportRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsCreateAllTransactionsMobilityCorporateReportResponse = {
  __typename?: "LedgersMsCreateAllTransactionsMobilityCorporateReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create a consumption monitoring report.  */
export type LedgersMsCreateConsumptionMonitoringReportRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsCreateConsumptionMonitoringReportResponse = {
  __typename?: "LedgersMsCreateConsumptionMonitoringReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create a cost tracking report.  */
export type LedgersMsCreateCostTrackingReportRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsCreateCostTrackingReportResponse = {
  __typename?: "LedgersMsCreateCostTrackingReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create a demand in the pin manager  */
export type LedgersMsCreateDemandRequest = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsCreateDemandResponse = {
  __typename?: "LedgersMsCreateDemandResponse";
  requestId: Scalars["String"]["output"];
};

/**  Create division order  */
export type LedgersMsCreateDivisionOrderRequest = {
  addressId?: InputMaybe<Scalars["String"]["input"]>;
  authorizedProducts?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  contactId?: InputMaybe<Scalars["String"]["input"]>;
  customizableLine1?: InputMaybe<Scalars["String"]["input"]>;
  customizableLine2?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  divisionNumber?: InputMaybe<Scalars["String"]["input"]>;
  supportWalletId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsCreateDivisionOrderResponse = {
  __typename?: "LedgersMsCreateDivisionOrderResponse";
  orderId: Scalars["ID"]["output"];
};

/**  Creates a division  */
export type LedgersMsCreateDivisionRequest = {
  addressId?: InputMaybe<Scalars["String"]["input"]>;
  /**  list of products  */
  authorizedProducts?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  contactId?: InputMaybe<Scalars["String"]["input"]>;
  customizableLine1?: InputMaybe<Scalars["String"]["input"]>;
  customizableLine2?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  divisionNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**  the support selected by the user  */
  supportWalletId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Who initiated the request  */
export type LedgersMsCreateDivisionRequestWho = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsCreateDivisionResponse = {
  __typename?: "LedgersMsCreateDivisionResponse";
  divisionId: Scalars["ID"]["output"];
};

/**  Create an EV detailed report  */
export type LedgersMsCreateEvDetailedReportRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsCreateEvDetailedReportResponse = {
  __typename?: "LedgersMsCreateEvDetailedReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create an order of a ledger.  */
export type LedgersMsCreateLedgerOrderRequest = {
  /**  the assign collaborator if ledgerType is mobility corporate  */
  collaboratorId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The type used during the ledger creation data request.  */
  ledgerTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The raw filled up data to be sent to the ledger provider.  */
  rawFormData?: InputMaybe<Scalars["String"]["input"]>;
  /**  The related sector  */
  sectorId?: InputMaybe<Scalars["String"]["input"]>;
  /**  The template used for the creation  */
  template?: InputMaybe<Scalars["String"]["input"]>;
  /**  The wallet used during the ledger creation data request.  */
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsCreateLedgerOrderResponse = {
  __typename?: "LedgersMsCreateLedgerOrderResponse";
  orderId: Scalars["ID"]["output"];
};

/**  Create a mileage report.  */
export type LedgersMsCreateMileageReportRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsCreateMileageReportResponse = {
  __typename?: "LedgersMsCreateMileageReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create a price ceiling report.  */
export type LedgersMsCreatePriceCeilingReportRequest = {
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  fuelCode?: InputMaybe<Scalars["String"]["input"]>;
  pricingDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type LedgersMsCreatePriceCeilingReportResponse = {
  __typename?: "LedgersMsCreatePriceCeilingReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create a toll passages report  */
export type LedgersMsCreateTollPassagesReportRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsCreateTollPassagesReportResponse = {
  __typename?: "LedgersMsCreateTollPassagesReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create a transactions Friday Monday report  */
export type LedgersMsCreateTransactionsFridayMondayReportRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsCreateTransactionsFridayMondayReportResponse = {
  __typename?: "LedgersMsCreateTransactionsFridayMondayReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create a transactions WE holidays report  */
export type LedgersMsCreateTransactionsWeekendHolidaysReportRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsCreateTransactionsWeekendHolidaysReportResponse = {
  __typename?: "LedgersMsCreateTransactionsWeekendHolidaysReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create a truck positions report  */
export type LedgersMsCreateTruckPositionsReportRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsCreateTruckPositionsReportResponse = {
  __typename?: "LedgersMsCreateTruckPositionsReportResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Delete (annuler) a ledger that is still in status new  */
export type LedgersMsDeleteLedgerRequest = {
  /**  The ledger id  */
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Create an export of all ledgers.  */
export type LedgersMsExportSupportConfigRequest = {
  /**  Deprecated : this report is not based on a date range  */
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  Deprecated : this report is not based on a date range  */
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsExportSupportConfigResponse = {
  __typename?: "LedgersMsExportSupportConfigResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Create an export of all transactions.  */
export type LedgersMsExportTransactionsRequest = {
  fromDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The ledger id - transactions will be filtered on ledger if provided  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  tillDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**
   *  The type of report that contains information like the report code and the version.
   * Should be propagated to Reporting as it is.
   */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LedgersMsExportTransactionsResponse = {
  __typename?: "LedgersMsExportTransactionsResponse";
  /**  The id of the report  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task  */
  taskId: Scalars["ID"]["output"];
};

/**  Fetch Ledgers export data  */
export type LedgersMsFetchLedgersExportRequest = {
  /**  The account ids to fetch data for  */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  Relationship between a account and sectors  */
  accounts?: InputMaybe<
    Array<InputMaybe<LedgersMsFetchLedgersExportRequestAccount>>
  >;
  /**  The id of the report  */
  reportId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  Add sectorIds (computed List), used from reporting for restriction for csv generation.  */
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/**  Relationship between a account and sectors  */
export type LedgersMsFetchLedgersExportRequestAccount = {
  /**  The customer number of accounts  */
  customerNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**  Sector IDs the user that requested the report will be restricted to.  */
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsField = {
  __typename?: "LedgersMsField";
  data: LedgersMsFieldData;
  path: Scalars["String"]["output"];
};

export type LedgersMsFieldData = {
  __typename?: "LedgersMsFieldData";
  /**  The column where the field should be displayed,by default the first column  */
  col: Scalars["Int64"]["output"];
  decorator: Scalars["String"]["output"];
  defaultValue: Scalars["String"]["output"];
  hidden: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  options?: Maybe<Array<LedgersMsFormOption>>;
  postName: Scalars["String"]["output"];
  postRequired: Scalars["Boolean"]["output"];
  required: Scalars["Boolean"]["output"];
  /**
   *  The preferred row where the field should be displayed
   * When the field do not have a row, it's added at the bottom
   */
  row: Scalars["Int64"]["output"];
  /**  The index of the section within the step  */
  section: Scalars["Int64"]["output"];
  /**  The index of the step  */
  step: Scalars["Int64"]["output"];
  /**  The index of the sub section within the section  */
  subSection: Scalars["Int64"]["output"];
  /**  Some specific tags, for rendering the fields  */
  tags: Scalars["String"]["output"];
  triggerRecreation: Scalars["Boolean"]["output"];
  type: Scalars["String"]["output"];
  validators?: Maybe<Array<LedgersMsFieldValidator>>;
  value: Scalars["String"]["output"];
  writable: Scalars["Boolean"]["output"];
};

export type LedgersMsFieldValidator = {
  __typename?: "LedgersMsFieldValidator";
  name: LedgersMsFieldValidatorName;
  options: LedgersMsValidatorOptions;
};

export enum LedgersMsFieldValidatorName {
  AuthorizedWeekDaysSelection = "AUTHORIZED_WEEK_DAYS_SELECTION",
  Digits = "DIGITS",
  LowerCase = "LOWER_CASE",
  MaxLength = "MAX_LENGTH",
  MaxLimit = "MAX_LIMIT",
  MinLength = "MIN_LENGTH",
  MinLimit = "MIN_LIMIT",
  Pattern = "PATTERN",
  UpperCase = "UPPER_CASE",
}

/**  The form data structure, used only for the contract generation...  */
export type LedgersMsFormData = {
  __typename?: "LedgersMsFormData";
  fields?: Maybe<Array<LedgersMsField>>;
  firstNodeName: Scalars["String"]["output"];
};

export type LedgersMsFormOption = {
  __typename?: "LedgersMsFormOption";
  id: Scalars["String"]["output"];
  impactedFields?: Maybe<Array<LedgersMsNestedFieldData>>;
  text: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/**  Retrieve the creation form to start the division creation process  */
export type LedgersMsGetDivisionCreationTemplateRequest = {
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetDivisionCreationTemplateResponse = {
  __typename?: "LedgersMsGetDivisionCreationTemplateResponse";
  divisionCreationData: LedgersMsGetDivisionCreationTemplateResponseDivisionCreationData;
  httpStatusCode: Scalars["Int"]["output"];
};

export type LedgersMsGetDivisionCreationTemplateResponseDivisionCreationData = {
  __typename?: "LedgersMsGetDivisionCreationTemplateResponseDivisionCreationData";
  /**  address  */
  address: LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataAddress;
  /**  contact  */
  contact: LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataContact;
  customizableLine1: LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataNode;
  customizableLine2: LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataNode;
  description: LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataNode;
  divisionNumber: LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataNode;
  /**  products  */
  products?: Maybe<
    Array<LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataProduct>
  >;
};

/**  address  */
export type LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataAddress =
  {
    __typename?: "LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataAddress";
    option?: Maybe<
      Array<LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataAddressOption>
    >;
    type: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
    writable: Scalars["Boolean"]["output"];
  };

export type LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataAddressOption =
  {
    __typename?: "LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataAddressOption";
    companyName: Scalars["String"]["output"];
    country: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    locality: Scalars["String"]["output"];
    postCode: Scalars["String"]["output"];
    streetName: Scalars["String"]["output"];
  };

/**  contact  */
export type LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataContact =
  {
    __typename?: "LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataContact";
    option?: Maybe<
      Array<LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataContactOption>
    >;
    type: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
    writable: Scalars["Boolean"]["output"];
  };

export type LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataContactOption =
  {
    __typename?: "LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataContactOption";
    contactId: Scalars["String"]["output"];
    firstName: Scalars["String"]["output"];
    lastName: Scalars["String"]["output"];
    optionId: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
  };

export type LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataNode =
  {
    __typename?: "LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataNode";
    type: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
    writable: Scalars["Boolean"]["output"];
  };

/**  products  */
export type LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataProduct =
  {
    __typename?: "LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataProduct";
    authorized: Scalars["Boolean"]["output"];
    category: Scalars["String"]["output"];
    code: Scalars["String"]["output"];
    groupCode: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    productTechnology: LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataProductProductTechnology;
  };

export type LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataProductProductTechnology =
  {
    __typename?: "LedgersMsGetDivisionCreationTemplateResponseDivisionCreationDataProductProductTechnology";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

/**  Retrieve the modification form to start the division modification process  */
export type LedgersMsGetDivisionModificationTemplateRequest = {
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetDivisionModificationTemplateResponse = {
  __typename?: "LedgersMsGetDivisionModificationTemplateResponse";
  divisionModificationData: LedgersMsGetDivisionModificationTemplateResponseDivisionModificationData;
  httpStatusCode: Scalars["Int"]["output"];
};

export type LedgersMsGetDivisionModificationTemplateResponseDivisionModificationData =
  {
    __typename?: "LedgersMsGetDivisionModificationTemplateResponseDivisionModificationData";
    /**  address  */
    address: LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataAddress;
    /**  contact  */
    contact: LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataContact;
    customizableLine1: LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataNode;
    customizableLine2: LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataNode;
    description: LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataNode;
    productRefrabrication: LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataNode;
    /**  products  */
    products?: Maybe<
      Array<LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataProduct>
    >;
  };

/**  address  */
export type LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataAddress =
  {
    __typename?: "LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataAddress";
    option?: Maybe<
      Array<LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataAddressOption>
    >;
    type: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
    writable: Scalars["Boolean"]["output"];
  };

export type LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataAddressOption =
  {
    __typename?: "LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataAddressOption";
    companyName: Scalars["String"]["output"];
    country: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    locality: Scalars["String"]["output"];
    postCode: Scalars["String"]["output"];
    streetName: Scalars["String"]["output"];
  };

/**  contact  */
export type LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataContact =
  {
    __typename?: "LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataContact";
    option?: Maybe<
      Array<LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataContactOption>
    >;
    type: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
    writable: Scalars["Boolean"]["output"];
  };

export type LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataContactOption =
  {
    __typename?: "LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataContactOption";
    contactId: Scalars["String"]["output"];
    firstName: Scalars["String"]["output"];
    lastName: Scalars["String"]["output"];
    optionId: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
  };

export type LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataNode =
  {
    __typename?: "LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataNode";
    type: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
    writable: Scalars["Boolean"]["output"];
  };

/**  products  */
export type LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataProduct =
  {
    __typename?: "LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataProduct";
    authorized: Scalars["Boolean"]["output"];
    category: Scalars["String"]["output"];
    code: Scalars["String"]["output"];
    groupCode: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    productTechnology: LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataProductProductTechnology;
  };

export type LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataProductProductTechnology =
  {
    __typename?: "LedgersMsGetDivisionModificationTemplateResponseDivisionModificationDataProductProductTechnology";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

/**  Provides with the CardPro division structure in order to modify a ledger.  */
export type LedgersMsGetDivisionsRequest = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetDivisionsResponse = {
  __typename?: "LedgersMsGetDivisionsResponse";
  divisions?: Maybe<Array<LedgersMsGetDivisionsResponseDivision>>;
};

export type LedgersMsGetDivisionsResponseDivision = {
  __typename?: "LedgersMsGetDivisionsResponseDivision";
  label: Scalars["String"]["output"];
  originalLabel: Scalars["String"]["output"];
  walletId: Scalars["ID"]["output"];
};

/**  Get Geographic Areas  */
export type LedgersMsGetGeographicAreasRequest = {
  /**  The geographic area code code used to search its children.  */
  parentCode?: InputMaybe<Scalars["String"]["input"]>;
  /**  The type to search (COUNTRY, LARGE_REGION, REGION, DEPARTMENT)  */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type LedgersMsGetGeographicAreasResponse = {
  __typename?: "LedgersMsGetGeographicAreasResponse";
  /**  The list of geographic areas  */
  geographicAreas?: Maybe<
    Array<LedgersMsGetGeographicAreasResponseGeographicArea>
  >;
};

/**  The list of geographic areas  */
export type LedgersMsGetGeographicAreasResponseGeographicArea = {
  __typename?: "LedgersMsGetGeographicAreasResponseGeographicArea";
  /**  The geographic area code  */
  code: Scalars["String"]["output"];
  /**  The geographic area label  */
  label: Scalars["String"]["output"];
};

/**  fetch the ledger creation template for a createCopy  */
export type LedgersMsGetLedgerCopyCreationDataRequest = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Who initiated the request  */
export type LedgersMsGetLedgerCopyCreationDataRequestWho = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetLedgerCopyCreationDataResponse = {
  __typename?: "LedgersMsGetLedgerCopyCreationDataResponse";
  /**  The ledger group category  */
  category: LedgersMsGetLedgerCopyCreationDataResponseCategory;
  /**  True if the partner was unavailable  */
  isUnavailable: Scalars["Boolean"]["output"];
  /**  the json prefill with the data from the copy ledger  */
  rawFormData: Scalars["String"]["output"];
};

/**  The ledger group category  */
export enum LedgersMsGetLedgerCopyCreationDataResponseCategory {
  Badge = "BADGE",
  Card = "CARD",
  PcomTypeUnknown = "PCOM_TYPE_UNKNOWN",
}

/**  Fetch the creation data used for the ledger creation.  */
export type LedgersMsGetLedgerCreationDataRequest = {
  ledgerTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Who initiated the request  */
export type LedgersMsGetLedgerCreationDataRequestWho = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetLedgerCreationDataResponse = {
  __typename?: "LedgersMsGetLedgerCreationDataResponse";
  /**  The ledger group category  */
  category: LedgersMsGetLedgerCreationDataResponseCategory;
  /**  True if the partner was unavailable  */
  isUnavailable: Scalars["Boolean"]["output"];
  /**  The raw data information used to fill up the create ledger order.  */
  rawFormData: Scalars["String"]["output"];
};

/**  The ledger group category  */
export enum LedgersMsGetLedgerCreationDataResponseCategory {
  Badge = "BADGE",
  Card = "CARD",
  PcomTypeUnknown = "PCOM_TYPE_UNKNOWN",
}

/**  Fetch the raw data of a ledger.  */
export type LedgersMsGetLedgerDataRequest = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Who initiated the request  */
export type LedgersMsGetLedgerDataRequestWho = {
  accountNumber?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetLedgerDataResponse = {
  __typename?: "LedgersMsGetLedgerDataResponse";
  /**  Optional: only available for "BADGE", expose the tracking provider URL  */
  deliveryTrackingUrl: Scalars["String"]["output"];
  /**  True if the ledger data contains AS24 data  */
  isDeclarationFormAvailable: Scalars["Boolean"]["output"];
  /**  True if the partner was unavailable  */
  isUnavailable: Scalars["Boolean"]["output"];
  /**  The ledger information as JSON string  */
  rawData: Scalars["String"]["output"];
  /**  The form data structure, used only for the contract generation...  */
  structure: LedgersMsFormData;
};

/**  Retrieve ledger data (converts raw json ledger data to object representation)  */
export type LedgersMsGetLedgerDataV2Request = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Who initiated the request  */
export type LedgersMsGetLedgerDataV2RequestWho = {
  accountNumber?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetLedgerDataV2Response = {
  __typename?: "LedgersMsGetLedgerDataV2Response";
  /**  Optional: only available for "BADGE", expose the tracking provider URL  */
  deliveryTrackingUrl: Scalars["String"]["output"];
  /**  The partner's http status if not successful  */
  httpStatusCode: Scalars["Int"]["output"];
  /**  True if the ledger data contains AS24 data  */
  isDeclarationFormAvailable: Scalars["Boolean"]["output"];
  /**  True if the partner was unavailable  */
  isUnavailable: Scalars["Boolean"]["output"];
  /**  The ledger information as object  */
  product: LedgersMsGetLedgerDataV2ResponseProduct;
};

/**  The ledger information as object  */
export type LedgersMsGetLedgerDataV2ResponseProduct = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProduct";
  attachements?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductAttachment>
  >;
  authorizedProducts?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel>
  >;
  authorizedServices?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel>
  >;
  carbonClass: LedgersMsGetLedgerDataV2ResponseProductCarbonClass;
  cardSettings: LedgersMsGetLedgerDataV2ResponseProductCardSetting;
  commercialCondition?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductCommercialCondition>
  >;
  complementaryInformation: Scalars["String"]["output"];
  creationDate: Scalars["String"]["output"];
  customerName: Scalars["String"]["output"];
  customerNumber: Scalars["String"]["output"];
  electric: LedgersMsGetLedgerDataV2ResponseProductElectric;
  electricLimits: LedgersMsGetLedgerDataV2ResponseProductElectricLimits;
  endDate: Scalars["String"]["output"];
  forbiddenProducts?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel>
  >;
  fuelLimits: LedgersMsGetLedgerDataV2ResponseProductFuelLimits;
  geographicalControls: LedgersMsGetLedgerDataV2ResponseProductGeographicalControl;
  linkedProduct: Scalars["String"]["output"];
  mobilitySettings: LedgersMsGetLedgerDataV2ResponseProductMobilitySettings;
  modificationDate: Scalars["String"]["output"];
  pan: Scalars["String"]["output"];
  perimeter?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel>
  >;
  productDelivery: LedgersMsGetLedgerDataV2ResponseProductProductDelivery;
  productNumber: LedgersMsGetLedgerDataV2ResponseProductProductNumber;
  productStatus: LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel;
  productType: LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel;
  registrationCountry: LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel;
  registrationNumber: Scalars["String"]["output"];
  sectorLabel: Scalars["String"]["output"];
  serviceLimits: LedgersMsGetLedgerDataV2ResponseProductServiceLimits;
  structureName: Scalars["String"]["output"];
  structureNumber: Scalars["String"]["output"];
  subStructureName: Scalars["String"]["output"];
  subStructureNumber: Scalars["String"]["output"];
  technicalControl: LedgersMsGetLedgerDataV2ResponseProductTechnicalControl;
  technology: LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel;
  timeControls: LedgersMsGetLedgerDataV2ResponseProductTimeControl;
  trackingNumber: Scalars["String"]["output"];
  truckSettings: LedgersMsGetLedgerDataV2ResponseProductTruckSetting;
  vehicleType: LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel;
  vin: Scalars["String"]["output"];
  weeklyLimit: LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel;
};

export type LedgersMsGetLedgerDataV2ResponseProductAttachment = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductAttachment";
  creationDate: Scalars["String"]["output"];
  document: Scalars["String"]["output"];
  documentLabel: Scalars["String"]["output"];
  documentType: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductCarbonClass = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductCarbonClass";
  cabinType: LedgersMsGetLedgerDataV2ResponseProductCarbonClassProductCodeLabel;
  carbonClass: Scalars["Int"]["output"];
  carbonClassV10: Scalars["Int"]["output"];
  carbonEmissionRate: LedgersMsGetLedgerDataV2ResponseProductCarbonClassCarbonEmissionRate;
  vehicleAxlesConfiguration: Scalars["String"]["output"];
  vehicleChassisConfiguration: LedgersMsGetLedgerDataV2ResponseProductCarbonClassProductCodeLabel;
  vehicleEnginePower: Scalars["String"]["output"];
  vehicleFirstRegistrationDate: Scalars["String"]["output"];
  vehicleGroup: Scalars["String"]["output"];
  vehicleSubgroup: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductCarbonClassCarbonEmissionRate =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductCarbonClassCarbonEmissionRate";
    unit: Scalars["String"]["output"];
    vehicleCarbonEmissionRate: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductCarbonClassProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductCarbonClassProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductCardSetting = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductCardSetting";
  electricPackage: Scalars["Boolean"]["output"];
  fuelPackage: LedgersMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
  nameOnCard: LedgersMsGetLedgerDataV2ResponseProductCardSettingNameOnCard;
  pinType: LedgersMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
  servicePackage: LedgersMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
  terminalBehaviour: LedgersMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
  tollPackage: LedgersMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
};

export type LedgersMsGetLedgerDataV2ResponseProductCardSettingNameOnCard = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductCardSettingNameOnCard";
  customizableLine1: Scalars["String"]["output"];
  customizableLine2: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductCommercialCondition = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductCommercialCondition";
  code: Scalars["String"]["output"];
  conditionCode: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  fees: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  partner: Scalars["String"]["output"];
  startDate: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductElectric = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductElectric";
  electricService: Scalars["Boolean"]["output"];
  partners?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductElectricPartner>
  >;
  totalCardMyFareId: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductElectricLimits = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductElectricLimits";
  allElectricsLimit: LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimit;
};

export type LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimit =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimit";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitProductCodeLabel;
    name: LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitProductCodeLabel;
    periodicity1: LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetail;
    periodicity2: LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetail;
    thresholdType: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetail =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetail";
    currency: LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetailProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductElectricPartner = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductElectricPartner";
  emaid: Scalars["String"]["output"];
  myFareG2mStatus: LedgersMsGetLedgerDataV2ResponseProductElectricPartnerProductCodeLabel;
  partenaireId: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductElectricPartnerProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductElectricPartnerProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductFuelLimits = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductFuelLimits";
  allFuelsLimit: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimit;
  fuel1Limit: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetail;
  fuel2Limit: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetail;
};

export type LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimit = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimit";
  actionControl: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitProductCodeLabel;
  name: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitProductCodeLabel;
  periodicity1: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetail;
  periodicity2: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetail;
  thresholdType: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetail =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetail";
    currency: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetailProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetail = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetail";
  actionControl: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailProductCodeLabel;
  name: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailProductCodeLabel;
  periodicity1: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetail;
  periodicity2: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetail;
  thresholdType: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetail =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetail";
    currency: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetailProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductGeographicalControl = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductGeographicalControl";
  zones: LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZones;
};

export type LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZones = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZones";
  actionControl: LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesProductCodeLabel;
  list?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1>
  >;
  modeControl: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1 =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    level: Scalars["String"]["output"];
    list?: Maybe<
      Array<LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2>
    >;
  };

export type LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2 =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    level: Scalars["String"]["output"];
    list?: Maybe<
      Array<LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3>
    >;
  };

export type LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3 =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    level: Scalars["String"]["output"];
    list?: Maybe<
      Array<LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3ZoneDetailLevel4>
    >;
  };

export type LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3ZoneDetailLevel4 =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3ZoneDetailLevel4";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    level: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettings = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettings";
  authorizedMobilityProducts: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProducts;
  authorizedMobilityServices: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServices;
  holder: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsHolder;
  mobilityTimeControls: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControls;
  productMobilityType: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsProductCodeLabel;
};

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProducts =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProducts";
    allProductsLimit: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    carRenting: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    hotel: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    maintenance: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    publicTransport: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    restaurant: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    taxi: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    travel: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitProductCodeLabel;
    limit?: Maybe<
      Array<LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimit>
    >;
    periodicity: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicity;
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimit =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimit";
    amount: Scalars["String"]["output"];
    amountType: Scalars["String"]["output"];
    currency: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimitProductCodeLabel;
    limitType: Scalars["String"]["output"];
    periodic: Scalars["Boolean"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimitProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicity =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicity";
    unitPeriodicity: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicityProductCodeLabel;
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicityProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicityProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServices =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServices";
    internetSell: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapper;
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapper =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapper";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapperProductCodeLabel;
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapperProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapperProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsHolder = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsHolder";
  civility: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  phoneNumber: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsHolderPhoneNumber;
};

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsHolderPhoneNumber =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsHolderPhoneNumber";
    internationalCode: Scalars["String"]["output"];
    number: Scalars["Int"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControls =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControls";
    authorizedDays: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDays;
    authorizedTime: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTime;
    prohibitedBankHolidays: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapper;
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapper =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapper";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapperProductCodeLabel;
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapperProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapperProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDays =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDays";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDaysProductCodeLabel;
    listOfDays: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDaysProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDaysProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTime =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTime";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTimeProductCodeLabel;
    endHour: Scalars["String"]["output"];
    startHour: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTimeProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTimeProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductMobilitySettingsProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductProductCodeLabel";
  code: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductProductDelivery = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductProductDelivery";
  dispatchMode?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductProductDeliveryProductCodeLabel>
  >;
  dispatchPriority?: Maybe<
    Array<LedgersMsGetLedgerDataV2ResponseProductProductDeliveryProductCodeLabel>
  >;
  pinDeliveryAddress: LedgersMsGetLedgerDataV2ResponseProductProductDeliveryPinDeliveryAddress;
  productDeliveryAddress: LedgersMsGetLedgerDataV2ResponseProductProductDeliveryProductDeliveryAddress;
  typeMobility: Scalars["Boolean"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductProductDeliveryPinDeliveryAddress =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductProductDeliveryPinDeliveryAddress";
    address: Scalars["String"]["output"];
    city: Scalars["String"]["output"];
    companyName: Scalars["String"]["output"];
    country: Scalars["String"]["output"];
    location: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    zipCode: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductProductDeliveryProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductProductDeliveryProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductProductDeliveryProductDeliveryAddress =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductProductDeliveryProductDeliveryAddress";
    address: Scalars["String"]["output"];
    city: Scalars["String"]["output"];
    companyName: Scalars["String"]["output"];
    country: Scalars["String"]["output"];
    location: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    zipCode: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductProductNumber = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductProductNumber";
  rank: Scalars["String"]["output"];
  shortNumber: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductServiceLimits = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductServiceLimits";
  allServicesLimit: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimit;
  service1Limit: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetail;
  service2Limit: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetail;
};

export type LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimit =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimit";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitProductCodeLabel;
    name: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitProductCodeLabel;
    periodicity1: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetail;
    periodicity2: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetail;
    thresholdType: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetail =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetail";
    currency: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetailProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetail =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetail";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailProductCodeLabel;
    name: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailProductCodeLabel;
    periodicity1: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetail;
    periodicity2: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetail;
    thresholdType: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetail =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetail";
    currency: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetailProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTechnicalControl = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductTechnicalControl";
  consumption: LedgersMsGetLedgerDataV2ResponseProductTechnicalControlConsumption;
  mainFuel: Scalars["String"]["output"];
  mileageEntry: LedgersMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapper;
  tankCapacity: LedgersMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacity;
};

export type LedgersMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapper =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapper";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapperProductCodeLabel;
  };

export type LedgersMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapperProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapperProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTechnicalControlConsumption =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTechnicalControlConsumption";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductTechnicalControlConsumptionProductCodeLabel;
    maxConsumption: Scalars["Int"]["output"];
    minConsumption: Scalars["Int"]["output"];
    unit: LedgersMsGetLedgerDataV2ResponseProductTechnicalControlConsumptionProductCodeLabel;
  };

export type LedgersMsGetLedgerDataV2ResponseProductTechnicalControlConsumptionProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTechnicalControlConsumptionProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacity =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacity";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacityProductCodeLabel;
    unit: LedgersMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacityProductCodeLabel;
    volume: Scalars["Int"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacityProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacityProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTimeControl = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControl";
  authorizedPeriod: LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriod;
  authorizedTime: LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTime;
  prohibitedBankHolidays: LedgersMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapper;
  prohibitedDays: LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedDays;
  prohibitedPeriod: LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriod;
};

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapper =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapper";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapperProductCodeLabel;
  };

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapperProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapperProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriod =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriod";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriodProductCodeLabel;
    endDate: Scalars["String"]["output"];
    repeatAnnualy: Scalars["Boolean"]["output"];
    startDate: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriodProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriodProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTime = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTime";
  actionControl: LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTimeProductCodeLabel;
  endHour: Scalars["String"]["output"];
  startHour: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTimeProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTimeProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedDays = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedDays";
  actionControl: LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedDaysProductCodeLabel;
  listOfDays: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedDaysProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedDaysProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriod =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriod";
    actionControl: LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriodProductCodeLabel;
    endDate: Scalars["String"]["output"];
    repeatAnnualy: Scalars["Boolean"]["output"];
    startDate: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriodProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriodProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type LedgersMsGetLedgerDataV2ResponseProductTruckSetting = {
  __typename?: "LedgersMsGetLedgerDataV2ResponseProductTruckSetting";
  cop: LedgersMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  emissionEuroClass: LedgersMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  emptyWeight: Scalars["String"]["output"];
  engineType: LedgersMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  interOpClass: LedgersMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  loadedWeight: Scalars["String"]["output"];
  localClass: LedgersMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  nbAxlesTractor: Scalars["Int"]["output"];
  nbAxlesTrailer: Scalars["Int"]["output"];
  particleFilter: LedgersMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  technicalMaxWeight: Scalars["String"]["output"];
  trailerWeight: Scalars["String"]["output"];
};

export type LedgersMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel =
  {
    __typename?: "LedgersMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

/**  Fetch the modification data used for the modification of ledger  */
export type LedgersMsGetLedgerModificationDataRequest = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Who initiated the request  */
export type LedgersMsGetLedgerModificationDataRequestWho = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetLedgerModificationDataResponse = {
  __typename?: "LedgersMsGetLedgerModificationDataResponse";
  /**  Ledger group category  */
  category: LedgersMsGetLedgerModificationDataResponseCategory;
  /**  True if the partner was unavailable  */
  isUnavailable: Scalars["Boolean"]["output"];
  /**  The raw data information used to fill up the modification ledger order.  */
  rawFormData: Scalars["String"]["output"];
};

/**  Ledger group category  */
export enum LedgersMsGetLedgerModificationDataResponseCategory {
  Badge = "BADGE",
  Card = "CARD",
  PcomTypeUnknown = "PCOM_TYPE_UNKNOWN",
}

/**  Get ledger with complementary information  */
export type LedgersMsGetLedgerWithDetailsRequest = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetLedgerWithDetailsResponse = {
  __typename?: "LedgersMsGetLedgerWithDetailsResponse";
  /**  The group code associated to the ledger  */
  groupCode: Scalars["String"]["output"];
  /**  Check the status of the ledger such that it should not be blocked or desactivated  */
  isActive: Scalars["Boolean"]["output"];
  /**  The id of the ledger  */
  ledgerId: Scalars["ID"]["output"];
  /**  The date that the ledger was opposed  */
  retiredTs: Scalars["Int64"]["output"];
  /**  The status code of a ledger  */
  statusCode: Scalars["String"]["output"];
  /**  The status label of a ledger  */
  statusLabel: Scalars["String"]["output"];
  /**  The type code of a ledger  */
  typeCode: Scalars["String"]["output"];
};

/**
 *  Fetch the list of creatable ledger types.
 * List all orderable ledger types for the current user on the given wallet.
 */
export type LedgersMsGetOrderableWalletLedgerTypesRequest = {
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetOrderableWalletLedgerTypesResponse = {
  __typename?: "LedgersMsGetOrderableWalletLedgerTypesResponse";
  data?: Maybe<Array<LedgersMsGetOrderableWalletLedgerTypesResponseData>>;
};

export type LedgersMsGetOrderableWalletLedgerTypesResponseData = {
  __typename?: "LedgersMsGetOrderableWalletLedgerTypesResponseData";
  GroupIdData?: Maybe<LedgersMsSearchGroupsResponseData>;
  /**  The unique code  */
  code: Scalars["String"]["output"];
  /**  The ledger code comment  */
  codeHint: Scalars["String"]["output"];
  /**  The group the type is linked to  */
  groupId: Scalars["ID"]["output"];
  /**  The ledger id  */
  id: Scalars["ID"]["output"];
};

/**  Fetch the PIN type of a ledger.  */
export type LedgersMsGetPinTypeRequest = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetPinTypeResponse = {
  __typename?: "LedgersMsGetPinTypeResponse";
  code: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type LedgersMsGetSupportsAndDivisionsResponse = {
  __typename?: "LedgersMsGetSupportsAndDivisionsResponse";
  supportAccounts?: Maybe<
    Array<LedgersMsGetSupportsAndDivisionsResponseSupportAccount>
  >;
};

export type LedgersMsGetSupportsAndDivisionsResponseSupportAccount = {
  __typename?: "LedgersMsGetSupportsAndDivisionsResponseSupportAccount";
  divisionAccounts?: Maybe<
    Array<LedgersMsGetSupportsAndDivisionsResponseSupportAccountDivisionAccount>
  >;
  label: Scalars["String"]["output"];
  originalLabel: Scalars["String"]["output"];
  walletId: Scalars["ID"]["output"];
};

export type LedgersMsGetSupportsAndDivisionsResponseSupportAccountDivisionAccount =
  {
    __typename?: "LedgersMsGetSupportsAndDivisionsResponseSupportAccountDivisionAccount";
    LastOrderIdData?: Maybe<LedgersMsSearchOrdersResponseData>;
    label: Scalars["String"]["output"];
    lastOrderId: Scalars["ID"]["output"];
    originalLabel: Scalars["String"]["output"];
    status: LedgersMsGetSupportsAndDivisionsResponseSupportAccountDivisionAccountStatus;
    walletId: Scalars["ID"]["output"];
  };

export enum LedgersMsGetSupportsAndDivisionsResponseSupportAccountDivisionAccountStatus {
  Active = "ACTIVE",
  Closed = "CLOSED",
  Error = "ERROR",
  Init = "INIT",
  Instantiated = "INSTANTIATED",
  Unknown = "UNKNOWN",
  Updating = "UPDATING",
}

export type LedgersMsGetSupportsFromAccountResponse = {
  __typename?: "LedgersMsGetSupportsFromAccountResponse";
  supports?: Maybe<Array<LedgersMsGetSupportsFromAccountResponseSupport>>;
};

export type LedgersMsGetSupportsFromAccountResponseSupport = {
  __typename?: "LedgersMsGetSupportsFromAccountResponseSupport";
  label: Scalars["String"]["output"];
  originalLabel: Scalars["String"]["output"];
  walletId: Scalars["ID"]["output"];
};

/**  Get transaction's amounts stats.  */
export type LedgersMsGetTransactionAmountsRequest = {
  /**  Use "first of the month" when empty  */
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  /**  An optional ledger id to narrow the stats  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  Use "today" when empty  */
  tillDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type LedgersMsGetTransactionAmountsResponse = {
  __typename?: "LedgersMsGetTransactionAmountsResponse";
  /**  The sum of transaction spending  */
  amounts?: Maybe<Array<LedgersMsGetTransactionAmountsResponseAmount>>;
  /**  The number of all transactions  */
  transactionCount: Scalars["Int64"]["output"];
};

/**  The sum of transaction spending  */
export type LedgersMsGetTransactionAmountsResponseAmount = {
  __typename?: "LedgersMsGetTransactionAmountsResponseAmount";
  amountIncludingVat: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  /**  The number of transactions for the given currency  */
  transactionCount: Scalars["Int64"]["output"];
};

/**  Retrieve vehicle declaration form from middle  */
export type LedgersMsGetVehicleDeclarationFormRequest = {
  /**  The ledger_id from the user request (required)  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsGetVehicleDeclarationFormResponse = {
  __typename?: "LedgersMsGetVehicleDeclarationFormResponse";
  DocumentIdData?: Maybe<MediaMsSearchDocumentsResponseData>;
  /**  document_id stored in media-service (required)  */
  documentId: Scalars["ID"]["output"];
};

export type LedgersMsGetWalletTreeResponse = {
  __typename?: "LedgersMsGetWalletTreeResponse";
  nodes?: Maybe<Array<LedgersMsGetWalletTreeResponseNode>>;
};

export type LedgersMsGetWalletTreeResponseNode = {
  __typename?: "LedgersMsGetWalletTreeResponseNode";
  SettingsIdData?: Maybe<LedgersMsSearchWalletSettingsResponseData>;
  label: Scalars["String"]["output"];
  level: Scalars["Int"]["output"];
  originalLabel: Scalars["String"]["output"];
  parentId: Scalars["ID"]["output"];
  settingsId: Scalars["ID"]["output"];
  walletId: Scalars["ID"]["output"];
};

export type LedgersMsListCountriesResponse = {
  __typename?: "LedgersMsListCountriesResponse";
  data?: Maybe<Array<LedgersMsListCountriesResponseCountry>>;
};

export type LedgersMsListCountriesResponseCountry = {
  __typename?: "LedgersMsListCountriesResponseCountry";
  code: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type LedgersMsListFuelCodesResponse = {
  __typename?: "LedgersMsListFuelCodesResponse";
  data?: Maybe<Array<LedgersMsListFuelCodesResponseFuelCode>>;
};

export type LedgersMsListFuelCodesResponseFuelCode = {
  __typename?: "LedgersMsListFuelCodesResponseFuelCode";
  code: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type LedgersMsListLedgerChangesRequest = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsListLedgerChangesResponse = {
  __typename?: "LedgersMsListLedgerChangesResponse";
  changes?: Maybe<Array<LedgersMsListLedgerChangesResponseLedgerChange>>;
};

export type LedgersMsListLedgerChangesResponseLedgerChange = {
  __typename?: "LedgersMsListLedgerChangesResponseLedgerChange";
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  terminatedAt: Scalars["Int64"]["output"];
  type: Scalars["String"]["output"];
  userId: Scalars["ID"]["output"];
};

/**  Get informations for report codes  */
export type LedgersMsListReportTypesRequest = {
  filters?: InputMaybe<LedgersMsListReportTypesRequestFilters>;
};

export type LedgersMsListReportTypesRequestFilters = {
  /**  The report codes  */
  reportCodes?: InputMaybe<
    Array<InputMaybe<LedgersMsListReportTypesRequestFiltersReportCodes>>
  >;
};

/**  The report codes  */
export enum LedgersMsListReportTypesRequestFiltersReportCodes {
  AllTransactionsMobilityCorporate = "ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  ConsumptionMonitoring_100KmPerCard = "CONSUMPTION_MONITORING_100_KM_PER_CARD",
  DetailedEvTransactions = "DETAILED_EV_TRANSACTIONS",
  ExportStateCardAndBadge = "EXPORT_STATE_CARD_AND_BADGE",
  ExportTransaction = "EXPORT_TRANSACTION",
  HistoricReportKm = "HISTORIC_REPORT_KM",
  PriceCeiling = "PRICE_CEILING",
  ReportUnknown = "REPORT_UNKNOWN",
  TollPassages = "TOLL_PASSAGES",
  TrackingCardAndBadgeAndBudgetTracking = "TRACKING_CARD_AND_BADGE_AND_BUDGET_TRACKING",
  TransactionsFridayMonday = "TRANSACTIONS_FRIDAY_MONDAY",
  TransactionsWeekendHolidays = "TRANSACTIONS_WEEKEND_HOLIDAYS",
  TruckPositions = "TRUCK_POSITIONS",
}

export type LedgersMsListReportTypesResponse = {
  __typename?: "LedgersMsListReportTypesResponse";
  /**  Report types detail  */
  data?: Maybe<Array<LedgersMsListReportTypesResponseReportTypeDetail>>;
};

/**  Report types detail  */
export type LedgersMsListReportTypesResponseReportTypeDetail = {
  __typename?: "LedgersMsListReportTypesResponseReportTypeDetail";
  /**  A report subscription can be planned for this report  */
  canBePlanned: Scalars["Boolean"]["output"];
  /**  Can export for all accounts (multi-pass)  */
  canExportAllAccounts: Scalars["Boolean"]["output"];
  /**  The count of involved accounts for the report code and the current user  */
  countOfInvolvedAccounts: Scalars["Int"]["output"];
  /**  Can generate the report  */
  isAuthorized: Scalars["Boolean"]["output"];
  /**  The ledgers report code  */
  reportCode: LedgersMsListReportTypesResponseReportTypeDetailReportCode;
  /**  The version list  */
  versions?: Maybe<
    Array<LedgersMsListReportTypesResponseReportTypeDetailReportTypeVersion>
  >;
};

/**  The ledgers report code  */
export enum LedgersMsListReportTypesResponseReportTypeDetailReportCode {
  AllTransactionsMobilityCorporate = "ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  ConsumptionMonitoring_100KmPerCard = "CONSUMPTION_MONITORING_100_KM_PER_CARD",
  DetailedEvTransactions = "DETAILED_EV_TRANSACTIONS",
  ExportStateCardAndBadge = "EXPORT_STATE_CARD_AND_BADGE",
  ExportTransaction = "EXPORT_TRANSACTION",
  HistoricReportKm = "HISTORIC_REPORT_KM",
  PriceCeiling = "PRICE_CEILING",
  ReportUnknown = "REPORT_UNKNOWN",
  TollPassages = "TOLL_PASSAGES",
  TrackingCardAndBadgeAndBudgetTracking = "TRACKING_CARD_AND_BADGE_AND_BUDGET_TRACKING",
  TransactionsFridayMonday = "TRANSACTIONS_FRIDAY_MONDAY",
  TransactionsWeekendHolidays = "TRANSACTIONS_WEEKEND_HOLIDAYS",
  TruckPositions = "TRUCK_POSITIONS",
}

/**  The version list  */
export type LedgersMsListReportTypesResponseReportTypeDetailReportTypeVersion =
  {
    __typename?: "LedgersMsListReportTypesResponseReportTypeDetailReportTypeVersion";
    /**  Whether this version is the default one  */
    defaultVersion: Scalars["Boolean"]["output"];
    /**  The type id  */
    typeId: Scalars["ID"]["output"];
    /**  The version of the report type  */
    version: Scalars["Int"]["output"];
  };

/**  Modify a division  */
export type LedgersMsModifyDivisionRequest = {
  addressId?: InputMaybe<Scalars["String"]["input"]>;
  /**  list of products  */
  authorizedProducts?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  contactId?: InputMaybe<Scalars["String"]["input"]>;
  customizableLine1?: InputMaybe<Scalars["String"]["input"]>;
  customizableLine2?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  productRefrabrication?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  the support selected by the user  */
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Who initiated the request  */
export type LedgersMsModifyDivisionRequestWho = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsModifyDivisionResponse = {
  __typename?: "LedgersMsModifyDivisionResponse";
  walletId: Scalars["ID"]["output"];
};

export type LedgersMsNestedFieldData = {
  __typename?: "LedgersMsNestedFieldData";
  decorator: Scalars["String"]["output"];
  defaultValue: Scalars["String"]["output"];
  hidden: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  options?: Maybe<Array<LedgersMsNestedNestedFormOption>>;
  required: Scalars["Boolean"]["output"];
  type: Scalars["String"]["output"];
  validators?: Maybe<Array<LedgersMsFieldValidator>>;
  value: Scalars["String"]["output"];
  writable: Scalars["Boolean"]["output"];
};

export type LedgersMsNestedNestedFieldData = {
  __typename?: "LedgersMsNestedNestedFieldData";
  decorator: LedgersMsNestedNestedFieldDataDecorator;
  defaultValue: Scalars["String"]["output"];
  hidden: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
  type: Scalars["String"]["output"];
  validators?: Maybe<Array<LedgersMsFieldValidator>>;
  value: Scalars["String"]["output"];
  writable: Scalars["Boolean"]["output"];
};

export enum LedgersMsNestedNestedFieldDataDecorator {
  DaysOfTheWeekPicker = "DAYS_OF_THE_WEEK_PICKER",
  Native = "NATIVE",
}

export type LedgersMsNestedNestedFormOption = {
  __typename?: "LedgersMsNestedNestedFormOption";
  id: Scalars["String"]["output"];
  impactedFields?: Maybe<Array<LedgersMsNestedNestedFieldData>>;
  text: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/**  Handle the order creation event.  */
export type LedgersMsOnCreateLedgerOrderRequest = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Handle the order creation event.  */
export type LedgersMsOnUpdateLedgerOrderRequest = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsOnUpdateLedgerSectorRequest = {
  /**  The id of the ledger to be modified  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The id of the sector for the specific ledger  */
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsPagedPagination = {
  __typename?: "LedgersMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type LedgersMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  Resend the PIN code for a ledger  */
export type LedgersMsResendPinCodeRequest = {
  /**  The ledger id  */
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsResendPinCodeRequestWho = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsResendPinCodeResponse = {
  __typename?: "LedgersMsResendPinCodeResponse";
  httpStatusCode: Scalars["Int"]["output"];
  /**  Contains the failed reason from card pro  */
  messageBody: Scalars["String"]["output"];
};

/**  Search error  */
export type LedgersMsSearchErrorCodeRequest = {
  filters?: InputMaybe<LedgersMsSearchErrorCodeRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<LedgersMsSearchErrorCodeRequestSort>>>;
};

export type LedgersMsSearchErrorCodeRequestFilters = {
  code?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsSearchErrorCodeRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchErrorCodeRequestSortField>;
};

export enum LedgersMsSearchErrorCodeRequestSortField {
  CreatedTs = "created_ts",
  UpdatedTs = "updated_ts",
}

export type LedgersMsSearchErrorCodeResponse = {
  __typename?: "LedgersMsSearchErrorCodeResponse";
  data?: Maybe<Array<LedgersMsSearchErrorCodeResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchErrorCodeResponseData = {
  __typename?: "LedgersMsSearchErrorCodeResponseData";
  /**  The unique code  */
  code: Scalars["String"]["output"];
  /**  create ts  */
  createdTs: Scalars["Int64"]["output"];
  /**  the description of the error code  */
  description: Scalars["String"]["output"];
  /**  The error ID  */
  id: Scalars["ID"]["output"];
  /**  update ts  */
  updatedTs: Scalars["Int64"]["output"];
};

export type LedgersMsSearchGroupsRequest = {
  filters?: InputMaybe<LedgersMsSearchGroupsRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<LedgersMsSearchGroupsRequestSort>>>;
};

export type LedgersMsSearchGroupsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsSearchGroupsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchGroupsRequestSortField>;
};

export enum LedgersMsSearchGroupsRequestSortField {
  Code = "code",
}

export type LedgersMsSearchGroupsResponse = {
  __typename?: "LedgersMsSearchGroupsResponse";
  data?: Maybe<Array<LedgersMsSearchGroupsResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchGroupsResponseData = {
  __typename?: "LedgersMsSearchGroupsResponseData";
  /**  The ledger group category (Card Or Badge)  */
  category: LedgersMsSearchGroupsResponseDataCategory;
  /**  The unique code  */
  code: Scalars["String"]["output"];
  /**  The product code comment  */
  codeHint: Scalars["String"]["output"];
  /**  The product id  */
  id: Scalars["ID"]["output"];
};

export enum LedgersMsSearchGroupsResponseDataCategory {
  Badge = "BADGE",
  Card = "CARD",
  PcomTypeUnknown = "PCOM_TYPE_UNKNOWN",
}

/**  Search ledger quota usage  */
export type LedgersMsSearchLedgerQuotaUsageRequest = {
  filters?: InputMaybe<LedgersMsSearchLedgerQuotaUsageRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<LedgersMsSearchLedgerQuotaUsageRequestSort>>
  >;
};

export type LedgersMsSearchLedgerQuotaUsageRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ledgerIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsSearchLedgerQuotaUsageRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchLedgerQuotaUsageRequestSortField>;
};

export enum LedgersMsSearchLedgerQuotaUsageRequestSortField {
  DateReceivedTs = "date_received_ts",
  Id = "id",
}

export type LedgersMsSearchLedgerQuotaUsageResponse = {
  __typename?: "LedgersMsSearchLedgerQuotaUsageResponse";
  data?: Maybe<Array<LedgersMsSearchLedgerQuotaUsageResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchLedgerQuotaUsageResponseData = {
  __typename?: "LedgersMsSearchLedgerQuotaUsageResponseData";
  LedgerIdData?: Maybe<LedgersMsSearchLedgersResponseData>;
  /**  The ceiling amount  */
  amount: Scalars["Float"]["output"];
  /**  The currency of the transaction  */
  currency: Scalars["String"]["output"];
  /**  True if email has been sent  */
  dateReceivedTs: Scalars["Int64"]["output"];
  /**  The limit usage ID  */
  id: Scalars["ID"]["output"];
  /**  The related ledger  */
  ledgerId: Scalars["ID"]["output"];
  /**  The percentage of the amount used  */
  limitUsageRatio: Scalars["Float"]["output"];
  /**  Indicates email status - successful / processing / failed  */
  notificationStatus: LedgersMsSearchLedgerQuotaUsageResponseDataNotificationStatus;
  /**  is user allowed to exceed limit  */
  overrunAllowed: Scalars["Boolean"]["output"];
  /**  The period on which the limit is being applied  */
  period: LedgersMsSearchLedgerQuotaUsageResponseDataPeriod;
  /**  The product code  */
  productCode: Scalars["String"]["output"];
  /**  The amount remaining. Remaining amount = amount - used amount  */
  remainingAmount: Scalars["Float"]["output"];
  resetTs: Scalars["Int64"]["output"];
  /**  The amount used  */
  usedAmount: Scalars["Float"]["output"];
};

export enum LedgersMsSearchLedgerQuotaUsageResponseDataNotificationStatus {
  QuotaUsageNotificationStatusFailed = "QUOTA_USAGE_NOTIFICATION_STATUS_FAILED",
  QuotaUsageNotificationStatusInitialized = "QUOTA_USAGE_NOTIFICATION_STATUS_INITIALIZED",
  QuotaUsageNotificationStatusSent = "QUOTA_USAGE_NOTIFICATION_STATUS_SENT",
  UnknownQuotaUsageNotificationStatus = "UNKNOWN_QUOTA_USAGE_NOTIFICATION_STATUS",
}

export enum LedgersMsSearchLedgerQuotaUsageResponseDataPeriod {
  Biweekly = "BIWEEKLY",
  Day = "DAY",
  Month = "MONTH",
  PeriodUnknown = "PERIOD_UNKNOWN",
  Permanent = "PERMANENT",
  Week = "WEEK",
  YearDay = "YEAR_DAY",
}

/**  Get account preferences related to the ledgers domain  */
export type LedgersMsSearchLedgersAccountPreferencesRequest = {
  filters?: InputMaybe<LedgersMsSearchLedgersAccountPreferencesRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<LedgersMsSearchLedgersAccountPreferencesRequestSort>>
  >;
};

export type LedgersMsSearchLedgersAccountPreferencesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsSearchLedgersAccountPreferencesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchLedgersAccountPreferencesRequestSortField>;
};

export enum LedgersMsSearchLedgersAccountPreferencesRequestSortField {
  Id = "id",
}

export type LedgersMsSearchLedgersAccountPreferencesResponse = {
  __typename?: "LedgersMsSearchLedgersAccountPreferencesResponse";
  data?: Maybe<Array<LedgersMsSearchLedgersAccountPreferencesResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchLedgersAccountPreferencesResponseData = {
  __typename?: "LedgersMsSearchLedgersAccountPreferencesResponseData";
  DefaultWalletIdData?: Maybe<LedgersMsSearchWalletsResponseData>;
  IdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  canBlockLedger: Scalars["Boolean"]["output"];
  canCancelLedgerOrder: Scalars["Boolean"]["output"];
  canCreateLedger: Scalars["Boolean"]["output"];
  canListTransactions: Scalars["Boolean"]["output"];
  canUpdateLedger: Scalars["Boolean"]["output"];
  /**  The optional default wallet  */
  defaultWalletId: Scalars["ID"]["output"];
  /**  The account ID  */
  id: Scalars["ID"]["output"];
  /**  The account number  */
  number: Scalars["String"]["output"];
};

/**  Search among ledgers  */
export type LedgersMsSearchLedgersRequest = {
  filters?: InputMaybe<LedgersMsSearchLedgersRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<LedgersMsSearchLedgersRequestSort>>>;
};

export type LedgersMsSearchLedgersRequestFilters = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  collaboratorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  hashedPans?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  panIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  pans?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  pcomType?: InputMaybe<LedgersMsSearchLedgersRequestFiltersPcomType>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  shortCode?: InputMaybe<Scalars["String"]["input"]>;
  statusIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  supportIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
  walletIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export enum LedgersMsSearchLedgersRequestFiltersPcomType {
  Badge = "BADGE",
  Card = "CARD",
  PcomTypeUnknown = "PCOM_TYPE_UNKNOWN",
}

export type LedgersMsSearchLedgersRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchLedgersRequestSortField>;
};

export enum LedgersMsSearchLedgersRequestSortField {
  ExpiresTs = "expires_ts",
  Name = "name",
  Rank = "rank",
  RegistrationNumber = "registration_number",
  ShortCode = "short_code",
  StatusId = "status_id",
  TypeId = "type_id",
  UpdatedTs = "updated_ts",
}

export type LedgersMsSearchLedgersResponse = {
  __typename?: "LedgersMsSearchLedgersResponse";
  data?: Maybe<Array<LedgersMsSearchLedgersResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchLedgersResponseData = {
  __typename?: "LedgersMsSearchLedgersResponseData";
  AccountIdData?: Maybe<LedgersMsSearchLedgersAccountPreferencesResponseData>;
  CollaboratorIdData?: Maybe<CollaboratorsMsSearchCollaboratorsResponseData>;
  LastOpenOrderIdData?: Maybe<LedgersMsSearchOrdersResponseData>;
  LinkedLedgerIdData?: Maybe<LedgersMsSearchLedgersResponseData>;
  SectorIdData?: Maybe<SectorsMsSearchSectorsResponseData>;
  StatusIdData?: Maybe<LedgersMsSearchStatusesResponseData>;
  TypeIdData?: Maybe<LedgersMsSearchTypesResponseData>;
  WalletIdData?: Maybe<LedgersMsSearchWalletsResponseData>;
  accountId: Scalars["ID"]["output"];
  /**  A ts for when a ledger is updated from “in manufacturing” to “active”-status code 5  */
  activationDateTs: Scalars["Int64"]["output"];
  /**  The timestamp set when a ledger is opposed  */
  blockedLedgerTs: Scalars["Int64"]["output"];
  /**  if can create  copy of ledger  */
  canCreateCopy: Scalars["Boolean"]["output"];
  /**  The collaborator_id exist if the ledger is nominative and is a mobility corporate card  */
  collaboratorId: Scalars["ID"]["output"];
  /**  An optional internal company reference  */
  complementaryInfo: Scalars["String"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  if can delete ledger  */
  deletable: Scalars["Boolean"]["output"];
  /**  The ledger EV Id  */
  evId: Scalars["String"]["output"];
  /**  When the ledger expires  */
  expiresTs: Scalars["Int64"]["output"];
  /**
   *  The ledger family composed of the account number, structure, division and short number. Used to identify the ledgers
   * of the same family.
   */
  family: Scalars["ID"]["output"];
  /**  Type of fuel that can be bought with that ledger  */
  fuelPackageCode: Scalars["String"]["output"];
  /**  The hashed PAN number provided by the data lake (kykDlk)  */
  hashedPan: Scalars["String"]["output"];
  /**  The ledger ID  */
  id: Scalars["ID"]["output"];
  /**  Type of input for security purposes when using card  */
  iptbehaviourCode: Scalars["String"]["output"];
  /**  If assignment is allow on this ledger  */
  isAssignmentAllowed: Scalars["Boolean"]["output"];
  /**  Is the card for an electric package  */
  isElectricPackage: Scalars["Boolean"]["output"];
  isModifiable: Scalars["Boolean"]["output"];
  isPinRequestActive: Scalars["Boolean"]["output"];
  isPinResendable: Scalars["Boolean"]["output"];
  lastOpenOrderId: Scalars["ID"]["output"];
  linkedLedgerId: Scalars["ID"]["output"];
  /**  The ledger's label  */
  name: Scalars["String"]["output"];
  nextLedgerId: Scalars["ID"]["output"];
  /**  The ledger's label  */
  originalName: Scalars["String"]["output"];
  /**  The obfuscated PAN  */
  pan: Scalars["String"]["output"];
  /**  Target: pcom_type (Card Or Badge)  */
  pcomType: LedgersMsSearchLedgersResponseDataPcomType;
  /**  The expired ts for the previous ledger  */
  previousLedgerExpiredTs: Scalars["Int64"]["output"];
  previousLedgerId: Scalars["ID"]["output"];
  /**  The version number of the ledger, incremented on each update.  */
  rank: Scalars["Int"]["output"];
  /**  An optional custom name on the card  */
  registrationNumber: Scalars["String"]["output"];
  renewalCancellable: Scalars["Boolean"]["output"];
  /**  The related sector  */
  sectorId: Scalars["ID"]["output"];
  /**  Service Available for that ledger  */
  servicePackageCode: Scalars["String"]["output"];
  /**  The ledger corresponding group code  */
  shortCode: Scalars["String"]["output"];
  /**  The status  */
  statusId: Scalars["ID"]["output"];
  /**  Toll service  */
  tollPackageCode: Scalars["String"]["output"];
  /**  The type  */
  typeId: Scalars["ID"]["output"];
  updatedTs: Scalars["Int64"]["output"];
  /**  The related wallet  */
  walletId: Scalars["ID"]["output"];
};

export enum LedgersMsSearchLedgersResponseDataPcomType {
  Badge = "BADGE",
  Card = "CARD",
  PcomTypeUnknown = "PCOM_TYPE_UNKNOWN",
}

/**  Search orderTemplate  */
export type LedgersMsSearchOrderTemplateRequest = {
  filters?: InputMaybe<LedgersMsSearchOrderTemplateRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<LedgersMsSearchOrderTemplateRequestSort>>
  >;
};

export type LedgersMsSearchOrderTemplateRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsSearchOrderTemplateRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchOrderTemplateRequestSortField>;
};

export enum LedgersMsSearchOrderTemplateRequestSortField {
  CreatedTs = "created_ts",
  UpdatedTs = "updated_ts",
}

export type LedgersMsSearchOrderTemplateResponse = {
  __typename?: "LedgersMsSearchOrderTemplateResponse";
  data?: Maybe<Array<LedgersMsSearchOrderTemplateResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchOrderTemplateResponseData = {
  __typename?: "LedgersMsSearchOrderTemplateResponseData";
  OrderIdData?: Maybe<LedgersMsSearchOrdersResponseData>;
  createdTs: Scalars["Int64"]["output"];
  /**  The template used to verify the form data  */
  fixTemplate: Scalars["String"]["output"];
  /**  The order template ID  */
  id: Scalars["ID"]["output"];
  /**  order id  */
  orderId: Scalars["ID"]["output"];
  /**  The template used to verify the form data  */
  rawTemplate: Scalars["String"]["output"];
  /**  The template send to front  */
  templateFront: Scalars["String"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

/**  Search among orders  */
export type LedgersMsSearchOrdersRequest = {
  filters?: InputMaybe<LedgersMsSearchOrdersRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<LedgersMsSearchOrdersRequestSort>>>;
};

export type LedgersMsSearchOrdersRequestFilters = {
  blockedLedgerId?: InputMaybe<Scalars["ID"]["input"]>;
  errorIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<LedgersMsSearchOrdersRequestFiltersStatus>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  type?: InputMaybe<LedgersMsSearchOrdersRequestFiltersType>;
  types?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export enum LedgersMsSearchOrdersRequestFiltersStatus {
  Failed = "FAILED",
  Initialized = "INITIALIZED",
  OrderStatusUnknown = "ORDER_STATUS_UNKNOWN",
  Processing = "PROCESSING",
  Retrying = "RETRYING",
  Successful = "SUCCESSFUL",
}

export enum LedgersMsSearchOrdersRequestFiltersType {
  Block = "BLOCK",
  Cancel = "CANCEL",
  CollaboratorAssignment = "COLLABORATOR_ASSIGNMENT",
  CollaboratorDeleteAssignment = "COLLABORATOR_DELETE_ASSIGNMENT",
  CollaboratorPeriodUpdateAssignment = "COLLABORATOR_PERIOD_UPDATE_ASSIGNMENT",
  Create = "CREATE",
  CreateCancel = "CREATE_CANCEL",
  CreateDivision = "CREATE_DIVISION",
  Delete = "DELETE",
  DisplayPinCode = "DISPLAY_PIN_CODE",
  OrderTypeUnknown = "ORDER_TYPE_UNKNOWN",
  Renew = "RENEW",
  ResendPinCode = "RESEND_PIN_CODE",
  SectorUpdateAssignment = "SECTOR_UPDATE_ASSIGNMENT",
  Update = "UPDATE",
  UpdateDivision = "UPDATE_DIVISION",
  VehicleAssignment = "VEHICLE_ASSIGNMENT",
  VehicleDeleteAssignment = "VEHICLE_DELETE_ASSIGNMENT",
  VehiclePeriodUpdateAssignment = "VEHICLE_PERIOD_UPDATE_ASSIGNMENT",
}

export type LedgersMsSearchOrdersRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchOrdersRequestSortField>;
};

export enum LedgersMsSearchOrdersRequestSortField {
  CreatedTs = "created_ts",
  Status = "status",
  TerminatedTs = "terminated_ts",
  Type = "type",
  UpdatedTs = "updated_ts",
}

export type LedgersMsSearchOrdersResponse = {
  __typename?: "LedgersMsSearchOrdersResponse";
  data?: Maybe<Array<LedgersMsSearchOrdersResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchOrdersResponseData = {
  __typename?: "LedgersMsSearchOrdersResponseData";
  BlockedLedgerIdData?: Maybe<LedgersMsSearchLedgersResponseData>;
  CollaboratorIdData?: Maybe<CollaboratorsMsSearchCollaboratorsResponseData>;
  ErrorIdData?: Maybe<LedgersMsSearchErrorCodeResponseData>;
  LedgerIdData?: Maybe<LedgersMsSearchLedgersResponseData>;
  LedgerTypeIdData?: Maybe<LedgersMsSearchTypesResponseData>;
  SectorIdData?: Maybe<SectorsMsSearchSectorsResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  VehicleIdData?: Maybe<VehiclesMsSearchVehiclesResponseData>;
  WalletIdData?: Maybe<LedgersMsSearchWalletsResponseData>;
  /**  assignment id  */
  assignmentId: Scalars["ID"]["output"];
  /**  The optional blocked ledger id, used during renewal order to remember the blocked ledger...  */
  blockedLedgerId: Scalars["ID"]["output"];
  /**  The collaborator id  */
  collaboratorId: Scalars["ID"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  error id  */
  errorId: Scalars["ID"]["output"];
  /**  The reason code when the order failed  */
  failedReason: Scalars["String"]["output"];
  /**  the fields on which the error occurred  */
  fieldsInErr?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The assignment start date  */
  fromTs: Scalars["String"]["output"];
  /**  The order ID  */
  id: Scalars["ID"]["output"];
  /**  The related ledger, when the order has been successfully terminated.  */
  ledgerId: Scalars["ID"]["output"];
  /**  The requested type  */
  ledgerTypeId: Scalars["ID"]["output"];
  /**  when the ledger will be renewed  */
  renewTs: Scalars["String"]["output"];
  /**  Everytime the status is updated to "RETRYING", the retry count is incremented  */
  retryCount: Scalars["Int64"]["output"];
  /**  sector id  */
  sectorId: Scalars["ID"]["output"];
  status: LedgersMsSearchOrdersResponseDataStatus;
  /**  The template used to create or modify the ledger  */
  template: Scalars["String"]["output"];
  /**  When the order has been terminated  */
  terminatedTs: Scalars["Int64"]["output"];
  /**  The assignment end date  */
  tillTs: Scalars["String"]["output"];
  /**  The kind of order  */
  type: LedgersMsSearchOrdersResponseDataType;
  updatedTs: Scalars["Int64"]["output"];
  /**  Who created the order  */
  userId: Scalars["ID"]["output"];
  /**  The vehicle id  */
  vehicleId: Scalars["ID"]["output"];
  /**  The related wallet  */
  walletId: Scalars["ID"]["output"];
};

export enum LedgersMsSearchOrdersResponseDataStatus {
  Failed = "FAILED",
  Initialized = "INITIALIZED",
  OrderStatusUnknown = "ORDER_STATUS_UNKNOWN",
  Processing = "PROCESSING",
  Retrying = "RETRYING",
  Successful = "SUCCESSFUL",
}

export enum LedgersMsSearchOrdersResponseDataType {
  Block = "BLOCK",
  Cancel = "CANCEL",
  CollaboratorAssignment = "COLLABORATOR_ASSIGNMENT",
  CollaboratorDeleteAssignment = "COLLABORATOR_DELETE_ASSIGNMENT",
  CollaboratorPeriodUpdateAssignment = "COLLABORATOR_PERIOD_UPDATE_ASSIGNMENT",
  Create = "CREATE",
  CreateCancel = "CREATE_CANCEL",
  CreateDivision = "CREATE_DIVISION",
  Delete = "DELETE",
  DisplayPinCode = "DISPLAY_PIN_CODE",
  OrderTypeUnknown = "ORDER_TYPE_UNKNOWN",
  Renew = "RENEW",
  ResendPinCode = "RESEND_PIN_CODE",
  SectorUpdateAssignment = "SECTOR_UPDATE_ASSIGNMENT",
  Update = "UPDATE",
  UpdateDivision = "UPDATE_DIVISION",
  VehicleAssignment = "VEHICLE_ASSIGNMENT",
  VehicleDeleteAssignment = "VEHICLE_DELETE_ASSIGNMENT",
  VehiclePeriodUpdateAssignment = "VEHICLE_PERIOD_UPDATE_ASSIGNMENT",
}

/**  Search product categories  */
export type LedgersMsSearchProductCategoriesRequest = {
  filters?: InputMaybe<LedgersMsSearchProductCategoriesRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<LedgersMsSearchProductCategoriesRequestSort>>
  >;
};

export type LedgersMsSearchProductCategoriesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsSearchProductCategoriesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchProductCategoriesRequestSortField>;
};

export enum LedgersMsSearchProductCategoriesRequestSortField {
  Code = "code",
}

export type LedgersMsSearchProductCategoriesResponse = {
  __typename?: "LedgersMsSearchProductCategoriesResponse";
  data?: Maybe<Array<LedgersMsSearchProductCategoriesResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchProductCategoriesResponseData = {
  __typename?: "LedgersMsSearchProductCategoriesResponseData";
  /**  The unique code  */
  code: Scalars["String"]["output"];
  /**  The product category id  */
  id: Scalars["ID"]["output"];
};

/**  Search product family  */
export type LedgersMsSearchProductFamiliesRequest = {
  filters?: InputMaybe<LedgersMsSearchProductFamiliesRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<LedgersMsSearchProductFamiliesRequestSort>>
  >;
};

export type LedgersMsSearchProductFamiliesRequestFilters = {
  familyCode?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  superFamilyCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type LedgersMsSearchProductFamiliesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchProductFamiliesRequestSortField>;
};

export enum LedgersMsSearchProductFamiliesRequestSortField {
  Code = "code",
}

export type LedgersMsSearchProductFamiliesResponse = {
  __typename?: "LedgersMsSearchProductFamiliesResponse";
  data?: Maybe<Array<LedgersMsSearchProductFamiliesResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchProductFamiliesResponseData = {
  __typename?: "LedgersMsSearchProductFamiliesResponseData";
  /**  The product family code  */
  familyCode: Scalars["String"]["output"];
  /**  The product family id  */
  id: Scalars["ID"]["output"];
  /**  The super product family code  */
  superFamilyCode: Scalars["String"]["output"];
};

/**  Search product  */
export type LedgersMsSearchProductsRequest = {
  filters?: InputMaybe<LedgersMsSearchProductsRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<LedgersMsSearchProductsRequestSort>>>;
};

export type LedgersMsSearchProductsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsSearchProductsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchProductsRequestSortField>;
};

export enum LedgersMsSearchProductsRequestSortField {
  Code = "code",
}

export type LedgersMsSearchProductsResponse = {
  __typename?: "LedgersMsSearchProductsResponse";
  data?: Maybe<Array<LedgersMsSearchProductsResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchProductsResponseData = {
  __typename?: "LedgersMsSearchProductsResponseData";
  /**  The unique code  */
  code: Scalars["String"]["output"];
  /**  The product id  */
  id: Scalars["ID"]["output"];
};

/**  Search ledger statuses  */
export type LedgersMsSearchStatusesRequest = {
  filters?: InputMaybe<LedgersMsSearchStatusesRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<LedgersMsSearchStatusesRequestSort>>>;
};

export type LedgersMsSearchStatusesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsSearchStatusesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchStatusesRequestSortField>;
};

export enum LedgersMsSearchStatusesRequestSortField {
  Code = "code",
}

export type LedgersMsSearchStatusesResponse = {
  __typename?: "LedgersMsSearchStatusesResponse";
  data?: Maybe<Array<LedgersMsSearchStatusesResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchStatusesResponseData = {
  __typename?: "LedgersMsSearchStatusesResponseData";
  /**  True if ledgers of this status can be blocked or renewed (opposable).  */
  blockable: Scalars["Boolean"]["output"];
  /**  True if create a copy is possible  */
  canCreateCopy: Scalars["Boolean"]["output"];
  /**  True if we can reassign a collaborator for Mobility Corporate  */
  canReassignCollaborator: Scalars["Boolean"]["output"];
  /**  The unique code  */
  code: Scalars["String"]["output"];
  /**  The system code, used for internal codes  */
  codeSystem: Scalars["String"]["output"];
  /**  True if the ledger can be deleted  */
  deletable: Scalars["Boolean"]["output"];
  /**  The product id  */
  id: Scalars["ID"]["output"];
};

/**  Search among transactions  */
export type LedgersMsSearchTransactionsRequest = {
  filters?: InputMaybe<LedgersMsSearchTransactionsRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<LedgersMsSearchTransactionsRequestSort>>>;
};

export type LedgersMsSearchTransactionsRequestFilters = {
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  invoiceId?: InputMaybe<Scalars["ID"]["input"]>;
  invoiceStateCode?: InputMaybe<LedgersMsSearchTransactionsRequestFiltersInvoiceStateCode>;
  invoiceStateCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  productCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
  tillDate?: InputMaybe<Scalars["String"]["input"]>;
};

export enum LedgersMsSearchTransactionsRequestFiltersInvoiceStateCode {
  Invoiced = "INVOICED",
  OutOfInvoice = "OUT_OF_INVOICE",
  PendingInvoice = "PENDING_INVOICE",
  PendingValorization = "PENDING_VALORIZATION",
  UnknownInvoiceState = "UNKNOWN_INVOICE_STATE",
}

export type LedgersMsSearchTransactionsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchTransactionsRequestSortField>;
};

export enum LedgersMsSearchTransactionsRequestSortField {
  AmountIncludingVat = "amount_including_vat",
  Billable = "billable",
  Date = "date",
  DateTs = "date_ts",
  InvoiceId = "invoice_id",
  Label = "label",
  Number = "number",
  ProductCategoryId = "product_category_id",
  UpdatedTs = "updated_ts",
}

export type LedgersMsSearchTransactionsResponse = {
  __typename?: "LedgersMsSearchTransactionsResponse";
  data?: Maybe<Array<LedgersMsSearchTransactionsResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchTransactionsResponseData = {
  __typename?: "LedgersMsSearchTransactionsResponseData";
  FamilyIdData?: Maybe<LedgersMsSearchProductFamiliesResponseData>;
  InvoiceIdData?: Maybe<BillingMsSearchInvoicesResponseData>;
  LedgerIdData?: Maybe<LedgersMsSearchLedgersResponseData>;
  ProductCategoryIdData?: Maybe<LedgersMsSearchProductCategoriesResponseData>;
  ProductIdData?: Maybe<LedgersMsSearchProductsResponseData>;
  /**  The currency of the related amounts  */
  amountCurrency: Scalars["String"]["output"];
  /**  The total amount including the VAT (normalized in an integer, check the precision related to the currency)  */
  amountIncludingVat: Scalars["Float"]["output"];
  /**  The related toll roads class when the transaction was made with a badge, if there is such.  */
  badgeTollClass: Scalars["String"]["output"];
  /**  Whether or not this transaction should be paired to an invoice.  */
  billable: Scalars["Boolean"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**
   *  The date of the transaction in ISO 8601 format
   * Deprecated
   */
  date: Scalars["String"]["output"];
  /**  The date of the transaction  */
  dateTs: Scalars["Int64"]["output"];
  /**  The family related to the transaction  */
  familyId: Scalars["ID"]["output"];
  /**  The transaction ID  */
  id: Scalars["ID"]["output"];
  /**  The related invoice  */
  invoiceId: Scalars["String"]["output"];
  /**  The invoice state code  */
  invoiceStateCode: LedgersMsSearchTransactionsResponseDataInvoiceStateCode;
  /**  The site name of the transaction  */
  label: Scalars["String"]["output"];
  /**  The related ledger  */
  ledgerId: Scalars["ID"]["output"];
  /**  The transaction unique number (per account)  */
  number: Scalars["String"]["output"];
  /**  The related product category  */
  productCategoryId: Scalars["String"]["output"];
  /**  The related product  */
  productId: Scalars["String"]["output"];
  /**  The quantity of the transaction  */
  quantity: Scalars["Float"]["output"];
  /**  The timezone related to the transaction  */
  timezone: Scalars["String"]["output"];
  /**  The transaction's unique id  */
  uniqueId: Scalars["String"]["output"];
  /**  The unit of the transaction  */
  unit: Scalars["String"]["output"];
  /**  The transaction unit price  */
  unitPrice: Scalars["Float"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

export enum LedgersMsSearchTransactionsResponseDataInvoiceStateCode {
  Invoiced = "INVOICED",
  OutOfInvoice = "OUT_OF_INVOICE",
  PendingInvoice = "PENDING_INVOICE",
  PendingValorization = "PENDING_VALORIZATION",
  UnknownInvoiceState = "UNKNOWN_INVOICE_STATE",
}

/**  Search ledger types  */
export type LedgersMsSearchTypesRequest = {
  filters?: InputMaybe<LedgersMsSearchTypesRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<LedgersMsSearchTypesRequestSort>>>;
};

export type LedgersMsSearchTypesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type LedgersMsSearchTypesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchTypesRequestSortField>;
};

export enum LedgersMsSearchTypesRequestSortField {
  Code = "code",
}

export type LedgersMsSearchTypesResponse = {
  __typename?: "LedgersMsSearchTypesResponse";
  data?: Maybe<Array<LedgersMsSearchTypesResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchTypesResponseData = {
  __typename?: "LedgersMsSearchTypesResponseData";
  GroupIdData?: Maybe<LedgersMsSearchGroupsResponseData>;
  /**  The unique code  */
  code: Scalars["String"]["output"];
  /**  The ledger code comment  */
  codeHint: Scalars["String"]["output"];
  /**  The group the type is linked to  */
  groupId: Scalars["ID"]["output"];
  /**  The ledger id  */
  id: Scalars["ID"]["output"];
};

/**  Fetch wallet settings  */
export type LedgersMsSearchWalletSettingsRequest = {
  filters?: InputMaybe<LedgersMsSearchWalletSettingsRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<LedgersMsSearchWalletSettingsRequestSort>>
  >;
};

export type LedgersMsSearchWalletSettingsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  supportAccountNumbers?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
};

export type LedgersMsSearchWalletSettingsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchWalletSettingsRequestSortField>;
};

export enum LedgersMsSearchWalletSettingsRequestSortField {
  Id = "id",
}

export type LedgersMsSearchWalletSettingsResponse = {
  __typename?: "LedgersMsSearchWalletSettingsResponse";
  data?: Maybe<Array<LedgersMsSearchWalletSettingsResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchWalletSettingsResponseData = {
  __typename?: "LedgersMsSearchWalletSettingsResponseData";
  SectorIdData?: Maybe<SectorsMsSearchSectorsResponseData>;
  accountNumber: Scalars["String"]["output"];
  divisionAccountLabel: Scalars["String"]["output"];
  divisionAccountNumber: Scalars["String"]["output"];
  /**  The wallet settings ID  */
  id: Scalars["ID"]["output"];
  sectorId: Scalars["ID"]["output"];
  supportAccountLabel: Scalars["String"]["output"];
  supportAccountNumber: Scalars["String"]["output"];
};

/**  Search among wallets  */
export type LedgersMsSearchWalletsRequest = {
  filters?: InputMaybe<LedgersMsSearchWalletsRequestFilters>;
  paging?: InputMaybe<LedgersMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<LedgersMsSearchWalletsRequestSort>>>;
};

export type LedgersMsSearchWalletsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  showOrderableWallets?: InputMaybe<Scalars["Boolean"]["input"]>;
  type?: InputMaybe<LedgersMsSearchWalletsRequestFiltersType>;
};

export enum LedgersMsSearchWalletsRequestFiltersType {
  All = "ALL",
  Div = "DIV",
  Sup = "SUP",
}

export type LedgersMsSearchWalletsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<LedgersMsSearchWalletsRequestSortField>;
};

export enum LedgersMsSearchWalletsRequestSortField {
  CreatedTs = "created_ts",
  Id = "id",
  Label = "label",
  UpdatedTs = "updated_ts",
}

export type LedgersMsSearchWalletsResponse = {
  __typename?: "LedgersMsSearchWalletsResponse";
  data?: Maybe<Array<LedgersMsSearchWalletsResponseData>>;
  pagination: LedgersMsPagedPagination;
};

export type LedgersMsSearchWalletsResponseData = {
  __typename?: "LedgersMsSearchWalletsResponseData";
  AccountIdData?: Maybe<LedgersMsSearchLedgersAccountPreferencesResponseData>;
  LastOrderIdData?: Maybe<LedgersMsSearchOrdersResponseData>;
  SettingsIdData?: Maybe<LedgersMsSearchWalletSettingsResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**  The wallet ID  */
  id: Scalars["ID"]["output"];
  /**  The wallet name  */
  label: Scalars["String"]["output"];
  lastOrderId: Scalars["ID"]["output"];
  /**  The wallet label provided by CardPro  */
  originalLabel: Scalars["String"]["output"];
  /**  The related settings wallet, root level do not have such  */
  settingsId: Scalars["ID"]["output"];
  /**  The wallet status  */
  status: Scalars["String"]["output"];
  /**  The division status code provided by CardPro  */
  statusCode: Scalars["String"]["output"];
};

export type LedgersMsUpdateDivisionOrderRequest = {
  addressId?: InputMaybe<Scalars["String"]["input"]>;
  /**  list of products  */
  authorizedProducts?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  contactId?: InputMaybe<Scalars["String"]["input"]>;
  customizableLine1?: InputMaybe<Scalars["String"]["input"]>;
  customizableLine2?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  productRefrabrication?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  the walletId of the division to be modified  */
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsUpdateDivisionOrderResponse = {
  __typename?: "LedgersMsUpdateDivisionOrderResponse";
  orderId: Scalars["ID"]["output"];
};

/**  Create an order to modify/update a Ledger  */
export type LedgersMsUpdateLedgerOrderRequest = {
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The raw filled up data to be sent to the ledger provider.  */
  rawFormData?: InputMaybe<Scalars["String"]["input"]>;
  /**  The template used for the modification  */
  template?: InputMaybe<Scalars["String"]["input"]>;
};

export type LedgersMsUpdateLedgerOrderResponse = {
  __typename?: "LedgersMsUpdateLedgerOrderResponse";
  orderId: Scalars["ID"]["output"];
};

export type LedgersMsValidatorOptionAuthorizedWeekDaysSelection = {
  __typename?: "LedgersMsValidatorOptionAuthorizedWeekDaysSelection";
  authorizedWeekDaysRegex: Scalars["String"]["output"];
};

export type LedgersMsValidatorOptionDigits = {
  __typename?: "LedgersMsValidatorOptionDigits";
  digitsRegex: Scalars["String"]["output"];
};

export type LedgersMsValidatorOptionLowerCase = {
  __typename?: "LedgersMsValidatorOptionLowerCase";
  isLowerCase: Scalars["Boolean"]["output"];
};

export type LedgersMsValidatorOptionMaxLength = {
  __typename?: "LedgersMsValidatorOptionMaxLength";
  max: Scalars["Int"]["output"];
};

export type LedgersMsValidatorOptionMinLength = {
  __typename?: "LedgersMsValidatorOptionMinLength";
  min: Scalars["Int"]["output"];
};

export type LedgersMsValidatorOptionPattern = {
  __typename?: "LedgersMsValidatorOptionPattern";
  patternRegex: Scalars["String"]["output"];
};

export type LedgersMsValidatorOptionQuery = {
  __typename?: "LedgersMsValidatorOptionQuery";
  name: Scalars["String"]["output"];
};

export type LedgersMsValidatorOptionUpperCase = {
  __typename?: "LedgersMsValidatorOptionUpperCase";
  isUpperCase: Scalars["Boolean"]["output"];
};

export type LedgersMsValidatorOptions = {
  __typename?: "LedgersMsValidatorOptions";
  authorizedWeekDaysSelection: LedgersMsValidatorOptionAuthorizedWeekDaysSelection;
  digits: LedgersMsValidatorOptionDigits;
  lowerCase: LedgersMsValidatorOptionLowerCase;
  maxLength: LedgersMsValidatorOptionMaxLength;
  minLength: LedgersMsValidatorOptionMinLength;
  pattern: LedgersMsValidatorOptionPattern;
  query: LedgersMsValidatorOptionQuery;
  upperCase: LedgersMsValidatorOptionUpperCase;
};

/**  Verify if division code is unique  */
export type LedgersMsVerifyDivisionCodeRequest = {
  divisionCode?: InputMaybe<Scalars["String"]["input"]>;
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsVerifyDivisionCodeResponse = {
  __typename?: "LedgersMsVerifyDivisionCodeResponse";
  divisionCodeStatus: LedgersMsVerifyDivisionCodeResponseDivisionCodeStatus;
  isAvailable: Scalars["Boolean"]["output"];
};

export enum LedgersMsVerifyDivisionCodeResponseDivisionCodeStatus {
  CodeAlreadyExist = "CODE_ALREADY_EXIST",
  CodeInvalidLength = "CODE_INVALID_LENGTH",
  InvalidDivisionCode = "INVALID_DIVISION_CODE",
  UnknownDivisionCode = "UNKNOWN_DIVISION_CODE",
}

/**  check if shortcode exist for wallet  */
export type LedgersMsVerifyShortCodeRequest = {
  shortCode?: InputMaybe<Scalars["String"]["input"]>;
  walletId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LedgersMsVerifyShortCodeResponse = {
  __typename?: "LedgersMsVerifyShortCodeResponse";
  isAvailable: Scalars["Boolean"]["output"];
  shortCodeStatus: LedgersMsVerifyShortCodeResponseShortCodeStatus;
};

export enum LedgersMsVerifyShortCodeResponseShortCodeStatus {
  AlreadyExist = "ALREADY_EXIST",
  InvalidLength = "INVALID_LENGTH",
  InvalidShortCode = "INVALID_SHORT_CODE",
  UnknownShortCode = "UNKNOWN_SHORT_CODE",
}

export type LedgersMsgetLedgerStatisticByTypeRequest = {
  endDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  groupCode?: InputMaybe<Scalars["String"]["input"]>;
  orderStatus?: InputMaybe<LedgersMsgetLedgerStatisticByTypeRequestOrderStatus>;
  startDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  type?: InputMaybe<LedgersMsgetLedgerStatisticByTypeRequestType>;
};

export enum LedgersMsgetLedgerStatisticByTypeRequestOrderStatus {
  Failed = "FAILED",
  Initialized = "INITIALIZED",
  OrderStatusUnknown = "ORDER_STATUS_UNKNOWN",
  Processing = "PROCESSING",
  Retrying = "RETRYING",
  Successful = "SUCCESSFUL",
}

export enum LedgersMsgetLedgerStatisticByTypeRequestType {
  Block = "BLOCK",
  Cancel = "CANCEL",
  CollaboratorAssignment = "COLLABORATOR_ASSIGNMENT",
  CollaboratorDeleteAssignment = "COLLABORATOR_DELETE_ASSIGNMENT",
  CollaboratorPeriodUpdateAssignment = "COLLABORATOR_PERIOD_UPDATE_ASSIGNMENT",
  Create = "CREATE",
  CreateCancel = "CREATE_CANCEL",
  CreateDivision = "CREATE_DIVISION",
  Delete = "DELETE",
  DisplayPinCode = "DISPLAY_PIN_CODE",
  OrderTypeUnknown = "ORDER_TYPE_UNKNOWN",
  Renew = "RENEW",
  ResendPinCode = "RESEND_PIN_CODE",
  SectorUpdateAssignment = "SECTOR_UPDATE_ASSIGNMENT",
  Update = "UPDATE",
  UpdateDivision = "UPDATE_DIVISION",
  VehicleAssignment = "VEHICLE_ASSIGNMENT",
  VehicleDeleteAssignment = "VEHICLE_DELETE_ASSIGNMENT",
  VehiclePeriodUpdateAssignment = "VEHICLE_PERIOD_UPDATE_ASSIGNMENT",
}

export type LedgersMsgetLedgerStatisticByTypeResponse = {
  __typename?: "LedgersMsgetLedgerStatisticByTypeResponse";
  data?: Maybe<Array<LedgersMsgetLedgerStatisticByTypeResponseData>>;
};

export type LedgersMsgetLedgerStatisticByTypeResponseData = {
  __typename?: "LedgersMsgetLedgerStatisticByTypeResponseData";
  failReason: Scalars["String"]["output"];
  groupCode: Scalars["String"]["output"];
  ledgerCount: Scalars["Int64"]["output"];
  orderStatus: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type MediaMsCreateDocumentTypeRequest = {
  code?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaMsCreateDocumentTypeResponse = {
  __typename?: "MediaMsCreateDocumentTypeResponse";
  id: Scalars["ID"]["output"];
};

/**  Create a download token  */
export type MediaMsDownloadRequest = {
  documentId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MediaMsDownloadResponse = {
  __typename?: "MediaMsDownloadResponse";
  /**  The download token to use when calling /download/$token URI  */
  token: Scalars["String"]["output"];
};

export type MediaMsPagedPagination = {
  __typename?: "MediaMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type MediaMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  Search among document types  */
export type MediaMsSearchDocumentTypesRequest = {
  filters?: InputMaybe<MediaMsSearchDocumentTypesRequestFilters>;
  paging?: InputMaybe<MediaMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<MediaMsSearchDocumentTypesRequestSort>>>;
};

export type MediaMsSearchDocumentTypesRequestFilters = {
  code?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MediaMsSearchDocumentTypesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MediaMsSearchDocumentTypesRequestSortField>;
};

export enum MediaMsSearchDocumentTypesRequestSortField {
  Code = "code",
}

export type MediaMsSearchDocumentTypesResponse = {
  __typename?: "MediaMsSearchDocumentTypesResponse";
  data?: Maybe<Array<MediaMsSearchDocumentTypesResponseData>>;
  pagination: MediaMsPagedPagination;
};

export type MediaMsSearchDocumentTypesResponseData = {
  __typename?: "MediaMsSearchDocumentTypesResponseData";
  /**  The type code  */
  code: Scalars["String"]["output"];
  /**  The features you must have in order to access the related documents. This rule is ignored when the list is empty.  */
  features?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The ID of the document type  */
  id: Scalars["ID"]["output"];
  /**  True if the document is a report.  */
  isReport: Scalars["Boolean"]["output"];
  /**  The required maximum size in bytes  */
  maxSize: Scalars["Int64"]["output"];
  /**  The required mime types  */
  mimeTypes?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  True if the downloaded event should be advertised to other services...  */
  publishDownloadedEvent: Scalars["Boolean"]["output"];
  /**  The roles you must have in order to access the related documents. This rule is ignored when the list is empty.  */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The time to live of the related documents in seconds. Used during document creation.  */
  ttl: Scalars["Int64"]["output"];
};

/**  Search among documents  */
export type MediaMsSearchDocumentsRequest = {
  filters?: InputMaybe<MediaMsSearchDocumentsRequestFilters>;
  paging?: InputMaybe<MediaMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<MediaMsSearchDocumentsRequestSort>>>;
};

export type MediaMsSearchDocumentsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  filename?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  signature?: InputMaybe<Scalars["String"]["input"]>;
  typeCode?: InputMaybe<Scalars["String"]["input"]>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MediaMsSearchDocumentsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MediaMsSearchDocumentsRequestSortField>;
};

export enum MediaMsSearchDocumentsRequestSortField {
  Filename = "filename",
  UpdatedTs = "updated_ts",
}

export type MediaMsSearchDocumentsResponse = {
  __typename?: "MediaMsSearchDocumentsResponse";
  data?: Maybe<Array<MediaMsSearchDocumentsResponseData>>;
  pagination: MediaMsPagedPagination;
};

export type MediaMsSearchDocumentsResponseData = {
  __typename?: "MediaMsSearchDocumentsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  TypeIdData?: Maybe<MediaMsSearchDocumentTypesResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**  The content type of the given file  */
  contentType: Scalars["String"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  When the document was downloaded  */
  downloadedTs: Scalars["Int64"]["output"];
  /**  The document expiry date  */
  expiresTs: Scalars["Int64"]["output"];
  /**  The original file name  */
  filename: Scalars["String"]["output"];
  /**  The ID of the document  */
  id: Scalars["ID"]["output"];
  /**  The location DSN  */
  locationDsn: Scalars["String"]["output"];
  /**  The file signature hash in order to check integrity (a sha256)  */
  signature: Scalars["String"]["output"];
  /**  The size in bytes of the file  */
  size: Scalars["Int64"]["output"];
  /**  The document type  */
  typeId: Scalars["ID"]["output"];
  /**  Who created this document if there is such  */
  userId: Scalars["ID"]["output"];
};

/**  Search among capital statements (FR: relevé de capitalisation)  */
export type MediaMsSearchEndOfYearStatementDocumentsRequest = {
  filters?: InputMaybe<MediaMsSearchEndOfYearStatementDocumentsRequestFilters>;
  paging?: InputMaybe<MediaMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<MediaMsSearchEndOfYearStatementDocumentsRequestSort>>
  >;
};

export type MediaMsSearchEndOfYearStatementDocumentsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MediaMsSearchEndOfYearStatementDocumentsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MediaMsSearchEndOfYearStatementDocumentsRequestSortField>;
};

export enum MediaMsSearchEndOfYearStatementDocumentsRequestSortField {
  CreatedTs = "created_ts",
  Filename = "filename",
  UpdatedTs = "updated_ts",
}

export type MediaMsSearchEndOfYearStatementDocumentsResponse = {
  __typename?: "MediaMsSearchEndOfYearStatementDocumentsResponse";
  data?: Maybe<Array<MediaMsSearchEndOfYearStatementDocumentsResponseData>>;
  pagination: MediaMsPagedPagination;
};

export type MediaMsSearchEndOfYearStatementDocumentsResponseData = {
  __typename?: "MediaMsSearchEndOfYearStatementDocumentsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  TypeIdData?: Maybe<MediaMsSearchDocumentTypesResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**  The content type of the given file  */
  contentType: Scalars["String"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  When the document was downloaded  */
  downloadedTs: Scalars["Int64"]["output"];
  /**  The document expiry date  */
  expiresTs: Scalars["Int64"]["output"];
  /**  The original file name  */
  filename: Scalars["String"]["output"];
  /**  The ID of the document  */
  id: Scalars["ID"]["output"];
  /**  The location DSN  */
  locationDsn: Scalars["String"]["output"];
  /**  The file signature hash in order to check integrity (a sha256)  */
  signature: Scalars["String"]["output"];
  /**  The size in bytes of the file  */
  size: Scalars["Int64"]["output"];
  /**  The document type  */
  typeId: Scalars["ID"]["output"];
  /**  Who created this document if there is such  */
  userId: Scalars["ID"]["output"];
};

/**  Get account preferences related to the media domain  */
export type MediaMsSearchMediaAccountPreferencesRequest = {
  filters?: InputMaybe<MediaMsSearchMediaAccountPreferencesRequestFilters>;
  paging?: InputMaybe<MediaMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<MediaMsSearchMediaAccountPreferencesRequestSort>>
  >;
};

export type MediaMsSearchMediaAccountPreferencesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MediaMsSearchMediaAccountPreferencesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MediaMsSearchMediaAccountPreferencesRequestSortField>;
};

export enum MediaMsSearchMediaAccountPreferencesRequestSortField {
  Id = "id",
}

export type MediaMsSearchMediaAccountPreferencesResponse = {
  __typename?: "MediaMsSearchMediaAccountPreferencesResponse";
  data?: Maybe<Array<MediaMsSearchMediaAccountPreferencesResponseData>>;
  pagination: MediaMsPagedPagination;
};

export type MediaMsSearchMediaAccountPreferencesResponseData = {
  __typename?: "MediaMsSearchMediaAccountPreferencesResponseData";
  IdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  /**  The account ID  */
  id: Scalars["ID"]["output"];
};

/**  Search among tokens  */
export type MediaMsSearchTokensRequest = {
  filters?: InputMaybe<MediaMsSearchTokensRequestFilters>;
  paging?: InputMaybe<MediaMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<MediaMsSearchTokensRequestSort>>>;
};

export type MediaMsSearchTokensRequestFilters = {
  documentId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MediaMsSearchTokensRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MediaMsSearchTokensRequestSortField>;
};

export enum MediaMsSearchTokensRequestSortField {
  Counter = "counter",
}

export type MediaMsSearchTokensResponse = {
  __typename?: "MediaMsSearchTokensResponse";
  data?: Maybe<Array<MediaMsSearchTokensResponseData>>;
  pagination: MediaMsPagedPagination;
};

export type MediaMsSearchTokensResponseData = {
  __typename?: "MediaMsSearchTokensResponseData";
  /**  How may time the token has been used, leading to a file download.  */
  counter: Scalars["Int64"]["output"];
  /**  The id of the token  */
  id: Scalars["ID"]["output"];
  /**  If set, the document cannot be downloaded during the lock time. This helps to handle anti flood parallel downloads.  */
  lockedTill: Scalars["Int64"]["output"];
};

export type MediaMsUpdateDocumentTypeRequest = {
  features?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  isReport?: InputMaybe<Scalars["Boolean"]["input"]>;
  maxSize?: InputMaybe<Scalars["Int64"]["input"]>;
  mimeTypes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  publishDownloadedEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
  roles?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ttl?: InputMaybe<Scalars["Int64"]["input"]>;
};

/**  Build the accounts migration report  */
export type MiddleMsBuildAccountsMigrationReportRequest = {
  accountNumbers?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MiddleMsBuildAccountsMigrationReportResponse = {
  __typename?: "MiddleMsBuildAccountsMigrationReportResponse";
  /**  Number of accounts to be diagnosed  */
  diagnosedAccounts: Scalars["Int"]["output"];
  /**  Migration failures with reason(s)  */
  failures?: Maybe<
    Array<MiddleMsBuildAccountsMigrationReportResponseAccountMigrationReport>
  >;
  /**  Number of successfully migrated accounts  */
  migratedAccounts: Scalars["Int"]["output"];
  /**  Migration successes  */
  successes?: Maybe<
    Array<MiddleMsBuildAccountsMigrationReportResponseAccountMigrationReport>
  >;
};

/**  Migration failures with reason(s)  */
export type MiddleMsBuildAccountsMigrationReportResponseAccountMigrationReport =
  {
    __typename?: "MiddleMsBuildAccountsMigrationReportResponseAccountMigrationReport";
    accountHasNoPcom: Scalars["Boolean"]["output"];
    accountNumber: Scalars["String"]["output"];
    accountNumberIsAct: Scalars["Boolean"]["output"];
    billingAccountPayerCurrencyIsNull: Scalars["Boolean"]["output"];
    contactEmailIsInvalid: Scalars["Boolean"]["output"];
    contactEmailIsNull: Scalars["Boolean"]["output"];
    contactIsNull: Scalars["Boolean"]["output"];
    contractBillingFrequencyCodeIsNull: Scalars["Boolean"]["output"];
    contractContractNumIsNull: Scalars["Boolean"]["output"];
    contractExternalContractIdIsNull: Scalars["Boolean"]["output"];
    contractHasInvalidStatus: Scalars["Boolean"]["output"];
    contractHasNoScom: Scalars["Boolean"]["output"];
    contractIsNotMb2: Scalars["Boolean"]["output"];
    contractMissing: Scalars["Boolean"]["output"];
    contractOfferCodeIsNull: Scalars["Boolean"]["output"];
    contractOfferNameIsNull: Scalars["Boolean"]["output"];
    notPresentInAccountsService: Scalars["Boolean"]["output"];
  };

/**  Create a demand in the pin manager  */
export type MiddleMsCreateDemandRequest = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  gigyaId?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pans?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MiddleMsCreateDemandResponse = {
  __typename?: "MiddleMsCreateDemandResponse";
  requestId: Scalars["String"]["output"];
};

/**  Creates a new form data rule group  */
export type MiddleMsCreateFormDataRuleGroupRequest = {
  /**  The form data filters applied for this set of rules (the product codes)  */
  codes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /**  The description of the group  */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /**
   *  The list of user ID for whom this group should be ignored. Usually, you use this feature when you duplicate a
   * group and wish to restrict the "old" version and enable the "new one".
   */
  disabledFor?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  True if the rule should be applied  */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  The list of user ID for who this group should be applied.  */
  enabledFor?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  The list of ledgerTypeGroup the rules should be applied to. If null or empty, rule apply for all.  */
  groupCodeFor?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /**  The name of the group  */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /**  The raw rules configuration  */
  rules?: InputMaybe<Scalars["String"]["input"]>;
  /**  The type of FormRule  */
  type?: InputMaybe<MiddleMsCreateFormDataRuleGroupRequestType>;
};

export enum MiddleMsCreateFormDataRuleGroupRequestType {
  FormRuleTypeCopy = "FORM_RULE_TYPE_COPY",
  FormRuleTypeCreation = "FORM_RULE_TYPE_CREATION",
  FormRuleTypeCreationOrModification = "FORM_RULE_TYPE_CREATION_OR_MODIFICATION",
  FormRuleTypeModification = "FORM_RULE_TYPE_MODIFICATION",
  FormRuleTypeUnknown = "FORM_RULE_TYPE_UNKNOWN",
}

export type MiddleMsCreateFormDataRuleGroupResponse = {
  __typename?: "MiddleMsCreateFormDataRuleGroupResponse";
  id: Scalars["ID"]["output"];
};

/**  Deletes a form data rule group  */
export type MiddleMsDeleteFormDataRuleGroupRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Duplicate a form data rule group  */
export type MiddleMsDuplicateFormDataRuleGroupRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MiddleMsDuplicateFormDataRuleGroupResponse = {
  __typename?: "MiddleMsDuplicateFormDataRuleGroupResponse";
  id: Scalars["ID"]["output"];
};

export type MiddleMsGetIngestionSnapshotResponse = {
  __typename?: "MiddleMsGetIngestionSnapshotResponse";
  flows?: Maybe<Array<MiddleMsGetIngestionSnapshotResponseFlow>>;
};

export type MiddleMsGetIngestionSnapshotResponseFlow = {
  __typename?: "MiddleMsGetIngestionSnapshotResponseFlow";
  chunks?: Maybe<Array<MiddleMsGetIngestionSnapshotResponseFlowChunk>>;
  /**  The unique identification code of the flow  */
  code: Scalars["String"]["output"];
  failedReason: Scalars["String"]["output"];
  failedStep: Scalars["String"]["output"];
  failureTs: Scalars["Int64"]["output"];
  /**  Import is empty  */
  isEmpty: Scalars["Boolean"]["output"];
  /**  Import related to migration MB1 to MB2  */
  isMb1: Scalars["Boolean"]["output"];
  objectsPerSec: Scalars["Float"]["output"];
  /**  The starting date of the next payload of data to ingest  */
  offset: Scalars["Int64"]["output"];
  processed: Scalars["Int64"]["output"];
  progress: Scalars["Float"]["output"];
  /**  The current sequence number of the flow  */
  sequence: Scalars["Int64"]["output"];
  startTs: Scalars["Int64"]["output"];
  /**  Last tacker status  */
  status: MiddleMsGetIngestionSnapshotResponseFlowStatus;
  successfulTs: Scalars["Int64"]["output"];
  total: Scalars["Int64"]["output"];
};

export type MiddleMsGetIngestionSnapshotResponseFlowChunk = {
  __typename?: "MiddleMsGetIngestionSnapshotResponseFlowChunk";
  failedReason: Scalars["String"]["output"];
  failureTs: Scalars["Int64"]["output"];
  lastWorkerUpdateTs: Scalars["Int64"]["output"];
  lockedBy: Scalars["String"]["output"];
  lockedFrom: Scalars["Int64"]["output"];
  lockedTill: Scalars["Int64"]["output"];
  number: Scalars["Int"]["output"];
  objectsPerSec: Scalars["Float"]["output"];
  processed: Scalars["Int64"]["output"];
  progress: Scalars["Float"]["output"];
  /**  Last chunk status  */
  status: MiddleMsGetIngestionSnapshotResponseFlowChunkStatus;
  successfulTs: Scalars["Int64"]["output"];
  total: Scalars["Int64"]["output"];
};

/**  Last chunk status  */
export enum MiddleMsGetIngestionSnapshotResponseFlowChunkStatus {
  GetIngestionSnapshotResponseError = "GetIngestionSnapshotResponse_ERROR",
  GetIngestionSnapshotResponseInProgress = "GetIngestionSnapshotResponse_IN_PROGRESS",
  GetIngestionSnapshotResponseSuccess = "GetIngestionSnapshotResponse_SUCCESS",
  GetIngestionSnapshotResponseUnknown = "GetIngestionSnapshotResponse_UNKNOWN",
}

/**  Last tacker status  */
export enum MiddleMsGetIngestionSnapshotResponseFlowStatus {
  GetIngestionSnapshotResponseError = "GetIngestionSnapshotResponse_ERROR",
  GetIngestionSnapshotResponseInProgress = "GetIngestionSnapshotResponse_IN_PROGRESS",
  GetIngestionSnapshotResponseSuccess = "GetIngestionSnapshotResponse_SUCCESS",
  GetIngestionSnapshotResponseUnknown = "GetIngestionSnapshotResponse_UNKNOWN",
}

/**  Retrieve ledger data (converts raw json ledger data to object representation)  */
export type MiddleMsGetLedgerDataV2Request = {
  ledgerGroup?: InputMaybe<Scalars["String"]["input"]>;
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  pan?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  /**  Who initiated the request  */
  who?: InputMaybe<MiddleMsGetLedgerDataV2RequestWho>;
};

/**  Who initiated the request  */
export type MiddleMsGetLedgerDataV2RequestWho = {
  accountNumber?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MiddleMsGetLedgerDataV2Response = {
  __typename?: "MiddleMsGetLedgerDataV2Response";
  /**  The partner's http status if not successful  */
  httpStatusCode: Scalars["Int"]["output"];
  /**  True if the ledger data contains AS24 data  */
  isDeclarationFormAvailable: Scalars["Boolean"]["output"];
  /**  The ledger information as object  */
  product: MiddleMsGetLedgerDataV2ResponseProduct;
};

/**  The ledger information as object  */
export type MiddleMsGetLedgerDataV2ResponseProduct = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProduct";
  attachements?: Maybe<Array<MiddleMsGetLedgerDataV2ResponseProductAttachment>>;
  authorizedProducts?: Maybe<
    Array<MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel>
  >;
  authorizedServices?: Maybe<
    Array<MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel>
  >;
  carbonClass: MiddleMsGetLedgerDataV2ResponseProductCarbonClass;
  cardSettings: MiddleMsGetLedgerDataV2ResponseProductCardSetting;
  commercialCondition?: Maybe<
    Array<MiddleMsGetLedgerDataV2ResponseProductCommercialCondition>
  >;
  complementaryInformation: Scalars["String"]["output"];
  creationDate: Scalars["String"]["output"];
  customerName: Scalars["String"]["output"];
  customerNumber: Scalars["String"]["output"];
  electric: MiddleMsGetLedgerDataV2ResponseProductElectric;
  electricLimits: MiddleMsGetLedgerDataV2ResponseProductElectricLimits;
  endDate: Scalars["String"]["output"];
  forbiddenProducts?: Maybe<
    Array<MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel>
  >;
  fuelLimits: MiddleMsGetLedgerDataV2ResponseProductFuelLimits;
  geographicalControls: MiddleMsGetLedgerDataV2ResponseProductGeographicalControl;
  linkedProduct: Scalars["String"]["output"];
  mobilitySettings: MiddleMsGetLedgerDataV2ResponseProductMobilitySettings;
  modificationDate: Scalars["String"]["output"];
  pan: Scalars["String"]["output"];
  perimeter?: Maybe<
    Array<MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel>
  >;
  productDelivery: MiddleMsGetLedgerDataV2ResponseProductProductDelivery;
  productNumber: MiddleMsGetLedgerDataV2ResponseProductProductNumber;
  productStatus: MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel;
  productType: MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel;
  registrationCountry: MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel;
  registrationNumber: Scalars["String"]["output"];
  sectorLabel: Scalars["String"]["output"];
  serviceLimits: MiddleMsGetLedgerDataV2ResponseProductServiceLimits;
  structureName: Scalars["String"]["output"];
  structureNumber: Scalars["String"]["output"];
  subStructureName: Scalars["String"]["output"];
  subStructureNumber: Scalars["String"]["output"];
  technicalControl: MiddleMsGetLedgerDataV2ResponseProductTechnicalControl;
  technology: MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel;
  timeControls: MiddleMsGetLedgerDataV2ResponseProductTimeControl;
  trackingNumber: Scalars["String"]["output"];
  truckSettings: MiddleMsGetLedgerDataV2ResponseProductTruckSetting;
  vehicleType: MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel;
  vin: Scalars["String"]["output"];
  weeklyLimit: MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel;
};

export type MiddleMsGetLedgerDataV2ResponseProductAttachment = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductAttachment";
  creationDate: Scalars["String"]["output"];
  document: Scalars["String"]["output"];
  documentLabel: Scalars["String"]["output"];
  documentType: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductCarbonClass = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductCarbonClass";
  cabinType: MiddleMsGetLedgerDataV2ResponseProductCarbonClassProductCodeLabel;
  carbonClass: Scalars["Int"]["output"];
  carbonClassV10: Scalars["Int"]["output"];
  carbonEmissionRate: MiddleMsGetLedgerDataV2ResponseProductCarbonClassCarbonEmissionRate;
  vehicleAxlesConfiguration: Scalars["String"]["output"];
  vehicleChassisConfiguration: MiddleMsGetLedgerDataV2ResponseProductCarbonClassProductCodeLabel;
  vehicleEnginePower: Scalars["String"]["output"];
  vehicleFirstRegistrationDate: Scalars["String"]["output"];
  vehicleGroup: Scalars["String"]["output"];
  vehicleSubgroup: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductCarbonClassCarbonEmissionRate =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductCarbonClassCarbonEmissionRate";
    unit: Scalars["String"]["output"];
    vehicleCarbonEmissionRate: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductCarbonClassProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductCarbonClassProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductCardSetting = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductCardSetting";
  electricPackage: Scalars["Boolean"]["output"];
  fuelPackage: MiddleMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
  nameOnCard: MiddleMsGetLedgerDataV2ResponseProductCardSettingNameOnCard;
  pinType: MiddleMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
  servicePackage: MiddleMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
  terminalBehaviour: MiddleMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
  tollPackage: MiddleMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel;
};

export type MiddleMsGetLedgerDataV2ResponseProductCardSettingNameOnCard = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductCardSettingNameOnCard";
  customizableLine1: Scalars["String"]["output"];
  customizableLine2: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductCardSettingProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductCommercialCondition = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductCommercialCondition";
  code: Scalars["String"]["output"];
  conditionCode: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  fees: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  partner: Scalars["String"]["output"];
  startDate: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductElectric = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductElectric";
  electricService: Scalars["Boolean"]["output"];
  partners?: Maybe<
    Array<MiddleMsGetLedgerDataV2ResponseProductElectricPartner>
  >;
  totalCardMyFareId: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductElectricLimits = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductElectricLimits";
  allElectricsLimit: MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimit;
};

export type MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimit =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimit";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitProductCodeLabel;
    name: MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitProductCodeLabel;
    periodicity1: MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetail;
    periodicity2: MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetail;
    thresholdType: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetail =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetail";
    currency: MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetailProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductElectricLimitsAllElectricsLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductElectricPartner = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductElectricPartner";
  emaid: Scalars["String"]["output"];
  myFareG2mStatus: MiddleMsGetLedgerDataV2ResponseProductElectricPartnerProductCodeLabel;
  partenaireId: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductElectricPartnerProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductElectricPartnerProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductFuelLimits = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductFuelLimits";
  allFuelsLimit: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimit;
  fuel1Limit: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetail;
  fuel2Limit: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetail;
};

export type MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimit = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimit";
  actionControl: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitProductCodeLabel;
  name: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitProductCodeLabel;
  periodicity1: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetail;
  periodicity2: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetail;
  thresholdType: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetail =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetail";
    currency: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetailProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductFuelLimitsAllFuelsLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetail = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetail";
  actionControl: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailProductCodeLabel;
  name: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailProductCodeLabel;
  periodicity1: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetail;
  periodicity2: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetail;
  thresholdType: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetail =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetail";
    currency: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetailProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductFuelLimitsFuelLimitDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductGeographicalControl = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductGeographicalControl";
  zones: MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZones;
};

export type MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZones = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZones";
  actionControl: MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesProductCodeLabel;
  list?: Maybe<
    Array<MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1>
  >;
  modeControl: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1 =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    level: Scalars["String"]["output"];
    list?: Maybe<
      Array<MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2>
    >;
  };

export type MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2 =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    level: Scalars["String"]["output"];
    list?: Maybe<
      Array<MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3>
    >;
  };

export type MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3 =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    level: Scalars["String"]["output"];
    list?: Maybe<
      Array<MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3ZoneDetailLevel4>
    >;
  };

export type MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3ZoneDetailLevel4 =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductGeographicalControlZonesZoneDetailLevel1ZoneDetailLevel2ZoneDetailLevel3ZoneDetailLevel4";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    level: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettings = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettings";
  authorizedMobilityProducts: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProducts;
  authorizedMobilityServices: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServices;
  holder: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsHolder;
  mobilityTimeControls: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControls;
  productMobilityType: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsProductCodeLabel;
};

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProducts =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProducts";
    allProductsLimit: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    carRenting: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    hotel: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    maintenance: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    publicTransport: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    restaurant: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    taxi: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
    travel: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit;
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimit";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitProductCodeLabel;
    limit?: Maybe<
      Array<MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimit>
    >;
    periodicity: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicity;
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimit =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimit";
    amount: Scalars["String"]["output"];
    amountType: Scalars["String"]["output"];
    currency: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimitProductCodeLabel;
    limitType: Scalars["String"]["output"];
    periodic: Scalars["Boolean"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimitProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicity =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicity";
    unitPeriodicity: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicityProductCodeLabel;
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicityProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitPeriodicityProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityProductsMobilityProductsLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServices =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServices";
    internetSell: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapper;
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapper =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapper";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapperProductCodeLabel;
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapperProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsAuthorizedMobilityServicesActionControlWrapperProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsHolder = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsHolder";
  civility: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  phoneNumber: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsHolderPhoneNumber;
};

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsHolderPhoneNumber =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsHolderPhoneNumber";
    internationalCode: Scalars["String"]["output"];
    number: Scalars["Int"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControls =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControls";
    authorizedDays: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDays;
    authorizedTime: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTime;
    prohibitedBankHolidays: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapper;
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapper =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapper";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapperProductCodeLabel;
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapperProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsActionControlWrapperProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDays =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDays";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDaysProductCodeLabel;
    listOfDays: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDaysProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedDaysProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTime =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTime";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTimeProductCodeLabel;
    endHour: Scalars["String"]["output"];
    startHour: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTimeProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsMobilityTimeControlsAuthorizedTimeProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductMobilitySettingsProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductProductCodeLabel";
  code: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductProductDelivery = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductProductDelivery";
  dispatchMode?: Maybe<
    Array<MiddleMsGetLedgerDataV2ResponseProductProductDeliveryProductCodeLabel>
  >;
  dispatchPriority?: Maybe<
    Array<MiddleMsGetLedgerDataV2ResponseProductProductDeliveryProductCodeLabel>
  >;
  pinDeliveryAddress: MiddleMsGetLedgerDataV2ResponseProductProductDeliveryPinDeliveryAddress;
  productDeliveryAddress: MiddleMsGetLedgerDataV2ResponseProductProductDeliveryProductDeliveryAddress;
  typeMobility: Scalars["Boolean"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductProductDeliveryPinDeliveryAddress =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductProductDeliveryPinDeliveryAddress";
    address: Scalars["String"]["output"];
    city: Scalars["String"]["output"];
    companyName: Scalars["String"]["output"];
    country: Scalars["String"]["output"];
    location: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    zipCode: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductProductDeliveryProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductProductDeliveryProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductProductDeliveryProductDeliveryAddress =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductProductDeliveryProductDeliveryAddress";
    address: Scalars["String"]["output"];
    city: Scalars["String"]["output"];
    companyName: Scalars["String"]["output"];
    country: Scalars["String"]["output"];
    location: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    zipCode: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductProductNumber = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductProductNumber";
  rank: Scalars["String"]["output"];
  shortNumber: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductServiceLimits = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductServiceLimits";
  allServicesLimit: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimit;
  service1Limit: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetail;
  service2Limit: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetail;
};

export type MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimit =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimit";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitProductCodeLabel;
    name: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitProductCodeLabel;
    periodicity1: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetail;
    periodicity2: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetail;
    thresholdType: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetail =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetail";
    currency: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetailProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductServiceLimitsAllServicesLimitProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetail =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetail";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailProductCodeLabel;
    name: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailProductCodeLabel;
    periodicity1: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetail;
    periodicity2: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetail;
    thresholdType: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetail =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetail";
    currency: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetailProductCodeLabel;
    startDate: Scalars["String"]["output"];
    unitPeriodicity: MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetailProductCodeLabel;
    value: Scalars["Int"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetailProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailPeriodicityDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductServiceLimitsServiceLimitDetailProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTechnicalControl = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductTechnicalControl";
  consumption: MiddleMsGetLedgerDataV2ResponseProductTechnicalControlConsumption;
  mainFuel: Scalars["String"]["output"];
  mileageEntry: MiddleMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapper;
  tankCapacity: MiddleMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacity;
};

export type MiddleMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapper =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapper";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapperProductCodeLabel;
  };

export type MiddleMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapperProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTechnicalControlActionControlWrapperProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTechnicalControlConsumption =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTechnicalControlConsumption";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductTechnicalControlConsumptionProductCodeLabel;
    maxConsumption: Scalars["Int"]["output"];
    minConsumption: Scalars["Int"]["output"];
    unit: MiddleMsGetLedgerDataV2ResponseProductTechnicalControlConsumptionProductCodeLabel;
  };

export type MiddleMsGetLedgerDataV2ResponseProductTechnicalControlConsumptionProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTechnicalControlConsumptionProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacity =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacity";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacityProductCodeLabel;
    unit: MiddleMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacityProductCodeLabel;
    volume: Scalars["Int"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacityProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTechnicalControlTankCapacityProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTimeControl = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControl";
  authorizedPeriod: MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriod;
  authorizedTime: MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTime;
  prohibitedBankHolidays: MiddleMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapper;
  prohibitedDays: MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedDays;
  prohibitedPeriod: MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriod;
};

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapper =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapper";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapperProductCodeLabel;
  };

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapperProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlActionControlWrapperProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriod =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriod";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriodProductCodeLabel;
    endDate: Scalars["String"]["output"];
    repeatAnnualy: Scalars["Boolean"]["output"];
    startDate: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriodProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedPeriodProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTime = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTime";
  actionControl: MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTimeProductCodeLabel;
  endHour: Scalars["String"]["output"];
  startHour: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTimeProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlAuthorizedTimeProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedDays = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedDays";
  actionControl: MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedDaysProductCodeLabel;
  listOfDays: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedDaysProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedDaysProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriod =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriod";
    actionControl: MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriodProductCodeLabel;
    endDate: Scalars["String"]["output"];
    repeatAnnualy: Scalars["Boolean"]["output"];
    startDate: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriodProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTimeControlProhibitedPeriodProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetLedgerDataV2ResponseProductTruckSetting = {
  __typename?: "MiddleMsGetLedgerDataV2ResponseProductTruckSetting";
  cop: MiddleMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  emissionEuroClass: MiddleMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  emptyWeight: Scalars["String"]["output"];
  engineType: MiddleMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  interOpClass: MiddleMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  loadedWeight: Scalars["String"]["output"];
  localClass: MiddleMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  nbAxlesTractor: Scalars["Int"]["output"];
  nbAxlesTrailer: Scalars["Int"]["output"];
  particleFilter: MiddleMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel;
  technicalMaxWeight: Scalars["String"]["output"];
  trailerWeight: Scalars["String"]["output"];
};

export type MiddleMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel =
  {
    __typename?: "MiddleMsGetLedgerDataV2ResponseProductTruckSettingProductCodeLabel";
    code: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
  };

export type MiddleMsGetPartnerToSubmitExpensesResponse = {
  __typename?: "MiddleMsGetPartnerToSubmitExpensesResponse";
  url: Scalars["String"]["output"];
};

export type MiddleMsGetPassAlertRedirectionFormResponse = {
  __typename?: "MiddleMsGetPassAlertRedirectionFormResponse";
  inputs?: Maybe<Array<MiddleMsGetPassAlertRedirectionFormResponseInput>>;
  method: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type MiddleMsGetPassAlertRedirectionFormResponseInput = {
  __typename?: "MiddleMsGetPassAlertRedirectionFormResponseInput";
  name: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type MiddleMsGetSvaRedirectionFormResponse = {
  __typename?: "MiddleMsGetSvaRedirectionFormResponse";
  inputs?: Maybe<Array<MiddleMsGetSvaRedirectionFormResponseInput>>;
  method: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type MiddleMsGetSvaRedirectionFormResponseInput = {
  __typename?: "MiddleMsGetSvaRedirectionFormResponseInput";
  name: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type MiddleMsPagedPagination = {
  __typename?: "MiddleMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type MiddleMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  Start resynchronisation process for the given account numbers  */
export type MiddleMsResynchronisationRequest = {
  /**  List of account numbers to be synchronized  */
  customerAccountNumbers?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  /**  Type of resynchronization  */
  type?: InputMaybe<MiddleMsResynchronisationRequestType>;
};

/**  Type of resynchronization  */
export enum MiddleMsResynchronisationRequestType {
  ResyncTypeAll = "RESYNC_TYPE_ALL",
  ResyncTypeContract = "RESYNC_TYPE_CONTRACT",
  ResyncTypeCustomers = "RESYNC_TYPE_CUSTOMERS",
  ResyncTypeDriverCode = "RESYNC_TYPE_DRIVER_CODE",
  ResyncTypeProduct = "RESYNC_TYPE_PRODUCT",
  ResyncTypeStructure = "RESYNC_TYPE_STRUCTURE",
  ResyncTypeUnknown = "RESYNC_TYPE_UNKNOWN",
  ResyncTypeUsers = "RESYNC_TYPE_USERS",
}

export type MiddleMsResynchronisationResponse = {
  __typename?: "MiddleMsResynchronisationResponse";
  /**  Unique id of the request  */
  requestId: Scalars["ID"]["output"];
};

/**  Search among bulk operation items  */
export type MiddleMsSearchBulkOperationItemsRequest = {
  /**  Filters to apply to the search  */
  filters?: InputMaybe<MiddleMsSearchBulkOperationItemsRequestFilters>;
  /**  Pagination parameters  */
  paging?: InputMaybe<MiddleMsPagedPaging>;
  /**  Sorting criteria  */
  sorts?: InputMaybe<
    Array<InputMaybe<MiddleMsSearchBulkOperationItemsRequestSort>>
  >;
};

/**  Filters to apply to the search  */
export type MiddleMsSearchBulkOperationItemsRequestFilters = {
  /**  Filter by bulk operation item IDs  */
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  Filter by parent bulk operation ID  */
  operationId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Sorting criteria  */
export type MiddleMsSearchBulkOperationItemsRequestSort = {
  /**  Sort in ascending order if true, descending otherwise  */
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  The field to sort by  */
  field?: InputMaybe<MiddleMsSearchBulkOperationItemsRequestSortField>;
};

/**  The field to sort by  */
export enum MiddleMsSearchBulkOperationItemsRequestSortField {
  BusinessObjectId = "business_object_id",
  ClaimTs = "claim_ts",
  CompletedTs = "completed_ts",
  CreatedTs = "created_ts",
  RetryCount = "retry_count",
  UpdatedTs = "updated_ts",
}

export type MiddleMsSearchBulkOperationItemsResponse = {
  __typename?: "MiddleMsSearchBulkOperationItemsResponse";
  /**  List of bulk operation items  */
  data?: Maybe<Array<MiddleMsSearchBulkOperationItemsResponseData>>;
  /**  Pagination metadata  */
  pagination: MiddleMsPagedPagination;
};

/**  List of bulk operation items  */
export type MiddleMsSearchBulkOperationItemsResponseData = {
  __typename?: "MiddleMsSearchBulkOperationItemsResponseData";
  OperationIdData?: Maybe<MiddleMsSearchBulkOperationsResponseData>;
  /**  The ID of the business object to be processed (e.g., ledger ID, driver code ID)  */
  businessObjectId: Scalars["ID"]["output"];
  /**  The identifier of the worker/instance that claimed this item for processing  */
  claimBy: Scalars["String"]["output"];
  /**  The timestamp when this item was claimed for processing  */
  claimTs: Scalars["Int64"]["output"];
  /**  The timestamp when this item was completed (successfully or with failure)  */
  completedTs: Scalars["Int64"]["output"];
  /**  Timestamp when this item was created  */
  createdTs: Scalars["Int64"]["output"];
  /**  The timestamp when this item expires and should no longer be processed  */
  expiresTs: Scalars["Int64"]["output"];
  /**  The error message if the item processing failed  */
  failedReason: Scalars["String"]["output"];
  /**  The bulk operation item ID  */
  id: Scalars["ID"]["output"];
  /**  The parent bulk operation ID this item belongs to  */
  operationId: Scalars["ID"]["output"];
  /**  The number of times this item has been retried after failure  */
  retryCount: Scalars["Int"]["output"];
  /**  The current status of this item  */
  status: MiddleMsSearchBulkOperationItemsResponseDataStatus;
  /**  Timestamp when this item was last updated  */
  updatedTs: Scalars["Int64"]["output"];
};

/**  The current status of this item  */
export enum MiddleMsSearchBulkOperationItemsResponseDataStatus {
  BulkOperationItemStatusUnknown = "BULK_OPERATION_ITEM_STATUS_UNKNOWN",
  CompletedFailure = "COMPLETED_FAILURE",
  CompletedSuccess = "COMPLETED_SUCCESS",
  ItemFailed = "ITEM_FAILED",
  Pending = "PENDING",
  Processing = "PROCESSING",
  RetryPending = "RETRY_PENDING",
  SkippedCanceled = "SKIPPED_CANCELED",
  SkippedExpired = "SKIPPED_EXPIRED",
}

/**  Search among bulk operation types (kinds)  */
export type MiddleMsSearchBulkOperationTypesRequest = {
  /**  Filters to apply to the search  */
  filters?: InputMaybe<MiddleMsSearchBulkOperationTypesRequestFilters>;
  /**  Pagination parameters  */
  paging?: InputMaybe<MiddleMsPagedPaging>;
  /**  Sorting criteria  */
  sorts?: InputMaybe<
    Array<InputMaybe<MiddleMsSearchBulkOperationTypesRequestSort>>
  >;
};

/**  Filters to apply to the search  */
export type MiddleMsSearchBulkOperationTypesRequestFilters = {
  /**  Filter by bulk operation type IDs  */
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  Filter by operation kinds  */
  kinds?: InputMaybe<
    Array<InputMaybe<MiddleMsSearchBulkOperationTypesRequestFiltersKinds>>
  >;
};

/**  Filter by operation kinds  */
export enum MiddleMsSearchBulkOperationTypesRequestFiltersKinds {
  BulkOperationKindDriverCodeMassActivation = "BULK_OPERATION_KIND_DRIVER_CODE_MASS_ACTIVATION",
  BulkOperationKindDriverCodeMassDeactivation = "BULK_OPERATION_KIND_DRIVER_CODE_MASS_DEACTIVATION",
  BulkOperationKindLedgerMassBlock = "BULK_OPERATION_KIND_LEDGER_MASS_BLOCK",
  BulkOperationKindUnspecified = "BULK_OPERATION_KIND_UNSPECIFIED",
}

/**  Sorting criteria  */
export type MiddleMsSearchBulkOperationTypesRequestSort = {
  /**  Sort in ascending order if true, descending otherwise  */
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  The field to sort by  */
  field?: InputMaybe<MiddleMsSearchBulkOperationTypesRequestSortField>;
};

/**  The field to sort by  */
export enum MiddleMsSearchBulkOperationTypesRequestSortField {
  CreatedTs = "created_ts",
  Kind = "kind",
  UpdatedTs = "updated_ts",
}

export type MiddleMsSearchBulkOperationTypesResponse = {
  __typename?: "MiddleMsSearchBulkOperationTypesResponse";
  /**  List of bulk operation types  */
  data?: Maybe<Array<MiddleMsSearchBulkOperationTypesResponseData>>;
  /**  Pagination metadata  */
  pagination: MiddleMsPagedPagination;
};

/**  List of bulk operation types  */
export type MiddleMsSearchBulkOperationTypesResponseData = {
  __typename?: "MiddleMsSearchBulkOperationTypesResponseData";
  /**  Whether operations of this type can be cancelled  */
  cancelable: Scalars["Boolean"]["output"];
  /**  Timestamp when this type was created  */
  createdTs: Scalars["Int64"]["output"];
  /**  Expiration time in seconds for items of this operation type  */
  expirationInSeconds: Scalars["Int64"]["output"];
  /**  The bulk operation type ID  */
  id: Scalars["ID"]["output"];
  /**  The kind of bulk operation  */
  kind: MiddleMsSearchBulkOperationTypesResponseDataKind;
  /**  Maximum number of retry attempts allowed for failed items  */
  maxRetryCount: Scalars["Int"]["output"];
  /**  Timestamp when this type was last updated  */
  updatedTs: Scalars["Int64"]["output"];
};

/**  The kind of bulk operation  */
export enum MiddleMsSearchBulkOperationTypesResponseDataKind {
  BulkOperationKindDriverCodeMassActivation = "BULK_OPERATION_KIND_DRIVER_CODE_MASS_ACTIVATION",
  BulkOperationKindDriverCodeMassDeactivation = "BULK_OPERATION_KIND_DRIVER_CODE_MASS_DEACTIVATION",
  BulkOperationKindLedgerMassBlock = "BULK_OPERATION_KIND_LEDGER_MASS_BLOCK",
  BulkOperationKindUnspecified = "BULK_OPERATION_KIND_UNSPECIFIED",
}

/**  Search among bulk operations  */
export type MiddleMsSearchBulkOperationsRequest = {
  /**  Filters to apply to the search  */
  filters?: InputMaybe<MiddleMsSearchBulkOperationsRequestFilters>;
  /**  Pagination parameters  */
  paging?: InputMaybe<MiddleMsPagedPaging>;
  /**  Sorting criteria  */
  sorts?: InputMaybe<
    Array<InputMaybe<MiddleMsSearchBulkOperationsRequestSort>>
  >;
};

/**  Filters to apply to the search  */
export type MiddleMsSearchBulkOperationsRequestFilters = {
  /**  Filter by bulk operation IDs  */
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  Filter by bulk operation type IDs  */
  typeIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/**  Sorting criteria  */
export type MiddleMsSearchBulkOperationsRequestSort = {
  /**  Sort in ascending order if true, descending otherwise  */
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  The field to sort by  */
  field?: InputMaybe<MiddleMsSearchBulkOperationsRequestSortField>;
};

/**  The field to sort by  */
export enum MiddleMsSearchBulkOperationsRequestSortField {
  CreatedTs = "created_ts",
  UpdatedTs = "updated_ts",
}

export type MiddleMsSearchBulkOperationsResponse = {
  __typename?: "MiddleMsSearchBulkOperationsResponse";
  /**  List of bulk operations  */
  data?: Maybe<Array<MiddleMsSearchBulkOperationsResponseData>>;
  /**  Pagination metadata  */
  pagination: MiddleMsPagedPagination;
};

/**  List of bulk operations  */
export type MiddleMsSearchBulkOperationsResponseData = {
  __typename?: "MiddleMsSearchBulkOperationsResponseData";
  TypeIdData?: Maybe<MiddleMsSearchBulkOperationTypesResponseData>;
  /**  The timestamp when this operation was cancelled  */
  cancelTs: Scalars["Int64"]["output"];
  /**  Timestamp when this operation was created  */
  createdTs: Scalars["Int64"]["output"];
  /**  The bulk operation ID  */
  id: Scalars["ID"]["output"];
  /**  Number of failed items (calculated at runtime)  */
  itemsCountFailure: Scalars["Int"]["output"];
  /**  Number of successfully completed items (calculated at runtime)  */
  itemsCountSuccess: Scalars["Int"]["output"];
  /**  Total number of items in this bulk operation (calculated at runtime)  */
  itemsCountTotal: Scalars["Int"]["output"];
  /**  The kind of bulk operation (derived from BulkOperationType relation via GraphQL)  */
  kind: MiddleMsSearchBulkOperationsResponseDataKind;
  /**  Custom metadata associated with this operation (JSON format)  */
  metadata: Scalars["String"]["output"];
  /**  Progress ratio between 0 and 1 (calculated at runtime: (success + failure) / total)  */
  progress: Scalars["Float"]["output"];
  /**  The current status of this operation  */
  status: MiddleMsSearchBulkOperationsResponseDataStatus;
  /**  The bulk operation type ID  */
  typeId: Scalars["ID"]["output"];
  /**  Timestamp when this operation was last updated  */
  updatedTs: Scalars["Int64"]["output"];
  /**  The ID of the user who triggered this operation  */
  userId: Scalars["ID"]["output"];
};

/**  The kind of bulk operation (derived from BulkOperationType relation via GraphQL)  */
export enum MiddleMsSearchBulkOperationsResponseDataKind {
  BulkOperationKindDriverCodeMassActivation = "BULK_OPERATION_KIND_DRIVER_CODE_MASS_ACTIVATION",
  BulkOperationKindDriverCodeMassDeactivation = "BULK_OPERATION_KIND_DRIVER_CODE_MASS_DEACTIVATION",
  BulkOperationKindLedgerMassBlock = "BULK_OPERATION_KIND_LEDGER_MASS_BLOCK",
  BulkOperationKindUnspecified = "BULK_OPERATION_KIND_UNSPECIFIED",
}

/**  The current status of this operation  */
export enum MiddleMsSearchBulkOperationsResponseDataStatus {
  BulkOperationStatusUnknown = "BULK_OPERATION_STATUS_UNKNOWN",
  Canceled = "CANCELED",
  Completed = "COMPLETED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Pause = "PAUSE",
}

/**  Search among form data rules  */
export type MiddleMsSearchFormDataRuleGroupsRequest = {
  filters?: InputMaybe<MiddleMsSearchFormDataRuleGroupsRequestFilters>;
  paging?: InputMaybe<MiddleMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<MiddleMsSearchFormDataRuleGroupsRequestSort>>
  >;
};

export type MiddleMsSearchFormDataRuleGroupsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MiddleMsSearchFormDataRuleGroupsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MiddleMsSearchFormDataRuleGroupsRequestSortField>;
};

export enum MiddleMsSearchFormDataRuleGroupsRequestSortField {
  Name = "name",
}

export type MiddleMsSearchFormDataRuleGroupsResponse = {
  __typename?: "MiddleMsSearchFormDataRuleGroupsResponse";
  data?: Maybe<Array<MiddleMsSearchFormDataRuleGroupsResponseData>>;
  pagination: MiddleMsPagedPagination;
};

export type MiddleMsSearchFormDataRuleGroupsResponseData = {
  __typename?: "MiddleMsSearchFormDataRuleGroupsResponseData";
  /**  The form data filters applied for this set of rules (the product codes)  */
  codes?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The description of the group  */
  description: Scalars["String"]["output"];
  /**
   *  The list of user ID for whom this group should be ignored. Usually, you use this feature when you duplicate a
   * group and wish to restrict the "old" version and enable the "new one".
   */
  disabledFor?: Maybe<Array<Scalars["ID"]["output"]>>;
  /**  True if the rule should be applied  */
  enabled: Scalars["Boolean"]["output"];
  /**  The list of user ID for who this group should be applied.  */
  enabledFor?: Maybe<Array<Scalars["ID"]["output"]>>;
  /**  The list of ledgerTypeGroup the rules should be applied to. If null or empty, rule apply for all.  */
  groupCodeFor?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The group id  */
  id: Scalars["ID"]["output"];
  /**  The name of the group  */
  name: Scalars["String"]["output"];
  numberOfRules: Scalars["Int"]["output"];
  /**  The raw rules configuration  */
  rules: Scalars["String"]["output"];
  /**  The type of FormRule  */
  type: MiddleMsSearchFormDataRuleGroupsResponseDataType;
};

export enum MiddleMsSearchFormDataRuleGroupsResponseDataType {
  FormRuleTypeCopy = "FORM_RULE_TYPE_COPY",
  FormRuleTypeCreation = "FORM_RULE_TYPE_CREATION",
  FormRuleTypeCreationOrModification = "FORM_RULE_TYPE_CREATION_OR_MODIFICATION",
  FormRuleTypeModification = "FORM_RULE_TYPE_MODIFICATION",
  FormRuleTypeUnknown = "FORM_RULE_TYPE_UNKNOWN",
}

/**  Get account preferences related to the middle domain  */
export type MiddleMsSearchMiddleAccountPreferencesRequest = {
  filters?: InputMaybe<MiddleMsSearchMiddleAccountPreferencesRequestFilters>;
  paging?: InputMaybe<MiddleMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<MiddleMsSearchMiddleAccountPreferencesRequestSort>>
  >;
};

export type MiddleMsSearchMiddleAccountPreferencesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MiddleMsSearchMiddleAccountPreferencesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MiddleMsSearchMiddleAccountPreferencesRequestSortField>;
};

export enum MiddleMsSearchMiddleAccountPreferencesRequestSortField {
  Id = "id",
}

export type MiddleMsSearchMiddleAccountPreferencesResponse = {
  __typename?: "MiddleMsSearchMiddleAccountPreferencesResponse";
  data?: Maybe<Array<MiddleMsSearchMiddleAccountPreferencesResponseData>>;
  pagination: MiddleMsPagedPagination;
};

export type MiddleMsSearchMiddleAccountPreferencesResponseData = {
  __typename?: "MiddleMsSearchMiddleAccountPreferencesResponseData";
  IdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  /**  The CardPro user login  */
  cardProUserLogin: Scalars["String"]["output"];
  /**  The customer credit consumption  */
  creditConsumption: Scalars["Float"]["output"];
  /**  When we checked the customer credit for the last time  */
  creditLastCheckedTs: Scalars["Int64"]["output"];
  /**  The customer credit limit  */
  creditLimit: Scalars["Float"]["output"];
  /**  The account ID  */
  id: Scalars["ID"]["output"];
};

/**  Search among queryTrackerChunks  */
export type MiddleMsSearchQueryTrackerChunksRequest = {
  filters?: InputMaybe<MiddleMsSearchQueryTrackerChunksRequestFilters>;
  paging?: InputMaybe<MiddleMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<MiddleMsSearchQueryTrackerChunksRequestSort>>
  >;
};

export type MiddleMsSearchQueryTrackerChunksRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  locationDsn?: InputMaybe<Scalars["String"]["input"]>;
};

export type MiddleMsSearchQueryTrackerChunksRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MiddleMsSearchQueryTrackerChunksRequestSortField>;
};

export enum MiddleMsSearchQueryTrackerChunksRequestSortField {
  UpdatedTs = "updated_ts",
}

export type MiddleMsSearchQueryTrackerChunksResponse = {
  __typename?: "MiddleMsSearchQueryTrackerChunksResponse";
  data?: Maybe<Array<MiddleMsSearchQueryTrackerChunksResponseData>>;
  pagination: MiddleMsPagedPagination;
};

export type MiddleMsSearchQueryTrackerChunksResponseData = {
  __typename?: "MiddleMsSearchQueryTrackerChunksResponseData";
  QueryTrackerIdData?: Maybe<MiddleMsSearchQueryTrackersResponseData>;
  createdTs: Scalars["Int64"]["output"];
  failedReason: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastWorkerUpdateTs: Scalars["Int64"]["output"];
  locationDsn: Scalars["String"]["output"];
  lockedBy: Scalars["String"]["output"];
  lockedFrom: Scalars["Int64"]["output"];
  lockedTill: Scalars["Int64"]["output"];
  /**  Number of the chunk in the query tracking chunk list  */
  number: Scalars["Int"]["output"];
  /**  How many items were processed  */
  processed: Scalars["Int64"]["output"];
  /**  A progress value greater than 0 and less or equal to 1  */
  progress: Scalars["Float"]["output"];
  /**  The related query tracker access if there is such  */
  queryTrackerId: Scalars["ID"]["output"];
  successfulTs: Scalars["Int64"]["output"];
  /**  How many items are to be processed (this value may vary till we finish reading the file)  */
  total: Scalars["Int64"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

/**  Search among queryTrackers  */
export type MiddleMsSearchQueryTrackersRequest = {
  filters?: InputMaybe<MiddleMsSearchQueryTrackersRequestFilters>;
  paging?: InputMaybe<MiddleMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<MiddleMsSearchQueryTrackersRequestSort>>>;
};

export type MiddleMsSearchQueryTrackersRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MiddleMsSearchQueryTrackersRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MiddleMsSearchQueryTrackersRequestSortField>;
};

export enum MiddleMsSearchQueryTrackersRequestSortField {
  UpdatedTs = "updated_ts",
}

export type MiddleMsSearchQueryTrackersResponse = {
  __typename?: "MiddleMsSearchQueryTrackersResponse";
  data?: Maybe<Array<MiddleMsSearchQueryTrackersResponseData>>;
  pagination: MiddleMsPagedPagination;
};

export type MiddleMsSearchQueryTrackersResponseData = {
  __typename?: "MiddleMsSearchQueryTrackersResponseData";
  TypeIdData?: Maybe<MiddleMsSearchQueryTypesResponseData>;
  createdTs: Scalars["Int64"]["output"];
  dataReceivedAt: Scalars["Int64"]["output"];
  expiresInTs: Scalars["Int64"]["output"];
  failedReason: Scalars["String"]["output"];
  failedStep: Scalars["String"]["output"];
  /**  import min boundary  */
  fromTs: Scalars["Int64"]["output"];
  id: Scalars["ID"]["output"];
  locationDsn: Scalars["String"]["output"];
  /**  Matching partner query_id, for monitoring purpose  */
  partnerQueryId: Scalars["ID"]["output"];
  /**  A progress value greater than 0 and less or equal to 1  */
  progress: Scalars["Float"]["output"];
  sequence: Scalars["Int64"]["output"];
  /**  Service is ready to start import  */
  serviceIsReady: Scalars["Boolean"]["output"];
  successfulTs: Scalars["Int64"]["output"];
  /**  import max boundary  */
  tillTs: Scalars["Int64"]["output"];
  /**  The related query type access if there is such  */
  typeId: Scalars["ID"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

/**  Search among query types  */
export type MiddleMsSearchQueryTypesRequest = {
  filters?: InputMaybe<MiddleMsSearchQueryTypesRequestFilters>;
  paging?: InputMaybe<MiddleMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<MiddleMsSearchQueryTypesRequestSort>>>;
};

export type MiddleMsSearchQueryTypesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MiddleMsSearchQueryTypesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MiddleMsSearchQueryTypesRequestSortField>;
};

export enum MiddleMsSearchQueryTypesRequestSortField {
  Code = "code",
}

export type MiddleMsSearchQueryTypesResponse = {
  __typename?: "MiddleMsSearchQueryTypesResponse";
  data?: Maybe<Array<MiddleMsSearchQueryTypesResponseData>>;
  pagination: MiddleMsPagedPagination;
};

export type MiddleMsSearchQueryTypesResponseData = {
  __typename?: "MiddleMsSearchQueryTypesResponseData";
  code: Scalars["String"]["output"];
  disabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /**  The max start attempts when start failed. After that, flow will be disabled  */
  maxAttempts: Scalars["Int"]["output"];
  /**  The min retry delay before restart after a failed start  */
  minRetryDelay: Scalars["Int64"]["output"];
  offset: Scalars["Int64"]["output"];
  sequence: Scalars["Int64"]["output"];
};

/**  Search resync History  */
export type MiddleMsSearchResynchronisationHistoryRequest = {
  filters?: InputMaybe<MiddleMsSearchResynchronisationHistoryRequestFilters>;
  paging?: InputMaybe<MiddleMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<MiddleMsSearchResynchronisationHistoryRequestSort>>
  >;
};

export type MiddleMsSearchResynchronisationHistoryRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  customerAccountNumber?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  requestId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<MiddleMsSearchResynchronisationHistoryRequestFiltersStatus>;
  type?: InputMaybe<MiddleMsSearchResynchronisationHistoryRequestFiltersType>;
};

export enum MiddleMsSearchResynchronisationHistoryRequestFiltersStatus {
  ResyncStatusFailed = "RESYNC_STATUS_FAILED",
  ResyncStatusInitialized = "RESYNC_STATUS_INITIALIZED",
  ResyncStatusInProgress = "RESYNC_STATUS_IN_PROGRESS",
  ResyncStatusSuccessful = "RESYNC_STATUS_SUCCESSFUL",
  ResyncStatusUnknown = "RESYNC_STATUS_UNKNOWN",
}

export enum MiddleMsSearchResynchronisationHistoryRequestFiltersType {
  ResyncTypeAll = "RESYNC_TYPE_ALL",
  ResyncTypeContract = "RESYNC_TYPE_CONTRACT",
  ResyncTypeCustomers = "RESYNC_TYPE_CUSTOMERS",
  ResyncTypeDriverCode = "RESYNC_TYPE_DRIVER_CODE",
  ResyncTypeProduct = "RESYNC_TYPE_PRODUCT",
  ResyncTypeStructure = "RESYNC_TYPE_STRUCTURE",
  ResyncTypeUnknown = "RESYNC_TYPE_UNKNOWN",
  ResyncTypeUsers = "RESYNC_TYPE_USERS",
}

export type MiddleMsSearchResynchronisationHistoryRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<MiddleMsSearchResynchronisationHistoryRequestSortField>;
};

export enum MiddleMsSearchResynchronisationHistoryRequestSortField {
  AccountNumber = "account_number",
  CreatedTs = "created_ts",
  Type = "type",
}

export type MiddleMsSearchResynchronisationHistoryResponse = {
  __typename?: "MiddleMsSearchResynchronisationHistoryResponse";
  data?: Maybe<Array<MiddleMsSearchResynchronisationHistoryResponseData>>;
  pagination: MiddleMsPagedPagination;
};

export type MiddleMsSearchResynchronisationHistoryResponseData = {
  __typename?: "MiddleMsSearchResynchronisationHistoryResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  RequestingUserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  the related account  */
  accountId: Scalars["ID"]["output"];
  createdTs: Scalars["String"]["output"];
  /**  The account number  */
  customerAccountNumber: Scalars["String"]["output"];
  /**  The reSync id  */
  id: Scalars["ID"]["output"];
  /**  the number of message received  */
  msgCount: Scalars["Int"]["output"];
  /**  the request_id base on type and creation date  */
  requestId: Scalars["ID"]["output"];
  /**  the requesting user id  */
  requestingUserId: Scalars["ID"]["output"];
  /**  status of reSync successful or failed  */
  status: MiddleMsSearchResynchronisationHistoryResponseDataStatus;
  /**  Resync type  */
  type: MiddleMsSearchResynchronisationHistoryResponseDataType;
};

export enum MiddleMsSearchResynchronisationHistoryResponseDataStatus {
  ResyncStatusFailed = "RESYNC_STATUS_FAILED",
  ResyncStatusInitialized = "RESYNC_STATUS_INITIALIZED",
  ResyncStatusInProgress = "RESYNC_STATUS_IN_PROGRESS",
  ResyncStatusSuccessful = "RESYNC_STATUS_SUCCESSFUL",
  ResyncStatusUnknown = "RESYNC_STATUS_UNKNOWN",
}

export enum MiddleMsSearchResynchronisationHistoryResponseDataType {
  ResyncTypeAll = "RESYNC_TYPE_ALL",
  ResyncTypeContract = "RESYNC_TYPE_CONTRACT",
  ResyncTypeCustomers = "RESYNC_TYPE_CUSTOMERS",
  ResyncTypeDriverCode = "RESYNC_TYPE_DRIVER_CODE",
  ResyncTypeProduct = "RESYNC_TYPE_PRODUCT",
  ResyncTypeStructure = "RESYNC_TYPE_STRUCTURE",
  ResyncTypeUnknown = "RESYNC_TYPE_UNKNOWN",
  ResyncTypeUsers = "RESYNC_TYPE_USERS",
}

/**  Process a raw JSON provided by CardPro and check the result  */
export type MiddleMsTestFormDataRequest = {
  /**  The raw JSON string supposed to be provided by CardPro  */
  encodedJsonData?: InputMaybe<Scalars["String"]["input"]>;
  /**  An optional list of form data rule groups (even disabled, in order to test the output)  */
  formDataRuleGroupIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MiddleMsTestFormDataResponse = {
  __typename?: "MiddleMsTestFormDataResponse";
  encodedJsonData: Scalars["String"]["output"];
};

/**  Toggles a form data rule group enable/disable  */
export type MiddleMsToggleFormDataRuleGroupRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MiddleMsToggleFormDataRuleGroupResponse = {
  __typename?: "MiddleMsToggleFormDataRuleGroupResponse";
  enabled: Scalars["Boolean"]["output"];
};

/**  Updates a form data rule group  */
export type MiddleMsUpdateFormDataRuleGroupRequest = {
  /**  The form data filters applied for this set of rules (the product codes)  */
  codes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /**  The description of the group  */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /**
   *  The list of user ID for whom this group should be ignored. Usually, you use this feature when you duplicate a
   * group and wish to restrict the "old" version and enable the "new one".
   */
  disabledFor?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  True if the rule should be applied  */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  The list of user ID for who this group should be applied.  */
  enabledFor?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  The list of ledgerTypeGroup the rules should be applied to. If null or empty, rule apply for all.  */
  groupCodeFor?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /**  The group id  */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The name of the group  */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /**  The raw rules configuration  */
  rules?: InputMaybe<Scalars["String"]["input"]>;
  /**  The type of FormRule  */
  type?: InputMaybe<MiddleMsUpdateFormDataRuleGroupRequestType>;
};

export enum MiddleMsUpdateFormDataRuleGroupRequestType {
  FormRuleTypeCopy = "FORM_RULE_TYPE_COPY",
  FormRuleTypeCreation = "FORM_RULE_TYPE_CREATION",
  FormRuleTypeCreationOrModification = "FORM_RULE_TYPE_CREATION_OR_MODIFICATION",
  FormRuleTypeModification = "FORM_RULE_TYPE_MODIFICATION",
  FormRuleTypeUnknown = "FORM_RULE_TYPE_UNKNOWN",
}

export type Mutation = {
  __typename?: "Mutation";
  /**  Create new restriction for this user in account  */
  AccountsMsAddPrivilegeRestriction?: Maybe<Scalars["Void"]["output"]>;
  /**  Cancel support user invite  */
  AccountsMsCancelSupportUserInvite?: Maybe<Scalars["Void"]["output"]>;
  /**  Cancel user invite  */
  AccountsMsCancelUserInvite?: Maybe<Scalars["Void"]["output"]>;
  /**  Create a new agency  */
  AccountsMsCreateAgency: AccountsMsCreateAgencyResponse;
  /**
   *  Creates a roles profile
   *
   * When a roles profile is created under another one, the roles selection is restricted to the parent roles profile roles.
   */
  AccountsMsCreateRolesProfile: AccountsMsCreateRolesProfileResponse;
  /**
   *  Deletes a roles profile
   *
   * Only unused roles profile can be deleted.
   */
  AccountsMsDeleteRolesProfile: AccountsMsDeleteRolesProfileResponse;
  /**
   *  Disable a privilege
   *
   * The related user won't have access to this account anymore. Nothing happens if the privilege is already disabled.
   */
  AccountsMsDisable?: Maybe<Scalars["Void"]["output"]>;
  /**  Disable support user  */
  AccountsMsDisableSupportUser?: Maybe<Scalars["Void"]["output"]>;
  /**
   *  Enable a privilege
   *
   * The related user will be granted back his access to this account. Nothing happens if the privilege is already enabled.
   */
  AccountsMsEnable?: Maybe<Scalars["Void"]["output"]>;
  /**  Enable support user  */
  AccountsMsEnableSupportUser?: Maybe<Scalars["Void"]["output"]>;
  /**
   *  Extend a support session
   *
   * Extend a session for a support operator.
   */
  AccountsMsExtendSupport: AccountsMsExtendSupportResponse;
  /**
   *  Forget a privilege
   *
   * Deletes a privilege forever.
   */
  AccountsMsForget?: Maybe<Scalars["Void"]["output"]>;
  /**  Invite support user  */
  AccountsMsInviteSupportUser: AccountsMsInviteSupportUserResponse;
  /**
   *  Invite a user.
   *
   * Create a privilege for the given user in the current account. A notification is sent to the user.
   * When the user do not exist, we send a welcome notification. Otherwise, we send a classical invitation notification.
   * A new user is created with the same timezone and locale of the current user when the account preferred_locale is
   * not set.
   */
  AccountsMsInviteUser: AccountsMsInviteUserResponse;
  /**  List the supported locales  */
  AccountsMsListLocales: AccountsMsListLocalesResponse;
  /**
   *  Find a user.
   *
   * Search a user in the user book. Multiple results may be returned.
   */
  AccountsMsLookupUser: AccountsMsLookupUserResponse;
  /**  Resend invitation  */
  AccountsMsResendInviteUserNotification: AccountsMsResendInviteUserNotificationResponse;
  /**  Defines the main account of the current user.  */
  AccountsMsSetDefaultAccount?: Maybe<Scalars["Void"]["output"]>;
  AccountsMsStartSession: AccountsMsStartSessionResponse;
  /**
   *  Start a support session
   *
   * Start a session for a support operator, a session id will be created for a defined duration
   */
  AccountsMsStartSupport: AccountsMsStartSupportResponse;
  /**  Link the user's privilege to a roles profile  */
  AccountsMsSubscribePrivilege?: Maybe<Scalars["Void"]["output"]>;
  /**  Unlink user's privilege from from a roles profile  */
  AccountsMsUnsubscribePrivilege?: Maybe<Scalars["Void"]["output"]>;
  /**  Update the current user  */
  AccountsMsUpdateMe?: Maybe<Scalars["Void"]["output"]>;
  AccountsMsUpdateMyPersonalData?: Maybe<Scalars["Void"]["output"]>;
  AccountsMsUpdateMyPersonalPreferences?: Maybe<Scalars["Void"]["output"]>;
  /**  Update privilege restrictions depending on the caller's restrictions  */
  AccountsMsUpdatePrivilegeRestrictions?: Maybe<Scalars["Void"]["output"]>;
  AccountsMsUpdateRolesProfile: AccountsMsUpdateRolesProfileResponse;
  /**  Update support user. They must be active in order to be updated.  */
  AccountsMsUpdateSupportUser?: Maybe<Scalars["Void"]["output"]>;
  /**  Assign a collaborator to a ledger  */
  AssignmentsMsAssignCollaborator: AssignmentsMsAssignCollaboratorResponse;
  /**  Assign a vehicle to a ledger  */
  AssignmentsMsAssignVehicle: AssignmentsMsAssignVehicleResponse;
  /**  Delete assignment  */
  AssignmentsMsDeleteAssignment?: Maybe<Scalars["Void"]["output"]>;
  /**  Update assignment dates  */
  AssignmentsMsUpdatePeriod?: Maybe<Scalars["Void"]["output"]>;
  /**  Close a payment  */
  BillingMsClosePayment: BillingMsClosePaymentResponse;
  /**  Commit a payment  */
  BillingMsCommitPayment?: Maybe<Scalars["Void"]["output"]>;
  /**  Create a guarantee payment  */
  BillingMsCreateGuaranteePayment: BillingMsCreateGuaranteePaymentResponse;
  /**  Create a invoice payment  */
  BillingMsCreateInvoicePayment: BillingMsCreateInvoicePaymentResponse;
  /**
   *  Create an invoice transaction document order that will trigger OnCreateInvoiceTransactionsDocument
   * through event CreateInvoiceTransactionsDocumentEvent
   */
  BillingMsCreateInvoiceTransactionsDocument: BillingMsCreateInvoiceTransactionsDocumentResponse;
  BillingMsCreateTidDeliveryConfig: BillingMsCreateTidDeliveryConfigResponse;
  /**  Create a tid linked account  */
  BillingMsCreateTidLinkedAccount: BillingMsCreateTidLinkedAccountResponse;
  BillingMsCreateTidOrder: BillingMsCreateTidOrderResponse;
  /**  Create a Tid report.  */
  BillingMsCreateTidReport: BillingMsCreateTidReportResponse;
  BillingMsDeleteTidDeliveryConfig?: Maybe<Scalars["Void"]["output"]>;
  /**  Delete a tid linked account  */
  BillingMsDeleteTidLinkedAccount?: Maybe<Scalars["Void"]["output"]>;
  /**  List the last invoice document for each account of the current user  */
  BillingMsListMyLastInvoiceDocuments: BillingMsListMyLastInvoiceDocumentsResponse;
  BillingMsListMyLastTidDocuments: BillingMsListMyLastTidDocumentsResponse;
  /**  Update account address  */
  BillingMsUpdateAccountEmailAddress?: Maybe<Scalars["Void"]["output"]>;
  /**  Archive collaborator  */
  CollaboratorsMsArchiveCollaborator?: Maybe<Scalars["Void"]["output"]>;
  /**  Create a collaborator  */
  CollaboratorsMsCreateCollaborator: CollaboratorsMsCreateCollaboratorResponse;
  /**  Create a driver code with option to assign a collaborator  */
  CollaboratorsMsCreateDriverCode: CollaboratorsMsCreateDriverCodeResponse;
  /**
   *  Link a driver code to a collaborator. If the driver code does not exist, we will request our partner to create it.
   * The driver code will be in "creating" state.
   * We can also link an orphan driver code. It will be in "active" state.
   * We can link a driver code for a collaborator that has no driver code yet, or their drive code is blocked.
   */
  CollaboratorsMsLinkDriverCode?: Maybe<Scalars["Void"]["output"]>;
  /**
   *  Reedit all driver codes from the manager perspective.
   * We delegate the call to our partner that will send a paper mail with driver codes and card pin codes.
   * For a restricted manager, the driver codes to reedit are the one from the root sectors of their restricted sectors.
   */
  CollaboratorsMsReeditDriverCodes?: Maybe<Scalars["Void"]["output"]>;
  /**
   *  Our partner has accepted our request, the driver code will have the state "waiting to be blocked"
   * The driver code will be "blocked" when our partner will send us the relative state
   * If the partner does not accept our request (error), the driver code will stay at its previous state
   * Only an active driver code can be blocked.
   */
  CollaboratorsMsRequestToBlockDriverCode: CollaboratorsMsRequestToBlockDriverCodeResponse;
  /**
   *  Our partner has accepted our request, the driver code will have the state "waiting to be unblocked"
   * The driver code will be "unblocked" when our partner will send us the relative state
   * If the partner does not accept our request (error), the driver code will stay at its previous state
   * Only a blocked driver code can be unblocked.
   */
  CollaboratorsMsRequestToUnBlockDriverCode: CollaboratorsMsRequestToUnBlockDriverCodeResponse;
  /**  Set a collaborator supervisor  */
  CollaboratorsMsSetSupervisor?: Maybe<Scalars["Void"]["output"]>;
  /**  Unarchive collaborator  */
  CollaboratorsMsUnarchiveCollaborator?: Maybe<Scalars["Void"]["output"]>;
  /**  Remove a supervisor from a collaborator  */
  CollaboratorsMsUnsetSupervisor?: Maybe<Scalars["Void"]["output"]>;
  /**  Updates a collaborator  */
  CollaboratorsMsUpdateCollaborator?: Maybe<Scalars["Void"]["output"]>;
  /**  Update a driver code label with option to assign or update a collaborator  */
  CollaboratorsMsUpdateDriverCode?: Maybe<Scalars["Void"]["output"]>;
  /**  Search + create + update collaborator for mobility corporate  */
  CollaboratorsMsUpsertMobilityCorporateCollaborator: CollaboratorsMsUpsertMobilityCorporateCollaboratorResponse;
  /**  Flag customer in invoice for resync  */
  DatabayMsUpdateByAccountId?: Maybe<Scalars["Void"]["output"]>;
  /**  Block (oppose) a card or a badge  */
  LedgersMsBlockLedger?: Maybe<Scalars["Void"]["output"]>;
  /**  Block (oppose) a card or a badge for system partners  */
  LedgersMsBlockLedgerAsPartner?: Maybe<Scalars["Void"]["output"]>;
  /**  Cancel the renewal of a ledger  */
  LedgersMsCancelLedgerRenewal?: Maybe<Scalars["Void"]["output"]>;
  /**  Create a all transactions MC report  */
  LedgersMsCreateAllTransactionsMobilityCorporateReport: LedgersMsCreateAllTransactionsMobilityCorporateReportResponse;
  /**  Create a consumption monitoring report.  */
  LedgersMsCreateConsumptionMonitoringReport: LedgersMsCreateConsumptionMonitoringReportResponse;
  /**  Create a cost tracking report.  */
  LedgersMsCreateCostTrackingReport: LedgersMsCreateCostTrackingReportResponse;
  /**  Create a demand in the pin manager  */
  LedgersMsCreateDemand: LedgersMsCreateDemandResponse;
  /**  Creates a division  */
  LedgersMsCreateDivision: LedgersMsCreateDivisionResponse;
  /**  Create division order  */
  LedgersMsCreateDivisionOrder: LedgersMsCreateDivisionOrderResponse;
  /**  Create an EV detailed report  */
  LedgersMsCreateEvDetailedReport: LedgersMsCreateEvDetailedReportResponse;
  /**  Create an order of a ledger.  */
  LedgersMsCreateLedgerOrder: LedgersMsCreateLedgerOrderResponse;
  /**  Create a mileage report.  */
  LedgersMsCreateMileageReport: LedgersMsCreateMileageReportResponse;
  /**  Create a price ceiling report.  */
  LedgersMsCreatePriceCeilingReport: LedgersMsCreatePriceCeilingReportResponse;
  /**  Create a toll passages report  */
  LedgersMsCreateTollPassagesReport: LedgersMsCreateTollPassagesReportResponse;
  /**  Create a transactions Friday Monday report  */
  LedgersMsCreateTransactionsFridayMondayReport: LedgersMsCreateTransactionsFridayMondayReportResponse;
  /**  Create a transactions WE holidays report  */
  LedgersMsCreateTransactionsWeekendHolidaysReport: LedgersMsCreateTransactionsWeekendHolidaysReportResponse;
  /**  Create a truck positions report  */
  LedgersMsCreateTruckPositionsReport: LedgersMsCreateTruckPositionsReportResponse;
  /**  Delete (annuler) a ledger that is still in status new  */
  LedgersMsDeleteLedger?: Maybe<Scalars["Void"]["output"]>;
  /**  Create an export of all ledgers.  */
  LedgersMsExportSupportConfig: LedgersMsExportSupportConfigResponse;
  /**  Create an export of all transactions.  */
  LedgersMsExportTransactions: LedgersMsExportTransactionsResponse;
  /**  Fetch Ledgers export data  */
  LedgersMsFetchLedgersExport?: Maybe<Scalars["Void"]["output"]>;
  LedgersMsListLedgerChanges: LedgersMsListLedgerChangesResponse;
  /**  Modify a division  */
  LedgersMsModifyDivision: LedgersMsModifyDivisionResponse;
  /**  Handle the order creation event.  */
  LedgersMsOnCreateLedgerOrder?: Maybe<Scalars["Void"]["output"]>;
  /**  Handle the order creation event.  */
  LedgersMsOnUpdateLedgerOrder?: Maybe<Scalars["Void"]["output"]>;
  LedgersMsOnUpdateLedgerSector?: Maybe<Scalars["Void"]["output"]>;
  /**  Resend the PIN code for a ledger  */
  LedgersMsResendPinCode?: Maybe<Scalars["Void"]["output"]>;
  LedgersMsUpdateDivisionOrder: LedgersMsUpdateDivisionOrderResponse;
  /**  Create an order to modify/update a Ledger  */
  LedgersMsUpdateLedgerOrder: LedgersMsUpdateLedgerOrderResponse;
  MediaMsCreateDocumentType: MediaMsCreateDocumentTypeResponse;
  /**  Create a download token  */
  MediaMsDownload: MediaMsDownloadResponse;
  MediaMsUpdateDocumentType?: Maybe<Scalars["Void"]["output"]>;
  /**  Create a demand in the pin manager  */
  MiddleMsCreateDemand: MiddleMsCreateDemandResponse;
  /**  Creates a new form data rule group  */
  MiddleMsCreateFormDataRuleGroup: MiddleMsCreateFormDataRuleGroupResponse;
  /**  Deletes a form data rule group  */
  MiddleMsDeleteFormDataRuleGroup?: Maybe<Scalars["Void"]["output"]>;
  /**  Duplicate a form data rule group  */
  MiddleMsDuplicateFormDataRuleGroup: MiddleMsDuplicateFormDataRuleGroupResponse;
  /**  Start resynchronisation process for the given account numbers  */
  MiddleMsResynchronisation: MiddleMsResynchronisationResponse;
  /**  Process a raw JSON provided by CardPro and check the result  */
  MiddleMsTestFormData: MiddleMsTestFormDataResponse;
  /**  Toggles a form data rule group enable/disable  */
  MiddleMsToggleFormDataRuleGroup: MiddleMsToggleFormDataRuleGroupResponse;
  /**  Updates a form data rule group  */
  MiddleMsUpdateFormDataRuleGroup?: Maybe<Scalars["Void"]["output"]>;
  /**  Cleanup mail forwarder email boxes.  */
  NotificationsMsCleanupMailForwarder?: Maybe<Scalars["Void"]["output"]>;
  NotificationsMsDisableMySubscriptions?: Maybe<Scalars["Void"]["output"]>;
  NotificationsMsEnableMySubscriptions?: Maybe<Scalars["Void"]["output"]>;
  /**  Resend notifications  */
  NotificationsMsResendNotifications: NotificationsMsResendNotificationsResponse;
  /**  Send charging session tracking code  */
  NotificationsMsSendChargingSessionTrackingCode: NotificationsMsSendChargingSessionTrackingCodeResponse;
  /**  Resend notifications  */
  NotificationsMsSendVerificationCode: NotificationsMsSendVerificationCodeResponse;
  NotificationsMsSubscribe?: Maybe<Scalars["Void"]["output"]>;
  NotificationsMsUnsubscribe?: Maybe<Scalars["Void"]["output"]>;
  RemotechargingMsNotify?: Maybe<Scalars["Void"]["output"]>;
  RemotechargingMsOrderChargingSession: RemotechargingMsOrderChargingSessionResponse;
  RemotechargingMsStartSession?: Maybe<Scalars["Void"]["output"]>;
  RemotechargingMsUpdateChargingSessionOrderStatus?: Maybe<
    Scalars["Void"]["output"]
  >;
  /**  Request the creation of a report plan based on a code and parameters.  */
  ReportingMsCreateReportPlan: ReportingMsCreateReportPlanResponse;
  /**  Request the creation of a report type  */
  ReportingMsCreateReportType: ReportingMsCreateReportTypeResponse;
  /**  Remove a report plan.  */
  ReportingMsDeleteReportPlan?: Maybe<Scalars["Void"]["output"]>;
  /**
   *  Set expirationTs to now.
   * The current expirationTs should be null or future.
   * The reports should have an error status.
   */
  ReportingMsExpireReports?: Maybe<Scalars["Void"]["output"]>;
  /**  Request the generation of a report based on a code, type and parameters.  */
  ReportingMsGenerateReport: ReportingMsGenerateReportResponse;
  /**
   *  Resume the report steps based on the current state.
   * If the report is just created and waiting for data, dispatch a ReportQueryEvent.
   * If the report has fetched data and is waiting for document, dispatch a GenerateDocumentEvent.
   * If the report has a generated document, call Notifications.
   */
  ReportingMsRecoverReports?: Maybe<Scalars["Void"]["output"]>;
  /**  Request the statistics of reports.  */
  ReportingMsReportStatistics: ReportingMsReportStatisticsResponse;
  /**  Update a report plan.  */
  ReportingMsUpdateReportPlan?: Maybe<Scalars["Void"]["output"]>;
  ReportingMsUpdateReportType?: Maybe<Scalars["Void"]["output"]>;
  /**  Create sector  */
  SectorsMsCreateSector: SectorsMsCreateSectorResponse;
  /**  Delete sector  */
  SectorsMsDeleteSector?: Maybe<Scalars["Void"]["output"]>;
  /**  Set custom label of sector  */
  SectorsMsSetLabel?: Maybe<Scalars["Void"]["output"]>;
  /**  Update sector  */
  SectorsMsUpdateSector?: Maybe<Scalars["Void"]["output"]>;
  /**  Fetch transaction anomaly data  */
  TransactionsMsFetchTransactionAnomaly?: Maybe<Scalars["Void"]["output"]>;
  /**  Fetch transaction anomaly 24/24 data  */
  TransactionsMsFetchTransactionAnomaly24?: Maybe<Scalars["Void"]["output"]>;
  /**  Fetch transaction ev detailed data  */
  TransactionsMsFetchTransactionEvDetailed?: Maybe<Scalars["Void"]["output"]>;
  /**  Fetch transaction export data  */
  TransactionsMsFetchTransactionExport?: Maybe<Scalars["Void"]["output"]>;
  /**  Fetch transaction mobility corporate data  */
  TransactionsMsFetchTransactionMobilityCorporate?: Maybe<
    Scalars["Void"]["output"]
  >;
  /**  Fetch transaction toll passages data  */
  TransactionsMsFetchTransactionTollPassages?: Maybe<Scalars["Void"]["output"]>;
  /**  Archive vehicle  */
  VehiclesMsArchiveVehicle?: Maybe<Scalars["Void"]["output"]>;
  /**  Create a mileage record  */
  VehiclesMsCreateMileage: VehiclesMsCreateMileageResponse;
  /**  Create a vehicle  */
  VehiclesMsCreateVehicle: VehiclesMsCreateVehicleResponse;
  /**  Unarchive vehicle  */
  VehiclesMsUnarchiveVehicle?: Maybe<Scalars["Void"]["output"]>;
  VehiclesMsUpdateVehicle?: Maybe<Scalars["Void"]["output"]>;
  dummy?: Maybe<Scalars["String"]["output"]>;
};

export type MutationAccountsMsAddPrivilegeRestrictionArgs = {
  request?: InputMaybe<AccountsMsAddPrivilegeRestrictionRequest>;
};

export type MutationAccountsMsCancelSupportUserInviteArgs = {
  request?: InputMaybe<AccountsMsCancelSupportUserInviteRequest>;
};

export type MutationAccountsMsCancelUserInviteArgs = {
  request?: InputMaybe<AccountsMsCancelUserInviteRequest>;
};

export type MutationAccountsMsCreateAgencyArgs = {
  request?: InputMaybe<AccountsMsCreateAgencyRequest>;
};

export type MutationAccountsMsCreateRolesProfileArgs = {
  request?: InputMaybe<AccountsMsCreateRolesProfileRequest>;
};

export type MutationAccountsMsDeleteRolesProfileArgs = {
  request?: InputMaybe<AccountsMsDeleteRolesProfileRequest>;
};

export type MutationAccountsMsDisableArgs = {
  request?: InputMaybe<AccountsMsDisableRequest>;
};

export type MutationAccountsMsDisableSupportUserArgs = {
  request?: InputMaybe<AccountsMsDisableSupportUserRequest>;
};

export type MutationAccountsMsEnableArgs = {
  request?: InputMaybe<AccountsMsEnableRequest>;
};

export type MutationAccountsMsEnableSupportUserArgs = {
  request?: InputMaybe<AccountsMsEnableSupportUserRequest>;
};

export type MutationAccountsMsExtendSupportArgs = {
  request?: InputMaybe<AccountsMsExtendSupportRequest>;
};

export type MutationAccountsMsForgetArgs = {
  request?: InputMaybe<AccountsMsForgetRequest>;
};

export type MutationAccountsMsInviteSupportUserArgs = {
  request?: InputMaybe<AccountsMsInviteSupportUserRequest>;
};

export type MutationAccountsMsInviteUserArgs = {
  request?: InputMaybe<AccountsMsInviteUserRequest>;
};

export type MutationAccountsMsListLocalesArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type MutationAccountsMsLookupUserArgs = {
  request?: InputMaybe<AccountsMsLookupUserRequest>;
};

export type MutationAccountsMsResendInviteUserNotificationArgs = {
  request?: InputMaybe<AccountsMsResendInviteUserNotificationRequest>;
};

export type MutationAccountsMsSetDefaultAccountArgs = {
  request?: InputMaybe<AccountsMsSetDefaultAccountRequest>;
};

export type MutationAccountsMsStartSessionArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type MutationAccountsMsStartSupportArgs = {
  request?: InputMaybe<AccountsMsStartSupportRequest>;
};

export type MutationAccountsMsSubscribePrivilegeArgs = {
  request?: InputMaybe<AccountsMsSubscribePrivilegeRequest>;
};

export type MutationAccountsMsUnsubscribePrivilegeArgs = {
  request?: InputMaybe<AccountsMsUnsubscribePrivilegeRequest>;
};

export type MutationAccountsMsUpdateMeArgs = {
  request?: InputMaybe<AccountsMsUpdateMeRequest>;
};

export type MutationAccountsMsUpdateMyPersonalDataArgs = {
  request?: InputMaybe<AccountsMsUpdateMyPersonalDataRequest>;
};

export type MutationAccountsMsUpdateMyPersonalPreferencesArgs = {
  request?: InputMaybe<AccountsMsUpdateMyPersonalPreferencesRequest>;
};

export type MutationAccountsMsUpdatePrivilegeRestrictionsArgs = {
  request?: InputMaybe<AccountsMsUpdatePrivilegeRestrictionsRequest>;
};

export type MutationAccountsMsUpdateRolesProfileArgs = {
  request?: InputMaybe<AccountsMsUpdateRolesProfileRequest>;
};

export type MutationAccountsMsUpdateSupportUserArgs = {
  request?: InputMaybe<AccountsMsUpdateSupportUserRequest>;
};

export type MutationAssignmentsMsAssignCollaboratorArgs = {
  request?: InputMaybe<AssignmentsMsAssignCollaboratorRequest>;
};

export type MutationAssignmentsMsAssignVehicleArgs = {
  request?: InputMaybe<AssignmentsMsAssignVehicleRequest>;
};

export type MutationAssignmentsMsDeleteAssignmentArgs = {
  request?: InputMaybe<AssignmentsMsDeleteAssignmentRequest>;
};

export type MutationAssignmentsMsUpdatePeriodArgs = {
  request?: InputMaybe<AssignmentsMsUpdatePeriodRequest>;
};

export type MutationBillingMsClosePaymentArgs = {
  request?: InputMaybe<BillingMsClosePaymentRequest>;
};

export type MutationBillingMsCommitPaymentArgs = {
  request?: InputMaybe<BillingMsCommitPaymentRequest>;
};

export type MutationBillingMsCreateGuaranteePaymentArgs = {
  request?: InputMaybe<BillingMsCreateGuaranteePaymentRequest>;
};

export type MutationBillingMsCreateInvoicePaymentArgs = {
  request?: InputMaybe<BillingMsCreateInvoicePaymentRequest>;
};

export type MutationBillingMsCreateInvoiceTransactionsDocumentArgs = {
  request?: InputMaybe<BillingMsCreateInvoiceTransactionsDocumentRequest>;
};

export type MutationBillingMsCreateTidDeliveryConfigArgs = {
  request?: InputMaybe<BillingMsCreateTidDeliveryConfigRequest>;
};

export type MutationBillingMsCreateTidLinkedAccountArgs = {
  request?: InputMaybe<BillingMsCreateTidLinkedAccountRequest>;
};

export type MutationBillingMsCreateTidOrderArgs = {
  request?: InputMaybe<BillingMsCreateTidOrderRequest>;
};

export type MutationBillingMsCreateTidReportArgs = {
  request?: InputMaybe<BillingMsCreateTidReportRequest>;
};

export type MutationBillingMsDeleteTidDeliveryConfigArgs = {
  request?: InputMaybe<BillingMsDeleteTidDeliveryConfigRequest>;
};

export type MutationBillingMsDeleteTidLinkedAccountArgs = {
  request?: InputMaybe<BillingMsDeleteTidLinkedAccountRequest>;
};

export type MutationBillingMsListMyLastInvoiceDocumentsArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type MutationBillingMsListMyLastTidDocumentsArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type MutationBillingMsUpdateAccountEmailAddressArgs = {
  request?: InputMaybe<BillingMsUpdateAccountEmailAddressRequest>;
};

export type MutationCollaboratorsMsArchiveCollaboratorArgs = {
  request?: InputMaybe<CollaboratorsMsArchiveCollaboratorRequest>;
};

export type MutationCollaboratorsMsCreateCollaboratorArgs = {
  request?: InputMaybe<CollaboratorsMsCreateCollaboratorRequest>;
};

export type MutationCollaboratorsMsCreateDriverCodeArgs = {
  request?: InputMaybe<CollaboratorsMsCreateDriverCodeRequest>;
};

export type MutationCollaboratorsMsLinkDriverCodeArgs = {
  request?: InputMaybe<CollaboratorsMsLinkDriverCodeRequest>;
};

export type MutationCollaboratorsMsReeditDriverCodesArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type MutationCollaboratorsMsRequestToBlockDriverCodeArgs = {
  request?: InputMaybe<CollaboratorsMsRequestToBlockDriverCodeRequest>;
};

export type MutationCollaboratorsMsRequestToUnBlockDriverCodeArgs = {
  request?: InputMaybe<CollaboratorsMsRequestToUnBlockDriverCodeRequest>;
};

export type MutationCollaboratorsMsSetSupervisorArgs = {
  request?: InputMaybe<CollaboratorsMsSetSupervisorRequest>;
};

export type MutationCollaboratorsMsUnarchiveCollaboratorArgs = {
  request?: InputMaybe<CollaboratorsMsUnarchiveCollaboratorRequest>;
};

export type MutationCollaboratorsMsUnsetSupervisorArgs = {
  request?: InputMaybe<CollaboratorsMsUnsetSupervisorRequest>;
};

export type MutationCollaboratorsMsUpdateCollaboratorArgs = {
  request?: InputMaybe<CollaboratorsMsUpdateCollaboratorRequest>;
};

export type MutationCollaboratorsMsUpdateDriverCodeArgs = {
  request?: InputMaybe<CollaboratorsMsUpdateDriverCodeRequest>;
};

export type MutationCollaboratorsMsUpsertMobilityCorporateCollaboratorArgs = {
  request?: InputMaybe<CollaboratorsMsUpsertMobilityCorporateCollaboratorRequest>;
};

export type MutationDatabayMsUpdateByAccountIdArgs = {
  request?: InputMaybe<DatabayMsUpdateByAccountIdRequest>;
};

export type MutationLedgersMsBlockLedgerArgs = {
  request?: InputMaybe<LedgersMsBlockLedgerRequest>;
};

export type MutationLedgersMsBlockLedgerAsPartnerArgs = {
  request?: InputMaybe<LedgersMsBlockLedgerAsPartnerRequest>;
};

export type MutationLedgersMsCancelLedgerRenewalArgs = {
  request?: InputMaybe<LedgersMsCancelLedgerRenewalRequest>;
};

export type MutationLedgersMsCreateAllTransactionsMobilityCorporateReportArgs =
  {
    request?: InputMaybe<LedgersMsCreateAllTransactionsMobilityCorporateReportRequest>;
  };

export type MutationLedgersMsCreateConsumptionMonitoringReportArgs = {
  request?: InputMaybe<LedgersMsCreateConsumptionMonitoringReportRequest>;
};

export type MutationLedgersMsCreateCostTrackingReportArgs = {
  request?: InputMaybe<LedgersMsCreateCostTrackingReportRequest>;
};

export type MutationLedgersMsCreateDemandArgs = {
  request?: InputMaybe<LedgersMsCreateDemandRequest>;
};

export type MutationLedgersMsCreateDivisionArgs = {
  request?: InputMaybe<LedgersMsCreateDivisionRequest>;
};

export type MutationLedgersMsCreateDivisionOrderArgs = {
  request?: InputMaybe<LedgersMsCreateDivisionOrderRequest>;
};

export type MutationLedgersMsCreateEvDetailedReportArgs = {
  request?: InputMaybe<LedgersMsCreateEvDetailedReportRequest>;
};

export type MutationLedgersMsCreateLedgerOrderArgs = {
  request?: InputMaybe<LedgersMsCreateLedgerOrderRequest>;
};

export type MutationLedgersMsCreateMileageReportArgs = {
  request?: InputMaybe<LedgersMsCreateMileageReportRequest>;
};

export type MutationLedgersMsCreatePriceCeilingReportArgs = {
  request?: InputMaybe<LedgersMsCreatePriceCeilingReportRequest>;
};

export type MutationLedgersMsCreateTollPassagesReportArgs = {
  request?: InputMaybe<LedgersMsCreateTollPassagesReportRequest>;
};

export type MutationLedgersMsCreateTransactionsFridayMondayReportArgs = {
  request?: InputMaybe<LedgersMsCreateTransactionsFridayMondayReportRequest>;
};

export type MutationLedgersMsCreateTransactionsWeekendHolidaysReportArgs = {
  request?: InputMaybe<LedgersMsCreateTransactionsWeekendHolidaysReportRequest>;
};

export type MutationLedgersMsCreateTruckPositionsReportArgs = {
  request?: InputMaybe<LedgersMsCreateTruckPositionsReportRequest>;
};

export type MutationLedgersMsDeleteLedgerArgs = {
  request?: InputMaybe<LedgersMsDeleteLedgerRequest>;
};

export type MutationLedgersMsExportSupportConfigArgs = {
  request?: InputMaybe<LedgersMsExportSupportConfigRequest>;
};

export type MutationLedgersMsExportTransactionsArgs = {
  request?: InputMaybe<LedgersMsExportTransactionsRequest>;
};

export type MutationLedgersMsFetchLedgersExportArgs = {
  request?: InputMaybe<LedgersMsFetchLedgersExportRequest>;
};

export type MutationLedgersMsListLedgerChangesArgs = {
  request?: InputMaybe<LedgersMsListLedgerChangesRequest>;
};

export type MutationLedgersMsModifyDivisionArgs = {
  request?: InputMaybe<LedgersMsModifyDivisionRequest>;
};

export type MutationLedgersMsOnCreateLedgerOrderArgs = {
  request?: InputMaybe<LedgersMsOnCreateLedgerOrderRequest>;
};

export type MutationLedgersMsOnUpdateLedgerOrderArgs = {
  request?: InputMaybe<LedgersMsOnUpdateLedgerOrderRequest>;
};

export type MutationLedgersMsOnUpdateLedgerSectorArgs = {
  request?: InputMaybe<LedgersMsOnUpdateLedgerSectorRequest>;
};

export type MutationLedgersMsResendPinCodeArgs = {
  request?: InputMaybe<LedgersMsResendPinCodeRequest>;
};

export type MutationLedgersMsUpdateDivisionOrderArgs = {
  request?: InputMaybe<LedgersMsUpdateDivisionOrderRequest>;
};

export type MutationLedgersMsUpdateLedgerOrderArgs = {
  request?: InputMaybe<LedgersMsUpdateLedgerOrderRequest>;
};

export type MutationMediaMsCreateDocumentTypeArgs = {
  request?: InputMaybe<MediaMsCreateDocumentTypeRequest>;
};

export type MutationMediaMsDownloadArgs = {
  request?: InputMaybe<MediaMsDownloadRequest>;
};

export type MutationMediaMsUpdateDocumentTypeArgs = {
  request?: InputMaybe<MediaMsUpdateDocumentTypeRequest>;
};

export type MutationMiddleMsCreateDemandArgs = {
  request?: InputMaybe<MiddleMsCreateDemandRequest>;
};

export type MutationMiddleMsCreateFormDataRuleGroupArgs = {
  request?: InputMaybe<MiddleMsCreateFormDataRuleGroupRequest>;
};

export type MutationMiddleMsDeleteFormDataRuleGroupArgs = {
  request?: InputMaybe<MiddleMsDeleteFormDataRuleGroupRequest>;
};

export type MutationMiddleMsDuplicateFormDataRuleGroupArgs = {
  request?: InputMaybe<MiddleMsDuplicateFormDataRuleGroupRequest>;
};

export type MutationMiddleMsResynchronisationArgs = {
  request?: InputMaybe<MiddleMsResynchronisationRequest>;
};

export type MutationMiddleMsTestFormDataArgs = {
  request?: InputMaybe<MiddleMsTestFormDataRequest>;
};

export type MutationMiddleMsToggleFormDataRuleGroupArgs = {
  request?: InputMaybe<MiddleMsToggleFormDataRuleGroupRequest>;
};

export type MutationMiddleMsUpdateFormDataRuleGroupArgs = {
  request?: InputMaybe<MiddleMsUpdateFormDataRuleGroupRequest>;
};

export type MutationNotificationsMsCleanupMailForwarderArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type MutationNotificationsMsDisableMySubscriptionsArgs = {
  request?: InputMaybe<NotificationsMsDisableMySubscriptionsRequest>;
};

export type MutationNotificationsMsEnableMySubscriptionsArgs = {
  request?: InputMaybe<NotificationsMsEnableMySubscriptionsRequest>;
};

export type MutationNotificationsMsResendNotificationsArgs = {
  request?: InputMaybe<NotificationsMsResendNotificationsRequest>;
};

export type MutationNotificationsMsSendChargingSessionTrackingCodeArgs = {
  request?: InputMaybe<NotificationsMsSendChargingSessionTrackingCodeRequest>;
};

export type MutationNotificationsMsSendVerificationCodeArgs = {
  request?: InputMaybe<NotificationsMsSendVerificationCodeRequest>;
};

export type MutationNotificationsMsSubscribeArgs = {
  request?: InputMaybe<NotificationsMsSubscribeRequest>;
};

export type MutationNotificationsMsUnsubscribeArgs = {
  request?: InputMaybe<NotificationsMsUnsubscribeRequest>;
};

export type MutationRemotechargingMsNotifyArgs = {
  request?: InputMaybe<RemotechargingMsNotifyRequest>;
};

export type MutationRemotechargingMsOrderChargingSessionArgs = {
  request?: InputMaybe<RemotechargingMsOrderChargingSessionRequest>;
};

export type MutationRemotechargingMsStartSessionArgs = {
  request?: InputMaybe<RemotechargingMsStartSessionRequest>;
};

export type MutationRemotechargingMsUpdateChargingSessionOrderStatusArgs = {
  request?: InputMaybe<RemotechargingMsUpdateChargingSessionOrderStatusRequest>;
};

export type MutationReportingMsCreateReportPlanArgs = {
  request?: InputMaybe<ReportingMsCreateReportPlanRequest>;
};

export type MutationReportingMsCreateReportTypeArgs = {
  request?: InputMaybe<ReportingMsCreateReportTypeRequest>;
};

export type MutationReportingMsDeleteReportPlanArgs = {
  request?: InputMaybe<ReportingMsDeleteReportPlanRequest>;
};

export type MutationReportingMsExpireReportsArgs = {
  request?: InputMaybe<ReportingMsExpireReportsRequest>;
};

export type MutationReportingMsGenerateReportArgs = {
  request?: InputMaybe<ReportingMsGenerateReportRequest>;
};

export type MutationReportingMsRecoverReportsArgs = {
  request?: InputMaybe<ReportingMsRecoverReportsRequest>;
};

export type MutationReportingMsReportStatisticsArgs = {
  request?: InputMaybe<ReportingMsReportStatisticsRequest>;
};

export type MutationReportingMsUpdateReportPlanArgs = {
  request?: InputMaybe<ReportingMsUpdateReportPlanRequest>;
};

export type MutationReportingMsUpdateReportTypeArgs = {
  request?: InputMaybe<ReportingMsUpdateReportTypeRequest>;
};

export type MutationSectorsMsCreateSectorArgs = {
  request?: InputMaybe<SectorsMsCreateSectorRequest>;
};

export type MutationSectorsMsDeleteSectorArgs = {
  request?: InputMaybe<SectorsMsDeleteSectorRequest>;
};

export type MutationSectorsMsSetLabelArgs = {
  request?: InputMaybe<SectorsMsSetLabelRequest>;
};

export type MutationSectorsMsUpdateSectorArgs = {
  request?: InputMaybe<SectorsMsUpdateSectorRequest>;
};

export type MutationTransactionsMsFetchTransactionAnomalyArgs = {
  request?: InputMaybe<TransactionsMsFetchTransactionAnomalyRequest>;
};

export type MutationTransactionsMsFetchTransactionAnomaly24Args = {
  request?: InputMaybe<TransactionsMsFetchTransactionAnomaly24Request>;
};

export type MutationTransactionsMsFetchTransactionEvDetailedArgs = {
  request?: InputMaybe<TransactionsMsFetchTransactionEvDetailedRequest>;
};

export type MutationTransactionsMsFetchTransactionExportArgs = {
  request?: InputMaybe<TransactionsMsFetchTransactionExportRequest>;
};

export type MutationTransactionsMsFetchTransactionMobilityCorporateArgs = {
  request?: InputMaybe<TransactionsMsFetchTransactionMobilityCorporateRequest>;
};

export type MutationTransactionsMsFetchTransactionTollPassagesArgs = {
  request?: InputMaybe<TransactionsMsFetchTransactionTollPassagesRequest>;
};

export type MutationVehiclesMsArchiveVehicleArgs = {
  request?: InputMaybe<VehiclesMsArchiveVehicleRequest>;
};

export type MutationVehiclesMsCreateMileageArgs = {
  request?: InputMaybe<VehiclesMsCreateMileageRequest>;
};

export type MutationVehiclesMsCreateVehicleArgs = {
  request?: InputMaybe<VehiclesMsCreateVehicleRequest>;
};

export type MutationVehiclesMsUnarchiveVehicleArgs = {
  request?: InputMaybe<VehiclesMsUnarchiveVehicleRequest>;
};

export type MutationVehiclesMsUpdateVehicleArgs = {
  request?: InputMaybe<VehiclesMsUpdateVehicleRequest>;
};

export type NotificationsMsDisableMySubscriptionsRequest = {
  /**  Disable subscriptions of current user on all its accounts  */
  applyOnAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NotificationsMsEnableMySubscriptionsRequest = {
  /**  Enable subscriptions of current user on all its accounts depending on its roles and features  */
  applyOnAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NotificationsMsGetMySubscriptionsResponse = {
  __typename?: "NotificationsMsGetMySubscriptionsResponse";
  notificationSubscriptions?: Maybe<
    Array<NotificationsMsGetMySubscriptionsResponseNotificationSubscription>
  >;
};

export type NotificationsMsGetMySubscriptionsResponseNotificationSubscription =
  {
    __typename?: "NotificationsMsGetMySubscriptionsResponseNotificationSubscription";
    notificationTypeCode: Scalars["String"]["output"];
    notificationTypeId: Scalars["String"]["output"];
    subscribed: Scalars["Boolean"]["output"];
  };

export type NotificationsMsPagedPagination = {
  __typename?: "NotificationsMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type NotificationsMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  Resend notifications  */
export type NotificationsMsResendNotificationsRequest = {
  /**  The IDs of notifications to resend  */
  notificationIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type NotificationsMsResendNotificationsResponse = {
  __typename?: "NotificationsMsResendNotificationsResponse";
  /**  The IDs of notifications  */
  jobIds?: Maybe<Array<Scalars["ID"]["output"]>>;
};

/**  Search among messages  */
export type NotificationsMsSearchMessagesRequest = {
  filters?: InputMaybe<NotificationsMsSearchMessagesRequestFilters>;
  paging?: InputMaybe<NotificationsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<NotificationsMsSearchMessagesRequestSort>>
  >;
};

export type NotificationsMsSearchMessagesRequestFilters = {
  failedReason?: InputMaybe<NotificationsMsSearchMessagesRequestFiltersFailedReason>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  notificationId?: InputMaybe<Scalars["ID"]["input"]>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<NotificationsMsSearchMessagesRequestFiltersStatus>;
};

export enum NotificationsMsSearchMessagesRequestFiltersFailedReason {
  BlacklistedRecipient = "BLACKLISTED_RECIPIENT",
  DeliveryFailed = "DELIVERY_FAILED",
  FailedReasonUnspecified = "FAILED_REASON_UNSPECIFIED",
  MissingRequiredParameter = "MISSING_REQUIRED_PARAMETER",
  NoLocale = "NO_LOCALE",
  OptedOut = "OPTED_OUT",
  TemplateError = "TEMPLATE_ERROR",
  TriggerError = "TRIGGER_ERROR",
}

export enum NotificationsMsSearchMessagesRequestFiltersStatus {
  AbortedAntiFlood = "ABORTED_ANTI_FLOOD",
  AbortedNoRegisteredUser = "ABORTED_NO_REGISTERED_USER",
  AbortedNoSendingSolution = "ABORTED_NO_SENDING_SOLUTION",
  AbortedNoTemplate = "ABORTED_NO_TEMPLATE",
  AbortedNoTrigger = "ABORTED_NO_TRIGGER",
  Handled = "HANDLED",
  InvalidErrorCode = "INVALID_ERROR_CODE",
  New = "NEW",
  NotificationStatusUnspecified = "NOTIFICATION_STATUS_UNSPECIFIED",
  Resend = "RESEND",
}

export type NotificationsMsSearchMessagesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<NotificationsMsSearchMessagesRequestSortField>;
};

export enum NotificationsMsSearchMessagesRequestSortField {
  Code = "code",
  UpdatedTs = "updatedTs",
}

export type NotificationsMsSearchMessagesResponse = {
  __typename?: "NotificationsMsSearchMessagesResponse";
  data?: Maybe<Array<NotificationsMsSearchMessagesResponseData>>;
  pagination: NotificationsMsPagedPagination;
};

export type NotificationsMsSearchMessagesResponseData = {
  __typename?: "NotificationsMsSearchMessagesResponseData";
  NotificationIdData?: Maybe<NotificationsMsSearchNotificationsResponseData>;
  RecipientIdData?: Maybe<NotificationsMsSearchRecipientsResponseData>;
  TriggerIdData?: Maybe<NotificationsMsSearchTriggersResponseData>;
  createdTs: Scalars["Int64"]["output"];
  /**  Why the notification failed  */
  failedReason: NotificationsMsSearchMessagesResponseDataFailedReason;
  /**  The message id  */
  id: Scalars["ID"]["output"];
  /**  The notification id  */
  notificationId: Scalars["ID"]["output"];
  /**  The recipient id  */
  recipientId: Scalars["String"]["output"];
  /**  The reference of the message used to communicate with the delivery solution.  */
  reference: Scalars["String"]["output"];
  /**  The status of the notification  */
  status: NotificationsMsSearchMessagesResponseDataStatus;
  /**  The related trigger  */
  triggerId: Scalars["ID"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

export enum NotificationsMsSearchMessagesResponseDataFailedReason {
  BlacklistedRecipient = "BLACKLISTED_RECIPIENT",
  DeliveryFailed = "DELIVERY_FAILED",
  FailedReasonUnspecified = "FAILED_REASON_UNSPECIFIED",
  MissingRequiredParameter = "MISSING_REQUIRED_PARAMETER",
  NoLocale = "NO_LOCALE",
  OptedOut = "OPTED_OUT",
  TemplateError = "TEMPLATE_ERROR",
  TriggerError = "TRIGGER_ERROR",
}

export enum NotificationsMsSearchMessagesResponseDataStatus {
  Failed = "FAILED",
  MessageStatusUnspecified = "MESSAGE_STATUS_UNSPECIFIED",
  Sent = "SENT",
}

/**  Search among messages documents  */
export type NotificationsMsSearchNotificationDocumentsRequest = {
  filters?: InputMaybe<NotificationsMsSearchNotificationDocumentsRequestFilters>;
  paging?: InputMaybe<NotificationsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<NotificationsMsSearchNotificationDocumentsRequestSort>>
  >;
};

export type NotificationsMsSearchNotificationDocumentsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type NotificationsMsSearchNotificationDocumentsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<NotificationsMsSearchNotificationDocumentsRequestSortField>;
};

export enum NotificationsMsSearchNotificationDocumentsRequestSortField {
  UpdatedTs = "updatedTs",
}

export type NotificationsMsSearchNotificationDocumentsResponse = {
  __typename?: "NotificationsMsSearchNotificationDocumentsResponse";
  data?: Maybe<Array<NotificationsMsSearchNotificationDocumentsResponseData>>;
  pagination: NotificationsMsPagedPagination;
};

export type NotificationsMsSearchNotificationDocumentsResponseData = {
  __typename?: "NotificationsMsSearchNotificationDocumentsResponseData";
  DocumentIdData?: Maybe<MediaMsSearchDocumentsResponseData>;
  NotificationIdData?: Maybe<NotificationsMsSearchNotificationsResponseData>;
  createdTs: Scalars["Int64"]["output"];
  /**  The related document  */
  documentId: Scalars["ID"]["output"];
  /**  The document id  */
  id: Scalars["ID"]["output"];
  /**  The notification id  */
  notificationId: Scalars["ID"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

/**  Search among notification types  */
export type NotificationsMsSearchNotificationTypesRequest = {
  filters?: InputMaybe<NotificationsMsSearchNotificationTypesRequestFilters>;
  paging?: InputMaybe<NotificationsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<NotificationsMsSearchNotificationTypesRequestSort>>
  >;
};

export type NotificationsMsSearchNotificationTypesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type NotificationsMsSearchNotificationTypesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<NotificationsMsSearchNotificationTypesRequestSortField>;
};

export enum NotificationsMsSearchNotificationTypesRequestSortField {
  Code = "code",
  UpdatedTs = "updatedTs",
}

export type NotificationsMsSearchNotificationTypesResponse = {
  __typename?: "NotificationsMsSearchNotificationTypesResponse";
  data?: Maybe<Array<NotificationsMsSearchNotificationTypesResponseData>>;
  pagination: NotificationsMsPagedPagination;
};

export type NotificationsMsSearchNotificationTypesResponseData = {
  __typename?: "NotificationsMsSearchNotificationTypesResponseData";
  Subscriptions?: Maybe<NotificationsMsSearchSubscriptionsResponseData>;
  canSubscribe: Scalars["Boolean"]["output"];
  /**  The notification code  */
  code: Scalars["String"]["output"];
  /**  won't be deseralized but it's used to fill canSubscribe field  */
  features?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The notification id  */
  id: Scalars["ID"]["output"];
  /**  won't be deseralized but it's used to fill canSubscribe field  */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  won't be deseralized but it's used to fill canSubscribe field  */
  subscribable: Scalars["Boolean"]["output"];
};

/**  Get account preferences related to the notifications domain  */
export type NotificationsMsSearchNotificationsAccountPreferencesRequest = {
  filters?: InputMaybe<NotificationsMsSearchNotificationsAccountPreferencesRequestFilters>;
  paging?: InputMaybe<NotificationsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<
      InputMaybe<NotificationsMsSearchNotificationsAccountPreferencesRequestSort>
    >
  >;
};

export type NotificationsMsSearchNotificationsAccountPreferencesRequestFilters =
  {
    ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  };

export type NotificationsMsSearchNotificationsAccountPreferencesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<NotificationsMsSearchNotificationsAccountPreferencesRequestSortField>;
};

export enum NotificationsMsSearchNotificationsAccountPreferencesRequestSortField {
  Id = "id",
}

export type NotificationsMsSearchNotificationsAccountPreferencesResponse = {
  __typename?: "NotificationsMsSearchNotificationsAccountPreferencesResponse";
  data?: Maybe<
    Array<NotificationsMsSearchNotificationsAccountPreferencesResponseData>
  >;
  pagination: NotificationsMsPagedPagination;
};

export type NotificationsMsSearchNotificationsAccountPreferencesResponseData = {
  __typename?: "NotificationsMsSearchNotificationsAccountPreferencesResponseData";
  IdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  /**  The account ID  */
  id: Scalars["ID"]["output"];
};

/**  Search among notifications  */
export type NotificationsMsSearchNotificationsRequest = {
  filters?: InputMaybe<NotificationsMsSearchNotificationsRequestFilters>;
  paging?: InputMaybe<NotificationsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<NotificationsMsSearchNotificationsRequestSort>>
  >;
};

export type NotificationsMsSearchNotificationsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  updatedTsGt?: InputMaybe<Scalars["Int64"]["input"]>;
  updatedTsLt?: InputMaybe<Scalars["Int64"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type NotificationsMsSearchNotificationsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<NotificationsMsSearchNotificationsRequestSortField>;
};

export enum NotificationsMsSearchNotificationsRequestSortField {
  CreatedTs = "createdTs",
  NotificationId = "notification_id",
  UpdatedTs = "updatedTs",
}

export type NotificationsMsSearchNotificationsResponse = {
  __typename?: "NotificationsMsSearchNotificationsResponse";
  data?: Maybe<Array<NotificationsMsSearchNotificationsResponseData>>;
  pagination: NotificationsMsPagedPagination;
};

export type NotificationsMsSearchNotificationsResponseData = {
  __typename?: "NotificationsMsSearchNotificationsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  TypeIdData?: Maybe<NotificationsMsSearchNotificationTypesResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  The optional related account  */
  accountId: Scalars["ID"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  The raw data of the user  */
  data: Scalars["String"]["output"];
  failedReason: NotificationsMsSearchNotificationsResponseDataFailedReason;
  /**  Whether the notification has attachments or not  */
  hasAttachments: Scalars["Boolean"]["output"];
  /**  The job id  */
  id: Scalars["ID"]["output"];
  /**  The status of the notification  */
  status: NotificationsMsSearchNotificationsResponseDataStatus;
  /**  The notification subject  */
  subject: Scalars["String"]["output"];
  /**  The notification type  */
  typeId: Scalars["ID"]["output"];
  updatedTs: Scalars["Int64"]["output"];
  /**  The related user  */
  userId: Scalars["ID"]["output"];
};

export enum NotificationsMsSearchNotificationsResponseDataFailedReason {
  BlacklistedRecipient = "BLACKLISTED_RECIPIENT",
  DeliveryFailed = "DELIVERY_FAILED",
  FailedReasonUnspecified = "FAILED_REASON_UNSPECIFIED",
  MissingRequiredParameter = "MISSING_REQUIRED_PARAMETER",
  NoLocale = "NO_LOCALE",
  OptedOut = "OPTED_OUT",
  TemplateError = "TEMPLATE_ERROR",
  TriggerError = "TRIGGER_ERROR",
}

export enum NotificationsMsSearchNotificationsResponseDataStatus {
  AbortedAntiFlood = "ABORTED_ANTI_FLOOD",
  AbortedNoRegisteredUser = "ABORTED_NO_REGISTERED_USER",
  AbortedNoSendingSolution = "ABORTED_NO_SENDING_SOLUTION",
  AbortedNoTemplate = "ABORTED_NO_TEMPLATE",
  AbortedNoTrigger = "ABORTED_NO_TRIGGER",
  Handled = "HANDLED",
  InvalidErrorCode = "INVALID_ERROR_CODE",
  New = "NEW",
  NotificationStatusUnspecified = "NOTIFICATION_STATUS_UNSPECIFIED",
  Resend = "RESEND",
}

/**  Get account preferences related to the notifications domain  */
export type NotificationsMsSearchRecipientsRequest = {
  filters?: InputMaybe<NotificationsMsSearchRecipientsRequestFilters>;
  paging?: InputMaybe<NotificationsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<NotificationsMsSearchRecipientsRequestSort>>
  >;
};

export type NotificationsMsSearchRecipientsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type NotificationsMsSearchRecipientsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<NotificationsMsSearchRecipientsRequestSortField>;
};

export enum NotificationsMsSearchRecipientsRequestSortField {
  Id = "id",
}

export type NotificationsMsSearchRecipientsResponse = {
  __typename?: "NotificationsMsSearchRecipientsResponse";
  data?: Maybe<Array<NotificationsMsSearchRecipientsResponseData>>;
  pagination: NotificationsMsPagedPagination;
};

export type NotificationsMsSearchRecipientsResponseData = {
  __typename?: "NotificationsMsSearchRecipientsResponseData";
  createdTs: Scalars["Int64"]["output"];
  /**  The email id  */
  emailId: Scalars["ID"]["output"];
  /**  The recipient id  */
  id: Scalars["ID"]["output"];
  /**  The list of channels that have been opt out  */
  optOutChannels?: Maybe<
    Array<NotificationsMsSearchRecipientsResponseDataOptOutChannels>
  >;
  updatedTs: Scalars["Int64"]["output"];
};

export enum NotificationsMsSearchRecipientsResponseDataOptOutChannels {
  ChannelUnspecified = "CHANNEL_UNSPECIFIED",
  Email = "EMAIL",
  Prune = "PRUNE",
  PushNotification = "PUSH_NOTIFICATION",
  Sms = "SMS",
}

/**  Search among notifications  */
export type NotificationsMsSearchSubscriptionsRequest = {
  filters?: InputMaybe<NotificationsMsSearchSubscriptionsRequestFilters>;
  paging?: InputMaybe<NotificationsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<NotificationsMsSearchSubscriptionsRequestSort>>
  >;
};

export type NotificationsMsSearchSubscriptionsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  notificationTypeIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type NotificationsMsSearchSubscriptionsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<NotificationsMsSearchSubscriptionsRequestSortField>;
};

export enum NotificationsMsSearchSubscriptionsRequestSortField {
  Id = "id",
}

export type NotificationsMsSearchSubscriptionsResponse = {
  __typename?: "NotificationsMsSearchSubscriptionsResponse";
  data?: Maybe<Array<NotificationsMsSearchSubscriptionsResponseData>>;
  pagination: NotificationsMsPagedPagination;
};

export type NotificationsMsSearchSubscriptionsResponseData = {
  __typename?: "NotificationsMsSearchSubscriptionsResponseData";
  AccountIdData?: Maybe<NotificationsMsSearchNotificationsAccountPreferencesResponseData>;
  NotificationTypeIdData?: Maybe<NotificationsMsSearchNotificationTypesResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**  If the given subscription is enabled or not  */
  enabled: Scalars["Boolean"]["output"];
  /**  The subscription id  */
  id: Scalars["ID"]["output"];
  /**  The related notification type  */
  notificationTypeId: Scalars["ID"]["output"];
  /**  The related user  */
  userId: Scalars["ID"]["output"];
};

/**  Search among triggers  */
export type NotificationsMsSearchTriggersRequest = {
  filters?: InputMaybe<NotificationsMsSearchTriggersRequestFilters>;
  paging?: InputMaybe<NotificationsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<NotificationsMsSearchTriggersRequestSort>>
  >;
};

export type NotificationsMsSearchTriggersRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type NotificationsMsSearchTriggersRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<NotificationsMsSearchTriggersRequestSortField>;
};

export enum NotificationsMsSearchTriggersRequestSortField {
  UpdatedTs = "updatedTs",
}

export type NotificationsMsSearchTriggersResponse = {
  __typename?: "NotificationsMsSearchTriggersResponse";
  data?: Maybe<Array<NotificationsMsSearchTriggersResponseData>>;
  pagination: NotificationsMsPagedPagination;
};

export type NotificationsMsSearchTriggersResponseData = {
  __typename?: "NotificationsMsSearchTriggersResponseData";
  NotificationTypeIdData?: Maybe<NotificationsMsSearchNotificationTypesResponseData>;
  /**  In which way the messages will be sent (ie: email, sms, push notification...)  */
  channel: NotificationsMsSearchTriggersResponseDataChannel;
  createdTs: Scalars["Int64"]["output"];
  description: Scalars["String"]["output"];
  /**  The trigger id  */
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  /**  The related notification type  */
  notificationTypeId: Scalars["ID"]["output"];
  status: NotificationsMsSearchTriggersResponseDataStatus;
  updatedTs: Scalars["Int64"]["output"];
};

export enum NotificationsMsSearchTriggersResponseDataChannel {
  ChannelUnspecified = "CHANNEL_UNSPECIFIED",
  Email = "EMAIL",
  Prune = "PRUNE",
  PushNotification = "PUSH_NOTIFICATION",
  Sms = "SMS",
}

export enum NotificationsMsSearchTriggersResponseDataStatus {
  AbortedAntiFlood = "ABORTED_ANTI_FLOOD",
  AbortedNoRegisteredUser = "ABORTED_NO_REGISTERED_USER",
  AbortedNoSendingSolution = "ABORTED_NO_SENDING_SOLUTION",
  AbortedNoTemplate = "ABORTED_NO_TEMPLATE",
  AbortedNoTrigger = "ABORTED_NO_TRIGGER",
  Handled = "HANDLED",
  InvalidErrorCode = "INVALID_ERROR_CODE",
  New = "NEW",
  NotificationStatusUnspecified = "NOTIFICATION_STATUS_UNSPECIFIED",
  Resend = "RESEND",
}

/**  Send charging session tracking code  */
export type NotificationsMsSendChargingSessionTrackingCodeRequest = {
  /**  The recipient email  */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**  The locale  */
  locale?: InputMaybe<Scalars["String"]["input"]>;
  /**  The tracking code  */
  trackingCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type NotificationsMsSendChargingSessionTrackingCodeResponse = {
  __typename?: "NotificationsMsSendChargingSessionTrackingCodeResponse";
  jobId: Scalars["ID"]["output"];
};

/**  Resend notifications  */
export type NotificationsMsSendVerificationCodeRequest = {
  /**  The locale  */
  locale?: InputMaybe<Scalars["String"]["input"]>;
  /**  The recipient phone number  */
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**  The sender  */
  sender?: InputMaybe<Scalars["String"]["input"]>;
  /**  The verification code to send  */
  verificationCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type NotificationsMsSendVerificationCodeResponse = {
  __typename?: "NotificationsMsSendVerificationCodeResponse";
  jobId: Scalars["ID"]["output"];
};

export type NotificationsMsSubscribeRequest = {
  /**  Subscribe current user on all its accounts depending on its roles and features  */
  applyOnAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationTypeCodes?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
};

export type NotificationsMsUnsubscribeRequest = {
  /**  Unsubscribe current user on all its accounts  */
  applyOnAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationTypeCodes?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
};

export type Query = {
  __typename?: "Query";
  /**  Count sectors of user in related to caller restriction  */
  AccountsMsCountNumberOfSectors: AccountsMsCountNumberOfSectorsResponse;
  /**  Count support user by status  */
  AccountsMsCountSupportUsersByStatus: AccountsMsCountSupportUsersByStatusResponse;
  /**  Count the users by status, scoped to the current account  */
  AccountsMsCountUsersByStatus: AccountsMsCountUsersByStatusResponse;
  /**  Count the users in a roles profile, scoped to the current account  */
  AccountsMsCountUsersInRolesProfile: AccountsMsCountUsersInRolesProfileResponse;
  /**  Count the users in sector  */
  AccountsMsCountUsersInSector: AccountsMsCountUsersInSectorResponse;
  /**
   *  Serve only for the frontend to forward the identity,
   * Triggering the baff with the id token that will call the LookupPassport
   * and set the cognito ids for the user
   */
  AccountsMsForwardIdentity?: Maybe<Scalars["Void"]["output"]>;
  /**  Get the owner of current account  */
  AccountsMsGetOwner: AccountsMsGetOwnerResponse;
  AccountsMsGetRolesGrid: AccountsMsGetRolesGridResponse;
  /**  List all available roles  */
  AccountsMsListRoles: AccountsMsListRolesResponse;
  /**
   *  The current identity information
   *
   * Returns the current user information, used by the frontend to load partial data about the user profile.
   */
  AccountsMsMe: AccountsMsMeResponse;
  AccountsMsReadRolesProfile: AccountsMsReadRolesProfileResponse;
  /**  Get the account information & preferences  */
  AccountsMsSearchAccounts: AccountsMsSearchAccountsResponse;
  /**  Search Agencies  */
  AccountsMsSearchAgencies: AccountsMsSearchAgenciesResponse;
  /**
   *  Search among the logs
   * A customer user can see the actions that has been done for him/her
   * A super support agent can see all the actions among their subsidiaries
   */
  AccountsMsSearchAuditLogs: AccountsMsSearchAuditLogsResponse;
  /**  Search among Contracts  */
  AccountsMsSearchContracts: AccountsMsSearchContractsResponse;
  /**  Search among current user's privileges  */
  AccountsMsSearchOwnPrivileges: AccountsMsSearchOwnPrivilegesResponse;
  /**  Search among user-account privileges  */
  AccountsMsSearchPlatformAccesses: AccountsMsSearchPlatformAccessesResponse;
  /**  Search privilege restrictions  */
  AccountsMsSearchPrivilegeRestrictions: AccountsMsSearchPrivilegeRestrictionsResponse;
  /**  Search among privilege subscriptions  */
  AccountsMsSearchPrivilegeSubscriptions: AccountsMsSearchPrivilegeSubscriptionsResponse;
  /**  Search among user-account privileges  */
  AccountsMsSearchPrivileges: AccountsMsSearchPrivilegesResponse;
  /**  Search among roles profiles  */
  AccountsMsSearchRolesProfiles: AccountsMsSearchRolesProfilesResponse;
  /**  Search among support users  */
  AccountsMsSearchSupportUsers: AccountsMsSearchSupportUsersResponse;
  /**  Search among users  */
  AccountsMsSearchUsers: AccountsMsSearchUsersResponse;
  /**  Count assignments by status  */
  AssignmentsMsCountAssignmentsByStatus: AssignmentsMsCountAssignmentsByStatusResponse;
  /**  Check if collaborator assignment is available for ledger  */
  AssignmentsMsIsCollaboratorAssignmentAvailable: AssignmentsMsIsCollaboratorAssignmentAvailableResponse;
  /**  Search among collaborator assignments  */
  AssignmentsMsSearchCollaboratorAssignments: AssignmentsMsSearchCollaboratorAssignmentsResponse;
  /**  Search among vehicle assignments  */
  AssignmentsMsSearchVehicleAssignments: AssignmentsMsSearchVehicleAssignmentsResponse;
  BillingMsGetAccountsLinkableToTid: BillingMsGetAccountsLinkableToTidResponse;
  /**  Search among payments  */
  BillingMsGetActiveGuaranteePayment: BillingMsGetActiveGuaranteePaymentResponse;
  BillingMsGetCustomerCreditState: BillingMsGetCustomerCreditStateResponse;
  BillingMsGetLastInvoice: BillingMsGetLastInvoiceResponse;
  /**  Create a invoice payment  */
  BillingMsListOpenPaymentDocuments: BillingMsListOpenPaymentDocumentsResponse;
  /**  Search among invoice addresses  */
  BillingMsSearchAddresses: BillingMsSearchAddressesResponse;
  /**  Get account preferences related to the billing domain  */
  BillingMsSearchBillingAccountPreferences: BillingMsSearchBillingAccountPreferencesResponse;
  /**  Search among billing frequencies  */
  BillingMsSearchBillingFrequencies: BillingMsSearchBillingFrequenciesResponse;
  BillingMsSearchBillingFrequencyHistory: BillingMsSearchBillingFrequencyHistoryResponse;
  /**  Search customer billing period for invoice  */
  BillingMsSearchBillingPeriodLinks: BillingMsSearchBillingPeriodLinksResponse;
  /**  Search billing period for invoice  */
  BillingMsSearchBillingPeriods: BillingMsSearchBillingPeriodsResponse;
  /**  Search customer billing period for invoice  */
  BillingMsSearchCustomerBillingPeriods: BillingMsSearchCustomerBillingPeriodsResponse;
  /**  Search among customer credit frequencies  */
  BillingMsSearchCustomerCreditFrequencies: BillingMsSearchCustomerCreditFrequenciesResponse;
  /**  Search Delegate billing period for invoice  */
  BillingMsSearchDelegateBillingPeriods: BillingMsSearchDelegateBillingPeriodsResponse;
  /**  Search invoice documents  */
  BillingMsSearchInvoiceDocuments: BillingMsSearchInvoiceDocumentsResponse;
  /**
   *  Search among invoice lines
   *
   * The invoice lines show the transaction that haven't been paired yet. If you wish to list the transactions of the
   * related invoice, please use the transactions search endpoint.
   */
  BillingMsSearchInvoiceLines: BillingMsSearchInvoiceLinesResponse;
  BillingMsSearchInvoiceTransactionDocumentOrders: BillingMsSearchInvoiceTransactionDocumentOrdersResponse;
  /**  Search among invoice types  */
  BillingMsSearchInvoiceTypes: BillingMsSearchInvoiceTypesResponse;
  /**  Search among Invoices  */
  BillingMsSearchInvoices: BillingMsSearchInvoicesResponse;
  /**  Search payer billing period for invoice  */
  BillingMsSearchPayerBillingPeriods: BillingMsSearchPayerBillingPeriodsResponse;
  /**  Search among payment documents  */
  BillingMsSearchPaymentDocuments: BillingMsSearchPaymentDocumentsResponse;
  /**  Search among payment methods  */
  BillingMsSearchPaymentMethods: BillingMsSearchPaymentMethodsResponse;
  /**  Search among payments  */
  BillingMsSearchPayments: BillingMsSearchPaymentsResponse;
  /**  Search for TID Delivery Configurations based on filter (Account IDs)  */
  BillingMsSearchTidDeliveryConfig: BillingMsSearchTidDeliveryConfigResponse;
  /**  Search tid linked account types  */
  BillingMsSearchTidLinkedAccountTypes: BillingMsSearchTidLinkedAccountTypesResponse;
  /**  Search for tid linked accounts  */
  BillingMsSearchTidLinkedAccounts: BillingMsSearchTidLinkedAccountsResponse;
  BillingMsSearchTidOrders: BillingMsSearchTidOrdersResponse;
  BillingMsSearchTidType: BillingMsSearchTidTypeResponse;
  /**  Search among Tids  */
  BillingMsSearchTids: BillingMsSearchTidsResponse;
  /**  Count collaborators by status  */
  CollaboratorsMsCountCollaboratorsByStatus: CollaboratorsMsCountCollaboratorsByStatusResponse;
  /**  Count collaborators in sector  */
  CollaboratorsMsCountCollaboratorsInSector: CollaboratorsMsCountCollaboratorsInSectorResponse;
  /**  Search among collaborators  */
  CollaboratorsMsSearchCollaborators: CollaboratorsMsSearchCollaboratorsResponse;
  CollaboratorsMsSearchDriverCodeAllocations: CollaboratorsMsSearchDriverCodeAllocationsResponse;
  CollaboratorsMsSearchDriverCodes: CollaboratorsMsSearchDriverCodesResponse;
  CollaboratorsMsSuggestDriverCode: CollaboratorsMsSuggestDriverCodeResponse;
  /**  Check if ledger with duplicata can be blocked  */
  LedgersMsBlockLedgerOptions: LedgersMsBlockLedgerOptionsResponse;
  /**  Count the ledgers by status  */
  LedgersMsCountLedgersByStatus: LedgersMsCountLedgersByStatusResponse;
  /**  Count ledgers in sector  */
  LedgersMsCountLedgersInSector: LedgersMsCountLedgersInSectorResponse;
  /**  Count the orders by status  */
  LedgersMsCountOrdersByStatus: LedgersMsCountOrdersByStatusResponse;
  /**  Count the transactions by state  */
  LedgersMsCountTransactionsByState: LedgersMsCountTransactionsByStateResponse;
  /**  Retrieve the creation form to start the division creation process  */
  LedgersMsGetDivisionCreationTemplate: LedgersMsGetDivisionCreationTemplateResponse;
  /**  Retrieve the modification form to start the division modification process  */
  LedgersMsGetDivisionModificationTemplate: LedgersMsGetDivisionModificationTemplateResponse;
  /**  Provides with the CardPro division structure in order to modify a ledger.  */
  LedgersMsGetDivisions: LedgersMsGetDivisionsResponse;
  /**  Get Geographic Areas  */
  LedgersMsGetGeographicAreas: LedgersMsGetGeographicAreasResponse;
  /**  fetch the ledger creation template for a createCopy  */
  LedgersMsGetLedgerCopyCreationData: LedgersMsGetLedgerCopyCreationDataResponse;
  /**  Fetch the creation data used for the ledger creation.  */
  LedgersMsGetLedgerCreationData: LedgersMsGetLedgerCreationDataResponse;
  /**  Fetch the raw data of a ledger.  */
  LedgersMsGetLedgerData: LedgersMsGetLedgerDataResponse;
  /**  Retrieve ledger data (converts raw json ledger data to object representation)  */
  LedgersMsGetLedgerDataV2: LedgersMsGetLedgerDataV2Response;
  /**  Fetch the modification data used for the modification of ledger  */
  LedgersMsGetLedgerModificationData: LedgersMsGetLedgerModificationDataResponse;
  /**  Get ledger with complementary information  */
  LedgersMsGetLedgerWithDetails: LedgersMsGetLedgerWithDetailsResponse;
  /**
   *  Fetch the list of creatable ledger types.
   * List all orderable ledger types for the current user on the given wallet.
   */
  LedgersMsGetOrderableWalletLedgerTypes: LedgersMsGetOrderableWalletLedgerTypesResponse;
  /**  Fetch the PIN type of a ledger.  */
  LedgersMsGetPinType: LedgersMsGetPinTypeResponse;
  /**  Provides with the CardPro support & division account structure in order to create a ledger.  */
  LedgersMsGetSupportsAndDivisions: LedgersMsGetSupportsAndDivisionsResponse;
  /**  Provides with the supports for a specific account number  */
  LedgersMsGetSupportsFromAccount: LedgersMsGetSupportsFromAccountResponse;
  /**  Get transaction's amounts stats.  */
  LedgersMsGetTransactionAmounts: LedgersMsGetTransactionAmountsResponse;
  /**  Retrieve vehicle declaration form from middle  */
  LedgersMsGetVehicleDeclarationForm: LedgersMsGetVehicleDeclarationFormResponse;
  /**  Return the whole wallet tree of the current account  */
  LedgersMsGetWalletTree: LedgersMsGetWalletTreeResponse;
  /**  List all countries. Required for PriceCeilingReport  */
  LedgersMsListCountries: LedgersMsListCountriesResponse;
  /**  List all fuel codes. Required for PriceCeilingReport  */
  LedgersMsListFuelCodes: LedgersMsListFuelCodesResponse;
  /**  Get informations for report codes  */
  LedgersMsListReportTypes: LedgersMsListReportTypesResponse;
  /**  Search error  */
  LedgersMsSearchErrorCode: LedgersMsSearchErrorCodeResponse;
  LedgersMsSearchGroups: LedgersMsSearchGroupsResponse;
  /**  Search ledger quota usage  */
  LedgersMsSearchLedgerQuotaUsage: LedgersMsSearchLedgerQuotaUsageResponse;
  /**  Search among ledgers  */
  LedgersMsSearchLedgers: LedgersMsSearchLedgersResponse;
  /**  Get account preferences related to the ledgers domain  */
  LedgersMsSearchLedgersAccountPreferences: LedgersMsSearchLedgersAccountPreferencesResponse;
  /**  Search orderTemplate  */
  LedgersMsSearchOrderTemplate: LedgersMsSearchOrderTemplateResponse;
  /**  Search among orders  */
  LedgersMsSearchOrders: LedgersMsSearchOrdersResponse;
  /**  Search product categories  */
  LedgersMsSearchProductCategories: LedgersMsSearchProductCategoriesResponse;
  /**  Search product family  */
  LedgersMsSearchProductFamilies: LedgersMsSearchProductFamiliesResponse;
  /**  Search product  */
  LedgersMsSearchProducts: LedgersMsSearchProductsResponse;
  /**  Search ledger statuses  */
  LedgersMsSearchStatuses: LedgersMsSearchStatusesResponse;
  /**  Search among transactions  */
  LedgersMsSearchTransactions: LedgersMsSearchTransactionsResponse;
  /**  Search ledger types  */
  LedgersMsSearchTypes: LedgersMsSearchTypesResponse;
  /**  Fetch wallet settings  */
  LedgersMsSearchWalletSettings: LedgersMsSearchWalletSettingsResponse;
  /**  Search among wallets  */
  LedgersMsSearchWallets: LedgersMsSearchWalletsResponse;
  /**  Verify if division code is unique  */
  LedgersMsVerifyDivisionCode: LedgersMsVerifyDivisionCodeResponse;
  /**  check if shortcode exist for wallet  */
  LedgersMsVerifyShortCode: LedgersMsVerifyShortCodeResponse;
  LedgersMsgetLedgerStatisticByType: LedgersMsgetLedgerStatisticByTypeResponse;
  /**  Search among document types  */
  MediaMsSearchDocumentTypes: MediaMsSearchDocumentTypesResponse;
  /**  Search among documents  */
  MediaMsSearchDocuments: MediaMsSearchDocumentsResponse;
  /**  Search among capital statements (FR: relevé de capitalisation)  */
  MediaMsSearchEndOfYearStatementDocuments: MediaMsSearchEndOfYearStatementDocumentsResponse;
  /**  Get account preferences related to the media domain  */
  MediaMsSearchMediaAccountPreferences: MediaMsSearchMediaAccountPreferencesResponse;
  /**  Search among tokens  */
  MediaMsSearchTokens: MediaMsSearchTokensResponse;
  /**  Build the accounts migration report  */
  MiddleMsBuildAccountsMigrationReport: MiddleMsBuildAccountsMigrationReportResponse;
  /**  Retrieve the global ingestion state information  */
  MiddleMsGetIngestionSnapshot: MiddleMsGetIngestionSnapshotResponse;
  /**  Retrieve ledger data (converts raw json ledger data to object representation)  */
  MiddleMsGetLedgerDataV2: MiddleMsGetLedgerDataV2Response;
  MiddleMsGetPartnerToSubmitExpenses: MiddleMsGetPartnerToSubmitExpensesResponse;
  MiddleMsGetPassAlertRedirectionForm: MiddleMsGetPassAlertRedirectionFormResponse;
  MiddleMsGetSvaRedirectionForm: MiddleMsGetSvaRedirectionFormResponse;
  /**  Search among bulk operation items  */
  MiddleMsSearchBulkOperationItems: MiddleMsSearchBulkOperationItemsResponse;
  /**  Search among bulk operation types (kinds)  */
  MiddleMsSearchBulkOperationTypes: MiddleMsSearchBulkOperationTypesResponse;
  /**  Search among bulk operations  */
  MiddleMsSearchBulkOperations: MiddleMsSearchBulkOperationsResponse;
  /**  Search among form data rules  */
  MiddleMsSearchFormDataRuleGroups: MiddleMsSearchFormDataRuleGroupsResponse;
  /**  Get account preferences related to the middle domain  */
  MiddleMsSearchMiddleAccountPreferences: MiddleMsSearchMiddleAccountPreferencesResponse;
  /**  Search among queryTrackerChunks  */
  MiddleMsSearchQueryTrackerChunks: MiddleMsSearchQueryTrackerChunksResponse;
  /**  Search among queryTrackers  */
  MiddleMsSearchQueryTrackers: MiddleMsSearchQueryTrackersResponse;
  /**  Search among query types  */
  MiddleMsSearchQueryTypes: MiddleMsSearchQueryTypesResponse;
  /**  Search resync History  */
  MiddleMsSearchResynchronisationHistory: MiddleMsSearchResynchronisationHistoryResponse;
  /**  Get subscriptions related to current user  */
  NotificationsMsGetMySubscriptions: NotificationsMsGetMySubscriptionsResponse;
  /**  Search among messages  */
  NotificationsMsSearchMessages: NotificationsMsSearchMessagesResponse;
  /**  Search among messages documents  */
  NotificationsMsSearchNotificationDocuments: NotificationsMsSearchNotificationDocumentsResponse;
  /**  Search among notification types  */
  NotificationsMsSearchNotificationTypes: NotificationsMsSearchNotificationTypesResponse;
  /**  Search among notifications  */
  NotificationsMsSearchNotifications: NotificationsMsSearchNotificationsResponse;
  /**  Get account preferences related to the notifications domain  */
  NotificationsMsSearchNotificationsAccountPreferences: NotificationsMsSearchNotificationsAccountPreferencesResponse;
  /**  Get account preferences related to the notifications domain  */
  NotificationsMsSearchRecipients: NotificationsMsSearchRecipientsResponse;
  /**  Search among notifications  */
  NotificationsMsSearchSubscriptions: NotificationsMsSearchSubscriptionsResponse;
  /**  Search among triggers  */
  NotificationsMsSearchTriggers: NotificationsMsSearchTriggersResponse;
  RemotechargingMsGetPreAuthAmountInOrderToCharge: RemotechargingMsGetPreAuthAmountInOrderToChargeResponse;
  RemotechargingMsSearchChargingSessions: RemotechargingMsSearchChargingSessionsResponse;
  /**  Count reports.  */
  ReportingMsCountReports: ReportingMsCountReportsResponse;
  /**  Count tasks.  */
  ReportingMsCountTasks: ReportingMsCountTasksResponse;
  /**  Fetch user's KPI  */
  ReportingMsGetKpis: ReportingMsGetKpisResponse;
  /**  Get information for report codes  */
  ReportingMsListReportTypes: ReportingMsListReportTypesResponse;
  /**  Search among report plan.  */
  ReportingMsSearchReportPlans: ReportingMsSearchReportPlansResponse;
  ReportingMsSearchReportTypes: ReportingMsSearchReportTypesResponse;
  /**  Search among reports.  */
  ReportingMsSearchReports: ReportingMsSearchReportsResponse;
  /**  Search among tasks.  */
  ReportingMsSearchTasks: ReportingMsSearchTasksResponse;
  /**  Get a sector by id  */
  SectorsMsSearchSectors: SectorsMsSearchSectorsResponse;
  /**  Get tax exemption quota usage (diplomats only).  */
  TransactionsMsGetMyTaxExemptionQuotaUsage: TransactionsMsGetMyTaxExemptionQuotaUsageResponse;
  /**  Search expenses  */
  TransactionsMsSearchExpenses: TransactionsMsSearchExpensesResponse;
  /**  Search among product categories  */
  TransactionsMsSearchProductCategories: TransactionsMsSearchProductCategoriesResponse;
  /**  Search among transactions  */
  TransactionsMsSearchTransactions: TransactionsMsSearchTransactionsResponse;
  /**  Get account preferences related to the transactions domain  */
  TransactionsMsSearchTransactionsAccountPreferences: TransactionsMsSearchTransactionsAccountPreferencesResponse;
  /**  Search used balance  */
  TransactionsMsSearchUniversalUsedBalance: TransactionsMsSearchUniversalUsedBalanceResponse;
  /**  Check the vehicle identification (license plate format or VIN)  */
  VehiclesMsCheckIdentification: VehiclesMsCheckIdentificationResponse;
  /**  Count vehicles by status  */
  VehiclesMsCountVehiclesByStatus: VehiclesMsCountVehiclesByStatusResponse;
  /**  Count vehicles in sector  */
  VehiclesMsCountVehiclesInSector: VehiclesMsCountVehiclesInSectorResponse;
  /**  Search among mileage records  */
  VehiclesMsSearchMileages: VehiclesMsSearchMileagesResponse;
  /**  Search among vehicles  */
  VehiclesMsSearchVehicles: VehiclesMsSearchVehiclesResponse;
  dummy?: Maybe<Scalars["String"]["output"]>;
};

export type QueryAccountsMsCountNumberOfSectorsArgs = {
  request?: InputMaybe<AccountsMsCountNumberOfSectorsRequest>;
};

export type QueryAccountsMsCountSupportUsersByStatusArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryAccountsMsCountUsersByStatusArgs = {
  request?: InputMaybe<AccountsMsCountUsersByStatusRequest>;
};

export type QueryAccountsMsCountUsersInRolesProfileArgs = {
  request?: InputMaybe<AccountsMsCountUsersInRolesProfileRequest>;
};

export type QueryAccountsMsCountUsersInSectorArgs = {
  request?: InputMaybe<AccountsMsCountUsersInSectorRequest>;
};

export type QueryAccountsMsForwardIdentityArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryAccountsMsGetOwnerArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryAccountsMsGetRolesGridArgs = {
  request?: InputMaybe<AccountsMsGetRolesGridRequest>;
};

export type QueryAccountsMsListRolesArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryAccountsMsMeArgs = {
  request?: InputMaybe<AccountsMsMeRequest>;
};

export type QueryAccountsMsReadRolesProfileArgs = {
  request?: InputMaybe<AccountsMsReadRolesProfileRequest>;
};

export type QueryAccountsMsSearchAccountsArgs = {
  request?: InputMaybe<AccountsMsSearchAccountsRequest>;
};

export type QueryAccountsMsSearchAgenciesArgs = {
  request?: InputMaybe<AccountsMsSearchAgenciesRequest>;
};

export type QueryAccountsMsSearchAuditLogsArgs = {
  request?: InputMaybe<AccountsMsSearchAuditLogsRequest>;
};

export type QueryAccountsMsSearchContractsArgs = {
  request?: InputMaybe<AccountsMsSearchContractsRequest>;
};

export type QueryAccountsMsSearchOwnPrivilegesArgs = {
  request?: InputMaybe<AccountsMsSearchOwnPrivilegesRequest>;
};

export type QueryAccountsMsSearchPlatformAccessesArgs = {
  request?: InputMaybe<AccountsMsSearchPlatformAccessesRequest>;
};

export type QueryAccountsMsSearchPrivilegeRestrictionsArgs = {
  request?: InputMaybe<AccountsMsSearchPrivilegeRestrictionsRequest>;
};

export type QueryAccountsMsSearchPrivilegeSubscriptionsArgs = {
  request?: InputMaybe<AccountsMsSearchPrivilegeSubscriptionsRequest>;
};

export type QueryAccountsMsSearchPrivilegesArgs = {
  request?: InputMaybe<AccountsMsSearchPrivilegesRequest>;
};

export type QueryAccountsMsSearchRolesProfilesArgs = {
  request?: InputMaybe<AccountsMsSearchRolesProfilesRequest>;
};

export type QueryAccountsMsSearchSupportUsersArgs = {
  request?: InputMaybe<AccountsMsSearchSupportUsersRequest>;
};

export type QueryAccountsMsSearchUsersArgs = {
  request?: InputMaybe<AccountsMsSearchUsersRequest>;
};

export type QueryAssignmentsMsCountAssignmentsByStatusArgs = {
  request?: InputMaybe<AssignmentsMsCountAssignmentsByStatusRequest>;
};

export type QueryAssignmentsMsIsCollaboratorAssignmentAvailableArgs = {
  request?: InputMaybe<AssignmentsMsIsCollaboratorAssignmentAvailableRequest>;
};

export type QueryAssignmentsMsSearchCollaboratorAssignmentsArgs = {
  request?: InputMaybe<AssignmentsMsSearchCollaboratorAssignmentsRequest>;
};

export type QueryAssignmentsMsSearchVehicleAssignmentsArgs = {
  request?: InputMaybe<AssignmentsMsSearchVehicleAssignmentsRequest>;
};

export type QueryBillingMsGetAccountsLinkableToTidArgs = {
  request?: InputMaybe<BillingMsGetAccountsLinkableToTidRequest>;
};

export type QueryBillingMsGetActiveGuaranteePaymentArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryBillingMsGetCustomerCreditStateArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryBillingMsGetLastInvoiceArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryBillingMsListOpenPaymentDocumentsArgs = {
  request?: InputMaybe<BillingMsListOpenPaymentDocumentsRequest>;
};

export type QueryBillingMsSearchAddressesArgs = {
  request?: InputMaybe<BillingMsSearchAddressesRequest>;
};

export type QueryBillingMsSearchBillingAccountPreferencesArgs = {
  request?: InputMaybe<BillingMsSearchBillingAccountPreferencesRequest>;
};

export type QueryBillingMsSearchBillingFrequenciesArgs = {
  request?: InputMaybe<BillingMsSearchBillingFrequenciesRequest>;
};

export type QueryBillingMsSearchBillingFrequencyHistoryArgs = {
  request?: InputMaybe<BillingMsSearchBillingFrequencyHistoryRequest>;
};

export type QueryBillingMsSearchBillingPeriodLinksArgs = {
  request?: InputMaybe<BillingMsSearchBillingPeriodLinksRequest>;
};

export type QueryBillingMsSearchBillingPeriodsArgs = {
  request?: InputMaybe<BillingMsSearchBillingPeriodsRequest>;
};

export type QueryBillingMsSearchCustomerBillingPeriodsArgs = {
  request?: InputMaybe<BillingMsSearchCustomerBillingPeriodsRequest>;
};

export type QueryBillingMsSearchCustomerCreditFrequenciesArgs = {
  request?: InputMaybe<BillingMsSearchCustomerCreditFrequenciesRequest>;
};

export type QueryBillingMsSearchDelegateBillingPeriodsArgs = {
  request?: InputMaybe<BillingMsSearchDelegateBillingPeriodsRequest>;
};

export type QueryBillingMsSearchInvoiceDocumentsArgs = {
  request?: InputMaybe<BillingMsSearchInvoiceDocumentsRequest>;
};

export type QueryBillingMsSearchInvoiceLinesArgs = {
  request?: InputMaybe<BillingMsSearchInvoiceLinesRequest>;
};

export type QueryBillingMsSearchInvoiceTransactionDocumentOrdersArgs = {
  request?: InputMaybe<BillingMsSearchInvoiceTransactionDocumentOrdersRequest>;
};

export type QueryBillingMsSearchInvoiceTypesArgs = {
  request?: InputMaybe<BillingMsSearchInvoiceTypesRequest>;
};

export type QueryBillingMsSearchInvoicesArgs = {
  request?: InputMaybe<BillingMsSearchInvoicesRequest>;
};

export type QueryBillingMsSearchPayerBillingPeriodsArgs = {
  request?: InputMaybe<BillingMsSearchPayerBillingPeriodsRequest>;
};

export type QueryBillingMsSearchPaymentDocumentsArgs = {
  request?: InputMaybe<BillingMsSearchPaymentDocumentsRequest>;
};

export type QueryBillingMsSearchPaymentMethodsArgs = {
  request?: InputMaybe<BillingMsSearchPaymentMethodsRequest>;
};

export type QueryBillingMsSearchPaymentsArgs = {
  request?: InputMaybe<BillingMsSearchPaymentsRequest>;
};

export type QueryBillingMsSearchTidDeliveryConfigArgs = {
  request?: InputMaybe<BillingMsSearchTidDeliveryConfigRequest>;
};

export type QueryBillingMsSearchTidLinkedAccountTypesArgs = {
  request?: InputMaybe<BillingMsSearchTidLinkedAccountTypesRequest>;
};

export type QueryBillingMsSearchTidLinkedAccountsArgs = {
  request?: InputMaybe<BillingMsSearchTidLinkedAccountsRequest>;
};

export type QueryBillingMsSearchTidOrdersArgs = {
  request?: InputMaybe<BillingMsSearchTidOrdersRequest>;
};

export type QueryBillingMsSearchTidTypeArgs = {
  request?: InputMaybe<BillingMsSearchTidTypeRequest>;
};

export type QueryBillingMsSearchTidsArgs = {
  request?: InputMaybe<BillingMsSearchTidsRequest>;
};

export type QueryCollaboratorsMsCountCollaboratorsByStatusArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryCollaboratorsMsCountCollaboratorsInSectorArgs = {
  request?: InputMaybe<CollaboratorsMsCountCollaboratorsInSectorRequest>;
};

export type QueryCollaboratorsMsSearchCollaboratorsArgs = {
  request?: InputMaybe<CollaboratorsMsSearchCollaboratorsRequest>;
};

export type QueryCollaboratorsMsSearchDriverCodeAllocationsArgs = {
  request?: InputMaybe<CollaboratorsMsSearchDriverCodeAllocationsRequest>;
};

export type QueryCollaboratorsMsSearchDriverCodesArgs = {
  request?: InputMaybe<CollaboratorsMsSearchDriverCodesRequest>;
};

export type QueryCollaboratorsMsSuggestDriverCodeArgs = {
  request?: InputMaybe<CollaboratorsMsSuggestDriverCodeRequest>;
};

export type QueryLedgersMsBlockLedgerOptionsArgs = {
  request?: InputMaybe<LedgersMsBlockLedgerOptionsRequest>;
};

export type QueryLedgersMsCountLedgersByStatusArgs = {
  request?: InputMaybe<LedgersMsCountLedgersByStatusRequest>;
};

export type QueryLedgersMsCountLedgersInSectorArgs = {
  request?: InputMaybe<LedgersMsCountLedgersInSectorRequest>;
};

export type QueryLedgersMsCountOrdersByStatusArgs = {
  request?: InputMaybe<LedgersMsCountOrdersByStatusRequest>;
};

export type QueryLedgersMsCountTransactionsByStateArgs = {
  request?: InputMaybe<LedgersMsCountTransactionsByStateRequest>;
};

export type QueryLedgersMsGetDivisionCreationTemplateArgs = {
  request?: InputMaybe<LedgersMsGetDivisionCreationTemplateRequest>;
};

export type QueryLedgersMsGetDivisionModificationTemplateArgs = {
  request?: InputMaybe<LedgersMsGetDivisionModificationTemplateRequest>;
};

export type QueryLedgersMsGetDivisionsArgs = {
  request?: InputMaybe<LedgersMsGetDivisionsRequest>;
};

export type QueryLedgersMsGetGeographicAreasArgs = {
  request?: InputMaybe<LedgersMsGetGeographicAreasRequest>;
};

export type QueryLedgersMsGetLedgerCopyCreationDataArgs = {
  request?: InputMaybe<LedgersMsGetLedgerCopyCreationDataRequest>;
};

export type QueryLedgersMsGetLedgerCreationDataArgs = {
  request?: InputMaybe<LedgersMsGetLedgerCreationDataRequest>;
};

export type QueryLedgersMsGetLedgerDataArgs = {
  request?: InputMaybe<LedgersMsGetLedgerDataRequest>;
};

export type QueryLedgersMsGetLedgerDataV2Args = {
  request?: InputMaybe<LedgersMsGetLedgerDataV2Request>;
};

export type QueryLedgersMsGetLedgerModificationDataArgs = {
  request?: InputMaybe<LedgersMsGetLedgerModificationDataRequest>;
};

export type QueryLedgersMsGetLedgerWithDetailsArgs = {
  request?: InputMaybe<LedgersMsGetLedgerWithDetailsRequest>;
};

export type QueryLedgersMsGetOrderableWalletLedgerTypesArgs = {
  request?: InputMaybe<LedgersMsGetOrderableWalletLedgerTypesRequest>;
};

export type QueryLedgersMsGetPinTypeArgs = {
  request?: InputMaybe<LedgersMsGetPinTypeRequest>;
};

export type QueryLedgersMsGetSupportsAndDivisionsArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryLedgersMsGetSupportsFromAccountArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryLedgersMsGetTransactionAmountsArgs = {
  request?: InputMaybe<LedgersMsGetTransactionAmountsRequest>;
};

export type QueryLedgersMsGetVehicleDeclarationFormArgs = {
  request?: InputMaybe<LedgersMsGetVehicleDeclarationFormRequest>;
};

export type QueryLedgersMsGetWalletTreeArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryLedgersMsListCountriesArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryLedgersMsListFuelCodesArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryLedgersMsListReportTypesArgs = {
  request?: InputMaybe<LedgersMsListReportTypesRequest>;
};

export type QueryLedgersMsSearchErrorCodeArgs = {
  request?: InputMaybe<LedgersMsSearchErrorCodeRequest>;
};

export type QueryLedgersMsSearchGroupsArgs = {
  request?: InputMaybe<LedgersMsSearchGroupsRequest>;
};

export type QueryLedgersMsSearchLedgerQuotaUsageArgs = {
  request?: InputMaybe<LedgersMsSearchLedgerQuotaUsageRequest>;
};

export type QueryLedgersMsSearchLedgersArgs = {
  request?: InputMaybe<LedgersMsSearchLedgersRequest>;
};

export type QueryLedgersMsSearchLedgersAccountPreferencesArgs = {
  request?: InputMaybe<LedgersMsSearchLedgersAccountPreferencesRequest>;
};

export type QueryLedgersMsSearchOrderTemplateArgs = {
  request?: InputMaybe<LedgersMsSearchOrderTemplateRequest>;
};

export type QueryLedgersMsSearchOrdersArgs = {
  request?: InputMaybe<LedgersMsSearchOrdersRequest>;
};

export type QueryLedgersMsSearchProductCategoriesArgs = {
  request?: InputMaybe<LedgersMsSearchProductCategoriesRequest>;
};

export type QueryLedgersMsSearchProductFamiliesArgs = {
  request?: InputMaybe<LedgersMsSearchProductFamiliesRequest>;
};

export type QueryLedgersMsSearchProductsArgs = {
  request?: InputMaybe<LedgersMsSearchProductsRequest>;
};

export type QueryLedgersMsSearchStatusesArgs = {
  request?: InputMaybe<LedgersMsSearchStatusesRequest>;
};

export type QueryLedgersMsSearchTransactionsArgs = {
  request?: InputMaybe<LedgersMsSearchTransactionsRequest>;
};

export type QueryLedgersMsSearchTypesArgs = {
  request?: InputMaybe<LedgersMsSearchTypesRequest>;
};

export type QueryLedgersMsSearchWalletSettingsArgs = {
  request?: InputMaybe<LedgersMsSearchWalletSettingsRequest>;
};

export type QueryLedgersMsSearchWalletsArgs = {
  request?: InputMaybe<LedgersMsSearchWalletsRequest>;
};

export type QueryLedgersMsVerifyDivisionCodeArgs = {
  request?: InputMaybe<LedgersMsVerifyDivisionCodeRequest>;
};

export type QueryLedgersMsVerifyShortCodeArgs = {
  request?: InputMaybe<LedgersMsVerifyShortCodeRequest>;
};

export type QueryLedgersMsgetLedgerStatisticByTypeArgs = {
  request?: InputMaybe<LedgersMsgetLedgerStatisticByTypeRequest>;
};

export type QueryMediaMsSearchDocumentTypesArgs = {
  request?: InputMaybe<MediaMsSearchDocumentTypesRequest>;
};

export type QueryMediaMsSearchDocumentsArgs = {
  request?: InputMaybe<MediaMsSearchDocumentsRequest>;
};

export type QueryMediaMsSearchEndOfYearStatementDocumentsArgs = {
  request?: InputMaybe<MediaMsSearchEndOfYearStatementDocumentsRequest>;
};

export type QueryMediaMsSearchMediaAccountPreferencesArgs = {
  request?: InputMaybe<MediaMsSearchMediaAccountPreferencesRequest>;
};

export type QueryMediaMsSearchTokensArgs = {
  request?: InputMaybe<MediaMsSearchTokensRequest>;
};

export type QueryMiddleMsBuildAccountsMigrationReportArgs = {
  request?: InputMaybe<MiddleMsBuildAccountsMigrationReportRequest>;
};

export type QueryMiddleMsGetIngestionSnapshotArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryMiddleMsGetLedgerDataV2Args = {
  request?: InputMaybe<MiddleMsGetLedgerDataV2Request>;
};

export type QueryMiddleMsGetPartnerToSubmitExpensesArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryMiddleMsGetPassAlertRedirectionFormArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryMiddleMsGetSvaRedirectionFormArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryMiddleMsSearchBulkOperationItemsArgs = {
  request?: InputMaybe<MiddleMsSearchBulkOperationItemsRequest>;
};

export type QueryMiddleMsSearchBulkOperationTypesArgs = {
  request?: InputMaybe<MiddleMsSearchBulkOperationTypesRequest>;
};

export type QueryMiddleMsSearchBulkOperationsArgs = {
  request?: InputMaybe<MiddleMsSearchBulkOperationsRequest>;
};

export type QueryMiddleMsSearchFormDataRuleGroupsArgs = {
  request?: InputMaybe<MiddleMsSearchFormDataRuleGroupsRequest>;
};

export type QueryMiddleMsSearchMiddleAccountPreferencesArgs = {
  request?: InputMaybe<MiddleMsSearchMiddleAccountPreferencesRequest>;
};

export type QueryMiddleMsSearchQueryTrackerChunksArgs = {
  request?: InputMaybe<MiddleMsSearchQueryTrackerChunksRequest>;
};

export type QueryMiddleMsSearchQueryTrackersArgs = {
  request?: InputMaybe<MiddleMsSearchQueryTrackersRequest>;
};

export type QueryMiddleMsSearchQueryTypesArgs = {
  request?: InputMaybe<MiddleMsSearchQueryTypesRequest>;
};

export type QueryMiddleMsSearchResynchronisationHistoryArgs = {
  request?: InputMaybe<MiddleMsSearchResynchronisationHistoryRequest>;
};

export type QueryNotificationsMsGetMySubscriptionsArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryNotificationsMsSearchMessagesArgs = {
  request?: InputMaybe<NotificationsMsSearchMessagesRequest>;
};

export type QueryNotificationsMsSearchNotificationDocumentsArgs = {
  request?: InputMaybe<NotificationsMsSearchNotificationDocumentsRequest>;
};

export type QueryNotificationsMsSearchNotificationTypesArgs = {
  request?: InputMaybe<NotificationsMsSearchNotificationTypesRequest>;
};

export type QueryNotificationsMsSearchNotificationsArgs = {
  request?: InputMaybe<NotificationsMsSearchNotificationsRequest>;
};

export type QueryNotificationsMsSearchNotificationsAccountPreferencesArgs = {
  request?: InputMaybe<NotificationsMsSearchNotificationsAccountPreferencesRequest>;
};

export type QueryNotificationsMsSearchRecipientsArgs = {
  request?: InputMaybe<NotificationsMsSearchRecipientsRequest>;
};

export type QueryNotificationsMsSearchSubscriptionsArgs = {
  request?: InputMaybe<NotificationsMsSearchSubscriptionsRequest>;
};

export type QueryNotificationsMsSearchTriggersArgs = {
  request?: InputMaybe<NotificationsMsSearchTriggersRequest>;
};

export type QueryRemotechargingMsGetPreAuthAmountInOrderToChargeArgs = {
  request?: InputMaybe<RemotechargingMsGetPreAuthAmountInOrderToChargeRequest>;
};

export type QueryRemotechargingMsSearchChargingSessionsArgs = {
  request?: InputMaybe<RemotechargingMsSearchChargingSessionsRequest>;
};

export type QueryReportingMsCountReportsArgs = {
  request?: InputMaybe<ReportingMsCountReportsRequest>;
};

export type QueryReportingMsCountTasksArgs = {
  request?: InputMaybe<ReportingMsCountTasksRequest>;
};

export type QueryReportingMsGetKpisArgs = {
  request?: InputMaybe<ReportingMsGetKpisRequest>;
};

export type QueryReportingMsListReportTypesArgs = {
  request?: InputMaybe<ReportingMsListReportTypesRequest>;
};

export type QueryReportingMsSearchReportPlansArgs = {
  request?: InputMaybe<ReportingMsSearchReportPlansRequest>;
};

export type QueryReportingMsSearchReportTypesArgs = {
  request?: InputMaybe<ReportingMsSearchReportTypesRequest>;
};

export type QueryReportingMsSearchReportsArgs = {
  request?: InputMaybe<ReportingMsSearchReportsRequest>;
};

export type QueryReportingMsSearchTasksArgs = {
  request?: InputMaybe<ReportingMsSearchTasksRequest>;
};

export type QuerySectorsMsSearchSectorsArgs = {
  request?: InputMaybe<SectorsMsSearchSectorsRequest>;
};

export type QueryTransactionsMsGetMyTaxExemptionQuotaUsageArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryTransactionsMsSearchExpensesArgs = {
  request?: InputMaybe<TransactionsMsSearchExpensesRequest>;
};

export type QueryTransactionsMsSearchProductCategoriesArgs = {
  request?: InputMaybe<TransactionsMsSearchProductCategoriesRequest>;
};

export type QueryTransactionsMsSearchTransactionsArgs = {
  request?: InputMaybe<TransactionsMsSearchTransactionsRequest>;
};

export type QueryTransactionsMsSearchTransactionsAccountPreferencesArgs = {
  request?: InputMaybe<TransactionsMsSearchTransactionsAccountPreferencesRequest>;
};

export type QueryTransactionsMsSearchUniversalUsedBalanceArgs = {
  request?: InputMaybe<TransactionsMsSearchUniversalUsedBalanceRequest>;
};

export type QueryVehiclesMsCheckIdentificationArgs = {
  request?: InputMaybe<VehiclesMsCheckIdentificationRequest>;
};

export type QueryVehiclesMsCountVehiclesByStatusArgs = {
  request?: InputMaybe<Scalars["Void"]["input"]>;
};

export type QueryVehiclesMsCountVehiclesInSectorArgs = {
  request?: InputMaybe<VehiclesMsCountVehiclesInSectorRequest>;
};

export type QueryVehiclesMsSearchMileagesArgs = {
  request?: InputMaybe<VehiclesMsSearchMileagesRequest>;
};

export type QueryVehiclesMsSearchVehiclesArgs = {
  request?: InputMaybe<VehiclesMsSearchVehiclesRequest>;
};

export type RemotechargingMsGetPreAuthAmountInOrderToChargeRequest = {
  networkId?: InputMaybe<Scalars["String"]["input"]>;
  vendorId?: InputMaybe<Scalars["String"]["input"]>;
};

export type RemotechargingMsGetPreAuthAmountInOrderToChargeResponse = {
  __typename?: "RemotechargingMsGetPreAuthAmountInOrderToChargeResponse";
  amount: Scalars["Float"]["output"];
  /**  ISO 4217  */
  currencyCode: Scalars["String"]["output"];
};

export type RemotechargingMsNotifyRequest = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  sessionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type RemotechargingMsOrderChargingSessionRequest = {
  /**  Otherwise, when guest, it must fulfill contact info.  */
  guest?: InputMaybe<RemotechargingMsOrderChargingSessionRequestGuest>;
  networkId?: InputMaybe<Scalars["String"]["input"]>;
  /**  When known by the system, a user can fulfill its payment card  */
  paymentCardId?: InputMaybe<Scalars["String"]["input"]>;
  subscribeToNewsletters?: InputMaybe<Scalars["Boolean"]["input"]>;
  vendorId?: InputMaybe<Scalars["String"]["input"]>;
};

/**  Otherwise, when guest, it must fulfill contact info.  */
export type RemotechargingMsOrderChargingSessionRequestGuest = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  sendReceiptByEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  sendTrackingCodeByEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RemotechargingMsOrderChargingSessionResponse = {
  __typename?: "RemotechargingMsOrderChargingSessionResponse";
  SessionIdData?: Maybe<RemotechargingMsSearchChargingSessionsResponseData>;
  /**  Form values for 3DS  */
  formValues: RemotechargingMsOrderChargingSessionResponseFormValues;
  /**  The URL in order to process the preauth if there is such  */
  preauthRedirectUrl: Scalars["String"]["output"];
  /**  The id of the initialized charging session  */
  sessionId: Scalars["ID"]["output"];
  /**  The human readable tracking code for guest session  */
  trackingCode: Scalars["String"]["output"];
};

/**  Form values for 3DS  */
export type RemotechargingMsOrderChargingSessionResponseFormValues = {
  __typename?: "RemotechargingMsOrderChargingSessionResponseFormValues";
  authenticateTransaction: Scalars["Boolean"]["output"];
  chargeTotal: Scalars["String"]["output"];
  checkoutOption: Scalars["String"]["output"];
  currency: Scalars["String"]["output"];
  formAction: Scalars["String"]["output"];
  hashAlgorithm: Scalars["String"]["output"];
  hashExtended: Scalars["String"]["output"];
  hostedDataId: Scalars["String"]["output"];
  hostedDataStoreId: Scalars["String"]["output"];
  oid: Scalars["String"]["output"];
  paymentMethod: Scalars["String"]["output"];
  storeName: Scalars["String"]["output"];
  timezone: Scalars["String"]["output"];
  transactionNotificationUrl: Scalars["String"]["output"];
  txnDatetime: Scalars["String"]["output"];
  txnType: Scalars["String"]["output"];
};

export type RemotechargingMsPagedPagination = {
  __typename?: "RemotechargingMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type RemotechargingMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RemotechargingMsSearchChargingSessionsRequest = {
  filters?: InputMaybe<RemotechargingMsSearchChargingSessionsRequestFilters>;
  paging?: InputMaybe<RemotechargingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<RemotechargingMsSearchChargingSessionsRequestSort>>
  >;
};

export type RemotechargingMsSearchChargingSessionsRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  paygoOrderRefs?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  trackingCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type RemotechargingMsSearchChargingSessionsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<RemotechargingMsSearchChargingSessionsRequestSortField>;
};

export enum RemotechargingMsSearchChargingSessionsRequestSortField {
  Id = "id",
  UpdatedTs = "updated_ts",
}

export type RemotechargingMsSearchChargingSessionsResponse = {
  __typename?: "RemotechargingMsSearchChargingSessionsResponse";
  data?: Maybe<Array<RemotechargingMsSearchChargingSessionsResponseData>>;
  pagination: RemotechargingMsPagedPagination;
};

export type RemotechargingMsSearchChargingSessionsResponseData = {
  __typename?: "RemotechargingMsSearchChargingSessionsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  IdData?: Maybe<RemotechargingMsSearchChargingSessionsResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  accountId: Scalars["ID"]["output"];
  createdTs: Scalars["Int64"]["output"];
  driverAccessId: Scalars["String"]["output"];
  guestId: Scalars["ID"]["output"];
  guestSessionTrackingCode: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  networkId: Scalars["String"]["output"];
  paygoOrderRef: Scalars["String"]["output"];
  paygoOrderStatus: Scalars["String"]["output"];
  updatedTs: Scalars["Int64"]["output"];
  userId: Scalars["ID"]["output"];
  /**  Paygo  */
  vendorId: Scalars["String"]["output"];
};

export type RemotechargingMsStartSessionRequest = {
  sessionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type RemotechargingMsUpdateChargingSessionOrderStatusRequest = {
  orderId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

/**  Count reports.  */
export type ReportingMsCountReportsRequest = {
  filters?: InputMaybe<ReportingMsCountReportsRequestFilters>;
};

export type ReportingMsCountReportsRequestFilters = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  status?: InputMaybe<
    Array<InputMaybe<ReportingMsCountReportsRequestFiltersStatus>>
  >;
};

export enum ReportingMsCountReportsRequestFiltersStatus {
  ReportAvailable = "REPORT_AVAILABLE",
  ReportError = "REPORT_ERROR",
  ReportNew = "REPORT_NEW",
  ReportPending = "REPORT_PENDING",
  UnknownReportStatus = "UNKNOWN_REPORT_STATUS",
}

export type ReportingMsCountReportsResponse = {
  __typename?: "ReportingMsCountReportsResponse";
  total: Scalars["Int64"]["output"];
};

/**  Count tasks.  */
export type ReportingMsCountTasksRequest = {
  filters?: InputMaybe<ReportingMsCountTasksRequestFilters>;
};

export type ReportingMsCountTasksRequestFilters = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  status?: InputMaybe<
    Array<InputMaybe<ReportingMsCountTasksRequestFiltersStatus>>
  >;
};

export enum ReportingMsCountTasksRequestFiltersStatus {
  Available = "AVAILABLE",
  Error = "ERROR",
  New = "NEW",
  Pending = "PENDING",
  UnknownStatus = "UNKNOWN_STATUS",
}

export type ReportingMsCountTasksResponse = {
  __typename?: "ReportingMsCountTasksResponse";
  total: Scalars["Int64"]["output"];
};

/**  Request the creation of a report plan based on a code and parameters.  */
export type ReportingMsCreateReportPlanRequest = {
  /**  How often a report is generated.  */
  frequency?: InputMaybe<ReportingMsCreateReportPlanRequestFrequency>;
  /**  The code that describes the type of the generated report.  */
  reportTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The id of the users that will be notified of the generated report.  */
  targetUserIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/**  How often a report is generated.  */
export enum ReportingMsCreateReportPlanRequestFrequency {
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
  UnknownFrequency = "UNKNOWN_FREQUENCY",
  Weekly = "WEEKLY",
}

export type ReportingMsCreateReportPlanResponse = {
  __typename?: "ReportingMsCreateReportPlanResponse";
  /**  The id of the created plan.  */
  reportPlanIds?: Maybe<Array<Scalars["ID"]["output"]>>;
};

/**  Request the creation of a report type  */
export type ReportingMsCreateReportTypeRequest = {
  /**  The code of a report  */
  code?: InputMaybe<ReportingMsCreateReportTypeRequestCode>;
  /**  Whether this version is the default one  */
  defaultVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  Whether the report type is enabled or not  */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  An exhaustive list of features to be able to access the report type.  */
  features?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /**  The report is available for all accounts or not  */
  isAllAccountsAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  The report is available for plan or not  */
  isPlanAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  An exhaustive list of roles to be able to access the report type.  */
  roles?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /**  The version of the report type  */
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  The code of a report  */
export enum ReportingMsCreateReportTypeRequestCode {
  AllTransactionsMobilityCorporate = "ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  ConsumptionMonitoring_100KmPerCard = "CONSUMPTION_MONITORING_100_KM_PER_CARD",
  DetailedEvTransactions = "DETAILED_EV_TRANSACTIONS",
  ExportBadge = "EXPORT_BADGE",
  ExportCard = "EXPORT_CARD",
  ExportDriverCode = "EXPORT_DRIVER_CODE",
  ExportStateCardAndBadge = "EXPORT_STATE_CARD_AND_BADGE",
  ExportTransaction = "EXPORT_TRANSACTION",
  HistoricReportKm = "HISTORIC_REPORT_KM",
  PriceCeiling = "PRICE_CEILING",
  ReportTest = "REPORT_TEST",
  ReportUnknown = "REPORT_UNKNOWN",
  Tid = "TID",
  TollPassages = "TOLL_PASSAGES",
  TrackingCardAndBadgeAndBudgetTracking = "TRACKING_CARD_AND_BADGE_AND_BUDGET_TRACKING",
  TransactionsFridayMonday = "TRANSACTIONS_FRIDAY_MONDAY",
  TransactionsWeekendHolidays = "TRANSACTIONS_WEEKEND_HOLIDAYS",
  TransactionAnomalies = "TRANSACTION_ANOMALIES",
  TransactionAnomalies_24 = "TRANSACTION_ANOMALIES_24",
  TruckPositions = "TRUCK_POSITIONS",
}

export type ReportingMsCreateReportTypeResponse = {
  __typename?: "ReportingMsCreateReportTypeResponse";
  id: Scalars["ID"]["output"];
};

/**  Remove a report plan.  */
export type ReportingMsDeleteReportPlanRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 *  Set expirationTs to now.
 * The current expirationTs should be null or future.
 * The reports should have an error status.
 */
export type ReportingMsExpireReportsRequest = {
  /**  The ids of the reports to update.  */
  reportIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/**  Request the generation of a report based on a code, type and parameters.  */
export type ReportingMsGenerateReportRequest = {
  /**  The code that describes the type of the requested report.  */
  code?: InputMaybe<ReportingMsGenerateReportRequestCode>;
  /**  The country code the datasource needs to provide data.  */
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  /**  The date the content of the report ends.  */
  endDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The id of a external reference like the DataLake.  */
  externalId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The fuel code the datasource needs to provide data.  */
  fuelCode?: InputMaybe<Scalars["String"]["input"]>;
  /**  The ledger id the datasource needs to filter data.  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The date the content of the report begins.  */
  startDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The type of report that contains information like the report code and the version.  */
  typeId?: InputMaybe<Scalars["ID"]["input"]>;
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**  The code that describes the type of the requested report.  */
export enum ReportingMsGenerateReportRequestCode {
  AllTransactionsMobilityCorporate = "ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  ConsumptionMonitoring_100KmPerCard = "CONSUMPTION_MONITORING_100_KM_PER_CARD",
  DetailedEvTransactions = "DETAILED_EV_TRANSACTIONS",
  ExportBadge = "EXPORT_BADGE",
  ExportCard = "EXPORT_CARD",
  ExportDriverCode = "EXPORT_DRIVER_CODE",
  ExportStateCardAndBadge = "EXPORT_STATE_CARD_AND_BADGE",
  ExportTransaction = "EXPORT_TRANSACTION",
  HistoricReportKm = "HISTORIC_REPORT_KM",
  PriceCeiling = "PRICE_CEILING",
  ReportTest = "REPORT_TEST",
  ReportUnknown = "REPORT_UNKNOWN",
  Tid = "TID",
  TollPassages = "TOLL_PASSAGES",
  TrackingCardAndBadgeAndBudgetTracking = "TRACKING_CARD_AND_BADGE_AND_BUDGET_TRACKING",
  TransactionsFridayMonday = "TRANSACTIONS_FRIDAY_MONDAY",
  TransactionsWeekendHolidays = "TRANSACTIONS_WEEKEND_HOLIDAYS",
  TransactionAnomalies = "TRANSACTION_ANOMALIES",
  TransactionAnomalies_24 = "TRANSACTION_ANOMALIES_24",
  TruckPositions = "TRUCK_POSITIONS",
}

export type ReportingMsGenerateReportResponse = {
  __typename?: "ReportingMsGenerateReportResponse";
  /**  The if of the requested report.  */
  reportId: Scalars["ID"]["output"];
  /**  The id of the task that handles the report. [DEPRECATED]  */
  taskId: Scalars["ID"]["output"];
};

/**  Fetch user's KPI  */
export type ReportingMsGetKpisRequest = {
  /**  The list of KPI. The number of KPI you can request at once is limited.  */
  kpis?: InputMaybe<Array<InputMaybe<ReportingMsGetKpisRequestKpi>>>;
  /**  The default filters apply to the kpis.  */
  parameters?: InputMaybe<ReportingMsGetKpisRequestParameters>;
};

/**  The list of KPI. The number of KPI you can request at once is limited.  */
export type ReportingMsGetKpisRequestKpi = {
  /**  The KPI code  */
  code?: InputMaybe<ReportingMsGetKpisRequestKpiCode>;
};

/**  The KPI code  */
export enum ReportingMsGetKpisRequestKpiCode {
  EvChargingAverageChargingFrequencyPerDay = "EV_CHARGING_AVERAGE_CHARGING_FREQUENCY_PER_DAY",
  EvChargingAverageChargingFrequencyPerWeek = "EV_CHARGING_AVERAGE_CHARGING_FREQUENCY_PER_WEEK",
  EvChargingAverageConsumptionInMonth = "EV_CHARGING_AVERAGE_CONSUMPTION_IN_MONTH",
  EvChargingAverageConsumptionPerDay = "EV_CHARGING_AVERAGE_CONSUMPTION_PER_DAY",
  EvChargingAverageCostPerDay = "EV_CHARGING_AVERAGE_COST_PER_DAY",
  EvChargingExpensesOfTheMonth = "EV_CHARGING_EXPENSES_OF_THE_MONTH",
  EvChargingNumberOfRechargesInMonth = "EV_CHARGING_NUMBER_OF_RECHARGES_IN_MONTH",
  EvChargingPowerConsumptionInMonth = "EV_CHARGING_POWER_CONSUMPTION_IN_MONTH",
  EvChargingPowerCostInMonth = "EV_CHARGING_POWER_COST_IN_MONTH",
  EvChargingRoamingPowerConsumptionInMonth = "EV_CHARGING_ROAMING_POWER_CONSUMPTION_IN_MONTH",
  EvChargingRoamingPowerCostInMonth = "EV_CHARGING_ROAMING_POWER_COST_IN_MONTH",
  EvChargingTotalCostOfChargingInMonth = "EV_CHARGING_TOTAL_COST_OF_CHARGING_IN_MONTH",
  EvVariationOfConsumptionWithPreviousMonth = "EV_VARIATION_OF_CONSUMPTION_WITH_PREVIOUS_MONTH",
  EvVariationOfCostWithPreviousMonth = "EV_VARIATION_OF_COST_WITH_PREVIOUS_MONTH",
  ExpensesOfTheMonth = "EXPENSES_OF_THE_MONTH",
  KpiPrune = "KPI_PRUNE",
  KpiUnknown = "KPI_UNKNOWN",
  TopExpensesOfTheMonth = "TOP_EXPENSES_OF_THE_MONTH",
  TotalAmountOfTransactionsInMonth = "TOTAL_AMOUNT_OF_TRANSACTIONS_IN_MONTH",
  TotalNumberOfTransactionsInMonth = "TOTAL_NUMBER_OF_TRANSACTIONS_IN_MONTH",
}

/**  The default filters apply to the kpis.  */
export type ReportingMsGetKpisRequestParameters = {
  /**
   *  The list of account ids to filter the kpis. If the list if empty, we fallback to the list of accounts where the
   * user has the capability to get KPIs.
   */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  The starting unix timestamp, it fallbacks to the 1st of the month.  */
  from?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The ending unix timestamp, it fallbacks to the current time.  */
  till?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type ReportingMsGetKpisResponse = {
  __typename?: "ReportingMsGetKpisResponse";
  /**  The list of KPI response, indexed by the requested KPI order.  */
  kpis?: Maybe<Array<ReportingMsGetKpisResponseKpi>>;
};

/**  The list of KPI response, indexed by the requested KPI order.  */
export type ReportingMsGetKpisResponseKpi = {
  __typename?: "ReportingMsGetKpisResponseKpi";
  /**  The KPI code  */
  code: ReportingMsGetKpisResponseKpiCode;
  /**  The KPI data  */
  data?: Maybe<Array<ReportingMsGetKpisResponseKpiData>>;
  /**  Set only when the given KPI has failed.  */
  failedReason: ReportingMsGetKpisResponseKpiFailedReason;
};

/**  The KPI code  */
export enum ReportingMsGetKpisResponseKpiCode {
  EvChargingAverageChargingFrequencyPerDay = "EV_CHARGING_AVERAGE_CHARGING_FREQUENCY_PER_DAY",
  EvChargingAverageChargingFrequencyPerWeek = "EV_CHARGING_AVERAGE_CHARGING_FREQUENCY_PER_WEEK",
  EvChargingAverageConsumptionInMonth = "EV_CHARGING_AVERAGE_CONSUMPTION_IN_MONTH",
  EvChargingAverageConsumptionPerDay = "EV_CHARGING_AVERAGE_CONSUMPTION_PER_DAY",
  EvChargingAverageCostPerDay = "EV_CHARGING_AVERAGE_COST_PER_DAY",
  EvChargingExpensesOfTheMonth = "EV_CHARGING_EXPENSES_OF_THE_MONTH",
  EvChargingNumberOfRechargesInMonth = "EV_CHARGING_NUMBER_OF_RECHARGES_IN_MONTH",
  EvChargingPowerConsumptionInMonth = "EV_CHARGING_POWER_CONSUMPTION_IN_MONTH",
  EvChargingPowerCostInMonth = "EV_CHARGING_POWER_COST_IN_MONTH",
  EvChargingRoamingPowerConsumptionInMonth = "EV_CHARGING_ROAMING_POWER_CONSUMPTION_IN_MONTH",
  EvChargingRoamingPowerCostInMonth = "EV_CHARGING_ROAMING_POWER_COST_IN_MONTH",
  EvChargingTotalCostOfChargingInMonth = "EV_CHARGING_TOTAL_COST_OF_CHARGING_IN_MONTH",
  EvVariationOfConsumptionWithPreviousMonth = "EV_VARIATION_OF_CONSUMPTION_WITH_PREVIOUS_MONTH",
  EvVariationOfCostWithPreviousMonth = "EV_VARIATION_OF_COST_WITH_PREVIOUS_MONTH",
  ExpensesOfTheMonth = "EXPENSES_OF_THE_MONTH",
  KpiPrune = "KPI_PRUNE",
  KpiUnknown = "KPI_UNKNOWN",
  TopExpensesOfTheMonth = "TOP_EXPENSES_OF_THE_MONTH",
  TotalAmountOfTransactionsInMonth = "TOTAL_AMOUNT_OF_TRANSACTIONS_IN_MONTH",
  TotalNumberOfTransactionsInMonth = "TOTAL_NUMBER_OF_TRANSACTIONS_IN_MONTH",
}

/**  The KPI data  */
export type ReportingMsGetKpisResponseKpiData = {
  __typename?: "ReportingMsGetKpisResponseKpiData";
  /**  An optional discriminator  */
  axis: Scalars["String"]["output"];
  /**  The unit of the value (ex: ['EUR', 'VAT_INCLUDED'])  */
  unit?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The datetime of the kpi update  */
  updatedAt: Scalars["Int64"]["output"];
  /**  The final value of the kpi data entry  */
  value: Scalars["String"]["output"];
  /**  The datetime of the kpi entry  */
  when: Scalars["Int64"]["output"];
};

/**  Set only when the given KPI has failed.  */
export enum ReportingMsGetKpisResponseKpiFailedReason {
  InvalidFormat = "INVALID_FORMAT",
  None = "NONE",
  Timeout = "TIMEOUT",
  Unimplemented = "UNIMPLEMENTED",
  UnknownFormat = "UNKNOWN_FORMAT",
}

/**  Get information for report codes  */
export type ReportingMsListReportTypesRequest = {
  filters?: InputMaybe<ReportingMsListReportTypesRequestFilters>;
};

export type ReportingMsListReportTypesRequestFilters = {
  /**  The report codes  */
  reportCodes?: InputMaybe<
    Array<InputMaybe<ReportingMsListReportTypesRequestFiltersReportCodes>>
  >;
};

/**  The report codes  */
export enum ReportingMsListReportTypesRequestFiltersReportCodes {
  AllTransactionsMobilityCorporate = "ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  ConsumptionMonitoring_100KmPerCard = "CONSUMPTION_MONITORING_100_KM_PER_CARD",
  DetailedEvTransactions = "DETAILED_EV_TRANSACTIONS",
  ExportBadge = "EXPORT_BADGE",
  ExportCard = "EXPORT_CARD",
  ExportDriverCode = "EXPORT_DRIVER_CODE",
  ExportStateCardAndBadge = "EXPORT_STATE_CARD_AND_BADGE",
  ExportTransaction = "EXPORT_TRANSACTION",
  HistoricReportKm = "HISTORIC_REPORT_KM",
  PriceCeiling = "PRICE_CEILING",
  ReportTest = "REPORT_TEST",
  ReportUnknown = "REPORT_UNKNOWN",
  Tid = "TID",
  TollPassages = "TOLL_PASSAGES",
  TrackingCardAndBadgeAndBudgetTracking = "TRACKING_CARD_AND_BADGE_AND_BUDGET_TRACKING",
  TransactionsFridayMonday = "TRANSACTIONS_FRIDAY_MONDAY",
  TransactionsWeekendHolidays = "TRANSACTIONS_WEEKEND_HOLIDAYS",
  TransactionAnomalies = "TRANSACTION_ANOMALIES",
  TransactionAnomalies_24 = "TRANSACTION_ANOMALIES_24",
  TruckPositions = "TRUCK_POSITIONS",
}

export type ReportingMsListReportTypesResponse = {
  __typename?: "ReportingMsListReportTypesResponse";
  /**  Report types detail  */
  data?: Maybe<Array<ReportingMsListReportTypesResponseReportTypeDetail>>;
};

/**  Report types detail  */
export type ReportingMsListReportTypesResponseReportTypeDetail = {
  __typename?: "ReportingMsListReportTypesResponseReportTypeDetail";
  /**  A report subscription can be planned for this report  */
  canBePlanned: Scalars["Boolean"]["output"];
  /**  Can export for all accounts (multi-pass)  */
  canExportAllAccounts: Scalars["Boolean"]["output"];
  /**  The count of involved accounts for the report code and the current user  */
  countOfInvolvedAccounts: Scalars["Int"]["output"];
  /**  Can generate the report  */
  isAuthorized: Scalars["Boolean"]["output"];
  /**  The report code  */
  reportCode: ReportingMsListReportTypesResponseReportTypeDetailReportCode;
  /**  The version list  */
  versions?: Maybe<
    Array<ReportingMsListReportTypesResponseReportTypeDetailReportTypeVersion>
  >;
};

/**  The report code  */
export enum ReportingMsListReportTypesResponseReportTypeDetailReportCode {
  AllTransactionsMobilityCorporate = "ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  ConsumptionMonitoring_100KmPerCard = "CONSUMPTION_MONITORING_100_KM_PER_CARD",
  DetailedEvTransactions = "DETAILED_EV_TRANSACTIONS",
  ExportBadge = "EXPORT_BADGE",
  ExportCard = "EXPORT_CARD",
  ExportDriverCode = "EXPORT_DRIVER_CODE",
  ExportStateCardAndBadge = "EXPORT_STATE_CARD_AND_BADGE",
  ExportTransaction = "EXPORT_TRANSACTION",
  HistoricReportKm = "HISTORIC_REPORT_KM",
  PriceCeiling = "PRICE_CEILING",
  ReportTest = "REPORT_TEST",
  ReportUnknown = "REPORT_UNKNOWN",
  Tid = "TID",
  TollPassages = "TOLL_PASSAGES",
  TrackingCardAndBadgeAndBudgetTracking = "TRACKING_CARD_AND_BADGE_AND_BUDGET_TRACKING",
  TransactionsFridayMonday = "TRANSACTIONS_FRIDAY_MONDAY",
  TransactionsWeekendHolidays = "TRANSACTIONS_WEEKEND_HOLIDAYS",
  TransactionAnomalies = "TRANSACTION_ANOMALIES",
  TransactionAnomalies_24 = "TRANSACTION_ANOMALIES_24",
  TruckPositions = "TRUCK_POSITIONS",
}

/**  The version list  */
export type ReportingMsListReportTypesResponseReportTypeDetailReportTypeVersion =
  {
    __typename?: "ReportingMsListReportTypesResponseReportTypeDetailReportTypeVersion";
    /**  Whether this version is the default one  */
    defaultVersion: Scalars["Boolean"]["output"];
    /**  The type id  */
    typeId: Scalars["ID"]["output"];
    /**  The version of the report type  */
    version: Scalars["Int"]["output"];
  };

export type ReportingMsPagedPagination = {
  __typename?: "ReportingMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type ReportingMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 *  Resume the report steps based on the current state.
 * If the report is just created and waiting for data, dispatch a ReportQueryEvent.
 * If the report has fetched data and is waiting for document, dispatch a GenerateDocumentEvent.
 * If the report has a generated document, call Notifications.
 */
export type ReportingMsRecoverReportsRequest = {
  /**  The ids of the reports to recover.  */
  reportIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/**  Request the statistics of reports.  */
export type ReportingMsReportStatisticsRequest = {
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type ReportingMsReportStatisticsResponse = {
  __typename?: "ReportingMsReportStatisticsResponse";
  reportStatisticsList?: Maybe<
    Array<ReportingMsReportStatisticsResponseReportStatistics>
  >;
};

export type ReportingMsReportStatisticsResponseReportStatistics = {
  __typename?: "ReportingMsReportStatisticsResponseReportStatistics";
  affiliate: Scalars["String"]["output"];
  /**  Nombre de rapports téléchargés au moins une fois  */
  downloadedReportsCount: Scalars["Int"]["output"];
  /**  Nombre de rapports en erreur  */
  failedReportsCount: Scalars["Int"]["output"];
  /**  Nombre de rapports générés  */
  generatedReportsCount: Scalars["Int"]["output"];
  /**  Nombre de rapports demandés  */
  requestedReportsCount: Scalars["Int"]["output"];
};

/**  Search among report plan.  */
export type ReportingMsSearchReportPlansRequest = {
  filters?: InputMaybe<ReportingMsSearchReportPlansRequestFilters>;
  paging?: InputMaybe<ReportingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<ReportingMsSearchReportPlansRequestSort>>
  >;
};

export type ReportingMsSearchReportPlansRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type ReportingMsSearchReportPlansRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<ReportingMsSearchReportPlansRequestSortField>;
};

export enum ReportingMsSearchReportPlansRequestSortField {
  Id = "id",
}

export type ReportingMsSearchReportPlansResponse = {
  __typename?: "ReportingMsSearchReportPlansResponse";
  data?: Maybe<Array<ReportingMsSearchReportPlansResponseData>>;
  pagination: ReportingMsPagedPagination;
};

export type ReportingMsSearchReportPlansResponseData = {
  __typename?: "ReportingMsSearchReportPlansResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  ReportTypeIdData?: Maybe<ReportingMsSearchReportTypesResponseData>;
  SourceUserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  TargetUserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  The main account for which the report is generated.  */
  accountId: Scalars["ID"]["output"];
  /**  How often a report is generated.  */
  frequency: ReportingMsSearchReportPlansResponseDataFrequency;
  /**  The id of the report plan  */
  id: Scalars["ID"]["output"];
  /**  The date the next report will be generated.  */
  nextReportTs: Scalars["Int64"]["output"];
  /**  The code that describes the type of the generated report.  */
  reportTypeId: Scalars["ID"]["output"];
  /**  The user that created the plan. It comes from the passport.  */
  sourceUserId: Scalars["ID"]["output"];
  /**  The date the plan begins.  */
  startTs: Scalars["Int64"]["output"];
  /**  The user that will be notified of the generated report.  */
  targetUserId: Scalars["ID"]["output"];
  /**  export for all accounts (multi-pass).  */
  withAllAccounts: Scalars["Boolean"]["output"];
};

/**  How often a report is generated.  */
export enum ReportingMsSearchReportPlansResponseDataFrequency {
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
  UnknownFrequency = "UNKNOWN_FREQUENCY",
  Weekly = "WEEKLY",
}

export type ReportingMsSearchReportTypesRequest = {
  filters?: InputMaybe<ReportingMsSearchReportTypesRequestFilters>;
  paging?: InputMaybe<ReportingMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<ReportingMsSearchReportTypesRequestSort>>
  >;
};

export type ReportingMsSearchReportTypesRequestFilters = {
  /**  The code of a report  */
  code?: InputMaybe<Scalars["String"]["input"]>;
  /**  The report is enabled or not  */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  Filter with one or more report type ids.  */
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /**  The report is available for plan or not  */
  isPlanAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReportingMsSearchReportTypesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<ReportingMsSearchReportTypesRequestSortField>;
};

export enum ReportingMsSearchReportTypesRequestSortField {
  Code = "code",
  Id = "id",
}

export type ReportingMsSearchReportTypesResponse = {
  __typename?: "ReportingMsSearchReportTypesResponse";
  data?: Maybe<Array<ReportingMsSearchReportTypesResponseData>>;
  pagination: ReportingMsPagedPagination;
};

export type ReportingMsSearchReportTypesResponseData = {
  __typename?: "ReportingMsSearchReportTypesResponseData";
  /**  The code of a report  */
  code: ReportingMsSearchReportTypesResponseDataCode;
  /**  Whether this version is the default one  */
  defaultVersion: Scalars["Boolean"]["output"];
  /**  Whether this version is enabled  */
  enabled: Scalars["Boolean"]["output"];
  /**  The features you must have in order to access the related documents. This rule is ignored when the list is empty.  */
  features?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The id of the report type  */
  id: Scalars["ID"]["output"];
  /**  The report is available for all accounts or not  */
  isAllAccountsAvailable: Scalars["Boolean"]["output"];
  /**  The report is available for plan or not  */
  isPlanAvailable: Scalars["Boolean"]["output"];
  /**  The roles you must have in order to access the related documents. This rule is ignored when the list is empty.  */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The version of the report type  */
  version: Scalars["Int"]["output"];
};

/**  The code of a report  */
export enum ReportingMsSearchReportTypesResponseDataCode {
  AllTransactionsMobilityCorporate = "ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  ConsumptionMonitoring_100KmPerCard = "CONSUMPTION_MONITORING_100_KM_PER_CARD",
  DetailedEvTransactions = "DETAILED_EV_TRANSACTIONS",
  ExportBadge = "EXPORT_BADGE",
  ExportCard = "EXPORT_CARD",
  ExportDriverCode = "EXPORT_DRIVER_CODE",
  ExportStateCardAndBadge = "EXPORT_STATE_CARD_AND_BADGE",
  ExportTransaction = "EXPORT_TRANSACTION",
  HistoricReportKm = "HISTORIC_REPORT_KM",
  PriceCeiling = "PRICE_CEILING",
  ReportTest = "REPORT_TEST",
  ReportUnknown = "REPORT_UNKNOWN",
  Tid = "TID",
  TollPassages = "TOLL_PASSAGES",
  TrackingCardAndBadgeAndBudgetTracking = "TRACKING_CARD_AND_BADGE_AND_BUDGET_TRACKING",
  TransactionsFridayMonday = "TRANSACTIONS_FRIDAY_MONDAY",
  TransactionsWeekendHolidays = "TRANSACTIONS_WEEKEND_HOLIDAYS",
  TransactionAnomalies = "TRANSACTION_ANOMALIES",
  TransactionAnomalies_24 = "TRANSACTION_ANOMALIES_24",
  TruckPositions = "TRUCK_POSITIONS",
}

/**  Search among reports.  */
export type ReportingMsSearchReportsRequest = {
  filters?: InputMaybe<ReportingMsSearchReportsRequestFilters>;
  paging?: InputMaybe<ReportingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<ReportingMsSearchReportsRequestSort>>>;
};

export type ReportingMsSearchReportsRequestFilters = {
  dateTsGt?: InputMaybe<Scalars["Int64"]["input"]>;
  dateTsLt?: InputMaybe<Scalars["Int64"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  status?: InputMaybe<
    Array<InputMaybe<ReportingMsSearchReportsRequestFiltersStatus>>
  >;
};

export enum ReportingMsSearchReportsRequestFiltersStatus {
  ReportAvailable = "REPORT_AVAILABLE",
  ReportError = "REPORT_ERROR",
  ReportNew = "REPORT_NEW",
  ReportPending = "REPORT_PENDING",
  UnknownReportStatus = "UNKNOWN_REPORT_STATUS",
}

export type ReportingMsSearchReportsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<ReportingMsSearchReportsRequestSortField>;
};

export enum ReportingMsSearchReportsRequestSortField {
  CreationTs = "creation_ts",
  ExpirationTs = "expiration_ts",
  Id = "id",
  Name = "name",
  Status = "status",
}

export type ReportingMsSearchReportsResponse = {
  __typename?: "ReportingMsSearchReportsResponse";
  data?: Maybe<Array<ReportingMsSearchReportsResponseData>>;
  pagination: ReportingMsPagedPagination;
};

export type ReportingMsSearchReportsResponseData = {
  __typename?: "ReportingMsSearchReportsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  DocumentIdData?: Maybe<MediaMsSearchDocumentsResponseData>;
  UserIdData?: Maybe<AccountsMsSearchUsersResponseData>;
  /**  The main account user that requested the report belongs to.  */
  accountId: Scalars["ID"]["output"];
  /**  The code that describes the type of the requested report.  */
  code: ReportingMsSearchReportsResponseDataCode;
  /**  The date the report has been created.  */
  creationTs: Scalars["Int64"]["output"];
  /**
   *  The customer number of accounts the user that requested the report belongs to.
   * Only the accounts for which the user has the right to request that type of report.
   */
  customerNumbers?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  The id of the related final document.  */
  documentId: Scalars["ID"]["output"];
  error: ReportingMsSearchReportsResponseDataError;
  /**  The date the report will be expired.  */
  expirationTs: Scalars["Int64"]["output"];
  /**  The message that describes the occurred error.  */
  failedMessage: Scalars["String"]["output"];
  /**  The reason of the occurred error.  */
  failedReason: Scalars["String"]["output"];
  /**  the duration of report generation (in secondes)  */
  generationDuration: Scalars["Int64"]["output"];
  /**  The if of the requested report.  */
  id: Scalars["ID"]["output"];
  /**  The locale the requested report is translated in. It comes from the passport.  */
  locale: Scalars["String"]["output"];
  /**  The name of the requested report.  */
  name: Scalars["String"]["output"];
  /**  The technical stage the report is currently at.  */
  state: ReportingMsSearchReportsResponseDataState;
  /**  The functional status the report is currently in.  */
  status: ReportingMsSearchReportsResponseDataStatus;
  /**  The timezone of the user that requested the report. It comes from the passport.  */
  timezone: Scalars["String"]["output"];
  /**  The user that requested the report.  */
  userId: Scalars["ID"]["output"];
};

export enum ReportingMsSearchReportsResponseDataCode {
  AllTransactionsMobilityCorporate = "ALL_TRANSACTIONS_MOBILITY_CORPORATE",
  ConsumptionMonitoring_100KmPerCard = "CONSUMPTION_MONITORING_100_KM_PER_CARD",
  DetailedEvTransactions = "DETAILED_EV_TRANSACTIONS",
  ExportBadge = "EXPORT_BADGE",
  ExportCard = "EXPORT_CARD",
  ExportDriverCode = "EXPORT_DRIVER_CODE",
  ExportStateCardAndBadge = "EXPORT_STATE_CARD_AND_BADGE",
  ExportTransaction = "EXPORT_TRANSACTION",
  HistoricReportKm = "HISTORIC_REPORT_KM",
  PriceCeiling = "PRICE_CEILING",
  ReportTest = "REPORT_TEST",
  ReportUnknown = "REPORT_UNKNOWN",
  Tid = "TID",
  TollPassages = "TOLL_PASSAGES",
  TrackingCardAndBadgeAndBudgetTracking = "TRACKING_CARD_AND_BADGE_AND_BUDGET_TRACKING",
  TransactionsFridayMonday = "TRANSACTIONS_FRIDAY_MONDAY",
  TransactionsWeekendHolidays = "TRANSACTIONS_WEEKEND_HOLIDAYS",
  TransactionAnomalies = "TRANSACTION_ANOMALIES",
  TransactionAnomalies_24 = "TRANSACTION_ANOMALIES_24",
  TruckPositions = "TRUCK_POSITIONS",
}

export type ReportingMsSearchReportsResponseDataError = {
  __typename?: "ReportingMsSearchReportsResponseDataError";
  code: Scalars["String"]["output"];
  locale: Scalars["String"]["output"];
  localizedMessage: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export enum ReportingMsSearchReportsResponseDataState {
  ReportCreated = "REPORT_CREATED",
  ReportDataFetched = "REPORT_DATA_FETCHED",
  ReportDocumentGenerated = "REPORT_DOCUMENT_GENERATED",
  ReportDownloaded = "REPORT_DOWNLOADED",
  ReportFailed = "REPORT_FAILED",
  ReportWaitingForData = "REPORT_WAITING_FOR_DATA",
  ReportWaitingForDocument = "REPORT_WAITING_FOR_DOCUMENT",
  ReportWaitingForDownload = "REPORT_WAITING_FOR_DOWNLOAD",
  UnknownReportState = "UNKNOWN_REPORT_STATE",
}

export enum ReportingMsSearchReportsResponseDataStatus {
  ReportAvailable = "REPORT_AVAILABLE",
  ReportError = "REPORT_ERROR",
  ReportNew = "REPORT_NEW",
  ReportPending = "REPORT_PENDING",
  UnknownReportStatus = "UNKNOWN_REPORT_STATUS",
}

/**  Search among tasks.  */
export type ReportingMsSearchTasksRequest = {
  filters?: InputMaybe<ReportingMsSearchTasksRequestFilters>;
  paging?: InputMaybe<ReportingMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<ReportingMsSearchTasksRequestSort>>>;
};

export type ReportingMsSearchTasksRequestFilters = {
  dateTsGt?: InputMaybe<Scalars["Int64"]["input"]>;
  dateTsLt?: InputMaybe<Scalars["Int64"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  reportId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<
    Array<InputMaybe<ReportingMsSearchTasksRequestFiltersStatus>>
  >;
};

export enum ReportingMsSearchTasksRequestFiltersStatus {
  Available = "AVAILABLE",
  Error = "ERROR",
  New = "NEW",
  Pending = "PENDING",
  UnknownStatus = "UNKNOWN_STATUS",
}

export type ReportingMsSearchTasksRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<ReportingMsSearchTasksRequestSortField>;
};

export enum ReportingMsSearchTasksRequestSortField {
  DocumentCreationTs = "document_creation_ts",
  DocumentExpirationTs = "document_expiration_ts",
  DocumentName = "document_name",
  Id = "id",
  Status = "status",
}

export type ReportingMsSearchTasksResponse = {
  __typename?: "ReportingMsSearchTasksResponse";
  data?: Maybe<Array<ReportingMsSearchTasksResponseData>>;
  pagination: ReportingMsPagedPagination;
};

export type ReportingMsSearchTasksResponseData = {
  __typename?: "ReportingMsSearchTasksResponseData";
  accountId: Scalars["ID"]["output"];
  documentCreationTs: Scalars["Int64"]["output"];
  documentExpirationTs: Scalars["Int64"]["output"];
  documentId: Scalars["ID"]["output"];
  documentName: Scalars["String"]["output"];
  failedMessage: Scalars["String"]["output"];
  failedReason: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  numberOfCustomers: Scalars["Int64"]["output"];
  reportId: Scalars["ID"]["output"];
  state: ReportingMsSearchTasksResponseDataState;
  status: ReportingMsSearchTasksResponseDataStatus;
  userId: Scalars["ID"]["output"];
};

export enum ReportingMsSearchTasksResponseDataState {
  Created = "CREATED",
  DataFetched = "DATA_FETCHED",
  DocumentGenerated = "DOCUMENT_GENERATED",
  Done = "DONE",
  Downloaded = "DOWNLOADED",
  Failed = "FAILED",
  UnknownState = "UNKNOWN_STATE",
  WaitingForData = "WAITING_FOR_DATA",
  WaitingForDocument = "WAITING_FOR_DOCUMENT",
}

export enum ReportingMsSearchTasksResponseDataStatus {
  Available = "AVAILABLE",
  Error = "ERROR",
  New = "NEW",
  Pending = "PENDING",
  UnknownStatus = "UNKNOWN_STATUS",
}

/**  Update a report plan.  */
export type ReportingMsUpdateReportPlanRequest = {
  /**  How often a report is generated.  */
  frequency?: InputMaybe<ReportingMsUpdateReportPlanRequestFrequency>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**  export for all accounts (multi-pass)  */
  withAllAccounts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**  How often a report is generated.  */
export enum ReportingMsUpdateReportPlanRequestFrequency {
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
  UnknownFrequency = "UNKNOWN_FREQUENCY",
  Weekly = "WEEKLY",
}

export type ReportingMsUpdateReportTypeRequest = {
  /**  Whether this version is the default one  */
  defaultVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  Whether the report type is enabled or not  */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  An exhaustive list of features to be able to access the report type.  */
  features?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The report is available for all accounts or not  */
  isAllAccountsAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  The report is available for plan or not  */
  isPlanAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**  An exhaustive list of roles to be able to access the report type.  */
  roles?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/**  Create sector  */
export type SectorsMsCreateSectorRequest = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SectorsMsCreateSectorResponse = {
  __typename?: "SectorsMsCreateSectorResponse";
  /**  The ID of the sector  */
  id: Scalars["ID"]["output"];
};

/**  Delete sector  */
export type SectorsMsDeleteSectorRequest = {
  attachmentSectorId?: InputMaybe<Scalars["ID"]["input"]>;
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SectorsMsPagedPagination = {
  __typename?: "SectorsMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type SectorsMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  Get a sector by id  */
export type SectorsMsSearchSectorsRequest = {
  filters?: InputMaybe<SectorsMsSearchSectorsRequestFilters>;
  paging?: InputMaybe<SectorsMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<SectorsMsSearchSectorsRequestSort>>>;
};

export type SectorsMsSearchSectorsRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  parentIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  partnerReferences?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /**  Get only the top level sectors from the organization  */
  topLevelSectors?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectorsMsSearchSectorsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<SectorsMsSearchSectorsRequestSortField>;
};

export enum SectorsMsSearchSectorsRequestSortField {
  Id = "id",
  PartnerReference = "partner_reference",
}

export type SectorsMsSearchSectorsResponse = {
  __typename?: "SectorsMsSearchSectorsResponse";
  data?: Maybe<Array<SectorsMsSearchSectorsResponseData>>;
  pagination: SectorsMsPagedPagination;
};

export type SectorsMsSearchSectorsResponseData = {
  __typename?: "SectorsMsSearchSectorsResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  Children?: Maybe<Array<Maybe<SectorsMsSearchSectorsResponseData>>>;
  CountCollaborators?: Maybe<CollaboratorsMsCountCollaboratorsInSectorResponseData>;
  CountLedgers?: Maybe<LedgersMsCountLedgersInSectorResponseData>;
  CountUsers?: Maybe<AccountsMsCountUsersInSectorResponseData>;
  CountVehicles?: Maybe<VehiclesMsCountVehiclesInSectorResponseData>;
  ParentIdData?: Maybe<SectorsMsSearchSectorsResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  createdTs: Scalars["Int64"]["output"];
  /**  The description of sector  */
  description: Scalars["String"]["output"];
  /**  the sector disable timestamp  */
  disabledTs: Scalars["Int64"]["output"];
  /**  The Sector ID  */
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  isDeletable: Scalars["Boolean"]["output"];
  /**  The sector label  */
  label: Scalars["String"]["output"];
  nbChildren: Scalars["Int64"]["output"];
  /**  The parent sector id  */
  parentId: Scalars["ID"]["output"];
  /**  The sector label from partner  */
  partnerLabel: Scalars["String"]["output"];
  /**  The sector partner reference for lvl 1 and 2  */
  partnerReference: Scalars["String"]["output"];
  /**  the time the sector has been created/updated from our partner  */
  recordedTs: Scalars["Int64"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

/**  Set custom label of sector  */
export type SectorsMsSetLabelRequest = {
  label?: InputMaybe<Scalars["String"]["input"]>;
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Update sector  */
export type SectorsMsUpdateSectorRequest = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
};

/**  Fetch transaction anomaly 24/24 data  */
export type TransactionsMsFetchTransactionAnomaly24Request = {
  /**  The account ids to fetch anomaly for  */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The id of the report  */
  reportId?: InputMaybe<Scalars["ID"]["input"]>;
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

/**  Fetch transaction anomaly data  */
export type TransactionsMsFetchTransactionAnomalyRequest = {
  /**  The account ids to fetch data for  */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The id of the report  */
  reportId?: InputMaybe<Scalars["ID"]["input"]>;
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

/**  Fetch transaction ev detailed data  */
export type TransactionsMsFetchTransactionEvDetailedRequest = {
  /**  The account ids to fetch data for  */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The id of the report  */
  reportId?: InputMaybe<Scalars["ID"]["input"]>;
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

/**  Fetch transaction export data  */
export type TransactionsMsFetchTransactionExportRequest = {
  /**  The account ids to fetch data for  */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The id of the ledger  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The id of the report  */
  reportId?: InputMaybe<Scalars["ID"]["input"]>;
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

/**  Fetch transaction mobility corporate data  */
export type TransactionsMsFetchTransactionMobilityCorporateRequest = {
  /**  The account ids to fetch data for  */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The id of the report  */
  reportId?: InputMaybe<Scalars["ID"]["input"]>;
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

/**  Fetch transaction toll passages data  */
export type TransactionsMsFetchTransactionTollPassagesRequest = {
  /**  The account ids to fetch data for  */
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The id of the report  */
  reportId?: InputMaybe<Scalars["ID"]["input"]>;
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type TransactionsMsGetMyTaxExemptionQuotaUsageResponse = {
  __typename?: "TransactionsMsGetMyTaxExemptionQuotaUsageResponse";
  accountNumber: Scalars["String"]["output"];
  accumulationEndTs: Scalars["Int64"]["output"];
  accumulationLastTs: Scalars["Int64"]["output"];
  percentageUsage: Scalars["Float"]["output"];
  periodicityCode: Scalars["String"]["output"];
  quota: Scalars["Float"]["output"];
  remaining: Scalars["Float"]["output"];
  usage: Scalars["Float"]["output"];
};

export type TransactionsMsPagedPagination = {
  __typename?: "TransactionsMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type TransactionsMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  Search expenses  */
export type TransactionsMsSearchExpensesRequest = {
  filters?: InputMaybe<TransactionsMsSearchExpensesRequestFilters>;
  paging?: InputMaybe<TransactionsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<TransactionsMsSearchExpensesRequestSort>>
  >;
};

export type TransactionsMsSearchExpensesRequestFilters = {
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  ledgerIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  superFamilyCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export type TransactionsMsSearchExpensesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<TransactionsMsSearchExpensesRequestSortField>;
};

export enum TransactionsMsSearchExpensesRequestSortField {
  ExpenseDt = "expense_dt",
  LedgerId = "ledger_id",
}

export type TransactionsMsSearchExpensesResponse = {
  __typename?: "TransactionsMsSearchExpensesResponse";
  data?: Maybe<Array<TransactionsMsSearchExpensesResponseData>>;
  pagination: TransactionsMsPagedPagination;
};

export type TransactionsMsSearchExpensesResponseData = {
  __typename?: "TransactionsMsSearchExpensesResponseData";
  /**  The details of the expense  */
  details?: Maybe<Array<TransactionsMsSearchExpensesResponseDataDetails>>;
  /**  The datetime utc when the expense has been done  */
  expenseTs: Scalars["Int64"]["output"];
  /**  The url of the downloadable invoice  */
  invoiceUrl: Scalars["String"]["output"];
  /**  The expense might need to be payed  */
  isUnpaid: Scalars["Boolean"]["output"];
  /**  The expense might not be valued right away  */
  isValued: Scalars["Boolean"]["output"];
  /**  The total price of the expense  */
  price: TransactionsMsSearchExpensesResponseDataPrice;
  /**  B2C: match the invoice number, B2B not valued  */
  reference: Scalars["String"]["output"];
};

/**  The details of the expense  */
export type TransactionsMsSearchExpensesResponseDataDetails = {
  __typename?: "TransactionsMsSearchExpensesResponseDataDetails";
  /**  The ledger used for the transaction  */
  ledgerId: Scalars["ID"]["output"];
  /**  Where the transaction has been made  */
  location: TransactionsMsSearchExpensesResponseDataDetailsLocation;
  /**  The datetime utc when the transaction has been done  */
  madeTs: Scalars["Int64"]["output"];
  /**  The name of the transaction  */
  name: Scalars["String"]["output"];
  /**  Provided when the transaction is for a charging session  */
  powerDelivery: TransactionsMsSearchExpensesResponseDataDetailsPowerDelivery;
  price: TransactionsMsSearchExpensesResponseDataDetailsPrice;
  /**  The type of transaction  */
  type: Scalars["Int"]["output"];
};

/**  Where the transaction has been made  */
export type TransactionsMsSearchExpensesResponseDataDetailsLocation = {
  __typename?: "TransactionsMsSearchExpensesResponseDataDetailsLocation";
  /**  Where the transaction has been made  */
  address: TransactionsMsSearchExpensesResponseDataDetailsLocationAddress;
  supplier: TransactionsMsSearchExpensesResponseDataDetailsLocationSupplier;
};

/**  Where the transaction has been made  */
export type TransactionsMsSearchExpensesResponseDataDetailsLocationAddress = {
  __typename?: "TransactionsMsSearchExpensesResponseDataDetailsLocationAddress";
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  line: Scalars["String"]["output"];
  zipCode: Scalars["String"]["output"];
};

export type TransactionsMsSearchExpensesResponseDataDetailsLocationSupplier = {
  __typename?: "TransactionsMsSearchExpensesResponseDataDetailsLocationSupplier";
  isTe: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
};

/**  Provided when the transaction is for a charging session  */
export type TransactionsMsSearchExpensesResponseDataDetailsPowerDelivery = {
  __typename?: "TransactionsMsSearchExpensesResponseDataDetailsPowerDelivery";
  /**  The duration of the charging session  */
  durationSeconds: Scalars["Int64"]["output"];
  quantity: TransactionsMsSearchExpensesResponseDataDetailsPowerDeliveryQuantity;
};

export type TransactionsMsSearchExpensesResponseDataDetailsPowerDeliveryQuantity =
  {
    __typename?: "TransactionsMsSearchExpensesResponseDataDetailsPowerDeliveryQuantity";
    /**  The amount of energy  */
    amount: Scalars["Float"]["output"];
    /**  The unit of measure  */
    uom: Scalars["String"]["output"];
  };

export type TransactionsMsSearchExpensesResponseDataDetailsPrice = {
  __typename?: "TransactionsMsSearchExpensesResponseDataDetailsPrice";
  amount: Scalars["Float"]["output"];
  /**  ISO 4217  */
  currency: Scalars["String"]["output"];
};

/**  The total price of the expense  */
export type TransactionsMsSearchExpensesResponseDataPrice = {
  __typename?: "TransactionsMsSearchExpensesResponseDataPrice";
  amount: Scalars["Float"]["output"];
  /**  ISO 4217  */
  currency: Scalars["String"]["output"];
};

/**  Search among product categories  */
export type TransactionsMsSearchProductCategoriesRequest = {
  filters?: InputMaybe<TransactionsMsSearchProductCategoriesRequestFilters>;
  paging?: InputMaybe<TransactionsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<TransactionsMsSearchProductCategoriesRequestSort>>
  >;
};

export type TransactionsMsSearchProductCategoriesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type TransactionsMsSearchProductCategoriesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<TransactionsMsSearchProductCategoriesRequestSortField>;
};

export enum TransactionsMsSearchProductCategoriesRequestSortField {
  Code = "code",
}

export type TransactionsMsSearchProductCategoriesResponse = {
  __typename?: "TransactionsMsSearchProductCategoriesResponse";
  data?: Maybe<Array<TransactionsMsSearchProductCategoriesResponseData>>;
  pagination: TransactionsMsPagedPagination;
};

export type TransactionsMsSearchProductCategoriesResponseData = {
  __typename?: "TransactionsMsSearchProductCategoriesResponseData";
  id: Scalars["ID"]["output"];
  productCategoryCode: Scalars["String"]["output"];
  productCategoryName: Scalars["String"]["output"];
};

/**  Get account preferences related to the transactions domain  */
export type TransactionsMsSearchTransactionsAccountPreferencesRequest = {
  filters?: InputMaybe<TransactionsMsSearchTransactionsAccountPreferencesRequestFilters>;
  paging?: InputMaybe<TransactionsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<
      InputMaybe<TransactionsMsSearchTransactionsAccountPreferencesRequestSort>
    >
  >;
};

export type TransactionsMsSearchTransactionsAccountPreferencesRequestFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type TransactionsMsSearchTransactionsAccountPreferencesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<TransactionsMsSearchTransactionsAccountPreferencesRequestSortField>;
};

export enum TransactionsMsSearchTransactionsAccountPreferencesRequestSortField {
  Id = "id",
}

export type TransactionsMsSearchTransactionsAccountPreferencesResponse = {
  __typename?: "TransactionsMsSearchTransactionsAccountPreferencesResponse";
  data?: Maybe<
    Array<TransactionsMsSearchTransactionsAccountPreferencesResponseData>
  >;
  pagination: TransactionsMsPagedPagination;
};

export type TransactionsMsSearchTransactionsAccountPreferencesResponseData = {
  __typename?: "TransactionsMsSearchTransactionsAccountPreferencesResponseData";
  IdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  /**  The account ID  */
  id: Scalars["ID"]["output"];
};

/**  Search among transactions  */
export type TransactionsMsSearchTransactionsRequest = {
  filters?: InputMaybe<TransactionsMsSearchTransactionsRequestFilters>;
  paging?: InputMaybe<TransactionsMsPagedPaging>;
  sorts?: InputMaybe<
    Array<InputMaybe<TransactionsMsSearchTransactionsRequestSort>>
  >;
};

export type TransactionsMsSearchTransactionsRequestFilters = {
  fromTs?: InputMaybe<Scalars["Int64"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  invoiceNumber?: InputMaybe<Scalars["String"]["input"]>;
  invoiceStateCode?: InputMaybe<
    Array<
      InputMaybe<TransactionsMsSearchTransactionsRequestFiltersInvoiceStateCode>
    >
  >;
  invoiceStateCodes?: InputMaybe<
    Array<
      InputMaybe<TransactionsMsSearchTransactionsRequestFiltersInvoiceStateCodes>
    >
  >;
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  productCategoryCode?: InputMaybe<Scalars["String"]["input"]>;
  tillTs?: InputMaybe<Scalars["Int64"]["input"]>;
};

export enum TransactionsMsSearchTransactionsRequestFiltersInvoiceStateCode {
  Invoiced = "INVOICED",
  OutOfInvoice = "OUT_OF_INVOICE",
  PendingInvoice = "PENDING_INVOICE",
  PendingValorization = "PENDING_VALORIZATION",
  UnknownInvoiceState = "UNKNOWN_INVOICE_STATE",
}

export enum TransactionsMsSearchTransactionsRequestFiltersInvoiceStateCodes {
  Invoiced = "INVOICED",
  OutOfInvoice = "OUT_OF_INVOICE",
  PendingInvoice = "PENDING_INVOICE",
  PendingValorization = "PENDING_VALORIZATION",
  UnknownInvoiceState = "UNKNOWN_INVOICE_STATE",
}

export type TransactionsMsSearchTransactionsRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<TransactionsMsSearchTransactionsRequestSortField>;
};

export enum TransactionsMsSearchTransactionsRequestSortField {
  TransactionsTs = "transactions_ts",
  UpdatedTs = "updated_ts",
}

export type TransactionsMsSearchTransactionsResponse = {
  __typename?: "TransactionsMsSearchTransactionsResponse";
  data?: Maybe<Array<TransactionsMsSearchTransactionsResponseData>>;
  pagination: TransactionsMsPagedPagination;
};

export type TransactionsMsSearchTransactionsResponseData = {
  __typename?: "TransactionsMsSearchTransactionsResponseData";
  amountCurrency: Scalars["String"]["output"];
  amountIncludingVat: Scalars["Float"]["output"];
  badgeTollClass: Scalars["String"]["output"];
  billable: Scalars["Boolean"]["output"];
  createdTs: Scalars["Int64"]["output"];
  date: Scalars["String"]["output"];
  dateTs: Scalars["Int64"]["output"];
  familyCd: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  invoiceId: Scalars["ID"]["output"];
  invoiceStateCode: TransactionsMsSearchTransactionsResponseDataInvoiceStateCode;
  label: Scalars["String"]["output"];
  ledgerId: Scalars["ID"]["output"];
  number: Scalars["String"]["output"];
  productCategoryCd: Scalars["String"]["output"];
  productCd: Scalars["String"]["output"];
  quantity: Scalars["Float"]["output"];
  timezone: Scalars["String"]["output"];
  uniqueId: Scalars["String"]["output"];
  unit: Scalars["String"]["output"];
  unitPrice: Scalars["Float"]["output"];
  updatedTs: Scalars["Int64"]["output"];
};

export enum TransactionsMsSearchTransactionsResponseDataInvoiceStateCode {
  Invoiced = "INVOICED",
  OutOfInvoice = "OUT_OF_INVOICE",
  PendingInvoice = "PENDING_INVOICE",
  PendingValorization = "PENDING_VALORIZATION",
  UnknownInvoiceState = "UNKNOWN_INVOICE_STATE",
}

/**  Search used balance  */
export type TransactionsMsSearchUniversalUsedBalanceRequest = {
  hashedPan?: InputMaybe<Scalars["String"]["input"]>;
};

export type TransactionsMsSearchUniversalUsedBalanceResponse = {
  __typename?: "TransactionsMsSearchUniversalUsedBalanceResponse";
  global?: Maybe<
    Array<TransactionsMsSearchUniversalUsedBalanceResponseUsedBalance>
  >;
  hashedPan: Scalars["String"]["output"];
  ledgerId: Scalars["ID"]["output"];
  usedBalance?: Maybe<
    Array<TransactionsMsSearchUniversalUsedBalanceResponseUsedBalance>
  >;
};

export type TransactionsMsSearchUniversalUsedBalanceResponseUsedBalance = {
  __typename?: "TransactionsMsSearchUniversalUsedBalanceResponseUsedBalance";
  period: Scalars["String"]["output"];
  productCategoryCode: Scalars["String"]["output"];
  transactionCount: Scalars["Int"]["output"];
  usedBalance: Scalars["Float"]["output"];
};

/**  Archive vehicle  */
export type VehiclesMsArchiveVehicleRequest = {
  /**  Todo: rename to archived_ts  */
  fleetExitDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/**  Check the vehicle identification (license plate format or VIN)  */
export type VehiclesMsCheckIdentificationRequest = {
  /**
   *  The country where we would check the identification (iso code 2)
   * Not used anymore
   */
  country?: InputMaybe<Scalars["String"]["input"]>;
  /**  The identification type  */
  type?: InputMaybe<VehiclesMsCheckIdentificationRequestType>;
  /**  The identification value  */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/**  The identification type  */
export enum VehiclesMsCheckIdentificationRequestType {
  IdentificationTypeUnknown = "IDENTIFICATION_TYPE_UNKNOWN",
  LicensePlate = "LICENSE_PLATE",
  Vin = "VIN",
}

export type VehiclesMsCheckIdentificationResponse = {
  __typename?: "VehiclesMsCheckIdentificationResponse";
  /**
   *  The list of country codes the license plate is matching.
   * The list can be empty if it does not match any of the system knows
   * It does not mean the identification is incorrect
   * The list is empty for VIN as it is international
   */
  nationalities?: Maybe<Array<Scalars["String"]["output"]>>;
  /**  true when the identification is valid  */
  valid: Scalars["Boolean"]["output"];
};

export type VehiclesMsCountVehiclesByStatusResponse = {
  __typename?: "VehiclesMsCountVehiclesByStatusResponse";
  /**  All vehicles without the fleet exit date  */
  activated: Scalars["Int64"]["output"];
  /**  All vehicles  */
  all: Scalars["Int64"]["output"];
  /**  All vehicles with the fleet exit date  */
  archived: Scalars["Int64"]["output"];
};

/**  Count vehicles in sector  */
export type VehiclesMsCountVehiclesInSectorRequest = {
  filters?: InputMaybe<VehiclesMsCountVehiclesInSectorRequestFilters>;
};

export type VehiclesMsCountVehiclesInSectorRequestFilters = {
  sectorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type VehiclesMsCountVehiclesInSectorResponse = {
  __typename?: "VehiclesMsCountVehiclesInSectorResponse";
  /**  All vehicles in sectors  */
  data?: Maybe<Array<VehiclesMsCountVehiclesInSectorResponseData>>;
};

/**  All vehicles in sectors  */
export type VehiclesMsCountVehiclesInSectorResponseData = {
  __typename?: "VehiclesMsCountVehiclesInSectorResponseData";
  /**  All vehicles without archived date or in future  */
  activated: Scalars["Int64"]["output"];
  /**  All vehicles  */
  all: Scalars["Int64"]["output"];
  /**  All vehicles with an expired archive date exceeded  */
  archived: Scalars["Int64"]["output"];
  sectorId: Scalars["ID"]["output"];
};

/**  Create a mileage record  */
export type VehiclesMsCreateMileageRequest = {
  /**  The mileage entry  */
  distanceKm?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The date entered by the user when making the entry  */
  entryDateTs?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The ledger linked to the mileage  */
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type VehiclesMsCreateMileageResponse = {
  __typename?: "VehiclesMsCreateMileageResponse";
  /**  The created mileage record  */
  id: Scalars["ID"]["output"];
};

/**  Create a vehicle  */
export type VehiclesMsCreateVehicleRequest = {
  /**  Todo: remove  */
  fleetEntryDate?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  Todo: remove  */
  fleetExitDate?: InputMaybe<Scalars["Int64"]["input"]>;
  /**  The vehicle license plate  */
  licensePlate?: InputMaybe<Scalars["String"]["input"]>;
  /**  The sector in which the vehicle will be created  */
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
  /**  The vehicle official identification number  */
  vin?: InputMaybe<Scalars["String"]["input"]>;
};

export type VehiclesMsCreateVehicleResponse = {
  __typename?: "VehiclesMsCreateVehicleResponse";
  /**  The created vehicle id  */
  id: Scalars["ID"]["output"];
};

export type VehiclesMsPagedPagination = {
  __typename?: "VehiclesMsPagedPagination";
  /**  The page number we wished to access  */
  page: Scalars["Int"]["output"];
  /**  The number of items per page  */
  size: Scalars["Int"]["output"];
  /**  The total number of items in the database for the given implicit filters (count query)  */
  total: Scalars["Int64"]["output"];
};

export type VehiclesMsPagedPaging = {
  /**  The page number we wish to access  */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /**  The number of items per page  */
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

/**  Search among mileage records  */
export type VehiclesMsSearchMileagesRequest = {
  filters?: InputMaybe<VehiclesMsSearchMileagesRequestFilters>;
  paging?: InputMaybe<VehiclesMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<VehiclesMsSearchMileagesRequestSort>>>;
};

export type VehiclesMsSearchMileagesRequestFilters = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  ledgerId?: InputMaybe<Scalars["ID"]["input"]>;
  source?: InputMaybe<VehiclesMsSearchMileagesRequestFiltersSource>;
};

export enum VehiclesMsSearchMileagesRequestFiltersSource {
  MileageSourceUnknown = "MILEAGE_SOURCE_UNKNOWN",
  Portal = "PORTAL",
}

export type VehiclesMsSearchMileagesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<VehiclesMsSearchMileagesRequestSortField>;
};

export enum VehiclesMsSearchMileagesRequestSortField {
  DistanceKm = "distance_km",
  EntryDateTs = "entry_date_ts",
}

export type VehiclesMsSearchMileagesResponse = {
  __typename?: "VehiclesMsSearchMileagesResponse";
  data?: Maybe<Array<VehiclesMsSearchMileagesResponseData>>;
  pagination: VehiclesMsPagedPagination;
};

export type VehiclesMsSearchMileagesResponseData = {
  __typename?: "VehiclesMsSearchMileagesResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  LedgerIdData?: Maybe<LedgersMsSearchLedgersResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**  The mileage value in kilometers  */
  distanceKm: Scalars["Int64"]["output"];
  /**  The timestamp of the mileage record  */
  entryDateTs: Scalars["Int64"]["output"];
  /**  The ID of the mileage  */
  id: Scalars["ID"]["output"];
  /**  The ledger id  */
  ledgerId: Scalars["ID"]["output"];
  /**  Enum for source of data  */
  source: VehiclesMsSearchMileagesResponseDataSource;
};

export enum VehiclesMsSearchMileagesResponseDataSource {
  MileageSourceUnknown = "MILEAGE_SOURCE_UNKNOWN",
  Portal = "PORTAL",
}

/**  Search among vehicles  */
export type VehiclesMsSearchVehiclesRequest = {
  filters?: InputMaybe<VehiclesMsSearchVehiclesRequestFilters>;
  paging?: InputMaybe<VehiclesMsPagedPaging>;
  sorts?: InputMaybe<Array<InputMaybe<VehiclesMsSearchVehiclesRequestSort>>>;
};

export type VehiclesMsSearchVehiclesRequestFilters = {
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type VehiclesMsSearchVehiclesRequestSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  field?: InputMaybe<VehiclesMsSearchVehiclesRequestSortField>;
};

export enum VehiclesMsSearchVehiclesRequestSortField {
  Id = "id",
  LicensePlate = "license_plate",
  UpdatedTs = "updated_ts",
}

export type VehiclesMsSearchVehiclesResponse = {
  __typename?: "VehiclesMsSearchVehiclesResponse";
  data?: Maybe<Array<VehiclesMsSearchVehiclesResponseData>>;
  pagination: VehiclesMsPagedPagination;
};

export type VehiclesMsSearchVehiclesResponseData = {
  __typename?: "VehiclesMsSearchVehiclesResponseData";
  AccountIdData?: Maybe<AccountsMsSearchAccountsResponseData>;
  SectorIdData?: Maybe<SectorsMsSearchSectorsResponseData>;
  /**  The related account  */
  accountId: Scalars["ID"]["output"];
  /**  The date the vehicle has been archived  */
  archivedTs: Scalars["Int64"]["output"];
  /**  Todo: remove  */
  fleetEntryDateTs: Scalars["Int64"]["output"];
  /**  Todo: replaced by archived_ts  */
  fleetExitDateTs: Scalars["Int64"]["output"];
  /**  The ID of the vehicle  */
  id: Scalars["ID"]["output"];
  /**  The vehicle license plate  */
  licensePlate: Scalars["String"]["output"];
  /**  The related sector  */
  sectorId: Scalars["ID"]["output"];
  status: VehiclesMsSearchVehiclesResponseDataStatus;
  /**  The vehicle official identification number  */
  vin: Scalars["String"]["output"];
};

export enum VehiclesMsSearchVehiclesResponseDataStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  VehicleStatusUnknown = "VEHICLE_STATUS_UNKNOWN",
}

/**  Unarchive vehicle  */
export type VehiclesMsUnarchiveVehicleRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type VehiclesMsUpdateVehicleRequest = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  licensePlate?: InputMaybe<Scalars["String"]["input"]>;
  sectorId?: InputMaybe<Scalars["ID"]["input"]>;
  vin?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetAccountDetailQueryVariables = Exact<{
  request: AccountsMsSearchAccountsRequest;
}>;

export type GetAccountDetailQuery = {
  __typename?: "Query";
  AccountsMsSearchAccounts: {
    __typename?: "AccountsMsSearchAccountsResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchAccountsResponseData";
      name: string;
      zipCode: string;
      city: string;
      country: string;
      number: string;
      address: string;
      MainPrivilegeIdData?: {
        __typename?: "AccountsMsSearchPrivilegesResponseData";
        UserIdData?: {
          __typename?: "AccountsMsSearchUsersResponseData";
          firstName: string;
          lastName: string;
          email: string;
        } | null;
      } | null;
    }> | null;
  };
};

export type GetAccountUsersQueryVariables = Exact<{
  request?: InputMaybe<AccountsMsSearchPrivilegesRequest>;
}>;

export type GetAccountUsersQuery = {
  __typename?: "Query";
  AccountsMsSearchPrivileges: {
    __typename?: "AccountsMsSearchPrivilegesResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchPrivilegesResponseData";
      id: string;
      lastUsedTs: number;
      status: AccountsMsSearchPrivilegesResponseDataStatus;
      UserIdData?: {
        __typename?: "AccountsMsSearchUsersResponseData";
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        createdTs: number;
      } | null;
      Subscriptions?: Array<{
        __typename?: "AccountsMsSearchPrivilegeSubscriptionsResponseData";
        RolesProfileIdData?: {
          __typename?: "AccountsMsSearchRolesProfilesResponseData";
          name: string;
          code: string;
        } | null;
      } | null> | null;
    }> | null;
    pagination: {
      __typename?: "AccountsMsPagedPagination";
      page: number;
      size: number;
      total: number;
    };
  };
};

export type GetAccountQueryVariables = Exact<{
  request: AccountsMsSearchAccountsRequest;
}>;

export type GetAccountQuery = {
  __typename?: "Query";
  AccountsMsSearchAccounts: {
    __typename?: "AccountsMsSearchAccountsResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchAccountsResponseData";
      id: string;
      number: string;
      name: string;
      registrationNumber: string;
      registrationName: string;
      country: string;
      city: string;
      zipCode: string;
      address: string;
      createdTs: string;
      MainPrivilegeIdData?: {
        __typename?: "AccountsMsSearchPrivilegesResponseData";
        id: string;
        UserIdData?: {
          __typename?: "AccountsMsSearchUsersResponseData";
          email: string;
          id: string;
          firstName: string;
          lastName: string;
        } | null;
      } | null;
    }> | null;
  };
};

export type GetUserQueryVariables = Exact<{
  request: AccountsMsSearchUsersRequest;
}>;

export type GetUserQuery = {
  __typename?: "Query";
  AccountsMsSearchUsers: {
    __typename?: "AccountsMsSearchUsersResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchUsersResponseData";
      id: string;
      email: string;
      locale: string;
      timezone: string;
      firstName: string;
      lastName: string;
      phone: string;
      phoneAlt: string;
      jobTitle: string;
    }> | null;
  };
};

export type AccountsMsSearchPrivilegesQueryVariables = Exact<{
  request?: InputMaybe<AccountsMsSearchPrivilegesRequest>;
}>;

export type AccountsMsSearchPrivilegesQuery = {
  __typename?: "Query";
  AccountsMsSearchPrivileges: {
    __typename?: "AccountsMsSearchPrivilegesResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchPrivilegesResponseData";
      id: string;
      roles?: Array<string> | null;
      rolesInvalidatedTs: number;
      disabledTs: number;
      lastUsedTs: number;
      invitedTs: number;
      enabledLastTs: number;
      userId: string;
      accountId: string;
      owner: boolean;
      status: AccountsMsSearchPrivilegesResponseDataStatus;
      AccountIdData?: {
        __typename?: "AccountsMsSearchAccountsResponseData";
        id: string;
        name: string;
        number: string;
        registrationName: string;
        registrationNumber: string;
        isActive: boolean;
        createdTs: string;
        mainPrivilegeId: string;
      } | null;
      Subscriptions?: Array<{
        __typename?: "AccountsMsSearchPrivilegeSubscriptionsResponseData";
        id: string;
        fromTs: number;
        tillTs: number;
        privilegeId: string;
        rolesProfileId: string;
        RolesProfileIdData?: {
          __typename?: "AccountsMsSearchRolesProfilesResponseData";
          id: string;
          name: string;
          roles?: Array<string> | null;
          code: string;
          accountId: string;
          parentId: string;
          rootId: string;
          system: boolean;
        } | null;
      } | null> | null;
    }> | null;
    pagination: {
      __typename?: "AccountsMsPagedPagination";
      page: number;
      size: number;
      total: number;
    };
  };
};

export type InviteAgentMutationVariables = Exact<{
  request?: InputMaybe<AccountsMsInviteSupportUserRequest>;
}>;

export type InviteAgentMutation = {
  __typename?: "Mutation";
  AccountsMsInviteSupportUser: {
    __typename?: "AccountsMsInviteSupportUserResponse";
    id: string;
  };
};

export type AccountsMsSearchAccountsQueryVariables = Exact<{
  request?: InputMaybe<AccountsMsSearchAccountsRequest>;
}>;

export type AccountsMsSearchAccountsQuery = {
  __typename?: "Query";
  AccountsMsSearchAccounts: {
    __typename?: "AccountsMsSearchAccountsResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchAccountsResponseData";
      id: string;
      name: string;
      number: string;
      registrationName: string;
      registrationNumber: string;
      isActive: boolean;
    }> | null;
  };
};

export type GetActionsByAccountQueryQueryVariables = Exact<{
  request?: InputMaybe<AccountsMsSearchAuditLogsRequest>;
}>;

export type GetActionsByAccountQueryQuery = {
  __typename?: "Query";
  AccountsMsSearchAuditLogs: {
    __typename?: "AccountsMsSearchAuditLogsResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchAuditLogsResponseData";
      id: string;
      action: string;
      whenTs: number;
      AgentIdData?: {
        __typename?: "AccountsMsSearchSupportUsersResponseData";
        firstName: string;
        lastName: string;
        id: string;
        AccessIdData?: {
          __typename?: "AccountsMsSearchPlatformAccessesResponseData";
          igg: string;
        } | null;
      } | null;
      UserIdData?: {
        __typename?: "AccountsMsSearchUsersResponseData";
        firstName: string;
        lastName: string;
      } | null;
    }> | null;
    pagination: {
      __typename?: "AccountsMsPagedPagination";
      size: number;
      page: number;
      total: number;
    };
  };
};

export type GetActionsByUserQueryQueryVariables = Exact<{
  request?: InputMaybe<AccountsMsSearchAuditLogsRequest>;
}>;

export type GetActionsByUserQueryQuery = {
  __typename?: "Query";
  AccountsMsSearchAuditLogs: {
    __typename?: "AccountsMsSearchAuditLogsResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchAuditLogsResponseData";
      id: string;
      action: string;
      whenTs: number;
      AgentIdData?: {
        __typename?: "AccountsMsSearchSupportUsersResponseData";
        firstName: string;
        lastName: string;
        id: string;
        AccessIdData?: {
          __typename?: "AccountsMsSearchPlatformAccessesResponseData";
          igg: string;
        } | null;
      } | null;
    }> | null;
    pagination: {
      __typename?: "AccountsMsPagedPagination";
      size: number;
      page: number;
      total: number;
    };
  };
};

export type CancelSupportAgentInviteMutationVariables = Exact<{
  request?: InputMaybe<AccountsMsCancelSupportUserInviteRequest>;
}>;

export type CancelSupportAgentInviteMutation = {
  __typename?: "Mutation";
  AccountsMsCancelSupportUserInvite?: any | null;
};

export type DisableAgentMutationVariables = Exact<{
  request?: InputMaybe<AccountsMsDisableSupportUserRequest>;
}>;

export type DisableAgentMutation = {
  __typename?: "Mutation";
  AccountsMsDisableSupportUser?: any | null;
};

export type EnableAgentMutationVariables = Exact<{
  request?: InputMaybe<AccountsMsEnableSupportUserRequest>;
}>;

export type EnableAgentMutation = {
  __typename?: "Mutation";
  AccountsMsEnableSupportUser?: any | null;
};

export type AccountsMsSearchSupportUsersQueryVariables = Exact<{
  request?: InputMaybe<AccountsMsSearchSupportUsersRequest>;
}>;

export type AccountsMsSearchSupportUsersQuery = {
  __typename?: "Query";
  AccountsMsSearchSupportUsers: {
    __typename?: "AccountsMsSearchSupportUsersResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchSupportUsersResponseData";
      id: string;
      accessId: string;
      rights?: Array<string> | null;
      firstName: string;
      lastName: string;
      jobTitle: string;
      email: string;
      profile: AccountsMsSearchSupportUsersResponseDataProfile;
      status: AccountsMsSearchSupportUsersResponseDataStatus;
      invitedBy: string;
      createdTs: number;
      AccessIdData?: {
        __typename?: "AccountsMsSearchPlatformAccessesResponseData";
        igg: string;
        lastAccessTs: number;
      } | null;
    }> | null;
    pagination: {
      __typename?: "AccountsMsPagedPagination";
      page: number;
      total: number;
      size: number;
    };
  };
};

export type AccountsMsCountSupportUsersByStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccountsMsCountSupportUsersByStatusQuery = {
  __typename?: "Query";
  AccountsMsCountSupportUsersByStatus: {
    __typename?: "AccountsMsCountSupportUsersByStatusResponse";
    all: number;
    enabled: number;
    disabled: number;
    inviting: number;
  };
};

export type UpdateAgentMutationVariables = Exact<{
  request?: InputMaybe<AccountsMsUpdateSupportUserRequest>;
}>;

export type UpdateAgentMutation = {
  __typename?: "Mutation";
  AccountsMsUpdateSupportUser?: any | null;
};

export type SearchAccountsMsMeQueryVariables = Exact<{
  request?: InputMaybe<AccountsMsMeRequest>;
}>;

export type SearchAccountsMsMeQuery = {
  __typename?: "Query";
  AccountsMsMe: {
    __typename?: "AccountsMsMeResponse";
    userId: string;
    sharedUserProfileTs: number;
    systemUserInfo?: any | null;
    supportUserInfo: {
      __typename?: "AccountsMsMeResponseSupportUser";
      igg: string;
      email: string;
      firstName: string;
      lastName: string;
      rights?: Array<string> | null;
      subsidiaries?: Array<string> | null;
    };
  };
};

export type CreateTidLinkedAccountMutationVariables = Exact<{
  request: BillingMsCreateTidLinkedAccountRequest;
}>;

export type CreateTidLinkedAccountMutation = {
  __typename?: "Mutation";
  BillingMsCreateTidLinkedAccount: {
    __typename?: "BillingMsCreateTidLinkedAccountResponse";
    id: string;
  };
};

export type DeleteTidLinkedAccountMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteTidLinkedAccountMutation = {
  __typename?: "Mutation";
  BillingMsDeleteTidLinkedAccount?: any | null;
};

export type GetAccountsLinkableToTidQueryVariables = Exact<{
  request: BillingMsGetAccountsLinkableToTidRequest;
}>;

export type GetAccountsLinkableToTidQuery = {
  __typename?: "Query";
  BillingMsGetAccountsLinkableToTid: {
    __typename?: "BillingMsGetAccountsLinkableToTidResponse";
    data?: Array<{
      __typename?: "BillingMsGetAccountsLinkableToTidResponseData";
      accountId: string;
      accountNumber: string;
      accountName: string;
    }> | null;
    pagination: {
      __typename?: "BillingMsPagedPagination";
      page: number;
      size: number;
      total: number;
    };
  };
};

export type SearchTidLinkedAccountTypesQueryVariables = Exact<{
  request: BillingMsSearchTidLinkedAccountTypesRequest;
}>;

export type SearchTidLinkedAccountTypesQuery = {
  __typename?: "Query";
  BillingMsSearchTidLinkedAccountTypes: {
    __typename?: "BillingMsSearchTidLinkedAccountTypesResponse";
    data?: Array<{
      __typename?: "BillingMsSearchTidLinkedAccountTypesResponseData";
      id: string;
      code: string;
    }> | null;
  };
};

export type SearchTidLinkedAccountsQueryVariables = Exact<{
  request: BillingMsSearchTidLinkedAccountsRequest;
}>;

export type SearchTidLinkedAccountsQuery = {
  __typename?: "Query";
  BillingMsSearchTidLinkedAccounts: {
    __typename?: "BillingMsSearchTidLinkedAccountsResponse";
    data?: Array<{
      __typename?: "BillingMsSearchTidLinkedAccountsResponseData";
      id: string;
      linkedAccountId: string;
      updatedTs: number;
      typeId: string;
      TypeIdData?: {
        __typename?: "BillingMsSearchTidLinkedAccountTypesResponseData";
        code: string;
      } | null;
      LinkedAccountIdData?: {
        __typename?: "BillingMsSearchBillingAccountPreferencesResponseData";
        number: string;
        IdData?: {
          __typename?: "AccountsMsSearchAccountsResponseData";
          id: string;
          name: string;
        } | null;
      } | null;
    }> | null;
    pagination: {
      __typename?: "BillingMsPagedPagination";
      page: number;
      size: number;
      total: number;
    };
  };
};

export type GetSupportsAndDivisionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSupportsAndDivisionsQuery = {
  __typename?: "Query";
  LedgersMsGetSupportsAndDivisions: {
    __typename?: "LedgersMsGetSupportsAndDivisionsResponse";
    supportAccounts?: Array<{
      __typename?: "LedgersMsGetSupportsAndDivisionsResponseSupportAccount";
      label: string;
      originalLabel: string;
      walletId: string;
      divisionAccounts?: Array<{
        __typename?: "LedgersMsGetSupportsAndDivisionsResponseSupportAccountDivisionAccount";
        label: string;
        originalLabel: string;
        walletId: string;
      }> | null;
    }> | null;
  };
};

export type MiddleMsCreateFormDataRuleGroupMutationVariables = Exact<{
  request: MiddleMsCreateFormDataRuleGroupRequest;
}>;

export type MiddleMsCreateFormDataRuleGroupMutation = {
  __typename?: "Mutation";
  MiddleMsCreateFormDataRuleGroup: {
    __typename?: "MiddleMsCreateFormDataRuleGroupResponse";
    id: string;
  };
};

export type DeleteFormDataRuleGroupMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteFormDataRuleGroupMutation = {
  __typename?: "Mutation";
  MiddleMsDeleteFormDataRuleGroup?: any | null;
};

export type DuplicateFormDataRuleGroupMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DuplicateFormDataRuleGroupMutation = {
  __typename?: "Mutation";
  MiddleMsDuplicateFormDataRuleGroup: {
    __typename?: "MiddleMsDuplicateFormDataRuleGroupResponse";
    id: string;
  };
};

export type GetFormDataRuleGroupsQueryVariables = Exact<{
  request: MiddleMsSearchFormDataRuleGroupsRequest;
}>;

export type GetFormDataRuleGroupsQuery = {
  __typename?: "Query";
  MiddleMsSearchFormDataRuleGroups: {
    __typename?: "MiddleMsSearchFormDataRuleGroupsResponse";
    data?: Array<{
      __typename?: "MiddleMsSearchFormDataRuleGroupsResponseData";
      codes?: Array<string> | null;
      description: string;
      disabledFor?: Array<string> | null;
      enabled: boolean;
      enabledFor?: Array<string> | null;
      groupCodeFor?: Array<string> | null;
      id: string;
      name: string;
      numberOfRules: number;
      rules: string;
      type: MiddleMsSearchFormDataRuleGroupsResponseDataType;
    }> | null;
  };
};

export type ToggleFormDataRuleGroupMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ToggleFormDataRuleGroupMutation = {
  __typename?: "Mutation";
  MiddleMsToggleFormDataRuleGroup: {
    __typename?: "MiddleMsToggleFormDataRuleGroupResponse";
    enabled: boolean;
  };
};

export type UpdateFormDataRuleGroupMutationVariables = Exact<{
  request: MiddleMsUpdateFormDataRuleGroupRequest;
}>;

export type UpdateFormDataRuleGroupMutation = {
  __typename?: "Mutation";
  MiddleMsUpdateFormDataRuleGroup?: any | null;
};

export type GlobalSearchQueryVariables = Exact<{
  searchQuery: Scalars["String"]["input"];
  limitAccounts: Scalars["Int"]["input"];
  limitUsers: Scalars["Int"]["input"];
}>;

export type GlobalSearchQuery = {
  __typename: "Query";
  AccountsMsSearchAccounts: {
    __typename?: "AccountsMsSearchAccountsResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchAccountsResponseData";
      id: string;
      number: string;
      name: string;
    }> | null;
    pagination: { __typename?: "AccountsMsPagedPagination"; total: number };
  };
  AccountsMsSearchUsers: {
    __typename?: "AccountsMsSearchUsersResponse";
    data?: Array<{
      __typename?: "AccountsMsSearchUsersResponseData";
      id: string;
      email: string;
      firstName: string;
      lastName: string;
    }> | null;
    pagination: { __typename?: "AccountsMsPagedPagination"; total: number };
  };
};

export type AccountsMsStartSupportMutationVariables = Exact<{
  request?: InputMaybe<AccountsMsStartSupportRequest>;
}>;

export type AccountsMsStartSupportMutation = {
  __typename?: "Mutation";
  AccountsMsStartSupport: {
    __typename?: "AccountsMsStartSupportResponse";
    expiresTs: number;
    sessionId: string;
  };
};

export type LedgersMsGetLedgerCreationDataQueryVariables = Exact<{
  request?: InputMaybe<LedgersMsGetLedgerCreationDataRequest>;
}>;

export type LedgersMsGetLedgerCreationDataQuery = {
  __typename?: "Query";
  LedgersMsGetLedgerCreationData: {
    __typename?: "LedgersMsGetLedgerCreationDataResponse";
    category: LedgersMsGetLedgerCreationDataResponseCategory;
    isUnavailable: boolean;
    rawFormData: string;
  };
};

export type GetEditableLedgerCreationTemplateQueryVariables = Exact<{
  request: LedgersMsGetLedgerModificationDataRequest;
}>;

export type GetEditableLedgerCreationTemplateQuery = {
  __typename?: "Query";
  LedgersMsGetLedgerModificationData: {
    __typename?: "LedgersMsGetLedgerModificationDataResponse";
    rawFormData: string;
    isUnavailable: boolean;
    category: LedgersMsGetLedgerModificationDataResponseCategory;
  };
};

export type SearchLedgersStatusQueryVariables = Exact<{
  request: LedgersMsSearchStatusesRequest;
}>;

export type SearchLedgersStatusQuery = {
  __typename?: "Query";
  LedgersMsSearchStatuses: {
    __typename?: "LedgersMsSearchStatusesResponse";
    data?: Array<{
      __typename?: "LedgersMsSearchStatusesResponseData";
      id: string;
      code: string;
      canCreateCopy: boolean;
    }> | null;
  };
};

export type SearchLedgersQueryVariables = Exact<{
  request: LedgersMsSearchLedgersRequest;
}>;

export type SearchLedgersQuery = {
  __typename?: "Query";
  LedgersMsSearchLedgers: {
    __typename?: "LedgersMsSearchLedgersResponse";
    data?: Array<{
      __typename?: "LedgersMsSearchLedgersResponseData";
      id: string;
      rank: number;
      originalName: string;
      registrationNumber: string;
      name: string;
      statusId: string;
      typeId: string;
      pan: string;
      shortCode: string;
      evId: string;
      isElectricPackage: boolean;
      tollPackageCode: string;
      fuelPackageCode: string;
      nextLedgerId: string;
      renewalCancellable: boolean;
      isModifiable: boolean;
      pcomType: LedgersMsSearchLedgersResponseDataPcomType;
      expiresTs: number;
      complementaryInfo: string;
      canCreateCopy: boolean;
      isPinResendable: boolean;
      isPinRequestActive: boolean;
      SectorIdData?: {
        __typename?: "SectorsMsSearchSectorsResponseData";
        id: string;
        label: string;
      } | null;
      WalletIdData?: {
        __typename?: "LedgersMsSearchWalletsResponseData";
        id: string;
        SettingsIdData?: {
          __typename?: "LedgersMsSearchWalletSettingsResponseData";
          divisionAccountNumber: string;
          divisionAccountLabel: string;
          supportAccountLabel: string;
          supportAccountNumber: string;
          sectorId: string;
        } | null;
      } | null;
      LastOpenOrderIdData?: {
        __typename?: "LedgersMsSearchOrdersResponseData";
        type: LedgersMsSearchOrdersResponseDataType;
      } | null;
      StatusIdData?: {
        __typename?: "LedgersMsSearchStatusesResponseData";
        code: string;
        blockable: boolean;
        id: string;
        deletable: boolean;
      } | null;
      TypeIdData?: {
        __typename?: "LedgersMsSearchTypesResponseData";
        id: string;
        code: string;
        GroupIdData?: {
          __typename?: "LedgersMsSearchGroupsResponseData";
          codeHint: string;
          code: string;
        } | null;
      } | null;
    }> | null;
    pagination: {
      __typename?: "LedgersMsPagedPagination";
      page: number;
      size: number;
      total: number;
    };
  };
};

export type CountLedgersByStatusQueryVariables = Exact<{
  request: LedgersMsCountLedgersByStatusRequest;
}>;

export type CountLedgersByStatusQuery = {
  __typename?: "Query";
  LedgersMsCountLedgersByStatus: {
    __typename?: "LedgersMsCountLedgersByStatusResponse";
    metrics?: Array<{
      __typename?: "LedgersMsCountLedgersByStatusResponseMetric";
      statusCode: string;
      statusId: string;
      total: number;
      ledgerTypeMetrics?: Array<{
        __typename?: "LedgersMsCountLedgersByStatusResponseMetricLedgerTypeMetric";
        type: string;
        total: number;
      }> | null;
    }> | null;
  };
};

export type LedgersMsSearchLedgersQueryVariables = Exact<{
  request: LedgersMsSearchLedgersRequest;
}>;

export type LedgersMsSearchLedgersQuery = {
  __typename?: "Query";
  LedgersMsSearchLedgers: {
    __typename?: "LedgersMsSearchLedgersResponse";
    data?: Array<{
      __typename?: "LedgersMsSearchLedgersResponseData";
      id: string;
      name: string;
      pcomType: LedgersMsSearchLedgersResponseDataPcomType;
      TypeIdData?: {
        __typename?: "LedgersMsSearchTypesResponseData";
        id: string;
        codeHint: string;
        code: string;
        GroupIdData?: {
          __typename?: "LedgersMsSearchGroupsResponseData";
          code: string;
          codeHint: string;
        } | null;
      } | null;
      WalletIdData?: {
        __typename?: "LedgersMsSearchWalletsResponseData";
        id: string;
        label: string;
        originalLabel: string;
        SettingsIdData?: {
          __typename?: "LedgersMsSearchWalletSettingsResponseData";
          supportAccountLabel: string;
          divisionAccountLabel: string;
        } | null;
      } | null;
    }> | null;
  };
};

export type LedgersMsGetOrderableWalletLedgerTypesQueryVariables = Exact<{
  request?: InputMaybe<LedgersMsGetOrderableWalletLedgerTypesRequest>;
}>;

export type LedgersMsGetOrderableWalletLedgerTypesQuery = {
  __typename?: "Query";
  LedgersMsGetOrderableWalletLedgerTypes: {
    __typename?: "LedgersMsGetOrderableWalletLedgerTypesResponse";
    data?: Array<{
      __typename?: "LedgersMsGetOrderableWalletLedgerTypesResponseData";
      code: string;
      codeHint: string;
      groupId: string;
      id: string;
      GroupIdData?: {
        __typename?: "LedgersMsSearchGroupsResponseData";
        category: LedgersMsSearchGroupsResponseDataCategory;
        code: string;
        codeHint: string;
        id: string;
      } | null;
    }> | null;
  };
};

export type SearchGroupsQueryVariables = Exact<{
  request: LedgersMsSearchGroupsRequest;
}>;

export type SearchGroupsQuery = {
  __typename?: "Query";
  LedgersMsSearchGroups: {
    __typename?: "LedgersMsSearchGroupsResponse";
    data?: Array<{
      __typename?: "LedgersMsSearchGroupsResponseData";
      id: string;
      code: string;
      codeHint: string;
      category: LedgersMsSearchGroupsResponseDataCategory;
    }> | null;
    pagination: {
      __typename?: "LedgersMsPagedPagination";
      page: number;
      size: number;
      total: number;
    };
  };
};

export type GetMiddleMsBuildAccountsMigrationReportsQueryVariables = Exact<{
  request?: InputMaybe<MiddleMsBuildAccountsMigrationReportRequest>;
}>;

export type GetMiddleMsBuildAccountsMigrationReportsQuery = {
  __typename?: "Query";
  MiddleMsBuildAccountsMigrationReport: {
    __typename?: "MiddleMsBuildAccountsMigrationReportResponse";
    migratedAccounts: number;
    diagnosedAccounts: number;
    failures?: Array<{
      __typename?: "MiddleMsBuildAccountsMigrationReportResponseAccountMigrationReport";
      accountNumber: string;
      contactEmailIsNull: boolean;
      accountNumberIsAct: boolean;
      accountHasNoPcom: boolean;
      billingAccountPayerCurrencyIsNull: boolean;
      contractOfferNameIsNull: boolean;
      contractOfferCodeIsNull: boolean;
      contactEmailIsInvalid: boolean;
      contractBillingFrequencyCodeIsNull: boolean;
      contractExternalContractIdIsNull: boolean;
      contractContractNumIsNull: boolean;
      contractIsNotMb2: boolean;
      contractHasNoScom: boolean;
      contractHasInvalidStatus: boolean;
      notPresentInAccountsService: boolean;
      contactIsNull: boolean;
      contractMissing: boolean;
    }> | null;
    successes?: Array<{
      __typename?: "MiddleMsBuildAccountsMigrationReportResponseAccountMigrationReport";
      accountNumber: string;
      contactEmailIsNull: boolean;
      accountNumberIsAct: boolean;
      accountHasNoPcom: boolean;
      billingAccountPayerCurrencyIsNull: boolean;
      contractOfferNameIsNull: boolean;
      contractOfferCodeIsNull: boolean;
      contractBillingFrequencyCodeIsNull: boolean;
      contactEmailIsInvalid: boolean;
      contractExternalContractIdIsNull: boolean;
      contractContractNumIsNull: boolean;
      contractIsNotMb2: boolean;
      contractHasNoScom: boolean;
      contractHasInvalidStatus: boolean;
      notPresentInAccountsService: boolean;
      contactIsNull: boolean;
      contractMissing: boolean;
    }> | null;
  };
};

export type ResynchroniseMutationVariables = Exact<{
  request?: InputMaybe<MiddleMsResynchronisationRequest>;
}>;

export type ResynchroniseMutation = {
  __typename?: "Mutation";
  MiddleMsResynchronisation: {
    __typename?: "MiddleMsResynchronisationResponse";
    requestId: string;
  };
};

export type GetMiddleMsGetIngestionSnapshotQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMiddleMsGetIngestionSnapshotQuery = {
  __typename?: "Query";
  MiddleMsGetIngestionSnapshot: {
    __typename?: "MiddleMsGetIngestionSnapshotResponse";
    flows?: Array<{
      __typename?: "MiddleMsGetIngestionSnapshotResponseFlow";
      code: string;
      status: MiddleMsGetIngestionSnapshotResponseFlowStatus;
      isEmpty: boolean;
      isMb1: boolean;
      successfulTs: number;
    }> | null;
  };
};

export type GetNotificationsByUserQueryQueryVariables = Exact<{
  request?: InputMaybe<NotificationsMsSearchNotificationsRequest>;
}>;

export type GetNotificationsByUserQueryQuery = {
  __typename?: "Query";
  NotificationsMsSearchNotifications: {
    __typename?: "NotificationsMsSearchNotificationsResponse";
    data?: Array<{
      __typename?: "NotificationsMsSearchNotificationsResponseData";
      id: string;
      subject: string;
      hasAttachments: boolean;
      createdTs: number;
      status: NotificationsMsSearchNotificationsResponseDataStatus;
      failedReason: NotificationsMsSearchNotificationsResponseDataFailedReason;
      AccountIdData?: {
        __typename?: "AccountsMsSearchAccountsResponseData";
        name: string;
        number: string;
      } | null;
    }> | null;
    pagination: {
      __typename?: "NotificationsMsPagedPagination";
      size: number;
      page: number;
      total: number;
    };
  };
};

export const GetAccountDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccountDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AccountsMsSearchAccountsRequest" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchAccounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "zipCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "MainPrivilegeIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "UserIdData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountDetailQuery,
  GetAccountDetailQueryVariables
>;
export const GetAccountUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccountUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsSearchPrivilegesRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchPrivileges" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastUsedTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "UserIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdTs" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "Subscriptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "RolesProfileIdData",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountUsersQuery,
  GetAccountUsersQueryVariables
>;
export const GetAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AccountsMsSearchAccountsRequest" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchAccounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registrationNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registrationName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "zipCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "MainPrivilegeIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "UserIdData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAccountQuery, GetAccountQueryVariables>;
export const GetUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AccountsMsSearchUsersRequest" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locale" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezone" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneAlt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobTitle" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const AccountsMsSearchPrivilegesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountsMsSearchPrivileges" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsSearchPrivilegesRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchPrivileges" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "roles" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rolesInvalidatedTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "disabledTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastUsedTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invitedTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabledLastTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "owner" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "AccountIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "registrationName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "registrationNumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isActive" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdTs" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mainPrivilegeId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "Subscriptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fromTs" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tillTs" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "privilegeId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rolesProfileId" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "RolesProfileIdData",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "roles" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "accountId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "parentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rootId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "system" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountsMsSearchPrivilegesQuery,
  AccountsMsSearchPrivilegesQueryVariables
>;
export const InviteAgentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InviteAgent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsInviteSupportUserRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsInviteSupportUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InviteAgentMutation, InviteAgentMutationVariables>;
export const AccountsMsSearchAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountsMsSearchAccounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsSearchAccountsRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchAccounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registrationName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registrationNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountsMsSearchAccountsQuery,
  AccountsMsSearchAccountsQueryVariables
>;
export const GetActionsByAccountQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActionsByAccountQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsSearchAuditLogsRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchAuditLogs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "action" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "AgentIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "AccessIdData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "igg" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "UserIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "whenTs" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActionsByAccountQueryQuery,
  GetActionsByAccountQueryQueryVariables
>;
export const GetActionsByUserQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActionsByUserQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsSearchAuditLogsRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchAuditLogs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "action" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "AgentIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "AccessIdData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "igg" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "whenTs" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActionsByUserQueryQuery,
  GetActionsByUserQueryQueryVariables
>;
export const CancelSupportAgentInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelSupportAgentInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "AccountsMsCancelSupportUserInviteRequest",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsCancelSupportUserInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelSupportAgentInviteMutation,
  CancelSupportAgentInviteMutationVariables
>;
export const DisableAgentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DisableAgent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "AccountsMsDisableSupportUserRequest",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsDisableSupportUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DisableAgentMutation,
  DisableAgentMutationVariables
>;
export const EnableAgentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EnableAgent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsEnableSupportUserRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsEnableSupportUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnableAgentMutation, EnableAgentMutationVariables>;
export const AccountsMsSearchSupportUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountsMsSearchSupportUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "AccountsMsSearchSupportUsersRequest",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchSupportUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobTitle" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "profile" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invitedBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "AccessIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "igg" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastAccessTs" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountsMsSearchSupportUsersQuery,
  AccountsMsSearchSupportUsersQueryVariables
>;
export const AccountsMsCountSupportUsersByStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountsMsCountSupportUsersByStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "AccountsMsCountSupportUsersByStatus",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "all" } },
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "disabled" } },
                { kind: "Field", name: { kind: "Name", value: "inviting" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountsMsCountSupportUsersByStatusQuery,
  AccountsMsCountSupportUsersByStatusQueryVariables
>;
export const UpdateAgentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateAgent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsUpdateSupportUserRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsUpdateSupportUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAgentMutation, UpdateAgentMutationVariables>;
export const SearchAccountsMsMeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchAccountsMsMe" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsMeRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsMe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sharedUserProfileTs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "systemUserInfo" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supportUserInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "igg" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subsidiaries" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchAccountsMsMeQuery,
  SearchAccountsMsMeQueryVariables
>;
export const CreateTidLinkedAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTidLinkedAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "BillingMsCreateTidLinkedAccountRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BillingMsCreateTidLinkedAccount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateTidLinkedAccountMutation,
  CreateTidLinkedAccountMutationVariables
>;
export const DeleteTidLinkedAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTidLinkedAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BillingMsDeleteTidLinkedAccount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTidLinkedAccountMutation,
  DeleteTidLinkedAccountMutationVariables
>;
export const GetAccountsLinkableToTidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccountsLinkableToTid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "BillingMsGetAccountsLinkableToTidRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BillingMsGetAccountsLinkableToTid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountsLinkableToTidQuery,
  GetAccountsLinkableToTidQueryVariables
>;
export const SearchTidLinkedAccountTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchTidLinkedAccountTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "BillingMsSearchTidLinkedAccountTypesRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "BillingMsSearchTidLinkedAccountTypes",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchTidLinkedAccountTypesQuery,
  SearchTidLinkedAccountTypesQueryVariables
>;
export const SearchTidLinkedAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchTidLinkedAccounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "BillingMsSearchTidLinkedAccountsRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BillingMsSearchTidLinkedAccounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "linkedAccountId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "typeId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "TypeIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "LinkedAccountIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "IdData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchTidLinkedAccountsQuery,
  SearchTidLinkedAccountsQueryVariables
>;
export const GetSupportsAndDivisionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSupportsAndDivisions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "LedgersMsGetSupportsAndDivisions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supportAccounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "divisionAccounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "walletId" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "originalLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "walletId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSupportsAndDivisionsQuery,
  GetSupportsAndDivisionsQueryVariables
>;
export const MiddleMsCreateFormDataRuleGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MiddleMsCreateFormDataRuleGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "MiddleMsCreateFormDataRuleGroupRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "MiddleMsCreateFormDataRuleGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MiddleMsCreateFormDataRuleGroupMutation,
  MiddleMsCreateFormDataRuleGroupMutationVariables
>;
export const DeleteFormDataRuleGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteFormDataRuleGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "MiddleMsDeleteFormDataRuleGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteFormDataRuleGroupMutation,
  DeleteFormDataRuleGroupMutationVariables
>;
export const DuplicateFormDataRuleGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DuplicateFormDataRuleGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "MiddleMsDuplicateFormDataRuleGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DuplicateFormDataRuleGroupMutation,
  DuplicateFormDataRuleGroupMutationVariables
>;
export const GetFormDataRuleGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFormDataRuleGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "MiddleMsSearchFormDataRuleGroupsRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "MiddleMsSearchFormDataRuleGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "codes" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "disabledFor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabledFor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "groupCodeFor" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfRules" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rules" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFormDataRuleGroupsQuery,
  GetFormDataRuleGroupsQueryVariables
>;
export const ToggleFormDataRuleGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ToggleFormDataRuleGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "MiddleMsToggleFormDataRuleGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleFormDataRuleGroupMutation,
  ToggleFormDataRuleGroupMutationVariables
>;
export const UpdateFormDataRuleGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateFormDataRuleGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "MiddleMsUpdateFormDataRuleGroupRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "MiddleMsUpdateFormDataRuleGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFormDataRuleGroupMutation,
  UpdateFormDataRuleGroupMutationVariables
>;
export const GlobalSearchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GlobalSearch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchQuery" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limitAccounts" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limitUsers" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchAccounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "query" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "searchQuery" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "paging" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "size" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "limitAccounts" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsSearchUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "query" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "searchQuery" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "paging" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "size" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "limitUsers" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GlobalSearchQuery, GlobalSearchQueryVariables>;
export const AccountsMsStartSupportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AccountsMsStartSupport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccountsMsStartSupportRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "AccountsMsStartSupport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "expiresTs" } },
                { kind: "Field", name: { kind: "Name", value: "sessionId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountsMsStartSupportMutation,
  AccountsMsStartSupportMutationVariables
>;
export const LedgersMsGetLedgerCreationDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LedgersMsGetLedgerCreationData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "LedgersMsGetLedgerCreationDataRequest",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "LedgersMsGetLedgerCreationData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isUnavailable" },
                },
                { kind: "Field", name: { kind: "Name", value: "rawFormData" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LedgersMsGetLedgerCreationDataQuery,
  LedgersMsGetLedgerCreationDataQueryVariables
>;
export const GetEditableLedgerCreationTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEditableLedgerCreationTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "LedgersMsGetLedgerModificationDataRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "LedgersMsGetLedgerModificationData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawFormData" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isUnavailable" },
                },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEditableLedgerCreationTemplateQuery,
  GetEditableLedgerCreationTemplateQueryVariables
>;
export const SearchLedgersStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchLedgersStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LedgersMsSearchStatusesRequest" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "LedgersMsSearchStatuses" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCreateCopy" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchLedgersStatusQuery,
  SearchLedgersStatusQueryVariables
>;
export const SearchLedgersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchLedgers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LedgersMsSearchLedgersRequest" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "LedgersMsSearchLedgers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "rank" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "originalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registrationNumber" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "typeId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "pan" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "evId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "SectorIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isElectricPackage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tollPackageCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fuelPackageCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nextLedgerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "renewalCancellable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isModifiable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "WalletIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "SettingsIdData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "divisionAccountNumber",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "divisionAccountLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "supportAccountLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "supportAccountNumber",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sectorId" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pcomType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiresTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "complementaryInfo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "LastOpenOrderIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "StatusIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blockable" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deletable" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCreateCopy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "TypeIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "GroupIdData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "codeHint" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPinResendable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPinRequestActive" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchLedgersQuery, SearchLedgersQueryVariables>;
export const CountLedgersByStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CountLedgersByStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "LedgersMsCountLedgersByStatusRequest",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "LedgersMsCountLedgersByStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ledgerTypeMetrics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountLedgersByStatusQuery,
  CountLedgersByStatusQueryVariables
>;
export const LedgersMsSearchLedgersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LedgersMsSearchLedgers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LedgersMsSearchLedgersRequest" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "LedgersMsSearchLedgers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pcomType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "TypeIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "codeHint" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "GroupIdData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "codeHint" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "WalletIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "SettingsIdData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "supportAccountLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "divisionAccountLabel",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalLabel" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LedgersMsSearchLedgersQuery,
  LedgersMsSearchLedgersQueryVariables
>;
export const LedgersMsGetOrderableWalletLedgerTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LedgersMsGetOrderableWalletLedgerTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "LedgersMsGetOrderableWalletLedgerTypesRequest",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "LedgersMsGetOrderableWalletLedgerTypes",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "GroupIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "codeHint" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "codeHint" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "groupId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LedgersMsGetOrderableWalletLedgerTypesQuery,
  LedgersMsGetOrderableWalletLedgerTypesQueryVariables
>;
export const SearchGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LedgersMsSearchGroupsRequest" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "LedgersMsSearchGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "codeHint" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchGroupsQuery, SearchGroupsQueryVariables>;
export const GetMiddleMsBuildAccountsMigrationReportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMiddleMsBuildAccountsMigrationReports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "MiddleMsBuildAccountsMigrationReportRequest",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "MiddleMsBuildAccountsMigrationReport",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "migratedAccounts" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "diagnosedAccounts" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "failures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactEmailIsNull" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountNumberIsAct" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountHasNoPcom" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "billingAccountPayerCurrencyIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractOfferNameIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractOfferCodeIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactEmailIsInvalid" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractBillingFrequencyCodeIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractExternalContractIdIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractContractNumIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractIsNotMb2" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractHasNoScom" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractHasInvalidStatus",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "notPresentInAccountsService",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactIsNull" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractMissing" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "successes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactEmailIsNull" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountNumberIsAct" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountHasNoPcom" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "billingAccountPayerCurrencyIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractOfferNameIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractOfferCodeIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractBillingFrequencyCodeIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactEmailIsInvalid" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractExternalContractIdIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractContractNumIsNull",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractIsNotMb2" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractHasNoScom" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "contractHasInvalidStatus",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "notPresentInAccountsService",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactIsNull" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractMissing" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMiddleMsBuildAccountsMigrationReportsQuery,
  GetMiddleMsBuildAccountsMigrationReportsQueryVariables
>;
export const ResynchroniseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Resynchronise" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MiddleMsResynchronisationRequest" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "MiddleMsResynchronisation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "requestId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResynchroniseMutation,
  ResynchroniseMutationVariables
>;
export const GetMiddleMsGetIngestionSnapshotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMiddleMsGetIngestionSnapshot" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "MiddleMsGetIngestionSnapshot" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isEmpty" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "isMb1" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "successfulTs" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMiddleMsGetIngestionSnapshotQuery,
  GetMiddleMsGetIngestionSnapshotQueryVariables
>;
export const GetNotificationsByUserQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetNotificationsByUserQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "request" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "NotificationsMsSearchNotificationsRequest",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "NotificationsMsSearchNotifications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "request" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasAttachments" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdTs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "failedReason" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "AccountIdData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNotificationsByUserQueryQuery,
  GetNotificationsByUserQueryQueryVariables
>;
export const namedOperations = {
  Query: {
    GetAccountDetail: "GetAccountDetail",
    GetAccountUsers: "GetAccountUsers",
    GetAccount: "GetAccount",
    GetUser: "GetUser",
    AccountsMsSearchPrivileges: "AccountsMsSearchPrivileges",
    AccountsMsSearchAccounts: "AccountsMsSearchAccounts",
    GetActionsByAccountQuery: "GetActionsByAccountQuery",
    GetActionsByUserQuery: "GetActionsByUserQuery",
    AccountsMsSearchSupportUsers: "AccountsMsSearchSupportUsers",
    AccountsMsCountSupportUsersByStatus: "AccountsMsCountSupportUsersByStatus",
    SearchAccountsMsMe: "SearchAccountsMsMe",
    GetAccountsLinkableToTid: "GetAccountsLinkableToTid",
    SearchTidLinkedAccountTypes: "SearchTidLinkedAccountTypes",
    SearchTidLinkedAccounts: "SearchTidLinkedAccounts",
    GetSupportsAndDivisions: "GetSupportsAndDivisions",
    GetFormDataRuleGroups: "GetFormDataRuleGroups",
    GlobalSearch: "GlobalSearch",
    LedgersMsGetLedgerCreationData: "LedgersMsGetLedgerCreationData",
    GetEditableLedgerCreationTemplate: "GetEditableLedgerCreationTemplate",
    SearchLedgersStatus: "SearchLedgersStatus",
    SearchLedgers: "SearchLedgers",
    CountLedgersByStatus: "CountLedgersByStatus",
    LedgersMsSearchLedgers: "LedgersMsSearchLedgers",
    LedgersMsGetOrderableWalletLedgerTypes:
      "LedgersMsGetOrderableWalletLedgerTypes",
    SearchGroups: "SearchGroups",
    GetMiddleMsBuildAccountsMigrationReports:
      "GetMiddleMsBuildAccountsMigrationReports",
    GetMiddleMsGetIngestionSnapshot: "GetMiddleMsGetIngestionSnapshot",
    GetNotificationsByUserQuery: "GetNotificationsByUserQuery",
  },
  Mutation: {
    InviteAgent: "InviteAgent",
    CancelSupportAgentInvite: "CancelSupportAgentInvite",
    DisableAgent: "DisableAgent",
    EnableAgent: "EnableAgent",
    UpdateAgent: "UpdateAgent",
    CreateTidLinkedAccount: "CreateTidLinkedAccount",
    DeleteTidLinkedAccount: "DeleteTidLinkedAccount",
    MiddleMsCreateFormDataRuleGroup: "MiddleMsCreateFormDataRuleGroup",
    DeleteFormDataRuleGroup: "DeleteFormDataRuleGroup",
    DuplicateFormDataRuleGroup: "DuplicateFormDataRuleGroup",
    ToggleFormDataRuleGroup: "ToggleFormDataRuleGroup",
    UpdateFormDataRuleGroup: "UpdateFormDataRuleGroup",
    AccountsMsStartSupport: "AccountsMsStartSupport",
    Resynchronise: "Resynchronise",
  },
};
